{
  "generated_at": "2026-05-28T10:00:13.802Z",
  "tenant": "fredericia-portal.wastehero.io",
  "hauler": "marius-pedersen",
  "hauler_prefix": "MP-",
  "total_scanned": 40408,
  "total_mp_containers": 602,
  "dropped_unresolved_addresses": 0,
  "total_tickets_scanned": 29516,
  "total_mp_tickets": 1022,
  "ticket_skip_count": 77,
  "dropped_tickets_no_mp_container": 28494,
  "dropped_tickets_unresolvable": 0,
  "properties": [
    {
      "id": "UHJvcGVydHlUeXBlOjExMzc5ODk=",
      "location": {
        "name": "Skærbæk Havnegade 7 7000 Fredericia",
        "latitude": 55.516009,
        "longitude": 9.634072
      },
      "containers": [
        {
          "id": "mp-pc-1",
          "num_open_tickets": 3,
          "container": {
            "id": "mp-c-1",
            "container_id": "MP-7002-0",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDQyMDQzNQ==",
          "ticket_id": "10420435",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-10-10T19:29:25.514274+00:00",
          "updated_at": "2024-10-10T19:29:25.515470+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzc5ODk=",
            "location": {
              "latitude": 55.516009,
              "longitude": 9.634072,
              "name": "Skærbæk Havnegade 7 7000 Fredericia"
            }
          },
          "container": {
            "container_id": "MP-7002-0",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "name": "240 L 2-delt"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToxMDQyMDQzNA==",
          "ticket_id": "10420434",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-10-10T19:29:03.526581+00:00",
          "updated_at": "2024-10-10T19:29:03.527790+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzc5ODk=",
            "location": {
              "latitude": 55.516009,
              "longitude": 9.634072,
              "name": "Skærbæk Havnegade 7 7000 Fredericia"
            }
          },
          "container": {
            "container_id": "MP-7002-0",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "name": "240 L 2-delt"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToxMDQyMDQzMw==",
          "ticket_id": "10420433",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-10-10T19:28:41.058333+00:00",
          "updated_at": "2024-10-10T19:28:41.059620+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzc5ODk=",
            "location": {
              "latitude": 55.516009,
              "longitude": 9.634072,
              "name": "Skærbæk Havnegade 7 7000 Fredericia"
            }
          },
          "container": {
            "container_id": "MP-7002-0",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "name": "240 L 2-delt"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToxMTQ0NjY2",
          "ticket_id": "1144666",
          "ticket_type": "Beholder er fejlsorteret",
          "description": "",
          "status": 1,
          "priority": 1,
          "created_at": "2023-01-24T07:51:07.919377+00:00",
          "updated_at": "2023-01-24T07:51:07.932398+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": {
            "name": null
          },
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzc5ODk=",
            "location": {
              "latitude": 55.516009,
              "longitude": 9.634072,
              "name": "Skærbæk Havnegade 7, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20348_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc2NDQ=",
      "location": {
        "name": "Omøvænget 18 7000 Fredericia",
        "latitude": 55.52014958,
        "longitude": 9.64789143
      },
      "containers": [
        {
          "id": "mp-pc-2",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-2",
            "container_id": "MP-7002-1",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4ODI2MA==",
          "ticket_id": "20588260",
          "ticket_type": "AO-Generel besked",
          "description": "Tildelt standplads efter ønske efter beboerne.",
          "status": 6,
          "priority": 2,
          "created_at": "2022-07-22T08:03:00+00:00",
          "updated_at": "2025-08-19T00:25:00.868710+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2NDQ=",
            "location": {
              "latitude": 55.520159,
              "longitude": 9.647851,
              "name": "Omøvænget 18, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4OTIxNw==",
          "ticket_id": "20589217",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: Genbrug Parcel Omøvænget 18 (7000 Fredericia) ContainerNr:436095 ContainerBrik: Beholder der ønskes i stedet: 46840 Ny tømningsfrekvens: Gebyr: 0 kr Ønsket virkningsdato: 24/05 2022 Besked: Kontaktoplysninger: Rikke Augustinus",
          "status": 6,
          "priority": 2,
          "created_at": "2022-05-17T13:55:00+00:00",
          "updated_at": "2025-08-19T00:25:00.958094+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2NDQ=",
            "location": {
              "latitude": 55.520159,
              "longitude": 9.647851,
              "name": "Omøvænget 18, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4OTIxOA==",
          "ticket_id": "20589218",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 24/05 2022 Besked: Kontaktoplysninger: Rikke Augustinus",
          "status": 6,
          "priority": 2,
          "created_at": "2022-05-17T13:53:00+00:00",
          "updated_at": "2025-08-19T00:25:00.958139+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2NDQ=",
            "location": {
              "latitude": 55.520159,
              "longitude": 9.647851,
              "name": "Omøvænget 18, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4OTMwNQ==",
          "ticket_id": "20589305",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 19/05-2022 Besked: Kontaktoplysninger: Rikke Augustinus",
          "status": 6,
          "priority": 2,
          "created_at": "2022-05-11T14:07:00+00:00",
          "updated_at": "2025-08-19T00:25:00.962371+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2NDQ=",
            "location": {
              "latitude": 55.520159,
              "longitude": 9.647851,
              "name": "Omøvænget 18, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc2NTY=",
      "location": {
        "name": "Omøvænget 14 7000 Fredericia",
        "latitude": 55.5201285,
        "longitude": 9.64711794
      },
      "containers": [
        {
          "id": "mp-pc-3",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-3",
            "container_id": "MP-7002-2",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NjA4Nw==",
          "ticket_id": "20576087",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2025-04-11Fraktion: 1 (Mad/Rest)Navn: Joan DybroTlf.: 60938387Email: joandybro@live.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2025-04-12T12:37:00+00:00",
          "updated_at": "2025-08-19T00:25:00.005361+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2NTY=",
            "location": {
              "latitude": 55.520128,
              "longitude": 9.647117,
              "name": "Omøvænget 14, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MTE3OQ==",
          "ticket_id": "20581179",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Tømningsdato: 2024-04-05Fraktion: 2 (Genbrug)Navn: Joan DybroTlf.: 60938387Email: joandybro@live.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2024-04-07T22:10:00+00:00",
          "updated_at": "2025-08-19T00:25:00.361260+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2NTY=",
            "location": {
              "latitude": 55.520128,
              "longitude": 9.647117,
              "name": "Omøvænget 14, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4Nzk1NQ==",
          "ticket_id": "20587955",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Tømningsdato: 2022-08-16Fraktion: 2 (Genbrug)Navn: Joan DybroTlf.: 60938387Email: joandybro@live.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2022-08-17T07:00:00+00:00",
          "updated_at": "2025-08-19T00:25:00.841252+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2NTY=",
            "location": {
              "latitude": 55.520128,
              "longitude": 9.647117,
              "name": "Omøvænget 14, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4ODkyMw==",
          "ticket_id": "20588923",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 17/06 2022 Besked: Kontaktoplysninger: Jørgen Dybro",
          "status": 6,
          "priority": 2,
          "created_at": "2022-06-10T09:53:00+00:00",
          "updated_at": "2025-08-19T00:25:00.928788+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2NTY=",
            "location": {
              "latitude": 55.520128,
              "longitude": 9.647117,
              "name": "Omøvænget 14, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4ODkyNA==",
          "ticket_id": "20588924",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 17/06 2022 Besked: Kontaktoplysninger: Jørgen Dybro",
          "status": 6,
          "priority": 2,
          "created_at": "2022-06-10T09:52:00+00:00",
          "updated_at": "2025-08-19T00:25:00.928840+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2NTY=",
            "location": {
              "latitude": 55.520128,
              "longitude": 9.647117,
              "name": "Omøvænget 14, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3MDA=",
      "location": {
        "name": "Omøvænget 34 7000 Fredericia",
        "latitude": 55.522142,
        "longitude": 9.64787
      },
      "containers": [
        {
          "id": "mp-pc-4",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-4",
            "container_id": "MP-7002-3",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NzE0OQ==",
          "ticket_id": "20587149",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 26/10-2022 Besked: Kontaktoplysninger: Hans Christian Hansen",
          "status": 6,
          "priority": 2,
          "created_at": "2022-10-26T14:42:00+00:00",
          "updated_at": "2025-08-19T00:25:00.762267+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MDA=",
            "location": {
              "latitude": 55.522142,
              "longitude": 9.64787,
              "name": "Omøvænget 34, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4ODAwMg==",
          "ticket_id": "20588002",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 15/08-2022 Besked: Kontaktoplysninger: Hans Christian Hansen",
          "status": 6,
          "priority": 2,
          "created_at": "2022-08-12T13:07:00+00:00",
          "updated_at": "2025-08-19T00:25:00.843748+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MDA=",
            "location": {
              "latitude": 55.522142,
              "longitude": 9.64787,
              "name": "Omøvænget 34, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3MjE=",
      "location": {
        "name": "Omøvænget 36 7000 Fredericia",
        "latitude": 55.52200959,
        "longitude": 9.64729074
      },
      "containers": [
        {
          "id": "mp-pc-5",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-5",
            "container_id": "MP-7002-4",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NzcyOQ==",
          "ticket_id": "20577729",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Skraldebil kørte forbi uden at tømme beholderen. Men havde tid til en længere snak med genboen.",
          "status": 6,
          "priority": 2,
          "created_at": "2024-11-22T11:45:00+00:00",
          "updated_at": "2025-08-19T00:25:00.156228+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MjE=",
            "location": {
              "latitude": 55.521981,
              "longitude": 9.647438,
              "name": "Omøvænget 36, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4Njk4MA==",
          "ticket_id": "20586980",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 13/12-2022 Besked: Kontaktoplysninger: Henning Skaarup",
          "status": 6,
          "priority": 2,
          "created_at": "2022-11-17T12:34:00+00:00",
          "updated_at": "2025-08-19T00:25:00.753316+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MjE=",
            "location": {
              "latitude": 55.521981,
              "longitude": 9.647438,
              "name": "Omøvænget 36, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4Njk4MQ==",
          "ticket_id": "20586981",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 13/12-2022 Besked: Bestilt via kontaktformular den 14. november. De flytter ind den 15. december. Aftalt at de får beholder den 13. december. Kontaktoplysninger: Henning Skaarup",
          "status": 6,
          "priority": 2,
          "created_at": "2022-11-17T12:33:00+00:00",
          "updated_at": "2025-08-19T00:25:00.753363+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MjE=",
            "location": {
              "latitude": 55.521981,
              "longitude": 9.647438,
              "name": "Omøvænget 36, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3MzQ=",
      "location": {
        "name": "Gavnøvænget 7 7000 Fredericia",
        "latitude": 55.52272477,
        "longitude": 9.64550404
      },
      "containers": [
        {
          "id": "mp-pc-6",
          "num_open_tickets": 2,
          "container": {
            "id": "mp-c-6",
            "container_id": "MP-7002-5",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDQyMTYwNQ==",
          "ticket_id": "10421605",
          "ticket_type": "mp_test_lasse",
          "description": "Test Lasse ",
          "status": 1,
          "priority": 1,
          "created_at": "2024-10-11T10:32:12.326827+00:00",
          "updated_at": "2024-10-11T10:32:12.328025+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzQ=",
            "location": {
              "latitude": 55.52272477,
              "longitude": 9.64550404,
              "name": "Gavnøvænget 7 7000 Fredericia"
            }
          },
          "container": {
            "container_id": "MP-7002-5",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "name": "240 L 2-delt"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToxMDQyMTE1Mg==",
          "ticket_id": "10421152",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-10-11T07:30:05.209289+00:00",
          "updated_at": "2024-10-11T07:30:05.210461+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzQ=",
            "location": {
              "latitude": 55.52272477,
              "longitude": 9.64550404,
              "name": "Gavnøvænget 7 7000 Fredericia"
            }
          },
          "container": {
            "container_id": "MP-7002-5",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "name": "240 L 2-delt"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTY5Nw==",
          "ticket_id": "20585697",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Forkert registrering af tømmedag --- Kommunemail sendt Marius Pedersen Efter aftale med Morten Holm bestiller vi ekstra tømninger på Gavnøvænget nr. 3 7 11 15 27 34 og 46 Dvs. ekstra tømning af 7 beholdere inkl. evt. affaldssække. Morten undersøger muligheden for at omdele hængere med besked om ny tømmedato på fredage i lige uger. Venlig hilsen Michael Beltrão Sørensen",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-21T08:46:00+00:00",
          "updated_at": "2025-08-19T00:25:00.633607+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzQ=",
            "location": {
              "latitude": 55.522724,
              "longitude": 9.645504,
              "name": "Gavnøvænget 7, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTcyMg==",
          "ticket_id": "20585722",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Bedes tømt - ingen kvittering på loggen. Aftalt med kunden, der tømmes på mandag. Ekstra sæk stilles tømmes med pga. ikke tømt beholder som planlagt.",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-17T13:17:00+00:00",
          "updated_at": "2025-08-19T00:25:00.634894+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzQ=",
            "location": {
              "latitude": 55.522724,
              "longitude": 9.645504,
              "name": "Gavnøvænget 7, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTk0Mw==",
          "ticket_id": "20585943",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/02 2023 Besked: Kontaktoplysninger:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-25T14:28:00+00:00",
          "updated_at": "2025-08-19T00:25:00.650652+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzQ=",
            "location": {
              "latitude": 55.522724,
              "longitude": 9.645504,
              "name": "Gavnøvænget 7, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTk1MA==",
          "ticket_id": "20585950",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/02 2023 Besked: Kontaktoplysninger:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-25T12:47:00+00:00",
          "updated_at": "2025-08-19T00:25:00.651338+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzQ=",
            "location": {
              "latitude": 55.522724,
              "longitude": 9.645504,
              "name": "Gavnøvænget 7, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3MzU=",
      "location": {
        "name": "Gavnøvænget 11 7000 Fredericia",
        "latitude": 55.52284014,
        "longitude": 9.64581269
      },
      "containers": [
        {
          "id": "mp-pc-7",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-7",
            "container_id": "MP-7002-6",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NTk1Nw==",
          "ticket_id": "20575957",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Vi vil gerne bestille en ekstra tømning hurtigst muligt. Kommunemail sendt.",
          "status": 6,
          "priority": 2,
          "created_at": "2025-04-29T10:26:00+00:00",
          "updated_at": "2025-08-19T00:24:59.990663+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzU=",
            "location": {
              "latitude": 55.52284,
              "longitude": 9.645812,
              "name": "Gavnøvænget 11, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTY5Ng==",
          "ticket_id": "20585696",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Forkert registrering af tømmedag --- Kommunemail sendt Marius Pedersen Efter aftale med Morten Holm bestiller vi ekstra tømninger på Gavnøvænget nr. 3 7 11 15 27 34 og 46 Dvs. ekstra tømning af 7 beholdere inkl. evt. affaldssække. Morten undersøger muligheden for at omdele hængere med besked om ny tømmedato på fredage i lige uger. Venlig hilsen Michael Beltrão Sørensen",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-21T08:47:00+00:00",
          "updated_at": "2025-08-19T00:25:00.633559+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzU=",
            "location": {
              "latitude": 55.52284,
              "longitude": 9.645812,
              "name": "Gavnøvænget 11, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTk0Mg==",
          "ticket_id": "20585942",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/02 2023 Besked: Kontaktoplysninger:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-25T14:29:00+00:00",
          "updated_at": "2025-08-19T00:25:00.650556+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzU=",
            "location": {
              "latitude": 55.52284,
              "longitude": 9.645812,
              "name": "Gavnøvænget 11, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTk0OQ==",
          "ticket_id": "20585949",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/02 2023 Besked: Kontaktoplysninger:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-25T12:49:00+00:00",
          "updated_at": "2025-08-19T00:25:00.651242+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzU=",
            "location": {
              "latitude": 55.52284,
              "longitude": 9.645812,
              "name": "Gavnøvænget 11, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3MzY=",
      "location": {
        "name": "Gavnøvænget 15 7000 Fredericia",
        "latitude": 55.52295551,
        "longitude": 9.64612135
      },
      "containers": [
        {
          "id": "mp-pc-8",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-8",
            "container_id": "MP-7002-7",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDkxMzEyMA==",
          "ticket_id": "10913120",
          "ticket_type": "Affaldet skal afleveres på genbrugspladsen",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2025-02-07T09:07:51.182152+00:00",
          "updated_at": "2025-02-07T09:07:51.184023+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzY=",
            "location": {
              "latitude": 55.522955,
              "longitude": 9.646121,
              "name": "Gavnøvænget 15, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "lbl319_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDc1MA==",
          "ticket_id": "20584750",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Hej Fredericia kommune Jeg sendte i går en besked ind at vi ikke havde fået tømt genbrug. Fik svar tilbage at det næste gang var 2/6, men det passer ikke med det papir vi har fået tilsendt. Der skulle vi have haft tømt tirsdag 16/5 og igen 15/6. I skal nok lige kigge ind i det vi har fået tilsendt passer overens med jeres system, også lade vær med at lukke en sag, så man ikke kan svare direkte tilbage. Derfor jeg åbner en ny sag. Jeg sender et billede af vores tømmekalender, som vi har får tilse",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-18T17:32:00+00:00",
          "updated_at": "2025-08-19T00:25:00.579528+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzY=",
            "location": {
              "latitude": 55.522955,
              "longitude": 9.646121,
              "name": "Gavnøvænget 15, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDc2Ng==",
          "ticket_id": "20584766",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Hej Fredericia kommune Vi har ikke fået tømt genbrug i går, som ellers står i planen",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-17T06:14:00+00:00",
          "updated_at": "2025-08-19T00:25:00.580297+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzY=",
            "location": {
              "latitude": 55.522955,
              "longitude": 9.646121,
              "name": "Gavnøvænget 15, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTI2OA==",
          "ticket_id": "20585268",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-15T15:53:00+00:00",
          "updated_at": "2025-08-19T00:25:00.607236+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzY=",
            "location": {
              "latitude": 55.522955,
              "longitude": 9.646121,
              "name": "Gavnøvænget 15, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTY5NQ==",
          "ticket_id": "20585695",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Forkert registrering af tømmedag --- Kommunemail sendt Marius Pedersen Efter aftale med Morten Holm bestiller vi ekstra tømninger på Gavnøvænget nr. 3 7 11 15 27 34 og 46 Dvs. ekstra tømning af 7 beholdere inkl. evt. affaldssække. Morten undersøger muligheden for at omdele hængere med besked om ny tømmedato på fredage i lige uger. Venlig hilsen Michael Beltrão Sørensen",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-21T08:48:00+00:00",
          "updated_at": "2025-08-19T00:25:00.633511+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzY=",
            "location": {
              "latitude": 55.522955,
              "longitude": 9.646121,
              "name": "Gavnøvænget 15, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTcwMQ==",
          "ticket_id": "20585701",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-17T16:16:00+00:00",
          "updated_at": "2025-08-19T00:25:00.633805+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzY=",
            "location": {
              "latitude": 55.522955,
              "longitude": 9.646121,
              "name": "Gavnøvænget 15, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTk0MQ==",
          "ticket_id": "20585941",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/02 2023 Besked: Kontaktoplysninger:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-25T14:30:00+00:00",
          "updated_at": "2025-08-19T00:25:00.650459+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzY=",
            "location": {
              "latitude": 55.522955,
              "longitude": 9.646121,
              "name": "Gavnøvænget 15, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTk0OA==",
          "ticket_id": "20585948",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/02 2023 Besked: Kontaktoplysninger:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-25T12:51:00+00:00",
          "updated_at": "2025-08-19T00:25:00.651146+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzY=",
            "location": {
              "latitude": 55.522955,
              "longitude": 9.646121,
              "name": "Gavnøvænget 15, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3Mzg=",
      "location": {
        "name": "Gavnøvænget 34 7000 Fredericia",
        "latitude": 55.52322998,
        "longitude": 9.6458808
      },
      "containers": [
        {
          "id": "mp-pc-9",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-9",
            "container_id": "MP-7002-8",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTY5MQ==",
          "ticket_id": "20585691",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Mail henvendelse den 20.02. med mailsvar den 21.02: ---- Kære Annemette Kjær Tak for din henvendelse. Jeg kan ikke umiddelbart se, at vi har modtaget din besked via vores app - og så havde vi i Fredericia Kommune ovenikøbet store telefonproblemer i går. Så det har ikke været nemt for dig, at kontakte os. Jeg har nu fundet ud af, at det drejer sig om den nye bolig nr. 34 på Gavnøvænget. Vores renovatøren havde desværre fejlregistreret tømmedagen, hvilket resulterede i manglende tømning i fredags.",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-21T09:27:00+00:00",
          "updated_at": "2025-08-19T00:25:00.633315+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3Mzg=",
            "location": {
              "latitude": 55.523229,
              "longitude": 9.64588,
              "name": "Gavnøvænget 34, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTY5Mw==",
          "ticket_id": "20585693",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Forkert registrering af tømmedag --- Kommunemail sendt Marius Pedersen Efter aftale med Morten Holm bestiller vi ekstra tømninger på Gavnøvænget nr. 3 7 11 15 27 34 og 46 Dvs. ekstra tømning af 7 beholdere inkl. evt. affaldssække. Morten undersøger muligheden for at omdele hængere med besked om ny tømmedato på fredage i lige uger. Venlig hilsen Michael Beltrão Sørensen",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-21T08:49:00+00:00",
          "updated_at": "2025-08-19T00:25:00.633415+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3Mzg=",
            "location": {
              "latitude": 55.523229,
              "longitude": 9.64588,
              "name": "Gavnøvænget 34, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTk0MA==",
          "ticket_id": "20585940",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/02 2023 Besked: Kontaktoplysninger:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-25T14:31:00+00:00",
          "updated_at": "2025-08-19T00:25:00.650362+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3Mzg=",
            "location": {
              "latitude": 55.523229,
              "longitude": 9.64588,
              "name": "Gavnøvænget 34, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTk0Nw==",
          "ticket_id": "20585947",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/02 2023 Besked: Kontaktoplysninger:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-25T12:53:00+00:00",
          "updated_at": "2025-08-19T00:25:00.651050+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3Mzg=",
            "location": {
              "latitude": 55.523229,
              "longitude": 9.64588,
              "name": "Gavnøvænget 34, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3Mzk=",
      "location": {
        "name": "Gavnøvænget 46 7000 Fredericia",
        "latitude": 55.52335044,
        "longitude": 9.64398785
      },
      "containers": [
        {
          "id": "mp-pc-10",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-10",
            "container_id": "MP-7002-9",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYxMA==",
          "ticket_id": "20585610",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Hej Beklager ar skulle bruge jeres tid igen, men beholder til rest affald er fortsat ikke hentet. Det er ved at stresse mig det her. Beholderen er placeret ved vejen og håndtag vender korrekt. Mvh Zenja",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-23T13:44:00+00:00",
          "updated_at": "2025-08-19T00:25:00.627898+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3Mzk=",
            "location": {
              "latitude": 55.52335,
              "longitude": 9.643987,
              "name": "Gavnøvænget 46, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTY5Mg==",
          "ticket_id": "20585692",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Forkert registrering af tømmedag --- Kommunemail sendt Marius Pedersen Efter aftale med Morten Holm bestiller vi ekstra tømninger på Gavnøvænget nr. 3 7 11 15 27 34 og 46 Dvs. ekstra tømning af 7 beholdere inkl. evt. affaldssække. Morten undersøger muligheden for at omdele hængere med besked om ny tømmedato på fredage i lige uger. Venlig hilsen Michael Beltrão Sørensen",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-21T08:50:00+00:00",
          "updated_at": "2025-08-19T00:25:00.633364+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3Mzk=",
            "location": {
              "latitude": 55.52335,
              "longitude": 9.643987,
              "name": "Gavnøvænget 46, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTY5OQ==",
          "ticket_id": "20585699",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Jeg er flyttet hertil 1. Februar og har tilmeldt mig affaldsordning, men det er ikke afhentet, har ikke mere plads i beholderen. Skulle være hentet i fredags, men de kom ikke. Vil i se på det? Tak Mvh Zenja",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-18T10:17:00+00:00",
          "updated_at": "2025-08-19T00:25:00.633706+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3Mzk=",
            "location": {
              "latitude": 55.52335,
              "longitude": 9.643987,
              "name": "Gavnøvænget 46, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTkzOQ==",
          "ticket_id": "20585939",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/02 2023 Besked: Kontaktoplysninger:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-25T14:31:00+00:00",
          "updated_at": "2025-08-19T00:25:00.650264+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3Mzk=",
            "location": {
              "latitude": 55.52335,
              "longitude": 9.643987,
              "name": "Gavnøvænget 46, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTk0Ng==",
          "ticket_id": "20585946",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/02 2023 Besked: Kontaktoplysninger:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-25T12:55:00+00:00",
          "updated_at": "2025-08-19T00:25:00.650950+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3Mzk=",
            "location": {
              "latitude": 55.52335,
              "longitude": 9.643987,
              "name": "Gavnøvænget 46, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3MzI=",
      "location": {
        "name": "Gavnøvænget 27 7000 Fredericia",
        "latitude": 55.52330161,
        "longitude": 9.64704732
      },
      "containers": [
        {
          "id": "mp-pc-11",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-11",
            "container_id": "MP-7002-10",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTY5NA==",
          "ticket_id": "20585694",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Forkert registrering af tømmedag --- Kommunemail sendt Marius Pedersen Efter aftale med Morten Holm bestiller vi ekstra tømninger på Gavnøvænget nr. 3 7 11 15 27 34 og 46 Dvs. ekstra tømning af 7 beholdere inkl. evt. affaldssække. Morten undersøger muligheden for at omdele hængere med besked om ny tømmedato på fredage i lige uger. Venlig hilsen Michael Beltrão Sørensen",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-21T08:48:00+00:00",
          "updated_at": "2025-08-19T00:25:00.633463+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzI=",
            "location": {
              "latitude": 55.523301,
              "longitude": 9.647047,
              "name": "Gavnøvænget 27, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTcwMA==",
          "ticket_id": "20585700",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Er lige flyttet ind pr. 1/2, var ikke klar over jeg skulle tilmeldes. Vil gerne have beholder tømt fremover.",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-18T10:28:00+00:00",
          "updated_at": "2025-08-19T00:25:00.633755+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzI=",
            "location": {
              "latitude": 55.523301,
              "longitude": 9.647047,
              "name": "Gavnøvænget 27, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTg4NA==",
          "ticket_id": "20585884",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 07/02 2023 Besked: Kontaktoplysninger:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-31T09:17:00+00:00",
          "updated_at": "2025-08-19T00:25:00.643862+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzI=",
            "location": {
              "latitude": 55.523301,
              "longitude": 9.647047,
              "name": "Gavnøvænget 27, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTg4NQ==",
          "ticket_id": "20585885",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 07/02 2023 Besked: Kontaktoplysninger:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-31T09:16:00+00:00",
          "updated_at": "2025-08-19T00:25:00.643915+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzI=",
            "location": {
              "latitude": 55.523301,
              "longitude": 9.647047,
              "name": "Gavnøvænget 27, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4MTU=",
      "location": {
        "name": "Omøvænget 42 7000 Fredericia",
        "latitude": 55.52156794,
        "longitude": 9.6458776
      },
      "containers": [
        {
          "id": "mp-pc-12",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-12",
            "container_id": "MP-7002-11",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTE1Nw==",
          "ticket_id": "20585157",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 28/03-2023 Besked: Kontaktoplysninger: Carsten Rasmussen",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-28T12:16:00+00:00",
          "updated_at": "2025-08-19T00:25:00.600810+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MTU=",
            "location": {
              "latitude": 55.521567,
              "longitude": 9.645877,
              "name": "Omøvænget 42, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTE1Ng==",
          "ticket_id": "20585156",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 28/03-2023 Besked: Kontaktoplysninger: Carsten Rasmussen",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-28T12:16:00+00:00",
          "updated_at": "2025-08-19T00:25:00.600754+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MTU=",
            "location": {
              "latitude": 55.521567,
              "longitude": 9.645877,
              "name": "Omøvænget 42, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTczMjc=",
      "location": {
        "name": "Dybsøhaven 21 7000 Fredericia",
        "latitude": 55.52177502,
        "longitude": 9.64129219
      },
      "containers": [
        {
          "id": "mp-pc-13",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-13",
            "container_id": "MP-7002-12",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MTEwOQ==",
          "ticket_id": "20581109",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Hej. I har ikke været på adressen siden den 2. februar og tømme. Der rykkes nu for tømning. I januar via en tidligere sag, fik vi rettet korrekt tømmedag til. Vil I tømme hurtigst muligt og overholde tømningen fredag i ulige uger fremover?",
          "status": 6,
          "priority": 2,
          "created_at": "2024-04-12T07:57:00+00:00",
          "updated_at": "2025-08-19T00:25:00.357096+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczMjc=",
            "location": {
              "latitude": 55.521775,
              "longitude": 9.641292,
              "name": "Dybsøhaven 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MTkzNA==",
          "ticket_id": "20581934",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Der er tømning fredag lige uger på adressen. I har ikke været der i fredags. Vil I tømme hurtigst muligt?",
          "status": 6,
          "priority": 2,
          "created_at": "2024-01-31T12:32:00+00:00",
          "updated_at": "2025-08-19T00:25:00.408650+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczMjc=",
            "location": {
              "latitude": 55.521775,
              "longitude": 9.641292,
              "name": "Dybsøhaven 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MDY1Ng==",
          "ticket_id": "20590656",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 770 l rest - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 22/02-2022 Besked: Kontaktoplysninger: Hjembo Skærbæk ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2022-02-22T14:02:00+00:00",
          "updated_at": "2025-08-19T00:25:01.080870+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczMjc=",
            "location": {
              "latitude": 55.521775,
              "longitude": 9.641292,
              "name": "Dybsøhaven 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3MjA=",
      "location": {
        "name": "Omøvænget 12 7000 Fredericia",
        "latitude": 55.52016584,
        "longitude": 9.64671794
      },
      "containers": [
        {
          "id": "mp-pc-14",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-14",
            "container_id": "MP-7002-13",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3OTczNw==",
          "ticket_id": "20579737",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 17/07 2024 Besked: Kontaktoplysninger: Johnny Rodam 20163060 johnny.rodam@hotmail.com",
          "status": 6,
          "priority": 2,
          "created_at": "2024-07-10T13:58:00+00:00",
          "updated_at": "2025-08-19T00:25:00.270603+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MjA=",
            "location": {
              "latitude": 55.520165,
              "longitude": 9.646717,
              "name": "Omøvænget 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDQ5Nw==",
          "ticket_id": "20580497",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/07-2024 Besked: Bestilt af Birgitte, tlf. 61341019. Kontaktoplysninger: Birgitte Svinth",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-03T14:23:00+00:00",
          "updated_at": "2025-08-19T00:25:00.318600+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MjA=",
            "location": {
              "latitude": 55.520165,
              "longitude": 9.646717,
              "name": "Omøvænget 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3MDY=",
      "location": {
        "name": "Omøvænget 22 7000 Fredericia",
        "latitude": 55.52072851,
        "longitude": 9.64800294
      },
      "containers": [
        {
          "id": "mp-pc-15",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-15",
            "container_id": "MP-7002-14",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NzMxNA==",
          "ticket_id": "20587314",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Omøvænget 22 (7000 Fredericia) ContainerNr:436511 ContainerBrik: Beholder revnet Ønsket virkningsdato: 11/10-2022 Besked: Kontaktoplysninger: Mette Marie Sørensen",
          "status": 6,
          "priority": 2,
          "created_at": "2022-10-06T12:41:00+00:00",
          "updated_at": "2025-08-19T00:25:00.782454+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MDY=",
            "location": {
              "latitude": 55.520728,
              "longitude": 9.648002,
              "name": "Omøvænget 22, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NzQzNQ==",
          "ticket_id": "20587435",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 27/09-2022 Besked: Kontaktoplysninger: Mette Marie Sørensen",
          "status": 6,
          "priority": 2,
          "created_at": "2022-09-26T08:47:00+00:00",
          "updated_at": "2025-08-19T00:25:00.797844+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MDY=",
            "location": {
              "latitude": 55.520728,
              "longitude": 9.648002,
              "name": "Omøvænget 22, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NzQzNA==",
          "ticket_id": "20587434",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 27/09-2022 Besked: Kontaktoplysninger: Mette Marie Sørensen",
          "status": 6,
          "priority": 2,
          "created_at": "2022-09-26T08:47:00+00:00",
          "updated_at": "2025-08-19T00:25:00.797744+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MDY=",
            "location": {
              "latitude": 55.520728,
              "longitude": 9.648002,
              "name": "Omøvænget 22, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3MTY=",
      "location": {
        "name": "Omøvænget 10 7000 Fredericia",
        "latitude": 55.52020318,
        "longitude": 9.64631794
      },
      "containers": [
        {
          "id": "mp-pc-16",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-16",
            "container_id": "MP-7002-15",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NzEzMw==",
          "ticket_id": "20587133",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 31/10-2022 Besked: Kontaktoplysninger: Thomas Jelling Pedersen",
          "status": 6,
          "priority": 2,
          "created_at": "2022-10-31T09:21:00+00:00",
          "updated_at": "2025-08-19T00:25:00.761274+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MTY=",
            "location": {
              "latitude": 55.520241,
              "longitude": 9.646274,
              "name": "Omøvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NzEzMg==",
          "ticket_id": "20587132",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 31/10-2022 Besked: Kontaktoplysninger: Thomas Jelling Pedersen",
          "status": 6,
          "priority": 2,
          "created_at": "2022-10-31T09:21:00+00:00",
          "updated_at": "2025-08-19T00:25:00.761221+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MTY=",
            "location": {
              "latitude": 55.520241,
              "longitude": 9.646274,
              "name": "Omøvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3MzM=",
      "location": {
        "name": "Gavnøvænget 3 7000 Fredericia",
        "latitude": 55.5226094,
        "longitude": 9.64519539
      },
      "containers": [
        {
          "id": "mp-pc-17",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-17",
            "container_id": "MP-7002-16",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTAwNQ==",
          "ticket_id": "20585005",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Tlf. 42326623. Borger kontakter os og gør opmærksom på, at han kørte sin beholder ud, da bilen kørte op af vejen. En anden borger derude gjorde det samme - hun fik tømt, men ikke nr. 3. Bilen kørte forbi efterfølgende, men tømte ikke. Der er registreret i loggen, at der er tømt. Vil I sende en bil forbi og tømme?",
          "status": 6,
          "priority": 2,
          "created_at": "2023-04-14T10:43:00+00:00",
          "updated_at": "2025-08-19T00:25:00.592596+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzM=",
            "location": {
              "latitude": 55.522609,
              "longitude": 9.645195,
              "name": "Gavnøvænget 3, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTY5OA==",
          "ticket_id": "20585698",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Forkert registrering af tømmedag --- Kommunemail sendt Marius Pedersen Efter aftale med Morten Holm bestiller vi ekstra tømninger på Gavnøvænget nr. 3  7  11  15  27  34 og 46 Dvs. ekstra tømning af 7 beholdere inkl. evt. affaldssække. Morten undersøger muligheden for at omdele hængere med besked om ny tømmedato på fredage i lige uger. Venlig hilsen Michael Beltrão Sørensen",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-21T08:45:00+00:00",
          "updated_at": "2025-08-19T00:25:00.633656+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzM=",
            "location": {
              "latitude": 55.522609,
              "longitude": 9.645195,
              "name": "Gavnøvænget 3, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTk0NA==",
          "ticket_id": "20585944",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/02 2023 Besked: Kontaktoplysninger:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-25T14:15:00+00:00",
          "updated_at": "2025-08-19T00:25:00.650748+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzM=",
            "location": {
              "latitude": 55.522609,
              "longitude": 9.645195,
              "name": "Gavnøvænget 3, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTk1MQ==",
          "ticket_id": "20585951",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/02 2023 Besked: Kontaktoplysninger:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-25T12:44:00+00:00",
          "updated_at": "2025-08-19T00:25:00.651434+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzM=",
            "location": {
              "latitude": 55.522609,
              "longitude": 9.645195,
              "name": "Gavnøvænget 3, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3NDA=",
      "location": {
        "name": "Gavnøvænget 52 7000 Fredericia",
        "latitude": 55.52357674,
        "longitude": 9.64444526
      },
      "containers": [
        {
          "id": "mp-pc-18",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-18",
            "container_id": "MP-7002-17",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYxNg==",
          "ticket_id": "20585616",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T10:20:00+00:00",
          "updated_at": "2025-08-19T00:25:00.628189+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDA=",
            "location": {
              "latitude": 55.523576,
              "longitude": 9.644445,
              "name": "Gavnøvænget 52, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYxNw==",
          "ticket_id": "20585617",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T10:19:00+00:00",
          "updated_at": "2025-08-19T00:25:00.628235+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDA=",
            "location": {
              "latitude": 55.523576,
              "longitude": 9.644445,
              "name": "Gavnøvænget 52, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTgyNw==",
          "ticket_id": "20585827",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: 2-delt 240 l beholder - Lejlighed Gavnøvænget 52 (7000 Fredericia) ContainerNr:437032 ContainerBrik: Ønsket virkningsdato: 13/02 2023 Besked: Afmeldes da den er fejloprettet. Kontaktoplysninger:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-06T09:21:00+00:00",
          "updated_at": "2025-08-19T00:25:00.640850+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDA=",
            "location": {
              "latitude": 55.523576,
              "longitude": 9.644445,
              "name": "Gavnøvænget 52, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTgyNg==",
          "ticket_id": "20585826",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: Genbrug Lejlighed Gavnøvænget 52 (7000 Fredericia) ContainerNr:437039 ContainerBrik: Ønsket virkningsdato: 13/02 2023 Besked: Afmeldes da den er fejloprettet. Kontaktoplysninger:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-06T09:21:00+00:00",
          "updated_at": "2025-08-19T00:25:00.640799+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDA=",
            "location": {
              "latitude": 55.523576,
              "longitude": 9.644445,
              "name": "Gavnøvænget 52, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTkzOA==",
          "ticket_id": "20585938",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/02 2023 Besked: Kontaktoplysninger:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-25T14:32:00+00:00",
          "updated_at": "2025-08-19T00:25:00.650165+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDA=",
            "location": {
              "latitude": 55.523576,
              "longitude": 9.644445,
              "name": "Gavnøvænget 52, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTk0NQ==",
          "ticket_id": "20585945",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/02 2023 Besked: Kontaktoplysninger:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-25T12:57:00+00:00",
          "updated_at": "2025-08-19T00:25:00.650844+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDA=",
            "location": {
              "latitude": 55.523576,
              "longitude": 9.644445,
              "name": "Gavnøvænget 52, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3NDM=",
      "location": {
        "name": "Gavnøvænget 1 7000 Fredericia",
        "latitude": 55.52256467,
        "longitude": 9.64508822
      },
      "containers": [
        {
          "id": "mp-pc-19",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-19",
            "container_id": "MP-7002-18",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NTY0Ng==",
          "ticket_id": "20575646",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "Navn: Lise-Lotte Jacobsen Tlf.: 22639285Email: mufufugris@hotmail.dkBesked: Vil det være muligt at få en større beholder til restaffald eller en mere?",
          "status": 6,
          "priority": 2,
          "created_at": "2025-05-19T18:11:00+00:00",
          "updated_at": "2025-08-19T00:24:59.956011+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDM=",
            "location": {
              "latitude": 55.522564,
              "longitude": 9.645088,
              "name": "Gavnøvænget 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3NTc3MA==",
          "ticket_id": "20575770",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Fejlsorteret Er der afleveret flyer: Ja Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2025-05-09T10:52:00+00:00",
          "updated_at": "2025-08-19T00:24:59.969480+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDM=",
            "location": {
              "latitude": 55.522564,
              "longitude": 9.645088,
              "name": "Gavnøvænget 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTM1Mg==",
          "ticket_id": "20585352",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 2-delt 240 l beholder - Parcel Gavnøvænget 1 (7000 Fredericia) ContainerNr:437091 ContainerBrik:0040000012675875 Beholder der ønskes i stedet: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Gebyr: 0 kr Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-10T12:40:00+00:00",
          "updated_at": "2025-08-19T00:25:00.612460+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDM=",
            "location": {
              "latitude": 55.522564,
              "longitude": 9.645088,
              "name": "Gavnøvænget 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTY0MA==",
          "ticket_id": "20585640",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T09:54:00+00:00",
          "updated_at": "2025-08-19T00:25:00.630712+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDM=",
            "location": {
              "latitude": 55.522564,
              "longitude": 9.645088,
              "name": "Gavnøvænget 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYzOQ==",
          "ticket_id": "20585639",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T09:54:00+00:00",
          "updated_at": "2025-08-19T00:25:00.630492+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDM=",
            "location": {
              "latitude": 55.522564,
              "longitude": 9.645088,
              "name": "Gavnøvænget 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3NDQ=",
      "location": {
        "name": "Gavnøvænget 9 7000 Fredericia",
        "latitude": 55.52278245,
        "longitude": 9.64565837
      },
      "containers": [
        {
          "id": "mp-pc-20",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-20",
            "container_id": "MP-7002-19",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTM1MQ==",
          "ticket_id": "20585351",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 2-delt 240 l beholder - Parcel Gavnøvænget 9 (7000 Fredericia) ContainerNr:437093 ContainerBrik:00400000126BD704 Beholder der ønskes i stedet: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Gebyr: 0 kr Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-10T12:42:00+00:00",
          "updated_at": "2025-08-19T00:25:00.612392+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDQ=",
            "location": {
              "latitude": 55.522782,
              "longitude": 9.645658,
              "name": "Gavnøvænget 9, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYzNw==",
          "ticket_id": "20585637",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T09:59:00+00:00",
          "updated_at": "2025-08-19T00:25:00.629995+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDQ=",
            "location": {
              "latitude": 55.522782,
              "longitude": 9.645658,
              "name": "Gavnøvænget 9, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYzOA==",
          "ticket_id": "20585638",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T09:58:00+00:00",
          "updated_at": "2025-08-19T00:25:00.630261+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDQ=",
            "location": {
              "latitude": 55.522782,
              "longitude": 9.645658,
              "name": "Gavnøvænget 9, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3NDU=",
      "location": {
        "name": "Gavnøvænget 13 7000 Fredericia",
        "latitude": 55.52289782,
        "longitude": 9.64596702
      },
      "containers": [
        {
          "id": "mp-pc-21",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-21",
            "container_id": "MP-7002-20",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3ODg2MA==",
          "ticket_id": "20578860",
          "ticket_type": "AO-Generel besked - Lejlighed",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2024-08-21T10:46:00+00:00",
          "updated_at": "2025-08-19T00:25:00.220926+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDU=",
            "location": {
              "latitude": 55.522897,
              "longitude": 9.645967,
              "name": "Gavnøvænget 13, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3ODg2OA==",
          "ticket_id": "20578868",
          "ticket_type": "AO-Generel besked",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2024-08-20T18:11:00+00:00",
          "updated_at": "2025-08-19T00:25:00.221340+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDU=",
            "location": {
              "latitude": 55.522897,
              "longitude": 9.645967,
              "name": "Gavnøvænget 13, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTM1MA==",
          "ticket_id": "20585350",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 2-delt 240 l beholder - Parcel Gavnøvænget 13 (7000 Fredericia) ContainerNr:437095 ContainerBrik:00400000126BB05F Beholder der ønskes i stedet: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Gebyr: 0 kr Ønsket virkningsdato: 17/03 2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-10T12:43:00+00:00",
          "updated_at": "2025-08-19T00:25:00.612336+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDU=",
            "location": {
              "latitude": 55.522897,
              "longitude": 9.645967,
              "name": "Gavnøvænget 13, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYzNg==",
          "ticket_id": "20585636",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T10:00:00+00:00",
          "updated_at": "2025-08-19T00:25:00.629767+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDU=",
            "location": {
              "latitude": 55.522897,
              "longitude": 9.645967,
              "name": "Gavnøvænget 13, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYzNQ==",
          "ticket_id": "20585635",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T10:00:00+00:00",
          "updated_at": "2025-08-19T00:25:00.629459+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDU=",
            "location": {
              "latitude": 55.522897,
              "longitude": 9.645967,
              "name": "Gavnøvænget 13, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3NDc=",
      "location": {
        "name": "Gavnøvænget 20 7000 Fredericia",
        "latitude": 55.52282034,
        "longitude": 9.64479525
      },
      "containers": [
        {
          "id": "mp-pc-22",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-22",
            "container_id": "MP-7002-21",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMzkwMDE5NQ==",
          "ticket_id": "13900195",
          "ticket_type": "Affaldet skal sorteres som restaffald",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2025-04-04T08:08:24.635836+00:00",
          "updated_at": "2025-04-04T08:08:24.637053+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDc=",
            "location": {
              "latitude": 55.52282,
              "longitude": 9.644795,
              "name": "Gavnøvænget 20, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "lbl0030_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTM0OQ==",
          "ticket_id": "20585349",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 2-delt 240 l beholder - Parcel Gavnøvænget 20 (7000 Fredericia) ContainerNr:437097 ContainerBrik:00400000126BDAD6 Beholder der ønskes i stedet: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Gebyr: 0 kr Ønsket virkningsdato: 17/03 2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-10T12:44:00+00:00",
          "updated_at": "2025-08-19T00:25:00.612280+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDc=",
            "location": {
              "latitude": 55.52282,
              "longitude": 9.644795,
              "name": "Gavnøvænget 20, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYzNA==",
          "ticket_id": "20585634",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T10:02:00+00:00",
          "updated_at": "2025-08-19T00:25:00.629009+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDc=",
            "location": {
              "latitude": 55.52282,
              "longitude": 9.644795,
              "name": "Gavnøvænget 20, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYzMw==",
          "ticket_id": "20585633",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T10:02:00+00:00",
          "updated_at": "2025-08-19T00:25:00.628962+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDc=",
            "location": {
              "latitude": 55.52282,
              "longitude": 9.644795,
              "name": "Gavnøvænget 20, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3NDg=",
      "location": {
        "name": "Gavnøvænget 22 7000 Fredericia",
        "latitude": 55.52287886,
        "longitude": 9.64495033
      },
      "containers": [
        {
          "id": "mp-pc-23",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-23",
            "container_id": "MP-7002-22",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NDgwMg==",
          "ticket_id": "20584802",
          "ticket_type": "AO-Generel besked",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-10T16:30:00+00:00",
          "updated_at": "2025-08-19T00:25:00.581974+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDg=",
            "location": {
              "latitude": 55.522878,
              "longitude": 9.64495,
              "name": "Gavnøvænget 22, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTM0OA==",
          "ticket_id": "20585348",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 2-delt 240 l beholder - Parcel Gavnøvænget 22 (7000 Fredericia) ContainerNr:437099 ContainerBrik:00400000126BD8A7 Beholder der ønskes i stedet: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Gebyr: 0 kr Ønsket virkningsdato: 17/03 2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-10T12:45:00+00:00",
          "updated_at": "2025-08-19T00:25:00.612224+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDg=",
            "location": {
              "latitude": 55.522878,
              "longitude": 9.64495,
              "name": "Gavnøvænget 22, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYzMg==",
          "ticket_id": "20585632",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T10:03:00+00:00",
          "updated_at": "2025-08-19T00:25:00.628917+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDg=",
            "location": {
              "latitude": 55.522878,
              "longitude": 9.64495,
              "name": "Gavnøvænget 22, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYzMQ==",
          "ticket_id": "20585631",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T10:03:00+00:00",
          "updated_at": "2025-08-19T00:25:00.628872+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDg=",
            "location": {
              "latitude": 55.522878,
              "longitude": 9.64495,
              "name": "Gavnøvænget 22, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3NDY=",
      "location": {
        "name": "Gavnøvænget 25 7000 Fredericia",
        "latitude": 55.52324393,
        "longitude": 9.64689299
      },
      "containers": [
        {
          "id": "mp-pc-24",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-24",
            "container_id": "MP-7002-23",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NTA3OQ==",
          "ticket_id": "20575079",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Fejlsorteret Er der afleveret flyer: Ja Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2025-06-20T10:41:00+00:00",
          "updated_at": "2025-08-19T00:24:59.888207+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDY=",
            "location": {
              "latitude": 55.523243,
              "longitude": 9.646892,
              "name": "Gavnøvænget 25, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTM0Nw==",
          "ticket_id": "20585347",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 2-delt 240 l beholder - Parcel Gavnøvænget 25 (7000 Fredericia) ContainerNr:437103 ContainerBrik:00400000126BB5E8 Beholder der ønskes i stedet: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Gebyr: 0 kr Ønsket virkningsdato: 17/03 2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-10T12:46:00+00:00",
          "updated_at": "2025-08-19T00:25:00.612168+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDY=",
            "location": {
              "latitude": 55.523243,
              "longitude": 9.646892,
              "name": "Gavnøvænget 25, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYyOA==",
          "ticket_id": "20585628",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T10:06:00+00:00",
          "updated_at": "2025-08-19T00:25:00.628736+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDY=",
            "location": {
              "latitude": 55.523243,
              "longitude": 9.646892,
              "name": "Gavnøvænget 25, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYyNw==",
          "ticket_id": "20585627",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T10:06:00+00:00",
          "updated_at": "2025-08-19T00:25:00.628689+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDY=",
            "location": {
              "latitude": 55.523243,
              "longitude": 9.646892,
              "name": "Gavnøvænget 25, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3NDk=",
      "location": {
        "name": "Gavnøvænget 26 7000 Fredericia",
        "latitude": 55.5229959,
        "longitude": 9.64526048
      },
      "containers": [
        {
          "id": "mp-pc-25",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-25",
            "container_id": "MP-7002-24",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDkxMzA2Nw==",
          "ticket_id": "10913067",
          "ticket_type": "Affaldet skal afleveres på genbrugspladsen",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2025-02-07T08:48:04.313505+00:00",
          "updated_at": "2025-02-07T08:48:04.314490+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDk=",
            "location": {
              "latitude": 55.522995,
              "longitude": 9.64526,
              "name": "Gavnøvænget 26, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "lbl0034_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTM0Ng==",
          "ticket_id": "20585346",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 2-delt 240 l beholder - Parcel Gavnøvænget 26 (7000 Fredericia) ContainerNr:437101 ContainerBrik:0040000012673139 Beholder der ønskes i stedet: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Gebyr: 0 kr Ønsket virkningsdato: 17/03 2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-10T12:46:00+00:00",
          "updated_at": "2025-08-19T00:25:00.612112+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDk=",
            "location": {
              "latitude": 55.522995,
              "longitude": 9.64526,
              "name": "Gavnøvænget 26, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYyOQ==",
          "ticket_id": "20585629",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 15/02-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T10:05:00+00:00",
          "updated_at": "2025-08-19T00:25:00.628781+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDk=",
            "location": {
              "latitude": 55.522995,
              "longitude": 9.64526,
              "name": "Gavnøvænget 26, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYzMA==",
          "ticket_id": "20585630",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T10:04:00+00:00",
          "updated_at": "2025-08-19T00:25:00.628826+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDk=",
            "location": {
              "latitude": 55.522995,
              "longitude": 9.64526,
              "name": "Gavnøvænget 26, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4MTI=",
      "location": {
        "name": "Gavnøvænget 37 7000 Fredericia",
        "latitude": 55.52324252,
        "longitude": 9.64467555
      },
      "containers": [
        {
          "id": "mp-pc-26",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-26",
            "container_id": "MP-7002-25",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MDM2Nw==",
          "ticket_id": "20580367",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2024-05-24Fraktion: 1 (Mad/Rest)Navn: Camilla Niemann Tlf.: 29914801Email: camilla_erenbjerg@live.dkBesked: Vi glemt at køre den ud????",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-07T11:23:00+00:00",
          "updated_at": "2025-08-19T00:25:00.310909+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MTI=",
            "location": {
              "latitude": 55.523242,
              "longitude": 9.644675,
              "name": "Gavnøvænget 37, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MzMzMQ==",
          "ticket_id": "20583331",
          "ticket_type": "AO-Generel besked",
          "description": "Hej hvad ville det koste at få en stor beholder eller 1 ekstra beholder ?svar gerne tilbage på e-mail camilla_erenbjerg@live.dk eller ring til min mand 31747573",
          "status": 6,
          "priority": 2,
          "created_at": "2023-11-06T19:53:00+00:00",
          "updated_at": "2025-08-19T00:25:00.494223+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MTI=",
            "location": {
              "latitude": 55.523242,
              "longitude": 9.644675,
              "name": "Gavnøvænget 37, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZTo5ODgwODI2",
          "ticket_id": "9880826",
          "ticket_type": "Affaldet skal sorteres som restaffald",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2023-11-03T08:35:45.577747+00:00",
          "updated_at": "2023-11-03T08:35:45.592162+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MTI=",
            "location": {
              "latitude": 55.523242,
              "longitude": 9.644675,
              "name": "Gavnøvænget 37, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "lbl0041_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTM0NQ==",
          "ticket_id": "20585345",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 2-delt 240 l beholder - Parcel Gavnøvænget 37 (7000 Fredericia) ContainerNr:437107 ContainerBrik:00400000126BDA54 Beholder der ønskes i stedet: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Gebyr: 0 kr Ønsket virkningsdato: 17/03 2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-10T12:47:00+00:00",
          "updated_at": "2025-08-19T00:25:00.612056+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MTI=",
            "location": {
              "latitude": 55.523242,
              "longitude": 9.644675,
              "name": "Gavnøvænget 37, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYyMw==",
          "ticket_id": "20585623",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T10:13:00+00:00",
          "updated_at": "2025-08-19T00:25:00.628507+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MTI=",
            "location": {
              "latitude": 55.523242,
              "longitude": 9.644675,
              "name": "Gavnøvænget 37, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYyMg==",
          "ticket_id": "20585622",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T10:13:00+00:00",
          "updated_at": "2025-08-19T00:25:00.628462+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MTI=",
            "location": {
              "latitude": 55.523242,
              "longitude": 9.644675,
              "name": "Gavnøvænget 37, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3NTA=",
      "location": {
        "name": "Gavnøvænget 44 7000 Fredericia",
        "latitude": 55.52352257,
        "longitude": 9.64665621
      },
      "containers": [
        {
          "id": "mp-pc-27",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-27",
            "container_id": "MP-7002-26",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NTc2OQ==",
          "ticket_id": "20575769",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Fejlsorteret Er der afleveret flyer: Ja Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2025-05-09T10:58:00+00:00",
          "updated_at": "2025-08-19T00:24:59.969383+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NTA=",
            "location": {
              "latitude": 55.523522,
              "longitude": 9.646656,
              "name": "Gavnøvænget 44, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTM0NA==",
          "ticket_id": "20585344",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 2-delt 240 l beholder - Parcel Gavnøvænget 44 (7000 Fredericia) ContainerNr:437104 ContainerBrik:0040000012675C5B Beholder der ønskes i stedet: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Gebyr: 0 kr Ønsket virkningsdato: 17/03 2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-10T12:48:00+00:00",
          "updated_at": "2025-08-19T00:25:00.612000+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NTA=",
            "location": {
              "latitude": 55.523522,
              "longitude": 9.646656,
              "name": "Gavnøvænget 44, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYyNA==",
          "ticket_id": "20585624",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T10:11:00+00:00",
          "updated_at": "2025-08-19T00:25:00.628552+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NTA=",
            "location": {
              "latitude": 55.523522,
              "longitude": 9.646656,
              "name": "Gavnøvænget 44, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYyNQ==",
          "ticket_id": "20585625",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T10:10:00+00:00",
          "updated_at": "2025-08-19T00:25:00.628597+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NTA=",
            "location": {
              "latitude": 55.523522,
              "longitude": 9.646656,
              "name": "Gavnøvænget 44, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3NTE=",
      "location": {
        "name": "Gavnøvænget 47 7000 Fredericia",
        "latitude": 55.52358153,
        "longitude": 9.6454512
      },
      "containers": [
        {
          "id": "mp-pc-28",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-28",
            "container_id": "MP-7002-27",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTM0Mw==",
          "ticket_id": "20585343",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 2-delt 240 l beholder - Parcel Gavnøvænget 47 (7000 Fredericia) ContainerNr:437109 ContainerBrik:00400000126BD8F3 Beholder der ønskes i stedet: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Gebyr: 0 kr Ønsket virkningsdato: 17/03 2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-10T12:49:00+00:00",
          "updated_at": "2025-08-19T00:25:00.611944+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NTE=",
            "location": {
              "latitude": 55.523581,
              "longitude": 9.645451,
              "name": "Gavnøvænget 47, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYyMQ==",
          "ticket_id": "20585621",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T10:15:00+00:00",
          "updated_at": "2025-08-19T00:25:00.628417+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NTE=",
            "location": {
              "latitude": 55.523581,
              "longitude": 9.645451,
              "name": "Gavnøvænget 47, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYyMA==",
          "ticket_id": "20585620",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T10:15:00+00:00",
          "updated_at": "2025-08-19T00:25:00.628371+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NTE=",
            "location": {
              "latitude": 55.523581,
              "longitude": 9.645451,
              "name": "Gavnøvænget 47, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3NTI=",
      "location": {
        "name": "Gavnøvænget 48 7000 Fredericia",
        "latitude": 55.52342587,
        "longitude": 9.64414032
      },
      "containers": [
        {
          "id": "mp-pc-29",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-29",
            "container_id": "MP-7002-28",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTM0Mg==",
          "ticket_id": "20585342",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 2-delt 240 l beholder - Parcel Gavnøvænget 48 (7000 Fredericia) ContainerNr:437111 ContainerBrik:00400000126BB0C5 Beholder der ønskes i stedet: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Gebyr: 0 kr Ønsket virkningsdato: 17/03 2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-10T12:49:00+00:00",
          "updated_at": "2025-08-19T00:25:00.611887+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NTI=",
            "location": {
              "latitude": 55.523425,
              "longitude": 9.64414,
              "name": "Gavnøvænget 48, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYxOA==",
          "ticket_id": "20585618",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T10:18:00+00:00",
          "updated_at": "2025-08-19T00:25:00.628280+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NTI=",
            "location": {
              "latitude": 55.523425,
              "longitude": 9.64414,
              "name": "Gavnøvænget 48, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYxOQ==",
          "ticket_id": "20585619",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T10:17:00+00:00",
          "updated_at": "2025-08-19T00:25:00.628326+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NTI=",
            "location": {
              "latitude": 55.523425,
              "longitude": 9.64414,
              "name": "Gavnøvænget 48, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3OTc=",
      "location": {
        "name": "Gavnøvænget 30 7000 Fredericia",
        "latitude": 55.52311294,
        "longitude": 9.64557064
      },
      "containers": [
        {
          "id": "mp-pc-30",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-30",
            "container_id": "MP-7002-29",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3Njc4Ng==",
          "ticket_id": "20576786",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Flemming Lysdal Tlf.: 27632495Email: lysdal.flemming@gmail.comBesked: Er levering af affaldsposer/sække ovre. Jeg har nemlig endnu ikke modtaget nogen. Vh. Flemming Lysdal, Gavnøvænget 30",
          "status": 6,
          "priority": 2,
          "created_at": "2025-02-08T19:21:00+00:00",
          "updated_at": "2025-08-19T00:25:00.083027+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3OTc=",
            "location": {
              "latitude": 55.523112,
              "longitude": 9.64557,
              "name": "Gavnøvænget 30, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTQ3Mg==",
          "ticket_id": "20585472",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 15/03-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-09T10:41:00+00:00",
          "updated_at": "2025-08-19T00:25:00.619951+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3OTc=",
            "location": {
              "latitude": 55.523112,
              "longitude": 9.64557,
              "name": "Gavnøvænget 30, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTQ3Mw==",
          "ticket_id": "20585473",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 15/03-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-09T10:40:00+00:00",
          "updated_at": "2025-08-19T00:25:00.620010+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3OTc=",
            "location": {
              "latitude": 55.523112,
              "longitude": 9.64557,
              "name": "Gavnøvænget 30, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3OTk=",
      "location": {
        "name": "Gavnøvænget 33 7000 Fredericia",
        "latitude": 55.52310691,
        "longitude": 9.64436529
      },
      "containers": [
        {
          "id": "mp-pc-31",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-31",
            "container_id": "MP-7002-30",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTQ3MQ==",
          "ticket_id": "20585471",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 15/03-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-09T10:45:00+00:00",
          "updated_at": "2025-08-19T00:25:00.619894+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3OTk=",
            "location": {
              "latitude": 55.523106,
              "longitude": 9.644365,
              "name": "Gavnøvænget 33, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTQ3MA==",
          "ticket_id": "20585470",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 15/03-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-09T10:45:00+00:00",
          "updated_at": "2025-08-19T00:25:00.619837+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3OTk=",
            "location": {
              "latitude": 55.523106,
              "longitude": 9.644365,
              "name": "Gavnøvænget 33, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3OTY=",
      "location": {
        "name": "Gavnøvænget 23 7000 Fredericia",
        "latitude": 55.52318624,
        "longitude": 9.64673866
      },
      "containers": [
        {
          "id": "mp-pc-32",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-32",
            "container_id": "MP-7002-31",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTQ2OA==",
          "ticket_id": "20585468",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 15/03-2023 Besked: Kontaktoplysninger: Boligkontoret Fredericia",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-09T11:16:00+00:00",
          "updated_at": "2025-08-19T00:25:00.619723+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3OTY=",
            "location": {
              "latitude": 55.523186,
              "longitude": 9.646738,
              "name": "Gavnøvænget 23, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTQ2OQ==",
          "ticket_id": "20585469",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 15/03-2023 Besked: Kontaktoplysninger: Boligkontoret Fredericia",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-09T11:15:00+00:00",
          "updated_at": "2025-08-19T00:25:00.619781+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3OTY=",
            "location": {
              "latitude": 55.523186,
              "longitude": 9.646738,
              "name": "Gavnøvænget 23, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4MDE=",
      "location": {
        "name": "Gavnøvænget 39 7000 Fredericia",
        "latitude": 55.52331032,
        "longitude": 9.64483068
      },
      "containers": [
        {
          "id": "mp-pc-33",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-33",
            "container_id": "MP-7002-32",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTQ2Nw==",
          "ticket_id": "20585467",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 15/03-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-09T11:19:00+00:00",
          "updated_at": "2025-08-19T00:25:00.619666+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDE=",
            "location": {
              "latitude": 55.52331,
              "longitude": 9.64483,
              "name": "Gavnøvænget 39, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTQ2Ng==",
          "ticket_id": "20585466",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 15/03-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-09T11:19:00+00:00",
          "updated_at": "2025-08-19T00:25:00.619607+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDE=",
            "location": {
              "latitude": 55.52331,
              "longitude": 9.64483,
              "name": "Gavnøvænget 39, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4MDI=",
      "location": {
        "name": "Gavnøvænget 43 7000 Fredericia",
        "latitude": 55.52344593,
        "longitude": 9.64514094
      },
      "containers": [
        {
          "id": "mp-pc-34",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-34",
            "container_id": "MP-7002-33",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTQ2NA==",
          "ticket_id": "20585464",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 15/03-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-09T11:24:00+00:00",
          "updated_at": "2025-08-19T00:25:00.619487+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDI=",
            "location": {
              "latitude": 55.523445,
              "longitude": 9.64514,
              "name": "Gavnøvænget 43, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTQ2NQ==",
          "ticket_id": "20585465",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 15/03-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-09T11:23:00+00:00",
          "updated_at": "2025-08-19T00:25:00.619547+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDI=",
            "location": {
              "latitude": 55.523445,
              "longitude": 9.64514,
              "name": "Gavnøvænget 43, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4MDU=",
      "location": {
        "name": "Gavnøvænget 55 7000 Fredericia",
        "latitude": 55.52385274,
        "longitude": 9.64607174
      },
      "containers": [
        {
          "id": "mp-pc-35",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-35",
            "container_id": "MP-7002-34",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NjA5Nw==",
          "ticket_id": "20576097",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Der står 2 sække ved siden af, som ikke er taget med. De er betalt og koderne var sat på et stykke papir, der sidder på beholderen. Hun kunne ikke få dem til at sidde fast på selve poserne. Vil I hente dem, hurtigst muligt?",
          "status": 6,
          "priority": 2,
          "created_at": "2025-04-11T11:26:00+00:00",
          "updated_at": "2025-08-19T00:25:00.006354+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDU=",
            "location": {
              "latitude": 55.523852,
              "longitude": 9.646071,
              "name": "Gavnøvænget 55, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3ODAyOA==",
          "ticket_id": "20578028",
          "ticket_type": "AO-Generel besked",
          "description": "GENBRUGTE KODER EKSTRA SÆK Mail fra Marius Pedersen 27.09.2024 --- Hej Turen melder : Borgeren bruger de samme koder til ekstra sække! Første billede er fra 13.09.24, andet billede er fra idag. Begge gange er der medtaget 4 sække. Hvad gør vi hvis det gentager sig? Skal vi afvise afhentning? Venlig hilsen / Best regards Galina Erichsen Marius Pedersen A/S",
          "status": 6,
          "priority": 2,
          "created_at": "2024-10-30T15:59:00+00:00",
          "updated_at": "2025-08-19T00:25:00.172611+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDU=",
            "location": {
              "latitude": 55.523852,
              "longitude": 9.646071,
              "name": "Gavnøvænget 55, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTQ2Mw==",
          "ticket_id": "20585463",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 15/03-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-09T11:25:00+00:00",
          "updated_at": "2025-08-19T00:25:00.619428+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDU=",
            "location": {
              "latitude": 55.523852,
              "longitude": 9.646071,
              "name": "Gavnøvænget 55, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTQ2Mg==",
          "ticket_id": "20585462",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 15/03-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-09T11:25:00+00:00",
          "updated_at": "2025-08-19T00:25:00.619370+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDU=",
            "location": {
              "latitude": 55.523852,
              "longitude": 9.646071,
              "name": "Gavnøvænget 55, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4MDQ=",
      "location": {
        "name": "Gavnøvænget 50 7000 Fredericia",
        "latitude": 55.52350131,
        "longitude": 9.64429279
      },
      "containers": [
        {
          "id": "mp-pc-36",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-36",
            "container_id": "MP-7002-35",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTQ2MQ==",
          "ticket_id": "20585461",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 15/03-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-09T11:29:00+00:00",
          "updated_at": "2025-08-19T00:25:00.619310+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDQ=",
            "location": {
              "latitude": 55.523501,
              "longitude": 9.644292,
              "name": "Gavnøvænget 50, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTQ2MA==",
          "ticket_id": "20585460",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 15/03-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-09T11:29:00+00:00",
          "updated_at": "2025-08-19T00:25:00.619250+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDQ=",
            "location": {
              "latitude": 55.523501,
              "longitude": 9.644292,
              "name": "Gavnøvænget 50, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4MTg=",
      "location": {
        "name": "Gavnøvænget 28 7000 Fredericia",
        "latitude": 55.52305442,
        "longitude": 9.64541556
      },
      "containers": [
        {
          "id": "mp-pc-37",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-37",
            "container_id": "MP-7002-36",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MDg1OA==",
          "ticket_id": "20580858",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Hej, Vi er flyttet ind for 2 uger siden, og vores beholder er ikke blevet tømt",
          "status": 6,
          "priority": 2,
          "created_at": "2024-05-10T16:28:00+00:00",
          "updated_at": "2025-08-19T00:25:00.341014+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MTg=",
            "location": {
              "latitude": 55.523054,
              "longitude": 9.645415,
              "name": "Gavnøvænget 28, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTAzNw==",
          "ticket_id": "20585037",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 14/04-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-04-12T08:25:00+00:00",
          "updated_at": "2025-08-19T00:25:00.594105+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MTg=",
            "location": {
              "latitude": 55.523054,
              "longitude": 9.645415,
              "name": "Gavnøvænget 28, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTAzNg==",
          "ticket_id": "20585036",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 14/04-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-04-12T08:25:00+00:00",
          "updated_at": "2025-08-19T00:25:00.594058+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MTg=",
            "location": {
              "latitude": 55.523054,
              "longitude": 9.645415,
              "name": "Gavnøvænget 28, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3OTQ=",
      "location": {
        "name": "Gavnøvænget 5 7000 Fredericia",
        "latitude": 55.52266708,
        "longitude": 9.64534972
      },
      "containers": [
        {
          "id": "mp-pc-38",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-38",
            "container_id": "MP-7002-37",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTEyNQ==",
          "ticket_id": "20585125",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 14/04-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-30T14:33:00+00:00",
          "updated_at": "2025-08-19T00:25:00.598847+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3OTQ=",
            "location": {
              "latitude": 55.522667,
              "longitude": 9.645349,
              "name": "Gavnøvænget 5, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTEyNA==",
          "ticket_id": "20585124",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 14/04-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-30T14:33:00+00:00",
          "updated_at": "2025-08-19T00:25:00.598793+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3OTQ=",
            "location": {
              "latitude": 55.522667,
              "longitude": 9.645349,
              "name": "Gavnøvænget 5, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4MTE=",
      "location": {
        "name": "Gavnøvænget 31 7000 Fredericia",
        "latitude": 55.52263657,
        "longitude": 9.64433543
      },
      "containers": [
        {
          "id": "mp-pc-39",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-39",
            "container_id": "MP-7002-38",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NDk1Mw==",
          "ticket_id": "20584953",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Tove Høgedal Tlf.: 26213798Email: tovehoegedal27@outlook.dkBesked: Hej Jeg kan se at tømmekalender i app ikke stemmer med virkelighed. Vi fik tømt fredag d 15 og næste gang er d 28 april. I app står den til 21 april og igen 5 maj. Kan I opdatere app? Hilsen Tove, Gavnøvænget 31",
          "status": 6,
          "priority": 2,
          "created_at": "2023-04-19T20:21:00+00:00",
          "updated_at": "2025-08-19T00:25:00.589656+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MTE=",
            "location": {
              "latitude": 55.522636,
              "longitude": 9.644335,
              "name": "Gavnøvænget 31, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTI4OQ==",
          "ticket_id": "20585289",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 19/03-2023 Besked: Kontaktoplysninger: Tove Høgedal",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-14T10:10:00+00:00",
          "updated_at": "2025-08-19T00:25:00.608786+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MTE=",
            "location": {
              "latitude": 55.522636,
              "longitude": 9.644335,
              "name": "Gavnøvænget 31, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTI5MA==",
          "ticket_id": "20585290",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 19/03-2023 Besked: Bestilt af borger. Kontaktoplysninger: Tove Høgedal",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-14T10:09:00+00:00",
          "updated_at": "2025-08-19T00:25:00.608864+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MTE=",
            "location": {
              "latitude": 55.522636,
              "longitude": 9.644335,
              "name": "Gavnøvænget 31, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3Mzc=",
      "location": {
        "name": "Gavnøvænget 21 7000 Fredericia",
        "latitude": 55.52312856,
        "longitude": 9.64658433
      },
      "containers": [
        {
          "id": "mp-pc-40",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-40",
            "container_id": "MP-7002-39",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NTU3MA==",
          "ticket_id": "20575570",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Fejlsorteret Er der afleveret flyer: Ja Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2025-05-23T11:01:00+00:00",
          "updated_at": "2025-08-19T00:24:59.947920+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3Mzc=",
            "location": {
              "latitude": 55.523128,
              "longitude": 9.646584,
              "name": "Gavnøvænget 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3Njg3NQ==",
          "ticket_id": "20576875",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Fejlsorteret Er der afleveret flyer: Ja Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2025-01-31T11:07:00+00:00",
          "updated_at": "2025-08-19T00:25:00.092880+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3Mzc=",
            "location": {
              "latitude": 55.523128,
              "longitude": 9.646584,
              "name": "Gavnøvænget 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDg3MA==",
          "ticket_id": "20584870",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/05-2023 Besked: Kontaktoplysninger:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-02T12:17:00+00:00",
          "updated_at": "2025-08-19T00:25:00.585273+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3Mzc=",
            "location": {
              "latitude": 55.523128,
              "longitude": 9.646584,
              "name": "Gavnøvænget 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDg2OQ==",
          "ticket_id": "20584869",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/05-2023 Besked: Kontaktoplysninger:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-02T12:17:00+00:00",
          "updated_at": "2025-08-19T00:25:00.585223+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3Mzc=",
            "location": {
              "latitude": 55.523128,
              "longitude": 9.646584,
              "name": "Gavnøvænget 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4MDA=",
      "location": {
        "name": "Gavnøvænget 35 7000 Fredericia",
        "latitude": 55.52317472,
        "longitude": 9.64452042
      },
      "containers": [
        {
          "id": "mp-pc-41",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-41",
            "container_id": "MP-7002-40",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NDg2OA==",
          "ticket_id": "20584868",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/05-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-02T12:20:00+00:00",
          "updated_at": "2025-08-19T00:25:00.585174+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDA=",
            "location": {
              "latitude": 55.523174,
              "longitude": 9.64452,
              "name": "Gavnøvænget 35, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDg2Nw==",
          "ticket_id": "20584867",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/05-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-02T12:20:00+00:00",
          "updated_at": "2025-08-19T00:25:00.585124+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDA=",
            "location": {
              "latitude": 55.523174,
              "longitude": 9.64452,
              "name": "Gavnøvænget 35, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4MjM=",
      "location": {
        "name": "Gavnøvænget 49 7000 Fredericia",
        "latitude": 55.52364933,
        "longitude": 9.64560634
      },
      "containers": [
        {
          "id": "mp-pc-42",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-42",
            "container_id": "MP-7002-41",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NTc2OA==",
          "ticket_id": "20575768",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Fejlsorteret Er der afleveret flyer: Ja Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2025-05-09T11:02:00+00:00",
          "updated_at": "2025-08-19T00:24:59.969283+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MjM=",
            "location": {
              "latitude": 55.523649,
              "longitude": 9.645606,
              "name": "Gavnøvænget 49, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDg1NQ==",
          "ticket_id": "20584855",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/05-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-04T08:31:00+00:00",
          "updated_at": "2025-08-19T00:25:00.584511+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MjM=",
            "location": {
              "latitude": 55.523649,
              "longitude": 9.645606,
              "name": "Gavnøvænget 49, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDg1Ng==",
          "ticket_id": "20584856",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/05-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-04T08:30:00+00:00",
          "updated_at": "2025-08-19T00:25:00.584561+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MjM=",
            "location": {
              "latitude": 55.523649,
              "longitude": 9.645606,
              "name": "Gavnøvænget 49, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3OTU=",
      "location": {
        "name": "Gavnøvænget 19 7000 Fredericia",
        "latitude": 55.52307087,
        "longitude": 9.64643
      },
      "containers": [
        {
          "id": "mp-pc-43",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-43",
            "container_id": "MP-7002-42",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NDY0NA==",
          "ticket_id": "20584644",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/06-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-31T10:38:00+00:00",
          "updated_at": "2025-08-19T00:25:00.572104+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3OTU=",
            "location": {
              "latitude": 55.52307,
              "longitude": 9.64643,
              "name": "Gavnøvænget 19, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDY0NQ==",
          "ticket_id": "20584645",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/06-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-31T10:35:00+00:00",
          "updated_at": "2025-08-19T00:25:00.572161+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3OTU=",
            "location": {
              "latitude": 55.52307,
              "longitude": 9.64643,
              "name": "Gavnøvænget 19, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3OTg=",
      "location": {
        "name": "Gavnøvænget 32 7000 Fredericia",
        "latitude": 55.523227,
        "longitude": 9.645727
      },
      "containers": [
        {
          "id": "mp-pc-44",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-44",
            "container_id": "MP-7002-43",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4Mjg2OQ==",
          "ticket_id": "20582869",
          "ticket_type": "AO-Generel besked",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2023-12-22T07:10:00+00:00",
          "updated_at": "2025-08-19T00:25:00.460480+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3OTg=",
            "location": {
              "latitude": 55.523171,
              "longitude": 9.645725,
              "name": "Gavnøvænget 32, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDE4Ng==",
          "ticket_id": "20584186",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2023-07-07Fraktion: 1 (Mad/Rest)Navn: Per Zoffmann AndersenTlf.: 29469913Email: perzoffmann@gmail.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-07-10T11:33:00+00:00",
          "updated_at": "2025-08-19T00:25:00.544696+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3OTg=",
            "location": {
              "latitude": 55.523171,
              "longitude": 9.645725,
              "name": "Gavnøvænget 32, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDE5MQ==",
          "ticket_id": "20584191",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2023-07-06Fraktion: 1 (Mad/Rest)Navn: Per Zoffmann AndersenTlf.: 29469913Email: perzoffmann@gmail.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-07-07T14:06:00+00:00",
          "updated_at": "2025-08-19T00:25:00.545003+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3OTg=",
            "location": {
              "latitude": 55.523171,
              "longitude": 9.645725,
              "name": "Gavnøvænget 32, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTEyMg==",
          "ticket_id": "20585122",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2023-03-16Fraktion: 1 (Mad/Rest)Navn: Per Zoffmann AndersenTlf.: 29469913Email: perzoffmann@gmail.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-30T16:45:00+00:00",
          "updated_at": "2025-08-19T00:25:00.598685+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3OTg=",
            "location": {
              "latitude": 55.523171,
              "longitude": 9.645725,
              "name": "Gavnøvænget 32, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTQ3Nw==",
          "ticket_id": "20585477",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 14/03-2023 Besked: Tilmeldt jf. udlejningsoversigt. Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-09T10:32:00+00:00",
          "updated_at": "2025-08-19T00:25:00.620240+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3OTg=",
            "location": {
              "latitude": 55.523171,
              "longitude": 9.645725,
              "name": "Gavnøvænget 32, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTQ3Ng==",
          "ticket_id": "20585476",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 15/03-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-09T10:32:00+00:00",
          "updated_at": "2025-08-19T00:25:00.620182+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3OTg=",
            "location": {
              "latitude": 55.523171,
              "longitude": 9.645725,
              "name": "Gavnøvænget 32, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4Mjk=",
      "location": {
        "name": "Gavnøvænget 24 7000 Fredericia",
        "latitude": 55.52293738,
        "longitude": 9.6451054
      },
      "containers": [
        {
          "id": "mp-pc-45",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-45",
            "container_id": "MP-7002-44",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NDEyNw==",
          "ticket_id": "20584127",
          "ticket_type": "AO-Generel besked",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2023-07-20T07:49:00+00:00",
          "updated_at": "2025-08-19T00:25:00.541342+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4Mjk=",
            "location": {
              "latitude": 55.522937,
              "longitude": 9.645105,
              "name": "Gavnøvænget 24, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDIwMw==",
          "ticket_id": "20584203",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 14/07 2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-07-07T10:12:00+00:00",
          "updated_at": "2025-08-19T00:25:00.545687+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4Mjk=",
            "location": {
              "latitude": 55.522937,
              "longitude": 9.645105,
              "name": "Gavnøvænget 24, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDIwNA==",
          "ticket_id": "20584204",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 14/07 2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-07-07T10:11:00+00:00",
          "updated_at": "2025-08-19T00:25:00.545744+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4Mjk=",
            "location": {
              "latitude": 55.522937,
              "longitude": 9.645105,
              "name": "Gavnøvænget 24, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDMyNjY=",
      "location": {
        "name": "Gavnøvænget 40 7000 Fredericia",
        "latitude": 55.52340553,
        "longitude": 9.64634604
      },
      "containers": [
        {
          "id": "mp-pc-46",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-46",
            "container_id": "MP-7002-45",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3OTcxNA==",
          "ticket_id": "20579714",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 18/07 2024 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2024-07-11T11:11:00+00:00",
          "updated_at": "2025-08-19T00:25:00.269403+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDMyNjY=",
            "location": {
              "latitude": 55.523405,
              "longitude": 9.646346,
              "name": "Gavnøvænget 40, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDA0NA==",
          "ticket_id": "20584044",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 14/08 2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-08-07T09:05:00+00:00",
          "updated_at": "2025-08-19T00:25:00.536474+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDMyNjY=",
            "location": {
              "latitude": 55.523405,
              "longitude": 9.646346,
              "name": "Gavnøvænget 40, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4MjE=",
      "location": {
        "name": "Gavnøvænget 18 7000 Fredericia",
        "latitude": 55.52297358,
        "longitude": 9.64758302
      },
      "containers": [
        {
          "id": "mp-pc-47",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-47",
            "container_id": "MP-7002-46",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        },
        {
          "id": "mp-pc-48",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-48",
            "container_id": "MP-7002-49",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NTA0OA==",
          "ticket_id": "20575048",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Hej Kristina I må gerne komme og tømme dem, vi skal nok betale den ekstra udgift. Med venlig hilsen Steffen Sendt fra min iPhone",
          "status": 6,
          "priority": 2,
          "created_at": "2025-06-23T12:32:00+00:00",
          "updated_at": "2025-08-19T00:24:59.884790+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MjE=",
            "location": {
              "latitude": 55.522973,
              "longitude": 9.647583,
              "name": "Gavnøvænget 18, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3NTA2MA==",
          "ticket_id": "20575060",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2025-06-20Fraktion: 1 (Mad/Rest)Navn: Steffen FiltenborgTlf.: 27649495Email: steffen.f.scholer@gmail.comBesked: Vi stillede dem ikke hvor plejer så måske det også er lidt vores skyld - kan i afhente? De er helt fyldte",
          "status": 6,
          "priority": 2,
          "created_at": "2025-06-21T18:55:00+00:00",
          "updated_at": "2025-08-19T00:24:59.886192+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MjE=",
            "location": {
              "latitude": 55.522973,
              "longitude": 9.647583,
              "name": "Gavnøvænget 18, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4Mzc3Mg==",
          "ticket_id": "20583772",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 240 l rest - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 18/09 2023 Besked: Kontaktoplysninger: Malene Filtenborg Schøler",
          "status": 6,
          "priority": 2,
          "created_at": "2023-09-11T14:31:00+00:00",
          "updated_at": "2025-08-19T00:25:00.520373+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MjE=",
            "location": {
              "latitude": 55.522973,
              "longitude": 9.647583,
              "name": "Gavnøvænget 18, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDM2MQ==",
          "ticket_id": "20584361",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 05/07 2023 Besked: Kontaktoplysninger: Malene Filtenborg Schøler",
          "status": 6,
          "priority": 2,
          "created_at": "2023-06-28T08:50:00+00:00",
          "updated_at": "2025-08-19T00:25:00.555127+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MjE=",
            "location": {
              "latitude": 55.522973,
              "longitude": 9.647583,
              "name": "Gavnøvænget 18, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDUzOQ==",
          "ticket_id": "20584539",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 19/06 2023 Besked: Kontaktoplysninger: Malene Filtenborg Schøler",
          "status": 6,
          "priority": 2,
          "created_at": "2023-06-12T10:16:00+00:00",
          "updated_at": "2025-08-19T00:25:00.565768+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MjE=",
            "location": {
              "latitude": 55.522973,
              "longitude": 9.647583,
              "name": "Gavnøvænget 18, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4MzY=",
      "location": {
        "name": "Gavnøvænget 17 7000 Fredericia",
        "latitude": 55.52301319,
        "longitude": 9.64627567
      },
      "containers": [
        {
          "id": "mp-pc-49",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-49",
            "container_id": "MP-7002-47",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4Mzk2OQ==",
          "ticket_id": "20583969",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 15/08-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-08-15T09:42:00+00:00",
          "updated_at": "2025-08-19T00:25:00.532163+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MzY=",
            "location": {
              "latitude": 55.52301,
              "longitude": 9.646288,
              "name": "Gavnøvænget 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4Mzk3MA==",
          "ticket_id": "20583970",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 15/08-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-08-15T09:41:00+00:00",
          "updated_at": "2025-08-19T00:25:00.532217+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MzY=",
            "location": {
              "latitude": 55.52301,
              "longitude": 9.646288,
              "name": "Gavnøvænget 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4Mzg=",
      "location": {
        "name": "Gavnøvænget 36 7000 Fredericia",
        "latitude": 55.52328849,
        "longitude": 9.64603588
      },
      "containers": [
        {
          "id": "mp-pc-50",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-50",
            "container_id": "MP-7002-48",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4Mzg0OA==",
          "ticket_id": "20583848",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 15/09-2023 Besked: Bestilt til indflytning den 15-09-2023. Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-08-30T14:19:00+00:00",
          "updated_at": "2025-08-19T00:25:00.524904+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4Mzg=",
            "location": {
              "latitude": 55.523334,
              "longitude": 9.645946,
              "name": "Gavnøvænget 36, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4Mzg0Nw==",
          "ticket_id": "20583847",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 15/09-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-08-30T14:19:00+00:00",
          "updated_at": "2025-08-19T00:25:00.524848+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4Mzg=",
            "location": {
              "latitude": 55.523334,
              "longitude": 9.645946,
              "name": "Gavnøvænget 36, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4MjY=",
      "location": {
        "name": "Omøvænget 26 7000 Fredericia",
        "latitude": 55.52130745,
        "longitude": 9.64811446
      },
      "containers": [
        {
          "id": "mp-pc-51",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-51",
            "container_id": "MP-7002-50",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDQ3ODgwMQ==",
          "ticket_id": "10478801",
          "ticket_type": "Forkert emballage, sækken skal være i klar plast",
          "description": "<p></p>",
          "status": 1,
          "priority": 2,
          "created_at": "2024-12-02T11:43:15.871599+00:00",
          "updated_at": "2024-12-02T11:43:15.872821+00:00",
          "resolved_at": null,
          "preferred_date": "2024-12-02",
          "contact_name": null,
          "user": {
            "name": null
          },
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MjY=",
            "location": {
              "latitude": 55.521307,
              "longitude": 9.648114,
              "name": "Omøvænget 26, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "2940_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MzM4MA==",
          "ticket_id": "20583380",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 06/11 2023 Besked: Kontaktoplysninger: Stephanie Steinbacher 61761924 steffi-steinbacher@hotmail.de",
          "status": 6,
          "priority": 2,
          "created_at": "2023-10-30T15:04:00+00:00",
          "updated_at": "2025-08-19T00:25:00.497047+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MjY=",
            "location": {
              "latitude": 55.521307,
              "longitude": 9.648114,
              "name": "Omøvænget 26, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MzM4MQ==",
          "ticket_id": "20583381",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Ny tømningsfrekvens: Ønsket virkningsdato: 06/11 2023 Besked: Kontaktoplysninger: Stephanie Steinbacher 61761924 steffi-steinbacher@hotmail.de",
          "status": 6,
          "priority": 2,
          "created_at": "2023-10-30T15:02:00+00:00",
          "updated_at": "2025-08-19T00:25:00.497103+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MjY=",
            "location": {
              "latitude": 55.521307,
              "longitude": 9.648114,
              "name": "Omøvænget 26, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MzM4NQ==",
          "ticket_id": "20583385",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 31/10-2023 Besked: Kontaktoplysninger: Stephanie Steinbacher 61761924 steffi-steinbacher@hotmail.de",
          "status": 6,
          "priority": 2,
          "created_at": "2023-10-30T09:08:00+00:00",
          "updated_at": "2025-08-19T00:25:00.497342+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MjY=",
            "location": {
              "latitude": 55.521307,
              "longitude": 9.648114,
              "name": "Omøvænget 26, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MzM4Ng==",
          "ticket_id": "20583386",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "Hej, Vi overtager vores hus den 31/10 og vil gerne bestil nye beholder til affaldssortering. Mvh Stephanie Steinbacher",
          "status": 6,
          "priority": 2,
          "created_at": "2023-10-28T21:46:00+00:00",
          "updated_at": "2025-08-19T00:25:00.497402+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MjY=",
            "location": {
              "latitude": 55.521307,
              "longitude": 9.648114,
              "name": "Omøvænget 26, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4NDI=",
      "location": {
        "name": "Gavnøvænget 38 7000 Fredericia",
        "latitude": 55.52334701,
        "longitude": 9.64619096
      },
      "containers": [
        {
          "id": "mp-pc-52",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-52",
            "container_id": "MP-7002-51",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3Njg3NA==",
          "ticket_id": "20576874",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Beholder overfyldt Er der afleveret flyer: Ja Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2025-01-31T11:21:00+00:00",
          "updated_at": "2025-08-19T00:25:00.092785+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4NDI=",
            "location": {
              "latitude": 55.523388,
              "longitude": 9.646085,
              "name": "Gavnøvænget 38, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3NzczMg==",
          "ticket_id": "20577732",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Beholder overfyldt Er der afleveret flyer: Ja Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2024-11-22T11:34:00+00:00",
          "updated_at": "2025-08-19T00:25:00.156381+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4NDI=",
            "location": {
              "latitude": 55.523388,
              "longitude": 9.646085,
              "name": "Gavnøvænget 38, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MzQyMg==",
          "ticket_id": "20583422",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 24/10-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-10-24T08:47:00+00:00",
          "updated_at": "2025-08-19T00:25:00.499550+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4NDI=",
            "location": {
              "latitude": 55.523388,
              "longitude": 9.646085,
              "name": "Gavnøvænget 38, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MzQyMw==",
          "ticket_id": "20583423",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 24/10-2023 Besked: bestilt af udlejer. Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-10-24T08:46:00+00:00",
          "updated_at": "2025-08-19T00:25:00.499609+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4NDI=",
            "location": {
              "latitude": 55.523388,
              "longitude": 9.646085,
              "name": "Gavnøvænget 38, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc5ODk=",
      "location": {
        "name": "Gavnøvænget 42 7000 Fredericia",
        "latitude": 55.52346405,
        "longitude": 9.64650113
      },
      "containers": [
        {
          "id": "mp-pc-53",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-53",
            "container_id": "MP-7002-52",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MDYyOQ==",
          "ticket_id": "20580629",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 31/05 2024 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2024-05-24T12:46:00+00:00",
          "updated_at": "2025-08-19T00:25:00.326516+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc5ODk=",
            "location": {
              "latitude": 55.523522,
              "longitude": 9.646424,
              "name": "Gavnøvænget 42, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDYzMA==",
          "ticket_id": "20580630",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 23/05-2024 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2024-05-24T12:45:00+00:00",
          "updated_at": "2025-08-19T00:25:00.326571+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc5ODk=",
            "location": {
              "latitude": 55.523522,
              "longitude": 9.646424,
              "name": "Gavnøvænget 42, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDYyOA==",
          "ticket_id": "20580628",
          "ticket_type": "AO-Generel besked",
          "description": "Tlf. 26244512. Lejer ringer og oplyser, at beholder er væk i dag efter tømning. Der er ikke registreret en beholder på adressen. Tømmer I her og kan I have taget den med/eller sat den forkert?",
          "status": 6,
          "priority": 2,
          "created_at": "2024-05-24T12:44:00+00:00",
          "updated_at": "2025-08-19T00:25:00.326460+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc5ODk=",
            "location": {
              "latitude": 55.523522,
              "longitude": 9.646424,
              "name": "Gavnøvænget 42, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMzY3MDY=",
      "location": {
        "name": "Bjørnøvænget 3 7000 Fredericia",
        "latitude": 55.52204178,
        "longitude": 9.64326683
      },
      "containers": [
        {
          "id": "mp-pc-54",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-54",
            "container_id": "MP-7002-53",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3ODkyNg==",
          "ticket_id": "20578926",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Anette PadkærTlf.: 27200056Email: aopadkaer@gmail.comBesked: Vi er tilflyttere fra Kolding kommune , hvor vi fik små grønne poser til madaffald - har man også det i Fredericia ? Skraldespanden er jo til det , men skal man selv sørge for poser til det ? Mvh Anette",
          "status": 6,
          "priority": 2,
          "created_at": "2024-08-16T08:59:00+00:00",
          "updated_at": "2025-08-19T00:25:00.224348+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzY3MDY=",
            "location": {
              "latitude": 55.522001,
              "longitude": 9.643322,
              "name": "Bjørnøvænget 3, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3OTAyNw==",
          "ticket_id": "20579027",
          "ticket_type": "AO-Generel besked",
          "description": "Borger Anette oplyser, at hun ikke kan se genbrug på tømmekalenderen, det skulle gerne være fikset nu.",
          "status": 6,
          "priority": 2,
          "created_at": "2024-08-06T11:45:00+00:00",
          "updated_at": "2025-08-19T00:25:00.230839+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzY3MDY=",
            "location": {
              "latitude": 55.522001,
              "longitude": 9.643322,
              "name": "Bjørnøvænget 3, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3OTAyOA==",
          "ticket_id": "20579028",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 06/08-2024 Besked: Adressen er ikke tilmeldt genbrug. Kontaktoplysninger: Anette Padkær",
          "status": 6,
          "priority": 2,
          "created_at": "2024-08-06T11:39:00+00:00",
          "updated_at": "2025-08-19T00:25:00.230892+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzY3MDY=",
            "location": {
              "latitude": 55.522001,
              "longitude": 9.643322,
              "name": "Bjørnøvænget 3, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3OTAyOQ==",
          "ticket_id": "20579029",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Farligt affald Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 06/08-2024 Besked: Borger Anette Padkjær har hentet en rød kasse til farligt affald d. 06-08-24 Kontaktoplysninger: Anette Padkær",
          "status": 6,
          "priority": 2,
          "created_at": "2024-08-06T11:37:00+00:00",
          "updated_at": "2025-08-19T00:25:00.230950+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzY3MDY=",
            "location": {
              "latitude": 55.522001,
              "longitude": 9.643322,
              "name": "Bjørnøvænget 3, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3OTExMg==",
          "ticket_id": "20579112",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/08-2024 Besked: Kontaktoplysninger: Anette Padkær",
          "status": 6,
          "priority": 2,
          "created_at": "2024-07-31T09:00:00+00:00",
          "updated_at": "2025-08-19T00:25:00.235745+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzY3MDY=",
            "location": {
              "latitude": 55.522001,
              "longitude": 9.643322,
              "name": "Bjørnøvænget 3, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3NTM=",
      "location": {
        "name": "Gavnøvænget 56 7000 Fredericia",
        "latitude": 55.52372761,
        "longitude": 9.64475021
      },
      "containers": [
        {
          "id": "mp-pc-55",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-55",
            "container_id": "MP-7002-54",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTM0MQ==",
          "ticket_id": "20585341",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 2-delt 240 l beholder - Parcel Gavnøvænget 56 (7000 Fredericia) ContainerNr:437115 ContainerBrik:00400000126758E0 Beholder der ønskes i stedet: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Gebyr: 0 kr Ønsket virkningsdato: 17/03 2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-10T12:50:00+00:00",
          "updated_at": "2025-08-19T00:25:00.611830+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NTM=",
            "location": {
              "latitude": 55.523727,
              "longitude": 9.64475,
              "name": "Gavnøvænget 56, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYxNA==",
          "ticket_id": "20585614",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T10:22:00+00:00",
          "updated_at": "2025-08-19T00:25:00.628089+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NTM=",
            "location": {
              "latitude": 55.523727,
              "longitude": 9.64475,
              "name": "Gavnøvænget 56, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTYxNQ==",
          "ticket_id": "20585615",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/03-2023 Besked: Kontaktoplysninger: UDVIKLINGSSELSKABET HAGENØRVEJ ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-24T10:21:00+00:00",
          "updated_at": "2025-08-19T00:25:00.628142+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NTM=",
            "location": {
              "latitude": 55.523727,
              "longitude": 9.64475,
              "name": "Gavnøvænget 56, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4MDM=",
      "location": {
        "name": "Gavnøvænget 45 7000 Fredericia",
        "latitude": 55.52351373,
        "longitude": 9.64529607
      },
      "containers": [
        {
          "id": "mp-pc-56",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-56",
            "container_id": "MP-7002-55",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTQ3NQ==",
          "ticket_id": "20585475",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 15/03-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-09T10:36:00+00:00",
          "updated_at": "2025-08-19T00:25:00.620124+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDM=",
            "location": {
              "latitude": 55.523513,
              "longitude": 9.645296,
              "name": "Gavnøvænget 45, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTQ3NA==",
          "ticket_id": "20585474",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 15/03-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-09T10:36:00+00:00",
          "updated_at": "2025-08-19T00:25:00.620067+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDM=",
            "location": {
              "latitude": 55.523513,
              "longitude": 9.645296,
              "name": "Gavnøvænget 45, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4MDc=",
      "location": {
        "name": "Gavnøvænget 60 7000 Fredericia",
        "latitude": 55.52387847,
        "longitude": 9.64505516
      },
      "containers": [
        {
          "id": "mp-pc-57",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-57",
            "container_id": "MP-7002-56",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTQ1OA==",
          "ticket_id": "20585458",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 15/03-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-09T11:31:00+00:00",
          "updated_at": "2025-08-19T00:25:00.619121+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDc=",
            "location": {
              "latitude": 55.523878,
              "longitude": 9.645055,
              "name": "Gavnøvænget 60, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTQ1OQ==",
          "ticket_id": "20585459",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 15/03-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-09T11:30:00+00:00",
          "updated_at": "2025-08-19T00:25:00.619179+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDc=",
            "location": {
              "latitude": 55.523878,
              "longitude": 9.645055,
              "name": "Gavnøvænget 60, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4MDg=",
      "location": {
        "name": "Gavnøvænget 62 7000 Fredericia",
        "latitude": 55.52395391,
        "longitude": 9.64520764
      },
      "containers": [
        {
          "id": "mp-pc-58",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-58",
            "container_id": "MP-7002-57",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3ODcwOA==",
          "ticket_id": "20578708",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2024-08-16Fraktion: 1 (Mad/Rest)Navn: KatrineTlf.: 31505628Email: katrinepedersen35@gmail.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2024-08-30T19:12:00+00:00",
          "updated_at": "2025-08-19T00:25:00.213611+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDg=",
            "location": {
              "latitude": 55.523953,
              "longitude": 9.645207,
              "name": "Gavnøvænget 62, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDc1MA==",
          "ticket_id": "20580750",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: KatrineTlf.: 31505628Email: katrinepedersen35@gmail.comBesked: I har endnu ikke sendt os nogle affalssække så vi kan begynde at få sorteret? I skrev de ville blive sendt hurtigts muligt",
          "status": 6,
          "priority": 2,
          "created_at": "2024-05-21T14:31:00+00:00",
          "updated_at": "2025-08-19T00:25:00.333638+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDg=",
            "location": {
              "latitude": 55.523953,
              "longitude": 9.645207,
              "name": "Gavnøvænget 62, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDkwNQ==",
          "ticket_id": "20580905",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: KatrineTlf.: 31505628Email: katrinepedersen35@gmail.comBesked: Min kæreste og jeg er tilflytter her på gavnøvænget i Fredericia. Vores spørgsmål lyder på om der på sigt kommer andre skraldespande end mad/rest affald? Har vi forstået korrekt at alt andet ud over madrester skal i samme skraldespand som er restaffald. Der skal ikke sorteres i pap, plastik, metal osv?. Det skal også i restaffald? Mvh Katrine",
          "status": 6,
          "priority": 2,
          "created_at": "2024-05-03T14:55:00+00:00",
          "updated_at": "2025-08-19T00:25:00.343742+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDg=",
            "location": {
              "latitude": 55.523953,
              "longitude": 9.645207,
              "name": "Gavnøvænget 62, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTQ1Nw==",
          "ticket_id": "20585457",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 15/03-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-09T11:32:00+00:00",
          "updated_at": "2025-08-19T00:25:00.619064+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDg=",
            "location": {
              "latitude": 55.523953,
              "longitude": 9.645207,
              "name": "Gavnøvænget 62, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTQ1Ng==",
          "ticket_id": "20585456",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 15/03-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-09T11:32:00+00:00",
          "updated_at": "2025-08-19T00:25:00.619006+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDg=",
            "location": {
              "latitude": 55.523953,
              "longitude": 9.645207,
              "name": "Gavnøvænget 62, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4MDk=",
      "location": {
        "name": "Gavnøvænget 66 7000 Fredericia",
        "latitude": 55.52410477,
        "longitude": 9.64551259
      },
      "containers": [
        {
          "id": "mp-pc-59",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-59",
            "container_id": "MP-7002-58",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTQ1NQ==",
          "ticket_id": "20585455",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 15/03-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-09T11:35:00+00:00",
          "updated_at": "2025-08-19T00:25:00.618949+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDk=",
            "location": {
              "latitude": 55.524104,
              "longitude": 9.645512,
              "name": "Gavnøvænget 66, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTQ1NA==",
          "ticket_id": "20585454",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 15/03-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-09T11:35:00+00:00",
          "updated_at": "2025-08-19T00:25:00.618891+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDk=",
            "location": {
              "latitude": 55.524104,
              "longitude": 9.645512,
              "name": "Gavnøvænget 66, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4MDY=",
      "location": {
        "name": "Gavnøvænget 54 7000 Fredericia",
        "latitude": 55.52365217,
        "longitude": 9.64459774
      },
      "containers": [
        {
          "id": "mp-pc-60",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-60",
            "container_id": "MP-7002-59",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NTc2NQ==",
          "ticket_id": "20575765",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Fejlsorteret Er der afleveret flyer: Ja Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2025-05-09T11:14:00+00:00",
          "updated_at": "2025-08-19T00:24:59.968972+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDY=",
            "location": {
              "latitude": 55.523652,
              "longitude": 9.644597,
              "name": "Gavnøvænget 54, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTEyNg==",
          "ticket_id": "20585126",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 04/04-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-30T14:32:00+00:00",
          "updated_at": "2025-08-19T00:25:00.598900+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDY=",
            "location": {
              "latitude": 55.523652,
              "longitude": 9.644597,
              "name": "Gavnøvænget 54, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTEyNw==",
          "ticket_id": "20585127",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 04/04-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-30T14:31:00+00:00",
          "updated_at": "2025-08-19T00:25:00.598954+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MDY=",
            "location": {
              "latitude": 55.523652,
              "longitude": 9.644597,
              "name": "Gavnøvænget 54, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4MTk=",
      "location": {
        "name": "Gavnøvænget 51 7000 Fredericia",
        "latitude": 55.52371714,
        "longitude": 9.64576147
      },
      "containers": [
        {
          "id": "mp-pc-61",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-61",
            "container_id": "MP-7002-60",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NDY0Mg==",
          "ticket_id": "20584642",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/06-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-31T10:40:00+00:00",
          "updated_at": "2025-08-19T00:25:00.571993+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MTk=",
            "location": {
              "latitude": 55.523717,
              "longitude": 9.645761,
              "name": "Gavnøvænget 51, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDY0MQ==",
          "ticket_id": "20584641",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/06-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-31T10:40:00+00:00",
          "updated_at": "2025-08-19T00:25:00.571937+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MTk=",
            "location": {
              "latitude": 55.523717,
              "longitude": 9.645761,
              "name": "Gavnøvænget 51, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4MzA=",
      "location": {
        "name": "Gavnøvænget 64 7000 Fredericia",
        "latitude": 55.52402934,
        "longitude": 9.64536011
      },
      "containers": [
        {
          "id": "mp-pc-62",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-62",
            "container_id": "MP-7002-61",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4Mzg4NQ==",
          "ticket_id": "20583885",
          "ticket_type": "AO-Generel besked",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2023-08-24T16:08:00+00:00",
          "updated_at": "2025-08-19T00:25:00.527640+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MzA=",
            "location": {
              "latitude": 55.524029,
              "longitude": 9.64536,
              "name": "Gavnøvænget 64, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDIwMQ==",
          "ticket_id": "20584201",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 14/07 2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-07-07T10:13:00+00:00",
          "updated_at": "2025-08-19T00:25:00.545573+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MzA=",
            "location": {
              "latitude": 55.524029,
              "longitude": 9.64536,
              "name": "Gavnøvænget 64, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDIwMg==",
          "ticket_id": "20584202",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 14/07 2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-07-07T10:12:00+00:00",
          "updated_at": "2025-08-19T00:25:00.545631+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MzA=",
            "location": {
              "latitude": 55.524029,
              "longitude": 9.64536,
              "name": "Gavnøvænget 64, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4MzQ=",
      "location": {
        "name": "Gavnøvænget 58 7000 Fredericia",
        "latitude": 55.52380304,
        "longitude": 9.64490269
      },
      "containers": [
        {
          "id": "mp-pc-63",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-63",
            "container_id": "MP-7002-62",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MzYzMg==",
          "ticket_id": "20583632",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 30/09-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-09-29T13:32:00+00:00",
          "updated_at": "2025-08-19T00:25:00.512099+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MzQ=",
            "location": {
              "latitude": 55.523803,
              "longitude": 9.644902,
              "name": "Gavnøvænget 58, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDA0NQ==",
          "ticket_id": "20584045",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 14/08 2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-08-07T09:03:00+00:00",
          "updated_at": "2025-08-19T00:25:00.536531+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MzQ=",
            "location": {
              "latitude": 55.523803,
              "longitude": 9.644902,
              "name": "Gavnøvænget 58, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4Mzc=",
      "location": {
        "name": "Gavnøvænget 53 7000 Fredericia",
        "latitude": 55.52378494,
        "longitude": 9.6459166
      },
      "containers": [
        {
          "id": "mp-pc-64",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-64",
            "container_id": "MP-7002-63",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4Mzg1OA==",
          "ticket_id": "20583858",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 30/08-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-08-29T07:32:00+00:00",
          "updated_at": "2025-08-19T00:25:00.525477+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4Mzc=",
            "location": {
              "latitude": 55.523707,
              "longitude": 9.645901,
              "name": "Gavnøvænget 53, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4Mzg1Nw==",
          "ticket_id": "20583857",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 30/08-2023 Besked: Bestilt til nyindflyttere. Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-08-29T07:32:00+00:00",
          "updated_at": "2025-08-19T00:25:00.525421+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4Mzc=",
            "location": {
              "latitude": 55.523707,
              "longitude": 9.645901,
              "name": "Gavnøvænget 53, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc4MTY=",
      "location": {
        "name": "Gavnøvænget 41 7000 Fredericia",
        "latitude": 55.52337812,
        "longitude": 9.64498581
      },
      "containers": [
        {
          "id": "mp-pc-65",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-65",
            "container_id": "MP-7002-64",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTEyOA==",
          "ticket_id": "20585128",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 04/04-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-30T14:30:00+00:00",
          "updated_at": "2025-08-19T00:25:00.599010+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MTY=",
            "location": {
              "latitude": 55.523378,
              "longitude": 9.644985,
              "name": "Gavnøvænget 41, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTEyOQ==",
          "ticket_id": "20585129",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 04/04-2023 Besked: Kontaktoplysninger: Udviklingsselskabet Hagenør ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-30T14:29:00+00:00",
          "updated_at": "2025-08-19T00:25:00.599066+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc4MTY=",
            "location": {
              "latitude": 55.523378,
              "longitude": 9.644985,
              "name": "Gavnøvænget 41, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTE1NDE=",
      "location": {
        "name": "Gisselbakken 1 7000 Fredericia",
        "latitude": 55.516356,
        "longitude": 9.633956
      },
      "containers": [
        {
          "id": "mp-pc-66",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-66",
            "container_id": "MP-7002-65",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDcwMjE=",
      "location": {
        "name": "Gisselbakken 2 7000 Fredericia",
        "latitude": 55.516116,
        "longitude": 9.634822
      },
      "containers": [
        {
          "id": "mp-pc-67",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-67",
            "container_id": "MP-7002-66",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MzU0MA==",
          "ticket_id": "20593540",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Skal ikke sættes frem",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-18T11:26:00+00:00",
          "updated_at": "2025-08-19T00:25:01.271696+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDcwMjE=",
            "location": {
              "latitude": 55.516116,
              "longitude": 9.634822,
              "name": "Gisselbakken 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDM5MzQ=",
      "location": {
        "name": "Gisselbakken 4 7000 Fredericia",
        "latitude": 55.516403,
        "longitude": 9.634826
      },
      "containers": [
        {
          "id": "mp-pc-68",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-68",
            "container_id": "MP-7002-67",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5ODkyNQ==",
          "ticket_id": "20598925",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "Hej Affald/Genbrug Jeg ønsker at købe en ny grøn beholder, da den jeg har i forvejen er revnet ned langs siderne i begge sider. Jeg ved faktisk ikke hvordan disse skader kommer, da den står langs hæk eller hus. Men jeg går ud fra, at tilkøbet blot bliver reguleret på min ejendomsskat. På forhånd tak for hjælpen Hilsen Betina Cwiek Johansen",
          "status": 6,
          "priority": 2,
          "created_at": "2020-03-30T16:06:00+00:00",
          "updated_at": "2025-08-19T00:25:01.599818+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDM5MzQ=",
            "location": {
              "latitude": 55.516401,
              "longitude": 9.634826,
              "name": "Gisselbakken 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDkyOTM=",
      "location": {
        "name": "Gisselbakken 5 7000 Fredericia",
        "latitude": 55.516567,
        "longitude": 9.634531
      },
      "containers": [
        {
          "id": "mp-pc-69",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-69",
            "container_id": "MP-7002-68",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZTo1MzUwNzgyNg==",
          "ticket_id": "53507826",
          "ticket_type": "Affaldet skal afleveres på genbrugspladsen",
          "description": "Smadret glas(vindue s glas)\n",
          "status": 2,
          "priority": 0,
          "created_at": "2025-11-20T07:09:22.657178+00:00",
          "updated_at": "2025-11-20T07:09:22.658061+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDkyOTM=",
            "location": {
              "latitude": 55.516567,
              "longitude": 9.634524,
              "name": "Gisselbakken 5, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "11463_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZTo1MzUwNzgyNQ==",
          "ticket_id": "53507825",
          "ticket_type": "Affaldet skal afleveres på genbrugspladsen",
          "description": "Smadret glas(vindue s glas)\n",
          "status": 2,
          "priority": 0,
          "created_at": "2025-11-20T07:08:19.363871+00:00",
          "updated_at": "2025-11-20T07:08:19.364741+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDkyOTM=",
            "location": {
              "latitude": 55.516567,
              "longitude": 9.634524,
              "name": "Gisselbakken 5, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "11463_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc0MDk=",
      "location": {
        "name": "Bjørnøvænget 2 7000 Fredericia",
        "latitude": 55.52249079,
        "longitude": 9.64258152
      },
      "containers": [
        {
          "id": "mp-pc-70",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-70",
            "container_id": "MP-7002-69",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        },
        {
          "id": "mp-pc-71",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-71",
            "container_id": "MP-7002-70",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3OTExMw==",
          "ticket_id": "20579113",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: 2-delt 240 l beholder - Parcel Bjørnøvænget 2 (7000 Fredericia) ContainerNr:438444 ContainerBrik: Ønsket virkningsdato: 07/08 2024 Besked: Fejl Kontaktoplysninger: Jonas Schmidt 40448101 jonasschmidt04@gmail.com",
          "status": 6,
          "priority": 2,
          "created_at": "2024-07-31T08:59:00+00:00",
          "updated_at": "2025-08-19T00:25:00.235802+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc0MDk=",
            "location": {
              "latitude": 55.522473,
              "longitude": 9.642556,
              "name": "Bjørnøvænget 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3OTExNA==",
          "ticket_id": "20579114",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/08-2024 Besked: Kontaktoplysninger: Jonas Schmidt 40448101 jonasschmidt04@gmail.com",
          "status": 6,
          "priority": 2,
          "created_at": "2024-07-31T08:58:00+00:00",
          "updated_at": "2025-08-19T00:25:00.235858+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc0MDk=",
            "location": {
              "latitude": 55.522473,
              "longitude": 9.642556,
              "name": "Bjørnøvænget 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc2MDU=",
      "location": {
        "name": "Bjørnøvænget 4 7000 Fredericia",
        "latitude": 55.52259942,
        "longitude": 9.64217602
      },
      "containers": [
        {
          "id": "mp-pc-72",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-72",
            "container_id": "MP-7002-71",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MDk0MA==",
          "ticket_id": "20590940",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 17/02 2022 Besked: Kontaktoplysninger: Rikke Guldbrandt",
          "status": 6,
          "priority": 2,
          "created_at": "2022-02-10T11:22:00+00:00",
          "updated_at": "2025-08-19T00:25:01.107928+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2MDU=",
            "location": {
              "latitude": 55.522599,
              "longitude": 9.642176,
              "name": "Bjørnøvænget 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MDk0Mw==",
          "ticket_id": "20590943",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 17/02 2022 Besked: Kontaktoplysninger: Rikke Guldbrandt",
          "status": 6,
          "priority": 2,
          "created_at": "2022-02-10T10:33:00+00:00",
          "updated_at": "2025-08-19T00:25:01.108293+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2MDU=",
            "location": {
              "latitude": 55.522599,
              "longitude": 9.642176,
              "name": "Bjørnøvænget 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc0NzQ=",
      "location": {
        "name": "Bjørnøvænget 8 7000 Fredericia",
        "latitude": 55.52271819,
        "longitude": 9.64142494
      },
      "containers": [
        {
          "id": "mp-pc-73",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-73",
            "container_id": "MP-7002-72",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NDg3Mg==",
          "ticket_id": "20584872",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Tanja Tlf.: 53568091Email: hoejmose@hotmail.dkBesked: Vi mangler flere affaldssække til affaldssortering. Hvordan bestiller vi flere af disse?",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-01T16:57:00+00:00",
          "updated_at": "2025-08-19T00:25:00.585371+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc0NzQ=",
            "location": {
              "latitude": 55.522718,
              "longitude": 9.641424,
              "name": "Bjørnøvænget 8, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NjMzMA==",
          "ticket_id": "20586330",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Hej Lasse Beklager: Overså, at det var genbrug det handlede om.",
          "status": 6,
          "priority": 2,
          "created_at": "2022-12-27T12:45:00+00:00",
          "updated_at": "2025-08-19T00:25:00.692658+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc0NzQ=",
            "location": {
              "latitude": 55.522718,
              "longitude": 9.641424,
              "name": "Bjørnøvænget 8, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NjMzOA==",
          "ticket_id": "20586338",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Manglende tømning her trods oplysninger i tømmelog.",
          "status": 6,
          "priority": 2,
          "created_at": "2022-12-27T09:26:00+00:00",
          "updated_at": "2025-08-19T00:25:00.693448+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc0NzQ=",
            "location": {
              "latitude": 55.522718,
              "longitude": 9.641424,
              "name": "Bjørnøvænget 8, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NjM2Mg==",
          "ticket_id": "20586362",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Tømningsdato: 2022-12-23Fraktion: 2 (Genbrug)Navn: Mathias JohansenTlf.: 28266552Email: mathiasjohansen7000@gmail.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2022-12-25T20:25:00+00:00",
          "updated_at": "2025-08-19T00:25:00.695941+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc0NzQ=",
            "location": {
              "latitude": 55.522718,
              "longitude": 9.641424,
              "name": "Bjørnøvænget 8, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NjMzNA==",
          "ticket_id": "20586334",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Tømningsdato: 2022-12-23Fraktion: 2 (Genbrug)Navn: Tanja Tlf.: 53568091Email: hoejmose@hotmail.dkBesked: Vi har placeret det ved vejen til afhentning, det står der desværre endnu efter vi er vendt hjem fra juleferie.",
          "status": 6,
          "priority": 2,
          "created_at": "2022-12-25T10:46:00+00:00",
          "updated_at": "2025-08-19T00:25:00.693062+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc0NzQ=",
            "location": {
              "latitude": 55.522718,
              "longitude": 9.641424,
              "name": "Bjørnøvænget 8, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTczMDQ=",
      "location": {
        "name": "Bjørnøvænget 6 7000 Fredericia",
        "latitude": 55.52266966,
        "longitude": 9.64193366
      },
      "containers": [
        {
          "id": "mp-pc-74",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-74",
            "container_id": "MP-7002-73",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MTUxNQ==",
          "ticket_id": "20581515",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Fejlsorteret Er der afleveret flyer: Ja Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2024-03-01T09:51:00+00:00",
          "updated_at": "2025-08-19T00:25:00.381678+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczMDQ=",
            "location": {
              "latitude": 55.522707,
              "longitude": 9.641901,
              "name": "Bjørnøvænget 6, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MTY4Nw==",
          "ticket_id": "20581687",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Fejlsorteret Er der afleveret flyer: Ja Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2024-02-16T10:19:00+00:00",
          "updated_at": "2025-08-19T00:25:00.391144+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczMDQ=",
            "location": {
              "latitude": 55.522707,
              "longitude": 9.641901,
              "name": "Bjørnøvænget 6, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MTkxOA==",
          "ticket_id": "20581918",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Fejlsorteret Er der afleveret flyer: Ja Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2024-02-02T11:22:00+00:00",
          "updated_at": "2025-08-19T00:25:00.407901+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczMDQ=",
            "location": {
              "latitude": 55.522707,
              "longitude": 9.641901,
              "name": "Bjørnøvænget 6, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTIxNA==",
          "ticket_id": "20599214",
          "ticket_type": "AO-Ændring til 140 liter beholder til restaffald",
          "description": "vi ønsker en støre skraldespand Skal gammel beholder hjemtages: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2019-08-05T17:58:00+00:00",
          "updated_at": "2025-08-19T00:25:01.616973+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczMDQ=",
            "location": {
              "latitude": 55.522707,
              "longitude": 9.641901,
              "name": "Bjørnøvænget 6, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc1MjM=",
      "location": {
        "name": "Bjørnøvænget 1 7000 Fredericia",
        "latitude": 55.522244,
        "longitude": 9.642928
      },
      "containers": [
        {
          "id": "mp-pc-75",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-75",
            "container_id": "MP-7002-74",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NzU4OQ==",
          "ticket_id": "20577589",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Fejlsorteret Er der afleveret flyer: Ja Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2024-12-06T11:27:00+00:00",
          "updated_at": "2025-08-19T00:25:00.148978+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc1MjM=",
            "location": {
              "latitude": 55.522244,
              "longitude": 9.642928,
              "name": "Bjørnøvænget 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTczNzI=",
      "location": {
        "name": "Bjørnøvænget 10 7000 Fredericia",
        "latitude": 55.52203795,
        "longitude": 9.642786
      },
      "containers": [
        {
          "id": "mp-pc-76",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-76",
            "container_id": "MP-7002-75",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MzI0Ng==",
          "ticket_id": "20593246",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: 2-delt 240 l beholder - Parcel Bjørnøvænget 10 (7000 Fredericia) ContainerNr:417546 ContainerBrik: Ønsket virkningsdato: 10/11-2021 Besked: Kontaktoplysninger: Hans Henrik Sørensen 24250405 hansH39hitmail.com",
          "status": 6,
          "priority": 2,
          "created_at": "2021-11-05T10:04:00+00:00",
          "updated_at": "2025-08-19T00:25:01.255021+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczNzI=",
            "location": {
              "latitude": 55.521987,
              "longitude": 9.642836,
              "name": "Bjørnøvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzI0Nw==",
          "ticket_id": "20593247",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 10/11-2021 Besked: Låg og spand itu Kontaktoplysninger: Hans Henrik Sørensen 24250405 hansH39hitmail.com",
          "status": 6,
          "priority": 2,
          "created_at": "2021-11-05T10:02:00+00:00",
          "updated_at": "2025-08-19T00:25:01.255077+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczNzI=",
            "location": {
              "latitude": 55.521987,
              "longitude": 9.642836,
              "name": "Bjørnøvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzI0NQ==",
          "ticket_id": "20593245",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Hans HenrikTlf.: 24250504Email: hansH39@hotmail.comBesked: Hej har skrevet til jer 10000 gange og sendt foto mit låg påminde skraldespand er gået i stykker under jeres tømning nu sidder det ikke længre fast kom nu igang",
          "status": 6,
          "priority": 2,
          "created_at": "2021-11-04T12:39:00+00:00",
          "updated_at": "2025-08-19T00:25:01.254966+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczNzI=",
            "location": {
              "latitude": 55.521987,
              "longitude": 9.642836,
              "name": "Bjørnøvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzM4NQ==",
          "ticket_id": "20593385",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Bjørnøvænget 10 (7000 Fredericia) ContainerNr:417546 ContainerBrik: Låg itu Ønsket virkningsdato: 25/10-2021 Besked: Kontaktoplysninger: Hans Henrik Sørensen 24250405 hansH39hitmail.com",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-25T12:21:00+00:00",
          "updated_at": "2025-08-19T00:25:01.262808+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczNzI=",
            "location": {
              "latitude": 55.521987,
              "longitude": 9.642836,
              "name": "Bjørnøvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzM4NA==",
          "ticket_id": "20593384",
          "ticket_type": "AO-Håndtag itu (vedhæft evt foto - kun på web)",
          "description": "Mit låg er i stykker falder af ved næste tømning",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-25T11:47:00+00:00",
          "updated_at": "2025-08-19T00:25:01.262756+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczNzI=",
            "location": {
              "latitude": 55.521987,
              "longitude": 9.642836,
              "name": "Bjørnøvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzU2MQ==",
          "ticket_id": "20593561",
          "ticket_type": "AO-Håndtag itu (vedhæft evt foto - kun på web)",
          "description": "Det bliver ikke bedre med vores skraldespand nu taber den pladtik skruerne",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-17T09:59:00+00:00",
          "updated_at": "2025-08-19T00:25:01.273305+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczNzI=",
            "location": {
              "latitude": 55.521987,
              "longitude": 9.642836,
              "name": "Bjørnøvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5Mzg0MQ==",
          "ticket_id": "20593841",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Bjørnøvænget 10 (7000 Fredericia) ContainerNr:417546 ContainerBrik: Låg itu Ønsket virkningsdato: 04/10-2021 Besked: Beholder er knækket ved hængsel låg. Kontaktoplysninger: Hans Henrik Sørensen",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-04T11:13:00+00:00",
          "updated_at": "2025-08-19T00:25:01.290150+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczNzI=",
            "location": {
              "latitude": 55.521987,
              "longitude": 9.642836,
              "name": "Bjørnøvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5Mzg0MA==",
          "ticket_id": "20593840",
          "ticket_type": "AO-Håndtag itu (vedhæft evt foto - kun på web)",
          "description": "Navn: Annie SørensenTlf.: 30263745Email: oliveralberte@hotmail.comBesked: Beholder er knækket ved hængsel låg.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-02T17:44:00+00:00",
          "updated_at": "2025-08-19T00:25:01.290104+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczNzI=",
            "location": {
              "latitude": 55.521987,
              "longitude": 9.642836,
              "name": "Bjørnøvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc2MjE=",
      "location": {
        "name": "Bjørnøvænget 12 7000 Fredericia",
        "latitude": 55.521689,
        "longitude": 9.64282
      },
      "containers": [
        {
          "id": "mp-pc-77",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-77",
            "container_id": "MP-7002-76",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4ODkxOA==",
          "ticket_id": "20588918",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/06-2022 Besked: Kontaktoplysninger: Bent Stage 30483718 bentstage24@gmail.com",
          "status": 6,
          "priority": 2,
          "created_at": "2022-06-10T11:07:00+00:00",
          "updated_at": "2025-08-19T00:25:00.928521+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2MjE=",
            "location": {
              "latitude": 55.521689,
              "longitude": 9.64282,
              "name": "Bjørnøvænget 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4ODkxOQ==",
          "ticket_id": "20588919",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/06-2022 Besked: Kontaktoplysninger: Bent Stage 30483718 bentstage24@gmail.com",
          "status": 6,
          "priority": 2,
          "created_at": "2022-06-10T11:06:00+00:00",
          "updated_at": "2025-08-19T00:25:00.928576+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2MjE=",
            "location": {
              "latitude": 55.521689,
              "longitude": 9.64282,
              "name": "Bjørnøvænget 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc1MjE=",
      "location": {
        "name": "Bjørnøvænget 13 7000 Fredericia",
        "latitude": 55.5212719,
        "longitude": 9.64247499
      },
      "containers": [
        {
          "id": "mp-pc-78",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-78",
            "container_id": "MP-7002-77",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MTkxOQ==",
          "ticket_id": "20581919",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Fejlsorteret Er der afleveret flyer: Ja Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2024-02-02T11:15:00+00:00",
          "updated_at": "2025-08-19T00:25:00.407954+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc1MjE=",
            "location": {
              "latitude": 55.521271,
              "longitude": 9.642474,
              "name": "Bjørnøvænget 13, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTczNzU=",
      "location": {
        "name": "Bjørnøvænget 15 7000 Fredericia",
        "latitude": 55.5211512,
        "longitude": 9.64215228
      },
      "containers": [
        {
          "id": "mp-pc-79",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-79",
            "container_id": "MP-7002-78",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTczNzc=",
      "location": {
        "name": "Bjørnøvænget 17 7000 Fredericia",
        "latitude": 55.52098722,
        "longitude": 9.64168394
      },
      "containers": [
        {
          "id": "mp-pc-80",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-80",
            "container_id": "MP-7002-79",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTcyMjc=",
      "location": {
        "name": "Bjørnøvænget 19 7000 Fredericia",
        "latitude": 55.52084428,
        "longitude": 9.64145484
      },
      "containers": [
        {
          "id": "mp-pc-81",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-81",
            "container_id": "MP-7002-80",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NTY5MA==",
          "ticket_id": "20595690",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-07-23Fraktion: 1 (Mad/Rest)Navn: Anders LyhneTlf.: 23839407Email: lyhne_anders27@Hotmail.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-30T12:17:00+00:00",
          "updated_at": "2025-08-19T00:25:01.404917+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcyMjc=",
            "location": {
              "latitude": 55.520844,
              "longitude": 9.641435,
              "name": "Bjørnøvænget 19, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjA4OQ==",
          "ticket_id": "20596089",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-07-23Fraktion: 1 (Mad/Rest)Navn: Anders LyhneTlf.: 23839407Email: lyhne_anders27@Hotmail.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-24T14:52:00+00:00",
          "updated_at": "2025-08-19T00:25:01.429950+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcyMjc=",
            "location": {
              "latitude": 55.520844,
              "longitude": 9.641435,
              "name": "Bjørnøvænget 19, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTcyODU=",
      "location": {
        "name": "Bjørnøvænget 21 7000 Fredericia",
        "latitude": 55.52068987,
        "longitude": 9.64099869
      },
      "containers": [
        {
          "id": "mp-pc-82",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-82",
            "container_id": "MP-7002-81",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMzg5OTk0OQ==",
          "ticket_id": "13899949",
          "ticket_type": "Affaldet skal afleveres på genbrugspladsen",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2025-04-04T06:36:26.518998+00:00",
          "updated_at": "2025-04-04T06:36:26.520232+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcyODU=",
            "location": {
              "latitude": 55.520707,
              "longitude": 9.640982,
              "name": "Bjørnøvænget 21, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "16968_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MTIwNg==",
          "ticket_id": "20581206",
          "ticket_type": "AO-Generel besked",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2024-04-04T08:14:00+00:00",
          "updated_at": "2025-08-19T00:25:00.362991+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcyODU=",
            "location": {
              "latitude": 55.520707,
              "longitude": 9.640982,
              "name": "Bjørnøvænget 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTcyNTg=",
      "location": {
        "name": "Bjørnøvænget 23 7000 Fredericia",
        "latitude": 55.52078267,
        "longitude": 9.64067284
      },
      "containers": [
        {
          "id": "mp-pc-83",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-83",
            "container_id": "MP-7002-82",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NTA3Mw==",
          "ticket_id": "20575073",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Defekt låg Er der afleveret flyer: Nej Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2025-06-20T11:21:00+00:00",
          "updated_at": "2025-08-19T00:24:59.887604+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcyNTg=",
            "location": {
              "latitude": 55.520745,
              "longitude": 9.640637,
              "name": "Bjørnøvænget 23, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3NTMwNg==",
          "ticket_id": "20575306",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Defekt låg Er der afleveret flyer: Nej Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2025-06-06T11:14:00+00:00",
          "updated_at": "2025-08-19T00:24:59.913858+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcyNTg=",
            "location": {
              "latitude": 55.520745,
              "longitude": 9.640637,
              "name": "Bjørnøvænget 23, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTcyOTY=",
      "location": {
        "name": "Bjørnøvænget 11 7000 Fredericia",
        "latitude": 55.5214375,
        "longitude": 9.64296963
      },
      "containers": [
        {
          "id": "mp-pc-84",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-84",
            "container_id": "MP-7002-83",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MzAwNA==",
          "ticket_id": "20583004",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Tømningsdato: 2023-12-06Fraktion: 2 (Genbrug)Navn: Rune Faurby CarlssonTlf.: 30285208Email: carlssonrune@hotmail.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-12-07T16:13:00+00:00",
          "updated_at": "2025-08-19T00:25:00.467920+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcyOTY=",
            "location": {
              "latitude": 55.521434,
              "longitude": 9.64296,
              "name": "Bjørnøvænget 11, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTA3NA==",
          "ticket_id": "20591074",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Rune Faurby CarlssonTlf.: 30285208Email: carlssonrune@hotmail.comBesked: Hej. Vi fik for nogle uger siden leveret en ekstra affaldsbeholder. Det er ikke noget vi selv har bestilt og vi har en fået en besked herom. Ved I hvad det skyldes? Vi bor i nybyg, som tænker om det er til en anden adresse, men kan ikke se nogen info på den. Mvh Rune",
          "status": 6,
          "priority": 2,
          "created_at": "2022-02-03T11:58:00+00:00",
          "updated_at": "2025-08-19T00:25:01.122938+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcyOTY=",
            "location": {
              "latitude": 55.521434,
              "longitude": 9.64296,
              "name": "Bjørnøvænget 11, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5ODM0NA==",
          "ticket_id": "20598344",
          "ticket_type": "AO-Ændring til kompostbeholder",
          "description": "Hej, Vi vil gerne begynde at hjemmekompostere og afmelder derfor vores grønne affaldsspand. Hvornår vil ændringen træde i kraft og vil den grønne spand blive afhentet? Mvh Rune",
          "status": 6,
          "priority": 2,
          "created_at": "2021-01-29T10:48:00+00:00",
          "updated_at": "2025-08-19T00:25:01.564166+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcyOTY=",
            "location": {
              "latitude": 55.521434,
              "longitude": 9.64296,
              "name": "Bjørnøvænget 11, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5ODY5Mg==",
          "ticket_id": "20598692",
          "ticket_type": "AO-Generel besked",
          "description": "Hej, Vi har ikke fået leveret de brune poser til grønt affald i over et år. Så vidt jeg kan læse mig til burde de blive udleveret 1-2 årligt. Kan I sende et par pakker med til næste afhentning? Mvh Rune",
          "status": 6,
          "priority": 2,
          "created_at": "2020-07-10T20:44:00+00:00",
          "updated_at": "2025-08-19T00:25:01.584667+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcyOTY=",
            "location": {
              "latitude": 55.521434,
              "longitude": 9.64296,
              "name": "Bjørnøvænget 11, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTIzNQ==",
          "ticket_id": "20599235",
          "ticket_type": "AO-Bestilling af sommertømning  (15/6 - 15/8)",
          "description": "Hej, Jeg vil gerne bestille sommertømning af både rest- og grøntaffald. Hvornår kan det træde i kraft? Mvh Rune",
          "status": 6,
          "priority": 2,
          "created_at": "2019-07-27T20:12:00+00:00",
          "updated_at": "2025-08-19T00:25:01.618639+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcyOTY=",
            "location": {
              "latitude": 55.521434,
              "longitude": 9.64296,
              "name": "Bjørnøvænget 11, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTU5NQ==",
          "ticket_id": "20599595",
          "ticket_type": "AO-Manglende tømning - grønt affald",
          "description": "Hej, Jeg har ikke fået tømt mit grønne affald i sidste uge. Derimod fik jeg tømt min beholder til restaffald. Jeg kan ikke tjekke tømningstidspunkt via kommunens hjemmeside (http://www.p-fournaise-systems.dk/fredericia/), da min adresse (Bjørnøvænget 11), ikke fremgår. Slår jeg min nabos adresse op kan jeg se at restaffald bør hentes i lige uger, men skraldevognen kommer altså i ulige uger, og nu da de ikke tager mit grønne affald er jeg lidt forvirret. Kan I svare mig på hvornår jeg får afhente",
          "status": 6,
          "priority": 2,
          "created_at": "2018-11-13T13:22:00+00:00",
          "updated_at": "2025-08-19T00:25:01.639295+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcyOTY=",
            "location": {
              "latitude": 55.521434,
              "longitude": 9.64296,
              "name": "Bjørnøvænget 11, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc2MDM=",
      "location": {
        "name": "Bjørnøvænget 7 7000 Fredericia",
        "latitude": 55.52162025,
        "longitude": 9.64361079
      },
      "containers": [
        {
          "id": "mp-pc-85",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-85",
            "container_id": "MP-7002-84",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MDkyMQ==",
          "ticket_id": "20590921",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 01/01-2022 Besked: Kontaktoplysninger: Morning Stars ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2022-02-10T12:15:00+00:00",
          "updated_at": "2025-08-19T00:25:01.105917+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2MDM=",
            "location": {
              "latitude": 55.521499,
              "longitude": 9.643774,
              "name": "Bjørnøvænget 7, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MDkyMg==",
          "ticket_id": "20590922",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/01-2022 Besked: Kontaktoplysninger: Morning Stars ApS",
          "status": 6,
          "priority": 2,
          "created_at": "2022-02-10T12:14:00+00:00",
          "updated_at": "2025-08-19T00:25:01.106011+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2MDM=",
            "location": {
              "latitude": 55.521499,
              "longitude": 9.643774,
              "name": "Bjørnøvænget 7, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTcyNzY=",
      "location": {
        "name": "Bjørnøvænget 9 7000 Fredericia",
        "latitude": 55.52158497,
        "longitude": 9.64327233
      },
      "containers": [
        {
          "id": "mp-pc-86",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-86",
            "container_id": "MP-7002-85",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MjkxOA==",
          "ticket_id": "20592918",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Bjørnøvænget 9 (7000 Fredericia) ContainerNr:417460 ContainerBrik: Låg itu Ønsket virkningsdato: 29/11-2021 Besked: Kontaktoplysninger: Arne Hansen 41994526 Arnepia57@gmail.com",
          "status": 6,
          "priority": 2,
          "created_at": "2021-11-29T11:08:00+00:00",
          "updated_at": "2025-08-19T00:25:01.236588+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcyNzY=",
            "location": {
              "latitude": 55.521547,
              "longitude": 9.643196,
              "name": "Bjørnøvænget 9, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc1NjA=",
      "location": {
        "name": "Bjørnøvænget 5 7000 Fredericia",
        "latitude": 55.52184782,
        "longitude": 9.64348129
      },
      "containers": [
        {
          "id": "mp-pc-87",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-87",
            "container_id": "MP-7002-86",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3OTU1OQ==",
          "ticket_id": "20579559",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 23/07 2024 Besked: Kontaktoplysninger: Lene Gundelach-Taabbel 28118725 lene.gundelach@live.dk",
          "status": 6,
          "priority": 2,
          "created_at": "2024-07-16T08:22:00+00:00",
          "updated_at": "2025-08-19T00:25:00.261047+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc1NjA=",
            "location": {
              "latitude": 55.521826,
              "longitude": 9.643641,
              "name": "Bjørnøvænget 5, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDE2Nw==",
          "ticket_id": "20594167",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 16/09-2021 Besked: Kontaktoplysninger: Henrik Gundelach-Taabbel",
          "status": 6,
          "priority": 2,
          "created_at": "2021-09-16T09:49:00+00:00",
          "updated_at": "2025-08-19T00:25:01.309299+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc1NjA=",
            "location": {
              "latitude": 55.521826,
              "longitude": 9.643641,
              "name": "Bjørnøvænget 5, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3MTI=",
      "location": {
        "name": "Omøvænget 4 7000 Fredericia",
        "latitude": 55.52089473,
        "longitude": 9.64590796
      },
      "containers": [
        {
          "id": "mp-pc-88",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-88",
            "container_id": "MP-7002-87",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NzE1Ng==",
          "ticket_id": "20587156",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Tømningsdato: 2022-09-27Fraktion: 2 (Genbrug)Navn: Dorte Runge-Moos Tlf.: 23326216Email: runge-moos@mail.dkBesked: det er genbrug i dag den 25.10 der ikke er hentet. Det ligger stadig i vores indkørsel",
          "status": 6,
          "priority": 2,
          "created_at": "2022-10-25T20:17:00+00:00",
          "updated_at": "2025-08-19T00:25:00.762665+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MTI=",
            "location": {
              "latitude": 55.520942,
              "longitude": 9.645859,
              "name": "Omøvænget 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NzI5Nw==",
          "ticket_id": "20587297",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 11/10-2022 Besked: Kontaktoplysninger: Willy Jørgensen",
          "status": 6,
          "priority": 2,
          "created_at": "2022-10-07T11:45:00+00:00",
          "updated_at": "2025-08-19T00:25:00.780647+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MTI=",
            "location": {
              "latitude": 55.520942,
              "longitude": 9.645859,
              "name": "Omøvænget 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NzI5OA==",
          "ticket_id": "20587298",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 07/10-2022 Besked: Kontaktoplysninger: Willy Jørgensen",
          "status": 6,
          "priority": 2,
          "created_at": "2022-10-07T11:44:00+00:00",
          "updated_at": "2025-08-19T00:25:00.780749+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MTI=",
            "location": {
              "latitude": 55.520942,
              "longitude": 9.645859,
              "name": "Omøvænget 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3MzE=",
      "location": {
        "name": "Omøvænget 2 7000 Fredericia",
        "latitude": 55.52112445,
        "longitude": 9.64576537
      },
      "containers": [
        {
          "id": "mp-pc-89",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-89",
            "container_id": "MP-7002-88",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MTkyMA==",
          "ticket_id": "20581920",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Fejlsorteret Er der afleveret flyer: Ja Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2024-02-02T10:37:00+00:00",
          "updated_at": "2025-08-19T00:25:00.408001+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzE=",
            "location": {
              "latitude": 55.521124,
              "longitude": 9.645765,
              "name": "Omøvænget 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTE2Mw==",
          "ticket_id": "20585163",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Manglende tømning her - har stået meget længe. Der står ekstra sække, som skal med på fredag. Der er afstandstillæg på adressen.",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-28T09:20:00+00:00",
          "updated_at": "2025-08-19T00:25:00.601150+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzE=",
            "location": {
              "latitude": 55.521124,
              "longitude": 9.645765,
              "name": "Omøvænget 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTIzMA==",
          "ticket_id": "20585230",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Borger er tilmeldt med afstandstillæg. De har igen ikke fået tømt? Vil i give ruten besked om at være opmærksom på det, så vi ikke skal kontaktes efter hver tømmedag?",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-20T09:37:00+00:00",
          "updated_at": "2025-08-19T00:25:00.605006+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzE=",
            "location": {
              "latitude": 55.521124,
              "longitude": 9.645765,
              "name": "Omøvænget 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTcxMA==",
          "ticket_id": "20585710",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Tlf.nr. 23988200. Borger kontakter os for manglende tømning. De mener, at de betaler for afstandstillæg, så beholder skal afhentes på adressen. Jeg kan ikke se afstandstillæg i vores system - har I noget hos jer?",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-20T13:01:00+00:00",
          "updated_at": "2025-08-19T00:25:00.634244+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzE=",
            "location": {
              "latitude": 55.521124,
              "longitude": 9.645765,
              "name": "Omøvænget 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTgxMw==",
          "ticket_id": "20585813",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Tlf. 23988200 Borger ringer og gør opmærksom på, at de ikke har fået tømt i fredags trods registrering i tømmeloggen. Vil I undersøge med bilen?",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-06T09:39:00+00:00",
          "updated_at": "2025-08-19T00:25:00.639898+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzE=",
            "location": {
              "latitude": 55.521124,
              "longitude": 9.645765,
              "name": "Omøvænget 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NjIyNQ==",
          "ticket_id": "20586225",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 12/01 2023 Besked: Kontaktoplysninger: Dögg Káradóttir",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-05T12:40:00+00:00",
          "updated_at": "2025-08-19T00:25:00.681500+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzE=",
            "location": {
              "latitude": 55.521124,
              "longitude": 9.645765,
              "name": "Omøvænget 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NjIyNA==",
          "ticket_id": "20586224",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 12/01 2023 Besked: Kontaktoplysninger: Dögg Káradóttir",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-05T12:40:00+00:00",
          "updated_at": "2025-08-19T00:25:00.681402+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MzE=",
            "location": {
              "latitude": 55.521124,
              "longitude": 9.645765,
              "name": "Omøvænget 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3NDE=",
      "location": {
        "name": "Agersøvænget 6 7000 Fredericia",
        "latitude": 55.52099734,
        "longitude": 9.64439969
      },
      "containers": [
        {
          "id": "mp-pc-90",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-90",
            "container_id": "MP-7002-89",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTg1Ng==",
          "ticket_id": "20585856",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 07/02-2023 Besked: Bestilt af borger pr. tlf. Kontaktoplysninger: Henrik Hohwü Petersen",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-01T09:06:00+00:00",
          "updated_at": "2025-08-19T00:25:00.642372+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDE=",
            "location": {
              "latitude": 55.520974,
              "longitude": 9.644462,
              "name": "Agersøvænget 6, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTg1NQ==",
          "ticket_id": "20585855",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 08/02 2023 Besked: Kontaktoplysninger: Henrik Hohwü Petersen",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-01T09:06:00+00:00",
          "updated_at": "2025-08-19T00:25:00.642317+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3NDE=",
            "location": {
              "latitude": 55.520974,
              "longitude": 9.644462,
              "name": "Agersøvænget 6, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTczNzk=",
      "location": {
        "name": "Agersøvænget 1 7000 Fredericia",
        "latitude": 55.52016793,
        "longitude": 9.64488545
      },
      "containers": [
        {
          "id": "mp-pc-91",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-91",
            "container_id": "MP-7002-90",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NjgwMA==",
          "ticket_id": "20586800",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Navn: Benny BalsgaardTlf.: 31328445Email: bennybalsgaard@hotmail.comBesked: Vi glemte at sætte affaldsspanden id i fredags. Kan vi få en ekstra tømning først i uge 48. Vh Agersøvænget 1",
          "status": 6,
          "priority": 2,
          "created_at": "2022-11-26T13:05:00+00:00",
          "updated_at": "2025-08-19T00:25:00.739101+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczNzk=",
            "location": {
              "latitude": 55.520018,
              "longitude": 9.645125,
              "name": "Agersøvænget 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTczMTI=",
      "location": {
        "name": "Halmøvænget 1 7000 Fredericia",
        "latitude": 55.51964314,
        "longitude": 9.64503189
      },
      "containers": [
        {
          "id": "mp-pc-92",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-92",
            "container_id": "MP-7002-91",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTcwNjY=",
      "location": {
        "name": "Halmøvænget 3 7000 Fredericia",
        "latitude": 55.51941426,
        "longitude": 9.64499487
      },
      "containers": [
        {
          "id": "mp-pc-93",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-93",
            "container_id": "MP-7002-92",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4Nzc4MA==",
          "ticket_id": "20587780",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Kirsten GlerupTlf.: 42372440Email: kirstenglerup@yahoo.dkBesked: Sæk med tøj. Gælder det tøj, som ikke kan genbruges. Mvh Kirsten glerup",
          "status": 6,
          "priority": 2,
          "created_at": "2022-08-30T08:40:00+00:00",
          "updated_at": "2025-08-19T00:25:00.832607+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcwNjY=",
            "location": {
              "latitude": 55.519416,
              "longitude": 9.644929,
              "name": "Halmøvænget 3, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTcyOTA=",
      "location": {
        "name": "Halmøvænget 5 7000 Fredericia",
        "latitude": 55.519183,
        "longitude": 9.644757
      },
      "containers": [
        {
          "id": "mp-pc-94",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-94",
            "container_id": "MP-7002-93",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MDg2MA==",
          "ticket_id": "20580860",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Halmøvænget 5 (7000 Fredericia) ContainerNr:417473 ContainerBrik:00400000125C95DD Håndtag itu Ønsket virkningsdato: 14/05-2024 Besked: Mail fra borger: Vi har i dag fået tømt vores affaldsbeholder, desværre har renovationsfirmaet knækket håndtaget, hvilket ikke er underligt med den hårde behandling affaldsbeholderne får i forbindelse med tømning. Kontaktoplysninger: Else-Marie Lorenzen 23988948 Em_lorenzen@live.dk",
          "status": 6,
          "priority": 2,
          "created_at": "2024-05-13T10:29:00+00:00",
          "updated_at": "2025-08-19T00:25:00.341124+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcyOTA=",
            "location": {
              "latitude": 55.519183,
              "longitude": 9.644757,
              "name": "Halmøvænget 5, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzQzNg==",
          "ticket_id": "20593436",
          "ticket_type": "AO-Generel besked",
          "description": "Kontaktet af Trefor, som melder ind, at kabelboks ud for nr. 5 er blevet påkørt ved tømning 15.10. Hanne hos Trefor kan kontaktes på nr. 2688 3339 eller hl@trefor.dk.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-18T14:54:00+00:00",
          "updated_at": "2025-08-19T00:25:01.266083+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcyOTA=",
            "location": {
              "latitude": 55.519183,
              "longitude": 9.644757,
              "name": "Halmøvænget 5, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDEzMA==",
          "ticket_id": "20594130",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Else-Marie LorenzenTlf.: 23988948Email: em_lorenzen@live.dkBesked: Efter overgang til mere sortering, oplevede jeg at rullen med sække som kom i Maj var væsentlig mindre end tidligere udleverede ruller. Dette betyder at vi allerede nu er løbet tør for sække. I snit bruger vi 8 sække pr mdr. hvilket giver mulighed for sække til 7,5 afhentningsdage. Jeg har snakket med andre som også oplever at der i denne omgang slet ikke er leveret nok sække. Kunne det overvejes at der fremover leveres fle",
          "status": 6,
          "priority": 2,
          "created_at": "2021-09-14T11:24:00+00:00",
          "updated_at": "2025-08-19T00:25:01.307145+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcyOTA=",
            "location": {
              "latitude": 55.519183,
              "longitude": 9.644757,
              "name": "Halmøvænget 5, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTIzOQ==",
          "ticket_id": "20599239",
          "ticket_type": "AO-Manglende tømning - grønt affald",
          "description": "Tømning af grønt affald var på naboveje, men de glemte at komme og tømme vores",
          "status": 6,
          "priority": 2,
          "created_at": "2019-07-26T08:11:00+00:00",
          "updated_at": "2025-08-19T00:25:01.618869+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcyOTA=",
            "location": {
              "latitude": 55.519183,
              "longitude": 9.644757,
              "name": "Halmøvænget 5, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTM5MA==",
          "ticket_id": "20599390",
          "ticket_type": "AO-Generel besked",
          "description": "Hejsa Ved tidligere henvendelse fik jeg at vide at jeg ville få udleveret papirsposer fra jer i Oktober og februar. Nu er vi i slutningen af April og jeg har endnu ikke modtaget poserne som skulle komme i oktober 2018 eller februar 2019. Håber at I vil få os på listen over folk som skal have poser til grønt affald og at I vil sørge for at vi får leveret dem for februar måned som vi ikke har fået. En anden lille ting: Vi oplever flere gange at vores grønt affald bliver tømt den dag vi får tømt de",
          "status": 6,
          "priority": 2,
          "created_at": "2019-04-26T08:24:00+00:00",
          "updated_at": "2025-08-19T00:25:01.626753+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcyOTA=",
            "location": {
              "latitude": 55.519183,
              "longitude": 9.644757,
              "name": "Halmøvænget 5, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTUxNA==",
          "ticket_id": "20599514",
          "ticket_type": "AO-Generel besked",
          "description": "Hvor mange gange om året får man leveret papirsposer til grønt affald? Vi er nemlig ved at løbe tør, fik den første stak i uge 35. Må man bruge bioposer som man kan købe i supermarkedet? Hilsen Else-Marie",
          "status": 6,
          "priority": 2,
          "created_at": "2019-01-20T15:46:00+00:00",
          "updated_at": "2025-08-19T00:25:01.633712+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcyOTA=",
            "location": {
              "latitude": 55.519183,
              "longitude": 9.644757,
              "name": "Halmøvænget 5, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3MjI=",
      "location": {
        "name": "Halmøvænget 4 7000 Fredericia",
        "latitude": 55.51930412,
        "longitude": 9.64385427
      },
      "containers": [
        {
          "id": "mp-pc-95",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-95",
            "container_id": "MP-7002-94",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTA5MQ==",
          "ticket_id": "20585091",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Uwe Jensen Tlf.: 51370864Email: uwe@lerte.dkBesked: Mine afhentninger genbrug passer ikke med mine naboers. Vil i kigge på det",
          "status": 6,
          "priority": 2,
          "created_at": "2023-04-01T16:06:00+00:00",
          "updated_at": "2025-08-19T00:25:00.596864+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MjI=",
            "location": {
              "latitude": 55.519304,
              "longitude": 9.643854,
              "name": "Halmøvænget 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTEwNw==",
          "ticket_id": "20585107",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Uwe Jensen Tlf.: 51370864Email: uwe@lerte.dkBesked: Mine afhentninger genbrug passer ikke med mine naboers på samme vej. Vil i kigge på det.",
          "status": 6,
          "priority": 2,
          "created_at": "2023-04-01T16:04:00+00:00",
          "updated_at": "2025-08-19T00:25:00.597766+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MjI=",
            "location": {
              "latitude": 55.519304,
              "longitude": 9.643854,
              "name": "Halmøvænget 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NjY2Mw==",
          "ticket_id": "20586663",
          "ticket_type": "AO-Generel besked",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2022-12-08T18:29:00+00:00",
          "updated_at": "2025-08-19T00:25:00.724245+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MjI=",
            "location": {
              "latitude": 55.519304,
              "longitude": 9.643854,
              "name": "Halmøvænget 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4Njk2Mg==",
          "ticket_id": "20586962",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 28/11 2022 Besked: Kontaktoplysninger: Uwe Dieter Jensen",
          "status": 6,
          "priority": 2,
          "created_at": "2022-11-21T07:56:00+00:00",
          "updated_at": "2025-08-19T00:25:00.752442+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MjI=",
            "location": {
              "latitude": 55.519304,
              "longitude": 9.643854,
              "name": "Halmøvænget 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4Njk2Mw==",
          "ticket_id": "20586963",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 28/11 2022 Besked: Kontaktoplysninger: Uwe Dieter Jensen",
          "status": 6,
          "priority": 2,
          "created_at": "2022-11-21T07:55:00+00:00",
          "updated_at": "2025-08-19T00:25:00.752488+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MjI=",
            "location": {
              "latitude": 55.519304,
              "longitude": 9.643854,
              "name": "Halmøvænget 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc1MjA=",
      "location": {
        "name": "Halmøvænget 2 7000 Fredericia",
        "latitude": 55.51939109,
        "longitude": 9.64430201
      },
      "containers": [
        {
          "id": "mp-pc-96",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-96",
            "container_id": "MP-7002-95",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NjAxMQ==",
          "ticket_id": "20596011",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "mgl. tømning står på grund med byggeri, men hus er beboet. står op af skurvogn p.t.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-26T11:09:00+00:00",
          "updated_at": "2025-08-19T00:25:01.425286+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc1MjA=",
            "location": {
              "latitude": 55.519391,
              "longitude": 9.644302,
              "name": "Halmøvænget 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTczODA=",
      "location": {
        "name": "Halmøvænget 6 7000 Fredericia",
        "latitude": 55.51918896,
        "longitude": 9.64431449
      },
      "containers": [
        {
          "id": "mp-pc-97",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-97",
            "container_id": "MP-7002-96",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MzA1Mw==",
          "ticket_id": "20593053",
          "ticket_type": "AO-Generel besked",
          "description": "Beskadiget kabelboks i nr. 5 - robotplæneklipper/basen bag ved boksen er samtidigt beskadiget. Kenneth kan kontaktes på nr. 3155 4277 for nærmere oplysninger.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-18T14:50:00+00:00",
          "updated_at": "2025-08-19T00:25:01.244438+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczODA=",
            "location": {
              "latitude": 55.519233,
              "longitude": 9.64427,
              "name": "Halmøvænget 6, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc2OTU=",
      "location": {
        "name": "Agersøvænget 5 7000 Fredericia",
        "latitude": 55.51998525,
        "longitude": 9.64410815
      },
      "containers": [
        {
          "id": "mp-pc-98",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-98",
            "container_id": "MP-7002-97",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4Mjk3Mw==",
          "ticket_id": "20582973",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Bestilling sendes via kommunemail. Der er problemer med at beholder ikke kunne se hos MP. Ny container nr. 437688 oprettet.",
          "status": 6,
          "priority": 2,
          "created_at": "2023-12-11T13:31:00+00:00",
          "updated_at": "2025-08-19T00:25:00.466306+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2OTU=",
            "location": {
              "latitude": 55.519985,
              "longitude": 9.644108,
              "name": "Agersøvænget 5, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4Mjk3NA==",
          "ticket_id": "20582974",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: 2-delt 240 l beholder - Parcel Agersøvænget 5 (7000 Fredericia) ContainerNr:436203 ContainerBrik:004000001263F7F3 Ønsket virkningsdato: 11/12-2023 Besked: Kontaktoplysninger: Carsten Teglgård Pedersen",
          "status": 6,
          "priority": 2,
          "created_at": "2023-12-11T13:28:00+00:00",
          "updated_at": "2025-08-19T00:25:00.466355+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2OTU=",
            "location": {
              "latitude": 55.519985,
              "longitude": 9.644108,
              "name": "Agersøvænget 5, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4Mjk3NQ==",
          "ticket_id": "20582975",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 12/12-2023 Besked: Ny registrering, der erstatter container nr. 436203, der ikke er registeret hos Marius Pedersen. Kontaktoplysninger: Carsten Teglgård Pedersen",
          "status": 6,
          "priority": 2,
          "created_at": "2023-12-11T13:25:00+00:00",
          "updated_at": "2025-08-19T00:25:00.466403+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2OTU=",
            "location": {
              "latitude": 55.519985,
              "longitude": 9.644108,
              "name": "Agersøvænget 5, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4Mjk4Mg==",
          "ticket_id": "20582982",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Bedes tømt Navn: Heidi Linnet Besked: Vi havde stillet vores affaldsspand helt ud til vejen torsdag aften til tømning fredag morgen, men den er ikke blevet tømt. Den er næsten fuld, så vi vil gerne have den tømt snarest.",
          "status": 6,
          "priority": 2,
          "created_at": "2023-12-11T09:07:00+00:00",
          "updated_at": "2025-08-19T00:25:00.466770+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2OTU=",
            "location": {
              "latitude": 55.519985,
              "longitude": 9.644108,
              "name": "Agersøvænget 5, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MzU1MA==",
          "ticket_id": "20583550",
          "ticket_type": "AO-Generel besked",
          "description": "RM 240 l afmeldt i EASY 2022 ved hvad der ligner en fejl. Jeg har dd. fjernet slutdato i EASY. --- Marius Pedersen mail pr. 2023.09.05 Hej Her er en 2 delt 240 ltr. Spand nr. 436203 Vil i sørge for den kommer i affald online Venlig hilsen / Best regards Jane Nielsen Marius Pedersen A/S",
          "status": 6,
          "priority": 2,
          "created_at": "2023-10-06T15:17:00+00:00",
          "updated_at": "2025-08-19T00:25:00.507269+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2OTU=",
            "location": {
              "latitude": 55.519985,
              "longitude": 9.644108,
              "name": "Agersøvænget 5, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4ODY2Nw==",
          "ticket_id": "20588667",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 04/07 2022 Besked: Kontaktoplysninger: Carsten Teglgård Pedersen",
          "status": 6,
          "priority": 2,
          "created_at": "2022-06-27T10:31:00+00:00",
          "updated_at": "2025-08-19T00:25:00.914833+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2OTU=",
            "location": {
              "latitude": 55.519985,
              "longitude": 9.644108,
              "name": "Agersøvænget 5, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4ODY2OA==",
          "ticket_id": "20588668",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 04/07 2022 Besked: Kontaktoplysninger: Carsten Teglgård Pedersen",
          "status": 6,
          "priority": 2,
          "created_at": "2022-06-27T10:29:00+00:00",
          "updated_at": "2025-08-19T00:25:00.914931+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2OTU=",
            "location": {
              "latitude": 55.519985,
              "longitude": 9.644108,
              "name": "Agersøvænget 5, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTcyNDI=",
      "location": {
        "name": "Agersøvænget 11 7000 Fredericia",
        "latitude": 55.51960921,
        "longitude": 9.64293209
      },
      "containers": [
        {
          "id": "mp-pc-99",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-99",
            "container_id": "MP-7002-98",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDQ0MjI1OQ==",
          "ticket_id": "10442259",
          "ticket_type": "Gavepapir- og bånd er restaffald",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-11-01T07:13:17.251581+00:00",
          "updated_at": "2024-11-01T07:13:17.252243+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcyNDI=",
            "location": {
              "latitude": 55.51963,
              "longitude": 9.642893,
              "name": "Agersøvænget 11, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "16961_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTM5MzQ=",
      "location": {
        "name": "Ærøvænget 3 7000 Fredericia",
        "latitude": 55.518848,
        "longitude": 9.6422
      },
      "containers": [
        {
          "id": "mp-pc-100",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-100",
            "container_id": "MP-7002-99",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NDc5NQ==",
          "ticket_id": "20584795",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Thomas Ingwersen Tlf.: 24993759Email: thomas.ingwersen1313@gmail.comBesked: Hvordan får jeg flere poser til mad affald?",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-11T21:44:00+00:00",
          "updated_at": "2025-08-19T00:25:00.581650+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTM5MzQ=",
            "location": {
              "latitude": 55.518848,
              "longitude": 9.6422,
              "name": "Ærøvænget 3, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTE4NA==",
          "ticket_id": "20599184",
          "ticket_type": "AO-Ændring til 140 liter beholder til grønt affald",
          "description": "Skal gammel beholder hjemtages: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2019-08-20T11:10:00+00:00",
          "updated_at": "2025-08-19T00:25:01.614947+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTM5MzQ=",
            "location": {
              "latitude": 55.518848,
              "longitude": 9.6422,
              "name": "Ærøvænget 3, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTYyNTk=",
      "location": {
        "name": "Hjortøvænget 2 7000 Fredericia",
        "latitude": 55.5192801,
        "longitude": 9.64202757
      },
      "containers": [
        {
          "id": "mp-pc-101",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-101",
            "container_id": "MP-7002-100",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NDczMw==",
          "ticket_id": "20584733",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Marie-Louise HolmegaardTlf.: 20489405Email: ml-holmegaard@hotmail.comBesked: Er det muligt at få flere poser til genbrugssortering?? Har ikke flere",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-22T16:30:00+00:00",
          "updated_at": "2025-08-19T00:25:00.578509+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYyNTk=",
            "location": {
              "latitude": 55.51928,
              "longitude": 9.642027,
              "name": "Hjortøvænget 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTA3MQ==",
          "ticket_id": "20595071",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-08-06Fraktion: 1 (Mad/Rest)Navn: Marie-Louise HolmegaardTlf.: 20489405Email: ml-holmegaard@hotmail.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-14T15:05:00+00:00",
          "updated_at": "2025-08-19T00:25:01.364565+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYyNTk=",
            "location": {
              "latitude": 55.51928,
              "longitude": 9.642027,
              "name": "Hjortøvænget 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTYxNjY=",
      "location": {
        "name": "Hjortøvænget 4 7000 Fredericia",
        "latitude": 55.51948823,
        "longitude": 9.64197268
      },
      "containers": [
        {
          "id": "mp-pc-102",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-102",
            "container_id": "MP-7002-101",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NjQzNw==",
          "ticket_id": "20576437",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Ingen madaffald - tømt som restaffald Er der afleveret flyer: Nej Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2025-03-14T10:03:00+00:00",
          "updated_at": "2025-08-19T00:25:00.044345+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYxNjY=",
            "location": {
              "latitude": 55.519488,
              "longitude": 9.641972,
              "name": "Hjortøvænget 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTI0NQ==",
          "ticket_id": "20595245",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "STANDPLADS - ned forbi hus. Mellem hus, gennem låg til venstre bag garagen.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-10T14:41:00+00:00",
          "updated_at": "2025-08-19T00:25:01.375887+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYxNjY=",
            "location": {
              "latitude": 55.519488,
              "longitude": 9.641972,
              "name": "Hjortøvænget 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTI0Nw==",
          "ticket_id": "20595247",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Ekstra tømning uden beregning. Var blevet lovet at blive tilmeldt afstandsordningen, uden at det var sket.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-23T13:21:00+00:00",
          "updated_at": "2025-08-19T00:25:01.376005+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYxNjY=",
            "location": {
              "latitude": 55.519488,
              "longitude": 9.641972,
              "name": "Hjortøvænget 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTI5OA==",
          "ticket_id": "20599298",
          "ticket_type": "AO-Generel besked",
          "description": "Att.: Susanne Sigurdsson Angående sagsnummer: 16000274C Hej igen Jeg har en havemand, der tager alt det grønne affald med, så jeg mener umiddelbart ikke, at jeg har behov for en kompostbeholder. M. v. h. Nikolaj",
          "status": 6,
          "priority": 2,
          "created_at": "2019-06-12T11:42:00+00:00",
          "updated_at": "2025-08-19T00:25:01.621654+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYxNjY=",
            "location": {
              "latitude": 55.519488,
              "longitude": 9.641972,
              "name": "Hjortøvænget 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTMwMA==",
          "ticket_id": "20599300",
          "ticket_type": "AO-Generel besked",
          "description": "Hej Jeg bruger ikke beholderen til grønt affald, men jeg betaler for tømning. Jeg vil derfor høre, om jeg kan framelde tømningen, så jeg ikke bliver opkrævet betaling. M. v. h. Nikolaj",
          "status": 6,
          "priority": 2,
          "created_at": "2019-06-11T17:43:00+00:00",
          "updated_at": "2025-08-19T00:25:01.621748+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYxNjY=",
            "location": {
              "latitude": 55.519488,
              "longitude": 9.641972,
              "name": "Hjortøvænget 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTM0OQ==",
          "ticket_id": "20599349",
          "ticket_type": "AO-Ændring til 180-190 liter beholder til restaffald",
          "description": "Skal gammel beholder hjemtages: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2019-05-17T14:51:00+00:00",
          "updated_at": "2025-08-19T00:25:01.624626+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYxNjY=",
            "location": {
              "latitude": 55.519488,
              "longitude": 9.641972,
              "name": "Hjortøvænget 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTYxODM=",
      "location": {
        "name": "Hjortøvænget 6 7000 Fredericia",
        "latitude": 55.51962433,
        "longitude": 9.64175743
      },
      "containers": [
        {
          "id": "mp-pc-103",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-103",
            "container_id": "MP-7002-102",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY3NTY=",
      "location": {
        "name": "Hjortøvænget 13 7000 Fredericia",
        "latitude": 55.519484,
        "longitude": 9.641362
      },
      "containers": [
        {
          "id": "mp-pc-104",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-104",
            "container_id": "MP-7002-103",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQxMDk=",
      "location": {
        "name": "Hjortøvænget 8 7000 Fredericia",
        "latitude": 55.519758,
        "longitude": 9.64143
      },
      "containers": [
        {
          "id": "mp-pc-105",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-105",
            "container_id": "MP-7002-104",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY3NTc=",
      "location": {
        "name": "Hjortøvænget 15 7000 Fredericia",
        "latitude": 55.519665,
        "longitude": 9.641024
      },
      "containers": [
        {
          "id": "mp-pc-106",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-106",
            "container_id": "MP-7002-105",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MzQ3MA==",
          "ticket_id": "20583470",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Beholderen ej tømt, var ikke stillet i skel, men står synligt 3 meter fra skel. Vi kan ikke klare en hel periode til næste tømning. Stiller beholderen i skel hvis i har en bil i nærheden ð",
          "status": 6,
          "priority": 2,
          "created_at": "2023-10-13T15:47:00+00:00",
          "updated_at": "2025-08-19T00:25:00.502456+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY3NTc=",
            "location": {
              "latitude": 55.519665,
              "longitude": 9.641024,
              "name": "Hjortøvænget 15, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY3NTU=",
      "location": {
        "name": "Hjortøvænget 10 7000 Fredericia",
        "latitude": 55.519873,
        "longitude": 9.64109
      },
      "containers": [
        {
          "id": "mp-pc-107",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-107",
            "container_id": "MP-7002-106",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NDA1OQ==",
          "ticket_id": "20584059",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "Kære sagsbehandler, Jeg vil høre høre ind til muligheden for at skifte skraldespand fra en 2-delt 240 liters til mad- og restaffald, til en 240 liters til ren restaffald. Kan dette lade sig gøre? Tusind tak. Mvh Nicklas",
          "status": 6,
          "priority": 2,
          "created_at": "2023-08-04T07:53:00+00:00",
          "updated_at": "2025-08-19T00:25:00.537377+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY3NTU=",
            "location": {
              "latitude": 55.519873,
              "longitude": 9.64109,
              "name": "Hjortøvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTUwMzk=",
      "location": {
        "name": "Hjortøvænget 17 7000 Fredericia",
        "latitude": 55.51976738,
        "longitude": 9.64058961
      },
      "containers": [
        {
          "id": "mp-pc-108",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-108",
            "container_id": "MP-7002-107",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDYwMDU5Mw==",
          "ticket_id": "20600593",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Vi har i dag 12/10 ikke fået tømt vores beholder til restaffald, hvad gør vi nu? Den er fyldt op.",
          "status": 6,
          "priority": 2,
          "created_at": "2016-10-12T21:46:00+00:00",
          "updated_at": "2025-08-19T00:25:01.703816+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUwMzk=",
            "location": {
              "latitude": 55.519767,
              "longitude": 9.640589,
              "name": "Hjortøvænget 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTYwNjM=",
      "location": {
        "name": "Hjortøvænget 12 7000 Fredericia",
        "latitude": 55.51996853,
        "longitude": 9.64066732
      },
      "containers": [
        {
          "id": "mp-pc-109",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-109",
            "container_id": "MP-7002-108",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTYwMTM=",
      "location": {
        "name": "Hjortøvænget 14 7000 Fredericia",
        "latitude": 55.52001874,
        "longitude": 9.64036309
      },
      "containers": [
        {
          "id": "mp-pc-110",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-110",
            "container_id": "MP-7002-109",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQxMTA=",
      "location": {
        "name": "Hjortøvænget 19 7000 Fredericia",
        "latitude": 55.519765,
        "longitude": 9.640073
      },
      "containers": [
        {
          "id": "mp-pc-111",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-111",
            "container_id": "MP-7002-110",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQxMTE=",
      "location": {
        "name": "Hjortøvænget 20 7000 Fredericia",
        "latitude": 55.519786,
        "longitude": 9.639626
      },
      "containers": [
        {
          "id": "mp-pc-112",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-112",
            "container_id": "MP-7002-112",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NDExMQ==",
          "ticket_id": "20584111",
          "ticket_type": "AO-Generel besked",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2023-07-22T20:14:00+00:00",
          "updated_at": "2025-08-19T00:25:00.540397+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQxMTE=",
            "location": {
              "latitude": 55.519786,
              "longitude": 9.639626,
              "name": "Hjortøvænget 20, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQxMTI=",
      "location": {
        "name": "Hjortøvænget 21 7000 Fredericia",
        "latitude": 55.519566,
        "longitude": 9.639771
      },
      "containers": [
        {
          "id": "mp-pc-113",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-113",
            "container_id": "MP-7002-113",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5Njk1MQ==",
          "ticket_id": "20596951",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "Navn: Hans Kjær Poulsen Tlf.: 41751934Email: poulsenhansk@gmail.comBesked: Beholder defekt med knækket hængsel efter første tømning. Ville gerne medsende billede, men har ikke mulighed i denne formular",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-12T21:48:00+00:00",
          "updated_at": "2025-08-19T00:25:01.480383+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQxMTI=",
            "location": {
              "latitude": 55.519566,
              "longitude": 9.639771,
              "name": "Hjortøvænget 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5ODE5Nw==",
          "ticket_id": "20598197",
          "ticket_type": "AO-Ændring til 140 liter beholder til restaffald",
          "description": "Hej den første 140liter tømning uge 19. Til information overtages ejendommen af ny ejer den 15. Maj. Mvh. Torben Skal gammel beholder hjemtages: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2021-04-11T19:53:00+00:00",
          "updated_at": "2025-08-19T00:25:01.555621+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQxMTI=",
            "location": {
              "latitude": 55.519566,
              "longitude": 9.639771,
              "name": "Hjortøvænget 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTUwNDA=",
      "location": {
        "name": "Hjortøvænget 18 7000 Fredericia",
        "latitude": 55.52008997,
        "longitude": 9.6393878
      },
      "containers": [
        {
          "id": "mp-pc-114",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-114",
            "container_id": "MP-7002-114",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDAwMDEwMA==",
          "ticket_id": "10000100",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-01-30T12:40:33.181618+00:00",
          "updated_at": "2024-01-30T12:40:33.196273+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUwNDA=",
            "location": {
              "latitude": 55.520089,
              "longitude": 9.639387,
              "name": "Hjortøvænget 18, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20668_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDcxOQ==",
          "ticket_id": "20584719",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Lars Schmidt MichaelTlf.: 26884686Email: lsholding@gmail.comBesked: er det nyt at alu/metal og glas IKKE længere skal i samme pose. det er gået min næse forbi. pfh tak og vh Lars, M 26884686",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-24T16:41:00+00:00",
          "updated_at": "2025-08-19T00:25:00.577598+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUwNDA=",
            "location": {
              "latitude": 55.520089,
              "longitude": 9.639387,
              "name": "Hjortøvænget 18, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY3NTI=",
      "location": {
        "name": "Hjortøvænget 1 7000 Fredericia",
        "latitude": 55.519286,
        "longitude": 9.641569
      },
      "containers": [
        {
          "id": "mp-pc-115",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-115",
            "container_id": "MP-7002-115",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5Mzk0MQ==",
          "ticket_id": "20593941",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-09-17Fraktion: 1 (Mad/Rest)Navn: Irene Tlf.: 23338868Email: irs@energinet.dkBesked: Igen konstateret at alle madrest poser ikke tømmes ved afhentningen. Hvis i går efter der ikke skal komme rotter mv så er det altså ikke godt at en pose ligger 4 uger. Rammen til madrester virker simpelthen som om det er for lille",
          "status": 6,
          "priority": 2,
          "created_at": "2021-09-28T10:44:00+00:00",
          "updated_at": "2025-08-19T00:25:01.295445+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY3NTI=",
            "location": {
              "latitude": 55.519286,
              "longitude": 9.641569,
              "name": "Hjortøvænget 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDQ5MQ==",
          "ticket_id": "20594491",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Navn: Irene Tlf.: 23338868Email: irs@energinet.dkBesked: Beholderen er tømt men ikke fuldstændig. Vi har stadige en pose madaffald.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-21T10:07:00+00:00",
          "updated_at": "2025-08-19T00:25:01.329194+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY3NTI=",
            "location": {
              "latitude": 55.519286,
              "longitude": 9.641569,
              "name": "Hjortøvænget 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5ODIxNg==",
          "ticket_id": "20598216",
          "ticket_type": "AO-Generel besked",
          "description": "Hej Jeg har ved en fejl meldt en ændring på denne adresse. Se venligst bort fra denne da jeg bor i nr 21 og ikke 1. Mvh. Torben",
          "status": 6,
          "priority": 2,
          "created_at": "2021-04-11T19:47:00+00:00",
          "updated_at": "2025-08-19T00:25:01.556674+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY3NTI=",
            "location": {
              "latitude": 55.519286,
              "longitude": 9.641569,
              "name": "Hjortøvænget 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5ODIxNw==",
          "ticket_id": "20598217",
          "ticket_type": "AO-Ændring til 140 liter beholder til restaffald",
          "description": "Første 140liter tømning uge 19. Mvh. Torben Skal gammel beholder hjemtages: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2021-04-11T19:39:00+00:00",
          "updated_at": "2025-08-19T00:25:01.556728+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY3NTI=",
            "location": {
              "latitude": 55.519286,
              "longitude": 9.641569,
              "name": "Hjortøvænget 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQxMDc=",
      "location": {
        "name": "Hjortøvænget 3 7000 Fredericia",
        "latitude": 55.519141,
        "longitude": 9.641181
      },
      "containers": [
        {
          "id": "mp-pc-116",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-116",
            "container_id": "MP-7002-116",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY3NDc=",
      "location": {
        "name": "Hjortøvænget 11 7000 Fredericia",
        "latitude": 55.519331,
        "longitude": 9.640627
      },
      "containers": [
        {
          "id": "mp-pc-117",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-117",
            "container_id": "MP-7002-117",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY3NTM=",
      "location": {
        "name": "Hjortøvænget 5 7000 Fredericia",
        "latitude": 55.518985,
        "longitude": 9.640837
      },
      "containers": [
        {
          "id": "mp-pc-118",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-118",
            "container_id": "MP-7002-118",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY3NTQ=",
      "location": {
        "name": "Hjortøvænget 9 7000 Fredericia",
        "latitude": 55.519148,
        "longitude": 9.640302
      },
      "containers": [
        {
          "id": "mp-pc-119",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-119",
            "container_id": "MP-7002-119",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQxMDg=",
      "location": {
        "name": "Hjortøvænget 7 7000 Fredericia",
        "latitude": 55.518929,
        "longitude": 9.640476
      },
      "containers": [
        {
          "id": "mp-pc-120",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-120",
            "container_id": "MP-7002-120",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU1OTk=",
      "location": {
        "name": "Siøvænget 6 7000 Fredericia",
        "latitude": 55.517625,
        "longitude": 9.638877
      },
      "containers": [
        {
          "id": "mp-pc-121",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-121",
            "container_id": "MP-7002-121",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTA2NTA=",
      "location": {
        "name": "Lyøvænget 16 7000 Fredericia",
        "latitude": 55.517143,
        "longitude": 9.638323
      },
      "containers": [
        {
          "id": "mp-pc-122",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-122",
            "container_id": "MP-7002-122",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI1ODg=",
      "location": {
        "name": "Årøvænget 1 7000 Fredericia",
        "latitude": 55.518473,
        "longitude": 9.636537
      },
      "containers": [
        {
          "id": "mp-pc-123",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-123",
            "container_id": "MP-7002-124",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NDM2NQ==",
          "ticket_id": "20584365",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Anita FilholmTlf.: 30305393Email: anitafilholm@me.comBesked: Hejsa. Jeg har spurgt på både genbrugspladsen og senest igår hos mændene der hentede mit genbrug, om hvornår jeg vil modtage poser. De sagde de var færdig med uddelingen, og jeg skulle kontakte jer. Jeg har ikke modtaget nogle. Den sidste rulle måtte jeg selv købe på genbrugspladsen tilbage i april. Venligst Anita Filholm.",
          "status": 6,
          "priority": 2,
          "created_at": "2023-06-28T08:07:00+00:00",
          "updated_at": "2025-08-19T00:25:00.555354+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI1ODg=",
            "location": {
              "latitude": 55.518473,
              "longitude": 9.636537,
              "name": "Årøvænget 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjY4MA==",
          "ticket_id": "20592680",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-12-10Fraktion: 1 (Mad/Rest)Navn: Anita FilholmTlf.: 30305393Email: anitafilholm@me.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-11T10:27:00+00:00",
          "updated_at": "2025-08-19T00:25:01.223202+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI1ODg=",
            "location": {
              "latitude": 55.518473,
              "longitude": 9.636537,
              "name": "Årøvænget 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDU4Nw==",
          "ticket_id": "20594587",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Anita FilholmTlf.: 30305393Email: anitafilholm@me.comBesked: Hvilken genbrugspose skal poser fra vin kartoner være i ?",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-29T09:42:00+00:00",
          "updated_at": "2025-08-19T00:25:01.335251+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI1ODg=",
            "location": {
              "latitude": 55.518473,
              "longitude": 9.636537,
              "name": "Årøvænget 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NzkzNw==",
          "ticket_id": "20597937",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Anita FilholmTlf.: 30305393Email: anitafilholm@me.comBesked: Det affald der er i den gamle affaldsspand, altså fra inden d. 1/7 og selve den gamle spand. Hvornår bliver det afhentet? Venligst Anita.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-06-30T08:18:00+00:00",
          "updated_at": "2025-08-19T00:25:01.537402+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI1ODg=",
            "location": {
              "latitude": 55.518473,
              "longitude": 9.636537,
              "name": "Årøvænget 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTQyNw==",
          "ticket_id": "20599427",
          "ticket_type": "AO-Bestilling af sommertømning  (15/6 - 15/8)",
          "description": "Hejsa. 1. Jeg vil gerne bestille sommertømning. 2. Hvor kan jeg se hvilken størrelse beholder jeg har til restaffald? Og prisenforskellen på størrlserne? Venligst Anita",
          "status": 6,
          "priority": 2,
          "created_at": "2019-03-27T09:10:00+00:00",
          "updated_at": "2025-08-19T00:25:01.628745+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI1ODg=",
            "location": {
              "latitude": 55.518473,
              "longitude": 9.636537,
              "name": "Årøvænget 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQyMDc=",
      "location": {
        "name": "Bågøvænget 2 7000 Fredericia",
        "latitude": 55.51826845,
        "longitude": 9.63714413
      },
      "containers": [
        {
          "id": "mp-pc-124",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-124",
            "container_id": "MP-7002-125",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY5MDc=",
      "location": {
        "name": "Bågøvænget 1 7000 Fredericia",
        "latitude": 55.518101,
        "longitude": 9.637523
      },
      "containers": [
        {
          "id": "mp-pc-125",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-125",
            "container_id": "MP-7002-126",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDg1MjY=",
      "location": {
        "name": "Bågøvænget 4 7000 Fredericia",
        "latitude": 55.518069,
        "longitude": 9.637017
      },
      "containers": [
        {
          "id": "mp-pc-126",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-126",
            "container_id": "MP-7002-127",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZTo5OTk5Mjkx",
          "ticket_id": "9999291",
          "ticket_type": "Forkert emballage, sækken skal være i klar plast",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-01-30T06:54:28.501760+00:00",
          "updated_at": "2024-01-30T06:54:28.514368+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MjY=",
            "location": {
              "latitude": 55.518069,
              "longitude": 9.637017,
              "name": "Bågøvænget 4, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20560_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDk3Nw==",
          "ticket_id": "20594977",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-08-06Fraktion: 1 (Mad/Rest)Navn: Mette Fruergaard Tlf.: 61312061Email: Fruergaard.mette@gmail.comBesked: Dog var vi på ferie, og havde ikke kørt beholderen ned til vejen ????????",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-17T18:31:00+00:00",
          "updated_at": "2025-08-19T00:25:01.358597+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MjY=",
            "location": {
              "latitude": 55.518069,
              "longitude": 9.637017,
              "name": "Bågøvænget 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDM1NzM=",
      "location": {
        "name": "Bågøvænget 3 7000 Fredericia",
        "latitude": 55.517862,
        "longitude": 9.637522
      },
      "containers": [
        {
          "id": "mp-pc-127",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-127",
            "container_id": "MP-7002-128",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDM1NzQ=",
      "location": {
        "name": "Bågøvænget 6 7000 Fredericia",
        "latitude": 55.517883,
        "longitude": 9.63683
      },
      "containers": [
        {
          "id": "mp-pc-128",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-128",
            "container_id": "MP-7002-129",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDEyODg1Nw==",
          "ticket_id": "10128857",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-06-25T05:50:16.850421+00:00",
          "updated_at": "2024-06-25T05:50:16.850907+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDM1NzQ=",
            "location": {
              "latitude": 55.517883,
              "longitude": 9.63683,
              "name": "Bågøvænget 6, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20562_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTI3Mw==",
          "ticket_id": "20595273",
          "ticket_type": "AO-Generel besked",
          "description": "Beholderen var blevet hentet på standpladsen, men ikke sat tilbage. Vil i huske det :-)",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-10T08:34:00+00:00",
          "updated_at": "2025-08-19T00:25:01.377588+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDM1NzQ=",
            "location": {
              "latitude": 55.517883,
              "longitude": 9.63683,
              "name": "Bågøvænget 6, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQyMDg=",
      "location": {
        "name": "Bågøvænget 5 7000 Fredericia",
        "latitude": 55.51771371,
        "longitude": 9.63722117
      },
      "containers": [
        {
          "id": "mp-pc-129",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-129",
            "container_id": "MP-7002-130",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5OTE4MA==",
          "ticket_id": "20599180",
          "ticket_type": "AO-Ændring til 140 liter beholder til restaffald",
          "description": "Skal gammel beholder hjemtages: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2019-08-23T20:00:00+00:00",
          "updated_at": "2025-08-19T00:25:01.614709+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQyMDg=",
            "location": {
              "latitude": 55.517713,
              "longitude": 9.637221,
              "name": "Bågøvænget 5, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDM1NzU=",
      "location": {
        "name": "Bågøvænget 8 7000 Fredericia",
        "latitude": 55.517663,
        "longitude": 9.636605
      },
      "containers": [
        {
          "id": "mp-pc-130",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-130",
            "container_id": "MP-7002-131",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MTMwMQ==",
          "ticket_id": "20591301",
          "ticket_type": "AO-Håndtag itu (vedhæft evt foto - kun på web)",
          "description": "Beholder er gået itu i hængslet. Tappen er knækket.",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-18T19:13:00+00:00",
          "updated_at": "2025-08-19T00:25:01.138754+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDM1NzU=",
            "location": {
              "latitude": 55.517663,
              "longitude": 9.636605,
              "name": "Bågøvænget 8, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY5MDg=",
      "location": {
        "name": "Bågøvænget 7 7000 Fredericia",
        "latitude": 55.517538,
        "longitude": 9.637064
      },
      "containers": [
        {
          "id": "mp-pc-131",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-131",
            "container_id": "MP-7002-132",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MTUwMA==",
          "ticket_id": "20591500",
          "ticket_type": "AO-Generel besked",
          "description": "Ãnsker besked om hvornår det hentes genbrugsting, som glas , aviser pap oa",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-12T14:31:00+00:00",
          "updated_at": "2025-08-19T00:25:01.152454+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY5MDg=",
            "location": {
              "latitude": 55.517534,
              "longitude": 9.637064,
              "name": "Bågøvænget 7, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQyMDk=",
      "location": {
        "name": "Bågøvænget 10 7000 Fredericia",
        "latitude": 55.5174858,
        "longitude": 9.63650195
      },
      "containers": [
        {
          "id": "mp-pc-132",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-132",
            "container_id": "MP-7002-133",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDE5MTM1NQ==",
          "ticket_id": "10191355",
          "ticket_type": "Skadedyr",
          "description": "",
          "status": 7,
          "priority": 2,
          "created_at": "2024-09-02T09:04:52.176031+00:00",
          "updated_at": "2024-09-02T09:04:52.196683+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": {
            "name": null
          },
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQyMDk=",
            "location": {
              "latitude": 55.517485,
              "longitude": 9.636501,
              "name": "Bågøvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "415342",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "name": "2-delt 240 L"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToxMDE4NjAyMA==",
          "ticket_id": "10186020",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "",
          "status": 3,
          "priority": 1,
          "created_at": "2024-08-28T05:51:58.287049+00:00",
          "updated_at": "2024-08-28T05:51:58.287880+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": {
            "name": null,
            "phone_number": ""
          },
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQyMDk=",
            "location": {
              "latitude": 55.517485,
              "longitude": 9.636501,
              "name": "Bågøvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20566_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTYzNw==",
          "ticket_id": "20591637",
          "ticket_type": "AO-Håndtag itu (vedhæft evt foto - kun på web)",
          "description": "Ifm tømning af vores skraldespand fredag den 7. januar er håndtaget på spanden blevet ødelagt. Plastskruen i den ene side er blevet trukket ud, så lågen nu ikke kan åbne/lukke korrekt. Foto vedhæftet.",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-09T11:59:00+00:00",
          "updated_at": "2025-08-19T00:25:01.162329+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQyMDk=",
            "location": {
              "latitude": 55.517485,
              "longitude": 9.636501,
              "name": "Bågøvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDM1NzY=",
      "location": {
        "name": "Bågøvænget 9 7000 Fredericia",
        "latitude": 55.517319,
        "longitude": 9.637038
      },
      "containers": [
        {
          "id": "mp-pc-133",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-133",
            "container_id": "MP-7002-134",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NjA2Ng==",
          "ticket_id": "20596066",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "mgl. tømning - måske",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-23T12:59:00+00:00",
          "updated_at": "2025-08-19T00:25:01.428552+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDM1NzY=",
            "location": {
              "latitude": 55.517319,
              "longitude": 9.637038,
              "name": "Bågøvænget 9, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDM1Nzg=",
      "location": {
        "name": "Bågøvænget 20 7000 Fredericia",
        "latitude": 55.516602,
        "longitude": 9.635981
      },
      "containers": [
        {
          "id": "mp-pc-134",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-134",
            "container_id": "MP-7002-135",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDM1Nzc=",
      "location": {
        "name": "Bågøvænget 18 7000 Fredericia",
        "latitude": 55.516699,
        "longitude": 9.635627
      },
      "containers": [
        {
          "id": "mp-pc-135",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-135",
            "container_id": "MP-7002-136",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDg1MzE=",
      "location": {
        "name": "Bågøvænget 19 7000 Fredericia",
        "latitude": 55.516566,
        "longitude": 9.63631
      },
      "containers": [
        {
          "id": "mp-pc-136",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-136",
            "container_id": "MP-7002-137",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDg1Mjk=",
      "location": {
        "name": "Bågøvænget 15 7000 Fredericia",
        "latitude": 55.516818,
        "longitude": 9.636595
      },
      "containers": [
        {
          "id": "mp-pc-137",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-137",
            "container_id": "MP-7002-138",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDg1MzA=",
      "location": {
        "name": "Bågøvænget 17 7000 Fredericia",
        "latitude": 55.516514,
        "longitude": 9.63667
      },
      "containers": [
        {
          "id": "mp-pc-138",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-138",
            "container_id": "MP-7002-139",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MDQyMQ==",
          "ticket_id": "20590421",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Bågøvænget 17 1 (7000 Fredericia) ContainerNr:409680 ContainerBrik: Låg itu Ønsket virkningsdato: 04/10-2021 Besked: mangler prop Kontaktoplysninger: Jan Jensen",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-04T09:01:00+00:00",
          "updated_at": "2025-08-19T00:25:01.066613+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MzA=",
            "location": {
              "latitude": 55.51651,
              "longitude": 9.63667,
              "name": "Bågøvænget 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY5MTA=",
      "location": {
        "name": "Bågøvænget 16 7000 Fredericia",
        "latitude": 55.516885,
        "longitude": 9.636052
      },
      "containers": [
        {
          "id": "mp-pc-139",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-139",
            "container_id": "MP-7002-140",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY5MDk=",
      "location": {
        "name": "Bågøvænget 14 7000 Fredericia",
        "latitude": 55.517104,
        "longitude": 9.636159
      },
      "containers": [
        {
          "id": "mp-pc-140",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-140",
            "container_id": "MP-7002-141",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDg1Mjg=",
      "location": {
        "name": "Bågøvænget 12 7000 Fredericia",
        "latitude": 55.517299,
        "longitude": 9.636316
      },
      "containers": [
        {
          "id": "mp-pc-141",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-141",
            "container_id": "MP-7002-143",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDg1Mjc=",
      "location": {
        "name": "Bågøvænget 11 7000 Fredericia",
        "latitude": 55.517215,
        "longitude": 9.636751
      },
      "containers": [
        {
          "id": "mp-pc-142",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-142",
            "container_id": "MP-7002-144",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc1MDM=",
      "location": {
        "name": "Årøvænget 2 7000 Fredericia",
        "latitude": 55.518558,
        "longitude": 9.636053
      },
      "containers": [
        {
          "id": "mp-pc-143",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-143",
            "container_id": "MP-7002-145",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTEwOQ==",
          "ticket_id": "20585109",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Årøvænget 2 1 (7000 Fredericia) ContainerNr:408665 ContainerBrik:004000001263FAB5 Låg itu Ønsket virkningsdato: 07/04 2023 Besked: Kontaktoplysninger: Per Sørensen 28357346 tinaogper@privat.dk",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-31T13:35:00+00:00",
          "updated_at": "2025-08-19T00:25:00.597919+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc1MDM=",
            "location": {
              "latitude": 55.518558,
              "longitude": 9.636053,
              "name": "Årøvænget 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTEyMQ==",
          "ticket_id": "20585121",
          "ticket_type": "AO-Håndtag itu (vedhæft evt foto - kun på web)",
          "description": "Navn: Per SørensenTlf.: 28357346Email: tinaogper@privat.dkBesked: Låget er fortsat defekt - låget er kun hæftet i den ene side. Og meddelt ind til jer sidste år",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-30T16:05:00+00:00",
          "updated_at": "2025-08-19T00:25:00.598631+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc1MDM=",
            "location": {
              "latitude": 55.518558,
              "longitude": 9.636053,
              "name": "Årøvænget 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzE1MA==",
          "ticket_id": "20593150",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Årøvænget 2 1 (7000 Fredericia) ContainerNr:408665 ContainerBrik: Låg itu Ønsket virkningsdato: 11/11-2021 Besked: Kontaktoplysninger: Per Sørensen 28357346 tinaogper@privat.dk",
          "status": 6,
          "priority": 2,
          "created_at": "2021-11-11T10:47:00+00:00",
          "updated_at": "2025-08-19T00:25:01.249836+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc1MDM=",
            "location": {
              "latitude": 55.518558,
              "longitude": 9.636053,
              "name": "Årøvænget 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5ODY2NQ==",
          "ticket_id": "20598665",
          "ticket_type": "AO-Generel besked",
          "description": "Hej Vi har fået levet en beholder til grønt affald - det må være en fejl! Jeg henvente mig for at få oplysninger og med emnet generel besked. Jeg fik tilbagemelding som vist nedenfor. Vi ønsker at vente til næste år hvor affaldsordningen alligevel ændres. Giv venligst besked på hvad der er sket og at i henter beholder til grønt affald. Mvh Per ---- Tak for henvendelsen. Ã røvænget 2 er tilmeldt 1 stk.140 liter til rest affald. Ja det er muligt at få tømt en grøn affaldsbeholder på 140 liter. Beh",
          "status": 6,
          "priority": 2,
          "created_at": "2020-07-31T10:41:00+00:00",
          "updated_at": "2025-08-19T00:25:01.583250+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc1MDM=",
            "location": {
              "latitude": 55.518558,
              "longitude": 9.636053,
              "name": "Årøvænget 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5ODY3OQ==",
          "ticket_id": "20598679",
          "ticket_type": "AO-Generel besked",
          "description": "Hej Hvor kan jeg se hvad jeg har af aftale med jer - størrelse af beholder til restaffald? Vi har idag en kompostbeholder og vil gerne ændre den til beholder for grønt affald - er det muligt?",
          "status": 6,
          "priority": 2,
          "created_at": "2020-07-20T09:40:00+00:00",
          "updated_at": "2025-08-19T00:25:01.583948+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc1MDM=",
            "location": {
              "latitude": 55.518558,
              "longitude": 9.636053,
              "name": "Årøvænget 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI1ODk=",
      "location": {
        "name": "Årøvænget 3 7000 Fredericia",
        "latitude": 55.5183,
        "longitude": 9.636365
      },
      "containers": [
        {
          "id": "mp-pc-144",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-144",
            "container_id": "MP-7002-146",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI1OTA=",
      "location": {
        "name": "Årøvænget 4 7000 Fredericia",
        "latitude": 55.518349,
        "longitude": 9.635902
      },
      "containers": [
        {
          "id": "mp-pc-145",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-145",
            "container_id": "MP-7002-147",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI1OTE=",
      "location": {
        "name": "Årøvænget 5 7000 Fredericia",
        "latitude": 55.518115,
        "longitude": 9.636137
      },
      "containers": [
        {
          "id": "mp-pc-146",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-146",
            "container_id": "MP-7002-148",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc1MDQ=",
      "location": {
        "name": "Årøvænget 6 7000 Fredericia",
        "latitude": 55.518143,
        "longitude": 9.635612
      },
      "containers": [
        {
          "id": "mp-pc-147",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-147",
            "container_id": "MP-7002-149",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI1OTI=",
      "location": {
        "name": "Årøvænget 7 7000 Fredericia",
        "latitude": 55.517954,
        "longitude": 9.636002
      },
      "containers": [
        {
          "id": "mp-pc-148",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-148",
            "container_id": "MP-7002-150",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc1MDU=",
      "location": {
        "name": "Årøvænget 8 7000 Fredericia",
        "latitude": 55.517877,
        "longitude": 9.635506
      },
      "containers": [
        {
          "id": "mp-pc-149",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-149",
            "container_id": "MP-7002-151",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDA0OTQ1OQ==",
          "ticket_id": "10049459",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-03-26T06:31:46.380687+00:00",
          "updated_at": "2024-03-26T06:31:46.381524+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc1MDU=",
            "location": {
              "latitude": 55.517877,
              "longitude": 9.635506,
              "name": "Årøvænget 8, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20543_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4OTk5MQ==",
          "ticket_id": "20589991",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Årøvænget 8 1 (7000 Fredericia) ContainerNr:408667 ContainerBrik: Håndtag itu Ønsket virkningsdato: 17/08 2021 Besked: Knækket Kontaktoplysninger: Niels Riis",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-10T13:33:00+00:00",
          "updated_at": "2025-08-19T00:25:01.035448+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc1MDU=",
            "location": {
              "latitude": 55.517877,
              "longitude": 9.635506,
              "name": "Årøvænget 8, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU1NjE=",
      "location": {
        "name": "Årøvænget 9 7000 Fredericia",
        "latitude": 55.517726,
        "longitude": 9.636022
      },
      "containers": [
        {
          "id": "mp-pc-150",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-150",
            "container_id": "MP-7002-152",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU1NjI=",
      "location": {
        "name": "Årøvænget 11 7000 Fredericia",
        "latitude": 55.517565,
        "longitude": 9.635859
      },
      "containers": [
        {
          "id": "mp-pc-151",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-151",
            "container_id": "MP-7002-153",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI1OTM=",
      "location": {
        "name": "Årøvænget 10 7000 Fredericia",
        "latitude": 55.51766,
        "longitude": 9.635314
      },
      "containers": [
        {
          "id": "mp-pc-152",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-152",
            "container_id": "MP-7002-154",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MTYwNQ==",
          "ticket_id": "20591605",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-12-24Fraktion: 1 (Mad/Rest)Navn: Preben BirrTlf.: 31442915Email: preben@birr.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-07T13:54:00+00:00",
          "updated_at": "2025-08-19T00:25:01.160686+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI1OTM=",
            "location": {
              "latitude": 55.51766,
              "longitude": 9.635314,
              "name": "Årøvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU1NjM=",
      "location": {
        "name": "Årøvænget 12 7000 Fredericia",
        "latitude": 55.51757,
        "longitude": 9.634932
      },
      "containers": [
        {
          "id": "mp-pc-153",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-153",
            "container_id": "MP-7002-155",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NjU1OQ==",
          "ticket_id": "20576559",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2025-03-03T11:08:00+00:00",
          "updated_at": "2025-08-19T00:25:00.057670+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1NjM=",
            "location": {
              "latitude": 55.51757,
              "longitude": 9.634932,
              "name": "Årøvænget 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTEzMw==",
          "ticket_id": "20599133",
          "ticket_type": "AO-Ændring til 240 liter beholder til restaffald",
          "description": "Vi skal have 240 liter Vi beholder den gamle Skal gammel beholder hjemtages: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2019-10-04T17:41:00+00:00",
          "updated_at": "2025-08-19T00:25:01.611994+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1NjM=",
            "location": {
              "latitude": 55.51757,
              "longitude": 9.634932,
              "name": "Årøvænget 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc1MDY=",
      "location": {
        "name": "Årøvænget 13 7000 Fredericia",
        "latitude": 55.517396,
        "longitude": 9.635624
      },
      "containers": [
        {
          "id": "mp-pc-154",
          "num_open_tickets": 1,
          "container": {
            "id": "mp-c-154",
            "container_id": "MP-7002-156",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDQyMTIxOQ==",
          "ticket_id": "10421219",
          "ticket_type": "mp_test_lasse",
          "description": "Test Lasse 122",
          "status": 1,
          "priority": 0,
          "created_at": "2024-10-11T07:53:10.045981+00:00",
          "updated_at": "2024-10-11T07:53:52.882990+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc1MDY=",
            "location": {
              "latitude": 55.517396,
              "longitude": 9.635624,
              "name": "Årøvænget 13 7000 Fredericia"
            }
          },
          "container": {
            "container_id": "MP-7002-156",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "name": "240 L 2-delt"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU1NjQ=",
      "location": {
        "name": "Årøvænget 14 7000 Fredericia",
        "latitude": 55.517336,
        "longitude": 9.635039
      },
      "containers": [
        {
          "id": "mp-pc-155",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-155",
            "container_id": "MP-7002-157",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU1NjU=",
      "location": {
        "name": "Årøvænget 15 7000 Fredericia",
        "latitude": 55.517211,
        "longitude": 9.635499
      },
      "containers": [
        {
          "id": "mp-pc-156",
          "num_open_tickets": 1,
          "container": {
            "id": "mp-c-156",
            "container_id": "MP-7002-158",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDQyMTE5Mg==",
          "ticket_id": "10421192",
          "ticket_type": "Affaldet er ikke genbrugeligt",
          "description": "Test lasse ",
          "status": 1,
          "priority": 4,
          "created_at": "2024-10-11T07:50:23.368768+00:00",
          "updated_at": "2024-10-11T07:50:23.370009+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1NjU=",
            "location": {
              "latitude": 55.517211,
              "longitude": 9.635499,
              "name": "Årøvænget 15 7000 Fredericia"
            }
          },
          "container": {
            "container_id": "MP-7002-158",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "name": "240 L 2-delt"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4OTkwNQ==",
          "ticket_id": "20589905",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Årøvænget 15 1 (7000 Fredericia) ContainerNr:406727 ContainerBrik: Håndtag itu Ønsket virkningsdato: 31/08-2021 Besked: Knækket Kontaktoplysninger: Jonna Toft Nyby Petersen",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-31T14:57:00+00:00",
          "updated_at": "2025-08-19T00:25:01.026641+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1NjU=",
            "location": {
              "latitude": 55.517211,
              "longitude": 9.635499,
              "name": "Årøvænget 15, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTM5ODk=",
      "location": {
        "name": "Årøvænget 17 7000 Fredericia",
        "latitude": 55.517005,
        "longitude": 9.635296
      },
      "containers": [
        {
          "id": "mp-pc-157",
          "num_open_tickets": 1,
          "container": {
            "id": "mp-c-157",
            "container_id": "MP-7002-159",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDQyMTE4NQ==",
          "ticket_id": "10421185",
          "ticket_type": "Skarpe genstande",
          "description": "Test - lasse ",
          "status": 1,
          "priority": 0,
          "created_at": "2024-10-11T07:47:37.383269+00:00",
          "updated_at": "2024-10-11T07:47:37.384541+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTM5ODk=",
            "location": {
              "latitude": 55.517005,
              "longitude": 9.635296,
              "name": "Årøvænget 17 7000 Fredericia"
            }
          },
          "container": {
            "container_id": "MP-7002-159",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "name": "240 L 2-delt"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MTY3OQ==",
          "ticket_id": "20581679",
          "ticket_type": "AO-Generel besked",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2024-02-18T21:29:00+00:00",
          "updated_at": "2025-08-19T00:25:00.390760+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTM5ODk=",
            "location": {
              "latitude": 55.517005,
              "longitude": 9.635296,
              "name": "Årøvænget 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc1MDc=",
      "location": {
        "name": "Årøvænget 16 7000 Fredericia",
        "latitude": 55.517181,
        "longitude": 9.634777
      },
      "containers": [
        {
          "id": "mp-pc-158",
          "num_open_tickets": 1,
          "container": {
            "id": "mp-c-158",
            "container_id": "MP-7002-160",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDUzMTA0Ng==",
          "ticket_id": "10531046",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2025-01-30T06:35:11.377288+00:00",
          "updated_at": "2025-01-30T06:35:11.378521+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc1MDc=",
            "location": {
              "latitude": 55.517181,
              "longitude": 9.634777,
              "name": "Årøvænget 16, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20551_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToxMDQyMTE4Mg==",
          "ticket_id": "10421182",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "Test lasse ",
          "status": 1,
          "priority": 0,
          "created_at": "2024-10-11T07:46:36.394553+00:00",
          "updated_at": "2024-10-11T07:46:36.395248+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc1MDc=",
            "location": {
              "latitude": 55.517181,
              "longitude": 9.634777,
              "name": "Årøvænget 16 7000 Fredericia"
            }
          },
          "container": {
            "container_id": "MP-7002-160",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "name": "240 L 2-delt"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI1OTQ=",
      "location": {
        "name": "Årøvænget 18 7000 Fredericia",
        "latitude": 55.516981,
        "longitude": 9.634656
      },
      "containers": [
        {
          "id": "mp-pc-159",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-159",
            "container_id": "MP-7002-161",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NjY0MA==",
          "ticket_id": "20576640",
          "ticket_type": "AO-Håndtag itu (vedhæft evt foto - kun på web)",
          "description": "Hjul defekt - kunden vurderer det bare kan skiftes. Uge 9",
          "status": 6,
          "priority": 2,
          "created_at": "2025-02-25T11:01:00+00:00",
          "updated_at": "2025-08-19T00:25:00.066410+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI1OTQ=",
            "location": {
              "latitude": 55.516981,
              "longitude": 9.634656,
              "name": "Årøvænget 18, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTczNjc=",
      "location": {
        "name": "Årøvænget 19 7000 Fredericia",
        "latitude": 55.5167941,
        "longitude": 9.63505797
      },
      "containers": [
        {
          "id": "mp-pc-160",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-160",
            "container_id": "MP-7002-162",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU1NjY=",
      "location": {
        "name": "Årøvænget 20 7000 Fredericia",
        "latitude": 55.516813,
        "longitude": 9.634414
      },
      "containers": [
        {
          "id": "mp-pc-161",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-161",
            "container_id": "MP-7002-163",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MzkyOQ==",
          "ticket_id": "20593929",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: MargretheTlf.: 61605029Email: margrethe1981@gmail.comBesked: Hej, hvor kan jeg få ekstra piktogrammer? Vi mangler nogle til kommende tømning, da de allerede er brugt. Pft, vh Margrethe",
          "status": 6,
          "priority": 2,
          "created_at": "2021-09-28T17:56:00+00:00",
          "updated_at": "2025-08-19T00:25:01.294793+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1NjY=",
            "location": {
              "latitude": 55.516813,
              "longitude": 9.634414,
              "name": "Årøvænget 20, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTQwMQ==",
          "ticket_id": "20599401",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "Hej, jeg vil gerne købe ny beholder til restaffald, da låget er knækket af på nuværende. Vh Margrethe Nørgaard",
          "status": 6,
          "priority": 2,
          "created_at": "2019-04-20T11:29:00+00:00",
          "updated_at": "2025-08-19T00:25:01.627333+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1NjY=",
            "location": {
              "latitude": 55.516813,
              "longitude": 9.634414,
              "name": "Årøvænget 20, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU1OTg=",
      "location": {
        "name": "Siøvænget 4 7000 Fredericia",
        "latitude": 55.517783,
        "longitude": 9.639006
      },
      "containers": [
        {
          "id": "mp-pc-162",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-162",
            "container_id": "MP-7002-164",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5ODI0OA==",
          "ticket_id": "20598248",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "Hej. Hvsdkoster en ny beholder til almindelig husholdning? Vh Helle Winther",
          "status": 6,
          "priority": 2,
          "created_at": "2021-03-24T01:39:00+00:00",
          "updated_at": "2025-08-19T00:25:01.558483+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1OTg=",
            "location": {
              "latitude": 55.517783,
              "longitude": 9.639006,
              "name": "Siøvænget 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU1OTc=",
      "location": {
        "name": "Siøvænget 1 7000 Fredericia",
        "latitude": 55.518157,
        "longitude": 9.639955
      },
      "containers": [
        {
          "id": "mp-pc-163",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-163",
            "container_id": "MP-7002-165",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI2MzA=",
      "location": {
        "name": "Siøvænget 3 7000 Fredericia",
        "latitude": 55.517999,
        "longitude": 9.639918
      },
      "containers": [
        {
          "id": "mp-pc-164",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-164",
            "container_id": "MP-7002-166",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDEyOTY1Mg==",
          "ticket_id": "10129652",
          "ticket_type": "Affaldet skal sorteres som restaffald",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-06-25T09:39:52.848133+00:00",
          "updated_at": "2024-06-25T09:39:52.848969+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI2MzA=",
            "location": {
              "latitude": 55.517999,
              "longitude": 9.639918,
              "name": "Siøvænget 3, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20619_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI2Mjk=",
      "location": {
        "name": "Siøvænget 2 7000 Fredericia",
        "latitude": 55.517932,
        "longitude": 9.639547
      },
      "containers": [
        {
          "id": "mp-pc-165",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-165",
            "container_id": "MP-7002-167",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI2MzE=",
      "location": {
        "name": "Siøvænget 5 7000 Fredericia",
        "latitude": 55.517722,
        "longitude": 9.639901
      },
      "containers": [
        {
          "id": "mp-pc-166",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-166",
            "container_id": "MP-7002-168",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZTo5OTk5OTc0",
          "ticket_id": "9999974",
          "ticket_type": "Gavepapir- og bånd er restaffald",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-01-30T10:44:21.635530+00:00",
          "updated_at": "2024-01-30T10:44:21.650283+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI2MzE=",
            "location": {
              "latitude": 55.517722,
              "longitude": 9.639901,
              "name": "Siøvænget 5, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20621_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzA2MA==",
          "ticket_id": "20593060",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Anna Mette SvanborgTlf.: 28482992Email: annasvanborg@hotmail.comBesked: Jeg mangler klistermærker til mærkning af affaldsposerne",
          "status": 6,
          "priority": 2,
          "created_at": "2021-11-16T19:33:00+00:00",
          "updated_at": "2025-08-19T00:25:01.244780+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI2MzE=",
            "location": {
              "latitude": 55.517722,
              "longitude": 9.639901,
              "name": "Siøvænget 5, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI2MzI=",
      "location": {
        "name": "Siøvænget 8 7000 Fredericia",
        "latitude": 55.517572,
        "longitude": 9.639368
      },
      "containers": [
        {
          "id": "mp-pc-167",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-167",
            "container_id": "MP-7002-169",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MzA2Nw==",
          "ticket_id": "20593067",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Siøvænget 8 1 (7000 Fredericia) ContainerNr:413768 ContainerBrik: Låg itu Ønsket virkningsdato: 16/11-2021 Besked: Låg hængsel itu Kontaktoplysninger: Harry Matras Toftum 23897365 harrytoftum@live.com",
          "status": 6,
          "priority": 2,
          "created_at": "2021-11-16T11:47:00+00:00",
          "updated_at": "2025-08-19T00:25:01.245104+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI2MzI=",
            "location": {
              "latitude": 55.517572,
              "longitude": 9.639368,
              "name": "Siøvænget 8, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzA2OA==",
          "ticket_id": "20593068",
          "ticket_type": "AO-Håndtag itu (vedhæft evt foto - kun på web)",
          "description": "Hej, \"hængsel\" på affaldsbeholder ødelagt i forbindelse med tømning Mvh Harry Toftum",
          "status": 6,
          "priority": 2,
          "created_at": "2021-11-15T16:01:00+00:00",
          "updated_at": "2025-08-19T00:25:01.245150+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI2MzI=",
            "location": {
              "latitude": 55.517572,
              "longitude": 9.639368,
              "name": "Siøvænget 8, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTc4Ng==",
          "ticket_id": "20599786",
          "ticket_type": "AO-Ændring til 180-190 liter beholder til restaffald",
          "description": "Vi er lige flyttet til Fredericia og har ikke fået udleveret klare plastsække. Hvordan kan vi få dem udleveret? Bliver den nye beholder afleveret eller skal vi afhente den? Hvis det er en økonomisk fordel for os at i tager den gamle beholder retur må i gerne tage den. Hvis ikke vil vi gerne beholde den. Beklager hvis samme besked er sendt 2 gange. Skal gammel beholder hjemtages: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2018-07-04T10:46:00+00:00",
          "updated_at": "2025-08-19T00:25:01.650332+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI2MzI=",
            "location": {
              "latitude": 55.517572,
              "longitude": 9.639368,
              "name": "Siøvænget 8, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc1Mjk=",
      "location": {
        "name": "Siøvænget 7 7000 Fredericia",
        "latitude": 55.517477,
        "longitude": 9.63982
      },
      "containers": [
        {
          "id": "mp-pc-168",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-168",
            "container_id": "MP-7002-170",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MzczMg==",
          "ticket_id": "20583732",
          "ticket_type": "AO-Generel besked",
          "description": "Beholder var ikke sat frem. Der vil derfor være rekvirerede ekstra sække næste gang, som vi skal huske at tage med.",
          "status": 6,
          "priority": 2,
          "created_at": "2023-09-15T09:48:00+00:00",
          "updated_at": "2025-08-19T00:25:00.517971+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc1Mjk=",
            "location": {
              "latitude": 55.517477,
              "longitude": 9.63982,
              "name": "Siøvænget 7, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDgwNQ==",
          "ticket_id": "20584805",
          "ticket_type": "AO-Generel besked",
          "description": "Bemærk ved næste tømning 5 sække med ekstra affald - alle med sækkemærker.",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-11T09:48:00+00:00",
          "updated_at": "2025-08-19T00:25:00.582114+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc1Mjk=",
            "location": {
              "latitude": 55.517477,
              "longitude": 9.63982,
              "name": "Siøvænget 7, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTY3NA==",
          "ticket_id": "20591674",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Navn: Mikkel FogdalTlf.: 22577006Email: fogdal@hotmail.comBesked: Jeg har bestilt og betalt for en ekstra sæk i forbindelse med tømning fredag d. 7/1. Jeg kom til at lukke siden, inden jeg fik noteret koden, og kan ikke finde den igen. Hvad gør jeg? Venlig hilsen Mikkel Fogdal, Siøvænget 7, 7000 Fredericia",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-06T17:48:00+00:00",
          "updated_at": "2025-08-19T00:25:01.164648+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc1Mjk=",
            "location": {
              "latitude": 55.517477,
              "longitude": 9.63982,
              "name": "Siøvænget 7, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI2MzM=",
      "location": {
        "name": "Siøvænget 9 7000 Fredericia",
        "latitude": 55.517288,
        "longitude": 9.639734
      },
      "containers": [
        {
          "id": "mp-pc-169",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-169",
            "container_id": "MP-7002-171",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU2MDA=",
      "location": {
        "name": "Siøvænget 10 7000 Fredericia",
        "latitude": 55.517226,
        "longitude": 9.639305
      },
      "containers": [
        {
          "id": "mp-pc-170",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-170",
            "container_id": "MP-7002-172",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3Njg3OQ==",
          "ticket_id": "20576879",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Ingen madaffald - tømt som restaffald Er der afleveret flyer: Nej Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2025-01-31T09:45:00+00:00",
          "updated_at": "2025-08-19T00:25:00.093264+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU2MDA=",
            "location": {
              "latitude": 55.517226,
              "longitude": 9.639305,
              "name": "Siøvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQ3NTk=",
      "location": {
        "name": "Siøvænget 11 7000 Fredericia",
        "latitude": 55.51705125,
        "longitude": 9.63960555
      },
      "containers": [
        {
          "id": "mp-pc-171",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-171",
            "container_id": "MP-7002-173",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU2MDE=",
      "location": {
        "name": "Siøvænget 12 7000 Fredericia",
        "latitude": 55.517023,
        "longitude": 9.639186
      },
      "containers": [
        {
          "id": "mp-pc-172",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-172",
            "container_id": "MP-7002-174",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NzI2MA==",
          "ticket_id": "20597260",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Jeppe Kiilerich ØsterlundTlf.: 61692058Email: jeppe.kiilerich@gmail.comBesked: ift ny sorteringsbeholder (2 kamre), er det så underordnet hvilken type plastpose man bruger til bioaffald? Jeg har ikke kunnet finde nogen anvisninger andet end at det skal i en plastpose (markat i beholders låg)",
          "status": 6,
          "priority": 2,
          "created_at": "2021-06-29T17:35:00+00:00",
          "updated_at": "2025-08-19T00:25:01.498025+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU2MDE=",
            "location": {
              "latitude": 55.517047,
              "longitude": 9.639186,
              "name": "Siøvænget 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTIwMg==",
          "ticket_id": "20599202",
          "ticket_type": "AO-Ændring til 240 liter beholder til restaffald",
          "description": "Skal gammel beholder hjemtages: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2019-08-12T10:51:00+00:00",
          "updated_at": "2025-08-19T00:25:01.616071+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU2MDE=",
            "location": {
              "latitude": 55.517047,
              "longitude": 9.639186,
              "name": "Siøvænget 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI2MzQ=",
      "location": {
        "name": "Siøvænget 13 7000 Fredericia",
        "latitude": 55.516806,
        "longitude": 9.639578
      },
      "containers": [
        {
          "id": "mp-pc-173",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-173",
            "container_id": "MP-7002-175",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI2MzU=",
      "location": {
        "name": "Siøvænget 14 7000 Fredericia",
        "latitude": 55.516836,
        "longitude": 9.639047
      },
      "containers": [
        {
          "id": "mp-pc-174",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-174",
            "container_id": "MP-7002-176",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NTI4MQ==",
          "ticket_id": "20575281",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Chris VejenTlf.: 40143454Email: chris@vejen-jensen.comBesked: Eternit der kan dokumenteres asbestfrit både ved mærkning med NT som står for non-asbestos- technology, og 8 cifret nummer startende med 4 eller 5, hvorfor kan man ikke aflevere det på kommunens genbrugspladser? Det kan rent faktisk genbruges til cementproduktion, så forstår ikke at man går så meget op i genbrug, men ikke gør det helt Mvh Chris Vejen-Jensen.",
          "status": 6,
          "priority": 2,
          "created_at": "2025-06-09T08:22:00+00:00",
          "updated_at": "2025-08-19T00:24:59.911289+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI2MzU=",
            "location": {
              "latitude": 55.516836,
              "longitude": 9.63905,
              "name": "Siøvænget 14, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTg5NA==",
          "ticket_id": "20595894",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Navn: Chris VejenTlf.: 40143454Email: chris@vejen-jensen.comBesked: Vores beholder er ikke tømt i dag d. 23/7, på Siøvænget 14. Beholderen står 3 meter fra skel, så er inden for 5 meter grænsen .",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-23T18:52:00+00:00",
          "updated_at": "2025-08-19T00:25:01.418117+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI2MzU=",
            "location": {
              "latitude": 55.516836,
              "longitude": 9.63905,
              "name": "Siøvænget 14, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI4OTk=",
      "location": {
        "name": "Egholmvænget 7 7000 Fredericia",
        "latitude": 55.518563,
        "longitude": 9.638482
      },
      "containers": [
        {
          "id": "mp-pc-175",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-175",
            "container_id": "MP-7002-177",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU3MzA=",
      "location": {
        "name": "Egholmvænget 9 7000 Fredericia",
        "latitude": 55.518802,
        "longitude": 9.638235
      },
      "containers": [
        {
          "id": "mp-pc-176",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-176",
            "container_id": "MP-7002-178",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI4OTY=",
      "location": {
        "name": "Egholmvænget 1 7000 Fredericia",
        "latitude": 55.518242,
        "longitude": 9.638685
      },
      "containers": [
        {
          "id": "mp-pc-177",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-177",
            "container_id": "MP-7002-179",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQ4MTA=",
      "location": {
        "name": "Egholmvænget 3 7000 Fredericia",
        "latitude": 55.51819889,
        "longitude": 9.63830265
      },
      "containers": [
        {
          "id": "mp-pc-178",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-178",
            "container_id": "MP-7002-180",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDYxNjY=",
      "location": {
        "name": "Egholmvænget 5 7000 Fredericia",
        "latitude": 55.51836557,
        "longitude": 9.63806303
      },
      "containers": [
        {
          "id": "mp-pc-179",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-179",
            "container_id": "MP-7002-181",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQ4MTM=",
      "location": {
        "name": "Egholmvænget 12 7000 Fredericia",
        "latitude": 55.51864735,
        "longitude": 9.63909928
      },
      "containers": [
        {
          "id": "mp-pc-180",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-180",
            "container_id": "MP-7002-182",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU3Mjk=",
      "location": {
        "name": "Egholmvænget 2 7000 Fredericia",
        "latitude": 55.518411,
        "longitude": 9.639304
      },
      "containers": [
        {
          "id": "mp-pc-181",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-181",
            "container_id": "MP-7002-183",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTYyMzY=",
      "location": {
        "name": "Egholmvænget 10 7000 Fredericia",
        "latitude": 55.5188149,
        "longitude": 9.63953802
      },
      "containers": [
        {
          "id": "mp-pc-182",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-182",
            "container_id": "MP-7002-184",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5ODMxMw==",
          "ticket_id": "20598313",
          "ticket_type": "AO-Generel besked",
          "description": "Vores grå skraldespand har fået en flæk i siden. Det er vi noget trætte af for det er under et år siden vi fik en ny. Vi overfylder den på ingen måder så undrer os over at holdbarheden er så dårlig. Hvad er tidsplanen for hvornår de gamle skraldespande skal omskiftes til de nye to delte spande? Kan vi få byttet den vi har?",
          "status": 6,
          "priority": 2,
          "created_at": "2021-02-14T14:45:00+00:00",
          "updated_at": "2025-08-19T00:25:01.562320+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYyMzY=",
            "location": {
              "latitude": 55.518814,
              "longitude": 9.639538,
              "name": "Egholmvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTQ1OA==",
          "ticket_id": "20599458",
          "ticket_type": "AO-Generel besked",
          "description": "Hej, vi fik ny skraldespand i sommers. I forbindelse med tømning i onsdags er vores nye spand flækket ned langs den ene side. Den vil vi gerne have byttet til en ny. Jeg går ikke ud fra det er noget vi skal betale for når den næsten er ny og det er sket i forbindelse med tømning. mvh Simon Thorfinn",
          "status": 6,
          "priority": 2,
          "created_at": "2019-03-01T20:58:00+00:00",
          "updated_at": "2025-08-19T00:25:01.630504+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYyMzY=",
            "location": {
              "latitude": 55.518814,
              "longitude": 9.639538,
              "name": "Egholmvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTgyMQ==",
          "ticket_id": "20599821",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "Hej. Vores grå affaldsbeholder (240L) er flækket ned af den ene side i forbindelse med afhentning. Vi skal bruge en ny. Når det er sket i forbindelse med afhentning er det vel ikke noget vi skal betale for?",
          "status": 6,
          "priority": 2,
          "created_at": "2018-06-17T22:31:00+00:00",
          "updated_at": "2025-08-19T00:25:01.652375+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYyMzY=",
            "location": {
              "latitude": 55.518814,
              "longitude": 9.639538,
              "name": "Egholmvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI4OTc=",
      "location": {
        "name": "Egholmvænget 4 7000 Fredericia",
        "latitude": 55.518558,
        "longitude": 9.639764
      },
      "containers": [
        {
          "id": "mp-pc-183",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-183",
            "container_id": "MP-7002-185",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI4OTg=",
      "location": {
        "name": "Egholmvænget 6 7000 Fredericia",
        "latitude": 55.518741,
        "longitude": 9.640135
      },
      "containers": [
        {
          "id": "mp-pc-184",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-184",
            "container_id": "MP-7002-186",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQ4MTI=",
      "location": {
        "name": "Egholmvænget 8 7000 Fredericia",
        "latitude": 55.51898378,
        "longitude": 9.63989284
      },
      "containers": [
        {
          "id": "mp-pc-185",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-185",
            "container_id": "MP-7002-187",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3Njg4MQ==",
          "ticket_id": "20576881",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Egholmvænget 8 1 (7000 Fredericia) ContainerNr:415983 ContainerBrik:00400000125E011D Beholder revnet Ønsket virkningsdato: 05/02-2025 Besked: Kontaktoplysninger: Dorte Backs 24474421 dorte.backs@hotmail.com",
          "status": 6,
          "priority": 2,
          "created_at": "2025-01-31T09:43:00+00:00",
          "updated_at": "2025-08-19T00:25:00.093453+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQ4MTI=",
            "location": {
              "latitude": 55.518983,
              "longitude": 9.639892,
              "name": "Egholmvænget 8, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3Njg4Mg==",
          "ticket_id": "20576882",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Dorte BacksTlf.: 24474421Email: Dorte.backs@hotmail.comBesked: Vores skraldespand er gået i stykker ifm tømning og frost. Er det muligt at få en ny? Beboer på Egholmvænget 8, Skærbæk",
          "status": 6,
          "priority": 2,
          "created_at": "2025-01-30T16:15:00+00:00",
          "updated_at": "2025-08-19T00:25:00.093598+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQ4MTI=",
            "location": {
              "latitude": 55.518983,
              "longitude": 9.639892,
              "name": "Egholmvænget 8, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3ODczNA==",
          "ticket_id": "20578734",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Defekt låg Er der afleveret flyer: Nej Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2024-08-30T09:25:00+00:00",
          "updated_at": "2025-08-19T00:25:00.214829+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQ4MTI=",
            "location": {
              "latitude": 55.518983,
              "longitude": 9.639892,
              "name": "Egholmvænget 8, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTQ2Mw==",
          "ticket_id": "20599463",
          "ticket_type": "AO-Ændring til 140 liter beholder til restaffald",
          "description": "Skal gammel beholder hjemtages: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2019-02-27T15:50:00+00:00",
          "updated_at": "2025-08-19T00:25:01.630776+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQ4MTI=",
            "location": {
              "latitude": 55.518983,
              "longitude": 9.639892,
              "name": "Egholmvænget 8, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU3MzE=",
      "location": {
        "name": "Egholmvænget 14 7000 Fredericia",
        "latitude": 55.518933,
        "longitude": 9.63882
      },
      "containers": [
        {
          "id": "mp-pc-186",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-186",
            "container_id": "MP-7002-188",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4OTc3Mg==",
          "ticket_id": "20589772",
          "ticket_type": "AO-Beholder ikke sat på plads",
          "description": "Dette er en standpladsordningen med beholderen stilles ikke på plads. Er sket flere gange. Skal markeres med gult mærke.",
          "status": 6,
          "priority": 2,
          "created_at": "2022-04-01T11:22:00+00:00",
          "updated_at": "2025-08-19T00:25:01.012758+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU3MzE=",
            "location": {
              "latitude": 55.518933,
              "longitude": 9.63882,
              "name": "Egholmvænget 14, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI5MDA=",
      "location": {
        "name": "Egholmvænget 24 7000 Fredericia",
        "latitude": 55.519183,
        "longitude": 9.638692
      },
      "containers": [
        {
          "id": "mp-pc-187",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-187",
            "container_id": "MP-7002-189",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTcwMjg=",
      "location": {
        "name": "Egholmvænget 22 7000 Fredericia",
        "latitude": 55.51933326,
        "longitude": 9.6389753
      },
      "containers": [
        {
          "id": "mp-pc-188",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-188",
            "container_id": "MP-7002-190",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NzM1OQ==",
          "ticket_id": "20587359",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2022-09-30Fraktion: 1 (Mad/Rest)Navn: Michael Andersen Tlf.: 51947366Email: mbjerskov@gmail.comBesked: Beholder stod ikke ved skel.",
          "status": 6,
          "priority": 2,
          "created_at": "2022-10-02T08:55:00+00:00",
          "updated_at": "2025-08-19T00:25:00.789330+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcwMjg=",
            "location": {
              "latitude": 55.519333,
              "longitude": 9.638975,
              "name": "Egholmvænget 22, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDYwMDM2MA==",
          "ticket_id": "20600360",
          "ticket_type": "AO-Ændring til 180-190 liter beholder til restaffald",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2017-05-30T08:09:00+00:00",
          "updated_at": "2025-08-19T00:25:01.688746+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcwMjg=",
            "location": {
              "latitude": 55.519333,
              "longitude": 9.638975,
              "name": "Egholmvænget 22, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU3MzI=",
      "location": {
        "name": "Egholmvænget 16 7000 Fredericia",
        "latitude": 55.519082,
        "longitude": 9.639263
      },
      "containers": [
        {
          "id": "mp-pc-189",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-189",
            "container_id": "MP-7002-191",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5ODYwNg==",
          "ticket_id": "20598606",
          "ticket_type": "AO-Generel besked",
          "description": "Hej Jeg er ved at løbe tør for papirposer til grønt affald. Hvordan får jeg flere af dem? MVH Louise",
          "status": 6,
          "priority": 2,
          "created_at": "2020-09-01T16:25:00+00:00",
          "updated_at": "2025-08-19T00:25:01.579544+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU3MzI=",
            "location": {
              "latitude": 55.519082,
              "longitude": 9.639263,
              "name": "Egholmvænget 16, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTg4NQ==",
          "ticket_id": "20599885",
          "ticket_type": "AO-Ændring til 140 liter beholder til grønt affald",
          "description": "Hvor meget koster det at have en beholde til grønt affald. Og hvordan tilmelder jeg en sådan til min husstand? Skal gammel beholder hjemtages: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2018-05-21T17:16:00+00:00",
          "updated_at": "2025-08-19T00:25:01.656297+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU3MzI=",
            "location": {
              "latitude": 55.519082,
              "longitude": 9.639263,
              "name": "Egholmvænget 16, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDYwMDQxOA==",
          "ticket_id": "20600418",
          "ticket_type": "AO-Ændring til 180-190 liter beholder til restaffald",
          "description": "Vi har en 140l restaffald skraldespand og ønsker at ændre til en 180-190l. Hvad skal vi betale her og nu ved en opbytning? og hvad vil prisen være fremover?",
          "status": 6,
          "priority": 2,
          "created_at": "2017-04-19T16:25:00+00:00",
          "updated_at": "2025-08-19T00:25:01.691613+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU3MzI=",
            "location": {
              "latitude": 55.519082,
              "longitude": 9.639263,
              "name": "Egholmvænget 16, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU3MzM=",
      "location": {
        "name": "Egholmvænget 20 7000 Fredericia",
        "latitude": 55.519578,
        "longitude": 9.639282
      },
      "containers": [
        {
          "id": "mp-pc-190",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-190",
            "container_id": "MP-7002-192",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3Njg4Mw==",
          "ticket_id": "20576883",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Ingen madaffald - tømt som restaffald Er der afleveret flyer: Nej Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2025-01-31T09:36:00+00:00",
          "updated_at": "2025-08-19T00:25:00.093720+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU3MzM=",
            "location": {
              "latitude": 55.519578,
              "longitude": 9.639282,
              "name": "Egholmvænget 20, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTI5MA==",
          "ticket_id": "20591290",
          "ticket_type": "AO-Generel besked",
          "description": "der tømmes",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-24T08:33:00+00:00",
          "updated_at": "2025-08-19T00:25:01.138181+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU3MzM=",
            "location": {
              "latitude": 55.519578,
              "longitude": 9.639282,
              "name": "Egholmvænget 20, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTMwMA==",
          "ticket_id": "20591300",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2022-01-07Fraktion: 1 (Mad/Rest)Navn: NielsTlf.: 42714007Email: molichkit@gmail.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-21T14:00:00+00:00",
          "updated_at": "2025-08-19T00:25:01.138701+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU3MzM=",
            "location": {
              "latitude": 55.519578,
              "longitude": 9.639282,
              "name": "Egholmvænget 20, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTI5Ng==",
          "ticket_id": "20591296",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2022-01-07Fraktion: 1 (Mad/Rest)Navn: NielsTlf.: 42714007Email: molichkit@gmail.comBesked: Vi er tilmeldt med afhentning inde på grunden og det plejer også at virke men ikke denne gang",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-21T14:00:00+00:00",
          "updated_at": "2025-08-19T00:25:01.138491+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU3MzM=",
            "location": {
              "latitude": 55.519578,
              "longitude": 9.639282,
              "name": "Egholmvænget 20, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjQwOA==",
          "ticket_id": "20596408",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "mgl. tømning",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-19T13:13:00+00:00",
          "updated_at": "2025-08-19T00:25:01.447347+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU3MzM=",
            "location": {
              "latitude": 55.519578,
              "longitude": 9.639282,
              "name": "Egholmvænget 20, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjczNg==",
          "ticket_id": "20596736",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "ekstra tømning",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-15T12:43:00+00:00",
          "updated_at": "2025-08-19T00:25:01.468278+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU3MzM=",
            "location": {
              "latitude": 55.519578,
              "longitude": 9.639282,
              "name": "Egholmvænget 20, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5Njc5Ng==",
          "ticket_id": "20596796",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-07-09Fraktion: 1 (Mad/Rest)Navn: NielsTlf.: 42714007Email: molichkit@gmail.comBesked: Hej Vi er tilmeldt afhentning inde på grunden og har også fået det bekræftet på mail. men et eller andet må være gået galt den er ikke tømt. Mvh. Niels tlf. 42714007",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-14T18:15:00+00:00",
          "updated_at": "2025-08-19T00:25:01.471382+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU3MzM=",
            "location": {
              "latitude": 55.519578,
              "longitude": 9.639282,
              "name": "Egholmvænget 20, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5ODAwMQ==",
          "ticket_id": "20598001",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: NielsTlf.: 42714007Email: molichkit@gmail.comBesked: Hej Vi vil gerne have vort affald spand hentet ved huset, men kan ikke lige se hvor man tilmelder sig og betaler. Med venlig hilsen Niels",
          "status": 6,
          "priority": 2,
          "created_at": "2021-06-22T17:52:00+00:00",
          "updated_at": "2025-08-19T00:25:01.540979+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU3MzM=",
            "location": {
              "latitude": 55.519578,
              "longitude": 9.639282,
              "name": "Egholmvænget 20, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc1OTE=",
      "location": {
        "name": "Egholmvænget 18 7000 Fredericia",
        "latitude": 55.519261,
        "longitude": 9.63951
      },
      "containers": [
        {
          "id": "mp-pc-191",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-191",
            "container_id": "MP-7002-193",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY1NDQ=",
      "location": {
        "name": "Ærøvænget 4 7000 Fredericia",
        "latitude": 55.51815,
        "longitude": 9.641043
      },
      "containers": [
        {
          "id": "mp-pc-192",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-192",
            "container_id": "MP-7002-194",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY1NDk=",
      "location": {
        "name": "Ærøvænget 16 7000 Fredericia",
        "latitude": 55.517812,
        "longitude": 9.641395
      },
      "containers": [
        {
          "id": "mp-pc-193",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-193",
            "container_id": "MP-7002-195",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5OTc0NQ==",
          "ticket_id": "20599745",
          "ticket_type": "AO-Ændring til 240 liter beholder til restaffald",
          "description": "Skal gammel beholder hjemtages: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2018-07-26T10:20:00+00:00",
          "updated_at": "2025-08-19T00:25:01.647875+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY1NDk=",
            "location": {
              "latitude": 55.517812,
              "longitude": 9.641395,
              "name": "Ærøvænget 16, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTM5MzY=",
      "location": {
        "name": "Ærøvænget 6 7000 Fredericia",
        "latitude": 55.517769,
        "longitude": 9.640877
      },
      "containers": [
        {
          "id": "mp-pc-194",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-194",
            "container_id": "MP-7002-196",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQ5ODU=",
      "location": {
        "name": "Ærøvænget 8 7000 Fredericia",
        "latitude": 55.51748383,
        "longitude": 9.64082651
      },
      "containers": [
        {
          "id": "mp-pc-195",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-195",
            "container_id": "MP-7002-197",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY1NDg=",
      "location": {
        "name": "Ærøvænget 14 7000 Fredericia",
        "latitude": 55.517323,
        "longitude": 9.64127
      },
      "containers": [
        {
          "id": "mp-pc-196",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-196",
            "container_id": "MP-7002-198",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTM5Mzc=",
      "location": {
        "name": "Ærøvænget 10 7000 Fredericia",
        "latitude": 55.517171,
        "longitude": 9.640624
      },
      "containers": [
        {
          "id": "mp-pc-197",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-197",
            "container_id": "MP-7002-199",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MzE0MA==",
          "ticket_id": "20593140",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Ærøvænget 10 1 (7000 Fredericia) ContainerNr:415063 ContainerBrik: Låg itu Ønsket virkningsdato: 12/11-2021 Besked: Låg forsvundet efter tømning Kontaktoplysninger: Elin Jepsen 28602023 elin_simmelsgaard@hotmail.com",
          "status": 6,
          "priority": 2,
          "created_at": "2021-11-12T09:51:00+00:00",
          "updated_at": "2025-08-19T00:25:01.249373+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTM5Mzc=",
            "location": {
              "latitude": 55.517171,
              "longitude": 9.640624,
              "name": "Ærøvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzE0Mw==",
          "ticket_id": "20593143",
          "ticket_type": "AO-Håndtag itu (vedhæft evt foto - kun på web)",
          "description": "Navn: Jens Erik StengaardTlf.: 41612322Email: jstengaard@gmail.comBesked: Beholder leveret tilbage UDEN låg efter tømning 12.11.2021",
          "status": 6,
          "priority": 2,
          "created_at": "2021-11-12T08:58:00+00:00",
          "updated_at": "2025-08-19T00:25:01.249510+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTM5Mzc=",
            "location": {
              "latitude": 55.517171,
              "longitude": 9.640624,
              "name": "Ærøvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDYwMDY5Ng==",
          "ticket_id": "20600696",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "jeg har ikke fået tømt affaldsspand i denne uge ?",
          "status": 6,
          "priority": 2,
          "created_at": "2016-06-30T08:10:00+00:00",
          "updated_at": "2025-08-19T00:25:01.709813+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTM5Mzc=",
            "location": {
              "latitude": 55.517171,
              "longitude": 9.640624,
              "name": "Ærøvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQ5ODY=",
      "location": {
        "name": "Ærøvænget 12 7000 Fredericia",
        "latitude": 55.51701275,
        "longitude": 9.64110931
      },
      "containers": [
        {
          "id": "mp-pc-198",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-198",
            "container_id": "MP-7002-200",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY1NDc=",
      "location": {
        "name": "Ærøvænget 13 7000 Fredericia",
        "latitude": 55.518385,
        "longitude": 9.642137
      },
      "containers": [
        {
          "id": "mp-pc-199",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-199",
            "container_id": "MP-7002-201",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTM5MzI=",
      "location": {
        "name": "Ærøvænget 1 7000 Fredericia",
        "latitude": 55.51858,
        "longitude": 9.641993
      },
      "containers": [
        {
          "id": "mp-pc-200",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-200",
            "container_id": "MP-7002-202",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY1NDY=",
      "location": {
        "name": "Ærøvænget 11 7000 Fredericia",
        "latitude": 55.518461,
        "longitude": 9.642574
      },
      "containers": [
        {
          "id": "mp-pc-201",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-201",
            "container_id": "MP-7002-203",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY1NDU=",
      "location": {
        "name": "Ærøvænget 9 7000 Fredericia",
        "latitude": 55.518694,
        "longitude": 9.642812
      },
      "containers": [
        {
          "id": "mp-pc-202",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-202",
            "container_id": "MP-7002-204",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTM5MzU=",
      "location": {
        "name": "Ærøvænget 5 7000 Fredericia",
        "latitude": 55.518989,
        "longitude": 9.642797
      },
      "containers": [
        {
          "id": "mp-pc-203",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-203",
            "container_id": "MP-7002-205",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQ5ODQ=",
      "location": {
        "name": "Ærøvænget 7 7000 Fredericia",
        "latitude": 55.5188415,
        "longitude": 9.64334719
      },
      "containers": [
        {
          "id": "mp-pc-204",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-204",
            "container_id": "MP-7002-206",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDYwMDUyNA==",
          "ticket_id": "20600524",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "Hej, Vi vil gerne købe en ny beholder til vores restaffald - mener det er 180-190 liter beholder. Mvh. Bo Bidstrup",
          "status": 6,
          "priority": 2,
          "created_at": "2016-12-28T11:47:00+00:00",
          "updated_at": "2025-08-19T00:25:01.700329+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQ5ODQ=",
            "location": {
              "latitude": 55.518841,
              "longitude": 9.643347,
              "name": "Ærøvænget 7, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQ5ODM=",
      "location": {
        "name": "Ærøvænget 2 7000 Fredericia",
        "latitude": 55.51842865,
        "longitude": 9.64129831
      },
      "containers": [
        {
          "id": "mp-pc-205",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-205",
            "container_id": "MP-7002-207",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NTk0MQ==",
          "ticket_id": "20575941",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Søren GrønTlf.: 60571963Email: soren.gron@hotmail.comBesked: Ved genbrug pakkes hård og blød plast i separate poser før afhentning. Ved afhentning ser det ud til at begge poser deponeres i samme rum i bilen. Er dette tilfældet således at det ikke er nødvendig at sorterer i husholdningen ?",
          "status": 6,
          "priority": 2,
          "created_at": "2025-04-30T08:33:00+00:00",
          "updated_at": "2025-08-19T00:24:59.988824+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQ5ODM=",
            "location": {
              "latitude": 55.518428,
              "longitude": 9.641298,
              "name": "Ærøvænget 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTA3Nw==",
          "ticket_id": "20599077",
          "ticket_type": "AO-Ændring til 80-90 liter beholder til restaffald",
          "description": "Skal gammel beholder hjemtages: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2019-11-30T16:13:00+00:00",
          "updated_at": "2025-08-19T00:25:01.608701+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQ5ODM=",
            "location": {
              "latitude": 55.518428,
              "longitude": 9.641298,
              "name": "Ærøvænget 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY1NTE=",
      "location": {
        "name": "Ærøvænget 18 7000 Fredericia",
        "latitude": 55.51823,
        "longitude": 9.641682
      },
      "containers": [
        {
          "id": "mp-pc-206",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-206",
            "container_id": "MP-7002-208",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY1NTI=",
      "location": {
        "name": "Ærøvænget 20 7000 Fredericia",
        "latitude": 55.517818,
        "longitude": 9.642289
      },
      "containers": [
        {
          "id": "mp-pc-207",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-207",
            "container_id": "MP-7002-209",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTM5NjA=",
      "location": {
        "name": "Ærøvænget 32 7000 Fredericia",
        "latitude": 55.517525,
        "longitude": 9.643106
      },
      "containers": [
        {
          "id": "mp-pc-208",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-208",
            "container_id": "MP-7002-210",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5ODkyOQ==",
          "ticket_id": "20598929",
          "ticket_type": "AO-Ændring til 140 liter beholder til grønt affald",
          "description": "Venter på grønt beholder Skal gammel beholder hjemtages: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2020-03-30T10:34:00+00:00",
          "updated_at": "2025-08-19T00:25:01.600047+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTM5NjA=",
            "location": {
              "latitude": 55.517525,
              "longitude": 9.643106,
              "name": "Ærøvænget 32, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5ODkyNw==",
          "ticket_id": "20598927",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "Vil gerne købe en beholder til grønt affald, samt tilmelde til afhentning hver 14 dag. Mvh Jakob og Inge Sørensen",
          "status": 6,
          "priority": 2,
          "created_at": "2020-03-27T13:31:00+00:00",
          "updated_at": "2025-08-19T00:25:01.599935+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTM5NjA=",
            "location": {
              "latitude": 55.517525,
              "longitude": 9.643106,
              "name": "Ærøvænget 32, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY1NTU=",
      "location": {
        "name": "Ærøvænget 29 7000 Fredericia",
        "latitude": 55.517669,
        "longitude": 9.643527
      },
      "containers": [
        {
          "id": "mp-pc-209",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-209",
            "container_id": "MP-7002-211",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQ5ODc=",
      "location": {
        "name": "Ærøvænget 15 7000 Fredericia",
        "latitude": 55.51791503,
        "longitude": 9.64313062
      },
      "containers": [
        {
          "id": "mp-pc-210",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-210",
            "container_id": "MP-7002-212",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDYwMDAyMA==",
          "ticket_id": "20600020",
          "ticket_type": "AO-Ændring til 140 liter beholder til restaffald",
          "description": "Nuværende 190 ltr. beholder til restaffald ønskes skiftet til 140 ltr. beholder. Reduceret behov grundet færre personer i husstanden. Venlig hilsen Poul Andersen Skal gammel beholder hjemtages: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2018-02-18T13:12:00+00:00",
          "updated_at": "2025-08-19T00:25:01.667573+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQ5ODc=",
            "location": {
              "latitude": 55.517915,
              "longitude": 9.64313,
              "name": "Ærøvænget 15, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTM5Mzk=",
      "location": {
        "name": "Ærøvænget 22 7000 Fredericia",
        "latitude": 55.517401,
        "longitude": 9.642318
      },
      "containers": [
        {
          "id": "mp-pc-211",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-211",
            "container_id": "MP-7002-213",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDAwMDE1NQ==",
          "ticket_id": "10000155",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-01-30T14:11:11.949270+00:00",
          "updated_at": "2024-01-30T14:11:11.964368+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTM5Mzk=",
            "location": {
              "latitude": 55.517401,
              "longitude": 9.642318,
              "name": "Ærøvænget 22, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "lbl43_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDE1Nw==",
          "ticket_id": "20594157",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Mette Buhl Tlf.: 21130015Email: Mette-c-buhl@hotmail.comBesked: Hej :) Hvor kan man få flere klistermærker til de sække der bliver hentet en gang om måneden med pap, plastik osv?",
          "status": 6,
          "priority": 2,
          "created_at": "2021-09-14T19:49:00+00:00",
          "updated_at": "2025-08-19T00:25:01.308672+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTM5Mzk=",
            "location": {
              "latitude": 55.517401,
              "longitude": 9.642318,
              "name": "Ærøvænget 22, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTI4MQ==",
          "ticket_id": "20599281",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "Hej Efter overtagelse / indflytning er store flænger i afaldscontaineren observeret. Hvordan udbedres dette? / Søren Skyum.",
          "status": 6,
          "priority": 2,
          "created_at": "2019-06-23T20:48:00+00:00",
          "updated_at": "2025-08-19T00:25:01.620870+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTM5Mzk=",
            "location": {
              "latitude": 55.517401,
              "longitude": 9.642318,
              "name": "Ærøvænget 22, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTM5MzM=",
      "location": {
        "name": "Ærøvænget 30 7000 Fredericia",
        "latitude": 55.517029,
        "longitude": 9.642914
      },
      "containers": [
        {
          "id": "mp-pc-212",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-212",
            "container_id": "MP-7002-214",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTM5NDE=",
      "location": {
        "name": "Ærøvænget 24 7000 Fredericia",
        "latitude": 55.517006,
        "longitude": 9.642362
      },
      "containers": [
        {
          "id": "mp-pc-213",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-213",
            "container_id": "MP-7002-215",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTM5NDI=",
      "location": {
        "name": "Ærøvænget 26 7000 Fredericia",
        "latitude": 55.516757,
        "longitude": 9.642059
      },
      "containers": [
        {
          "id": "mp-pc-214",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-214",
            "container_id": "MP-7002-216",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTM5NDM=",
      "location": {
        "name": "Ærøvænget 28 7000 Fredericia",
        "latitude": 55.516652,
        "longitude": 9.642737
      },
      "containers": [
        {
          "id": "mp-pc-215",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-215",
            "container_id": "MP-7002-217",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY1NTQ=",
      "location": {
        "name": "Ærøvænget 27 7000 Fredericia",
        "latitude": 55.518001,
        "longitude": 9.643694
      },
      "containers": [
        {
          "id": "mp-pc-216",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-216",
            "container_id": "MP-7002-218",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDUzMjIyNg==",
          "ticket_id": "10532226",
          "ticket_type": "Affaldet skal sorteres som restaffald",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2025-01-30T12:44:14.877434+00:00",
          "updated_at": "2025-01-30T12:44:14.878406+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY1NTQ=",
            "location": {
              "latitude": 55.518001,
              "longitude": 9.643694,
              "name": "Ærøvænget 27, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "lbl37_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY1NTA=",
      "location": {
        "name": "Ærøvænget 17 7000 Fredericia",
        "latitude": 55.518234,
        "longitude": 9.643077
      },
      "containers": [
        {
          "id": "mp-pc-217",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-217",
            "container_id": "MP-7002-219",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTM5Mzg=",
      "location": {
        "name": "Ærøvænget 19 7000 Fredericia",
        "latitude": 55.518506,
        "longitude": 9.643707
      },
      "containers": [
        {
          "id": "mp-pc-218",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-218",
            "container_id": "MP-7002-220",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY1NTM=",
      "location": {
        "name": "Ærøvænget 25 7000 Fredericia",
        "latitude": 55.518392,
        "longitude": 9.644161
      },
      "containers": [
        {
          "id": "mp-pc-219",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-219",
            "container_id": "MP-7002-221",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQ5ODg=",
      "location": {
        "name": "Ærøvænget 21 7000 Fredericia",
        "latitude": 55.51884539,
        "longitude": 9.64412917
      },
      "containers": [
        {
          "id": "mp-pc-220",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-220",
            "container_id": "MP-7002-222",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5ODU3NQ==",
          "ticket_id": "20598575",
          "ticket_type": "AO-Ændring til 140 liter beholder til restaffald",
          "description": "Hvornår byttes den nye beholder med den gamle? Skal gammel beholder hjemtages: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2020-09-25T06:58:00+00:00",
          "updated_at": "2025-08-19T00:25:01.577605+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQ5ODg=",
            "location": {
              "latitude": 55.518845,
              "longitude": 9.644129,
              "name": "Ærøvænget 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTM5NDA=",
      "location": {
        "name": "Ærøvænget 23 7000 Fredericia",
        "latitude": 55.518703,
        "longitude": 9.64453
      },
      "containers": [
        {
          "id": "mp-pc-221",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-221",
            "container_id": "MP-7002-223",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQ1MDY=",
      "location": {
        "name": "Lyøvænget 2 7000 Fredericia",
        "latitude": 55.51582939,
        "longitude": 9.63739249
      },
      "containers": [
        {
          "id": "mp-pc-222",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-222",
            "container_id": "MP-7002-224",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTA2NDY=",
      "location": {
        "name": "Lyøvænget 1 7000 Fredericia",
        "latitude": 55.51556,
        "longitude": 9.637253
      },
      "containers": [
        {
          "id": "mp-pc-223",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-223",
            "container_id": "MP-7002-225",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDQ2NTg=",
      "location": {
        "name": "Lyøvænget 7 7000 Fredericia",
        "latitude": 55.51582,
        "longitude": 9.636877
      },
      "containers": [
        {
          "id": "mp-pc-224",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-224",
            "container_id": "MP-7002-226",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MjY4Mg==",
          "ticket_id": "20592682",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-12-10Fraktion: 1 (Mad/Rest)Navn: Pia NicolaisenTlf.: 27617001Email: famnicolaisen@me.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-11T08:15:00+00:00",
          "updated_at": "2025-08-19T00:25:01.223311+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQ2NTg=",
            "location": {
              "latitude": 55.51582,
              "longitude": 9.636877,
              "name": "Lyøvænget 7, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDcyMjc=",
      "location": {
        "name": "Lyøvænget 5 7000 Fredericia",
        "latitude": 55.515639,
        "longitude": 9.636728
      },
      "containers": [
        {
          "id": "mp-pc-225",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-225",
            "container_id": "MP-7002-227",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDQ2NjU=",
      "location": {
        "name": "Lyøvænget 3 7000 Fredericia",
        "latitude": 55.515428,
        "longitude": 9.636918
      },
      "containers": [
        {
          "id": "mp-pc-226",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-226",
            "container_id": "MP-7002-228",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NzIyNg==",
          "ticket_id": "20577226",
          "ticket_type": "AO-Generel besked",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2025-01-03T09:52:00+00:00",
          "updated_at": "2025-08-19T00:25:00.127468+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQ2NjU=",
            "location": {
              "latitude": 55.515428,
              "longitude": 9.636918,
              "name": "Lyøvænget 3, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3NzIyNw==",
          "ticket_id": "20577227",
          "ticket_type": "AO-Generel besked",
          "description": "Jeg plejer at få besked om tømning dagen før. I går fik jeg ingen besked (SMS)om tømning i dag? Det er en meget nyttig âreminderâ så jeg vil meget gerne have besked fremover",
          "status": 6,
          "priority": 2,
          "created_at": "2025-01-03T09:29:00+00:00",
          "updated_at": "2025-08-19T00:25:00.127514+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQ2NjU=",
            "location": {
              "latitude": 55.515428,
              "longitude": 9.636918,
              "name": "Lyøvænget 3, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZTo2OTM0ODY2",
          "ticket_id": "6934866",
          "ticket_type": "Beholder overfyldt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2023-06-27T10:31:05.285193+00:00",
          "updated_at": "2023-06-27T10:31:05.298801+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQ2NjU=",
            "location": {
              "latitude": 55.515428,
              "longitude": 9.636918,
              "name": "Lyøvænget 3, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20579_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZTo2OTM0ODYz",
          "ticket_id": "6934863",
          "ticket_type": "Beholder overfyldt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2023-06-27T10:27:24.436374+00:00",
          "updated_at": "2023-06-27T10:27:24.450135+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQ2NjU=",
            "location": {
              "latitude": 55.515428,
              "longitude": 9.636918,
              "name": "Lyøvænget 3, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20579_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDg1MDY=",
      "location": {
        "name": "Børup Sandevej 9 7000 Fredericia",
        "latitude": 55.51541,
        "longitude": 9.63662
      },
      "containers": [
        {
          "id": "mp-pc-227",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-227",
            "container_id": "MP-7002-229",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDYwMDIzNw==",
          "ticket_id": "20600237",
          "ticket_type": "AO-Ændring til 240 liter beholder til restaffald",
          "description": "Skal gammel beholder hjemtages: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2017-08-16T18:09:00+00:00",
          "updated_at": "2025-08-19T00:25:01.680760+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MDY=",
            "location": {
              "latitude": 55.51541,
              "longitude": 9.63662,
              "name": "Børup Sandevej 9, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQ1MDc=",
      "location": {
        "name": "Lyøvænget 9 7000 Fredericia",
        "latitude": 55.51604117,
        "longitude": 9.63703166
      },
      "containers": [
        {
          "id": "mp-pc-228",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-228",
            "container_id": "MP-7002-230",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTA2NDc=",
      "location": {
        "name": "Lyøvænget 4 7000 Fredericia",
        "latitude": 55.516025,
        "longitude": 9.637512
      },
      "containers": [
        {
          "id": "mp-pc-229",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-229",
            "container_id": "MP-7002-231",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDQ2NTk=",
      "location": {
        "name": "Lyøvænget 11 7000 Fredericia",
        "latitude": 55.516273,
        "longitude": 9.637098
      },
      "containers": [
        {
          "id": "mp-pc-230",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-230",
            "container_id": "MP-7002-232",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDQ2NTc=",
      "location": {
        "name": "Lyøvænget 6 7000 Fredericia",
        "latitude": 55.51622,
        "longitude": 9.637613
      },
      "containers": [
        {
          "id": "mp-pc-231",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-231",
            "container_id": "MP-7002-233",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTA2NDk=",
      "location": {
        "name": "Lyøvænget 13 7000 Fredericia",
        "latitude": 55.516471,
        "longitude": 9.6373
      },
      "containers": [
        {
          "id": "mp-pc-232",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-232",
            "container_id": "MP-7002-234",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDEwMzQ5OQ==",
          "ticket_id": "10103499",
          "ticket_type": "Affaldet skal sorteres som restaffald",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-05-27T06:22:30.872461+00:00",
          "updated_at": "2024-05-27T06:22:30.873149+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTA2NDk=",
            "location": {
              "latitude": 55.516471,
              "longitude": 9.6373,
              "name": "Lyøvænget 13, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20589_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDcyMjg=",
      "location": {
        "name": "Lyøvænget 8 7000 Fredericia",
        "latitude": 55.516415,
        "longitude": 9.637725
      },
      "containers": [
        {
          "id": "mp-pc-233",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-233",
            "container_id": "MP-7002-235",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDcyMjk=",
      "location": {
        "name": "Lyøvænget 15 7000 Fredericia",
        "latitude": 55.516661,
        "longitude": 9.637318
      },
      "containers": [
        {
          "id": "mp-pc-234",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-234",
            "container_id": "MP-7002-236",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZTo3MjY2NzE3",
          "ticket_id": "7266717",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2023-09-25T06:07:18.416093+00:00",
          "updated_at": "2023-09-25T06:07:18.429127+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDcyMjk=",
            "location": {
              "latitude": 55.516661,
              "longitude": 9.637318,
              "name": "Lyøvænget 15, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20591_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQ1MDg=",
      "location": {
        "name": "Lyøvænget 10 7000 Fredericia",
        "latitude": 55.51658971,
        "longitude": 9.63781749
      },
      "containers": [
        {
          "id": "mp-pc-235",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-235",
            "container_id": "MP-7002-237",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5OTUyOA==",
          "ticket_id": "20599528",
          "ticket_type": "AO-Ændring til 140 liter beholder til restaffald",
          "description": "Skal gammel beholder hjemtages: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2019-01-10T14:27:00+00:00",
          "updated_at": "2025-08-19T00:25:01.634516+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQ1MDg=",
            "location": {
              "latitude": 55.516589,
              "longitude": 9.637817,
              "name": "Lyøvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTA2NDg=",
      "location": {
        "name": "Lyøvænget 12 7000 Fredericia",
        "latitude": 55.516781,
        "longitude": 9.637943
      },
      "containers": [
        {
          "id": "mp-pc-236",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-236",
            "container_id": "MP-7002-238",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDQ2NjE=",
      "location": {
        "name": "Lyøvænget 17 7000 Fredericia",
        "latitude": 55.516877,
        "longitude": 9.637576
      },
      "containers": [
        {
          "id": "mp-pc-237",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-237",
            "container_id": "MP-7002-239",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDQ2NjA=",
      "location": {
        "name": "Lyøvænget 14 7000 Fredericia",
        "latitude": 55.516969,
        "longitude": 9.638113
      },
      "containers": [
        {
          "id": "mp-pc-238",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-238",
            "container_id": "MP-7002-240",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDA3NTczNw==",
          "ticket_id": "10075737",
          "ticket_type": "Affaldet skal afleveres på genbrugspladsen",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-04-24T06:26:19.548393+00:00",
          "updated_at": "2024-04-24T06:26:19.549291+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQ2NjA=",
            "location": {
              "latitude": 55.516969,
              "longitude": 9.638113,
              "name": "Lyøvænget 14, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20590_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTA2NTI=",
      "location": {
        "name": "Lyøvænget 19 7000 Fredericia",
        "latitude": 55.517082,
        "longitude": 9.637718
      },
      "containers": [
        {
          "id": "mp-pc-239",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-239",
            "container_id": "MP-7002-241",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDQ2NjI=",
      "location": {
        "name": "Lyøvænget 21 7000 Fredericia",
        "latitude": 55.51731,
        "longitude": 9.637778
      },
      "containers": [
        {
          "id": "mp-pc-240",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-240",
            "container_id": "MP-7002-242",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NTg3Mw==",
          "ticket_id": "20595873",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "ekstra tømning",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-28T11:42:00+00:00",
          "updated_at": "2025-08-19T00:25:01.416914+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQ2NjI=",
            "location": {
              "latitude": 55.51731,
              "longitude": 9.637778,
              "name": "Lyøvænget 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTk4OQ==",
          "ticket_id": "20595989",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Ej tømt den 23.7. Hvornår tømmes??",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-26T11:54:00+00:00",
          "updated_at": "2025-08-19T00:25:01.424005+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQ2NjI=",
            "location": {
              "latitude": 55.51731,
              "longitude": 9.637778,
              "name": "Lyøvænget 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTA2NTE=",
      "location": {
        "name": "Lyøvænget 18 7000 Fredericia",
        "latitude": 55.517389,
        "longitude": 9.638166
      },
      "containers": [
        {
          "id": "mp-pc-241",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-241",
            "container_id": "MP-7002-243",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDQ2NjM=",
      "location": {
        "name": "Lyøvænget 23 7000 Fredericia",
        "latitude": 55.517545,
        "longitude": 9.637858
      },
      "containers": [
        {
          "id": "mp-pc-242",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-242",
            "container_id": "MP-7002-244",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDQ2NjQ=",
      "location": {
        "name": "Lyøvænget 25 7000 Fredericia",
        "latitude": 55.517566,
        "longitude": 9.638085
      },
      "containers": [
        {
          "id": "mp-pc-243",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-243",
            "container_id": "MP-7002-245",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTkxMTc=",
      "location": {
        "name": "Vigøvej 2 7000 Fredericia",
        "latitude": 55.51522725,
        "longitude": 9.63858222
      },
      "containers": [
        {
          "id": "mp-pc-244",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-244",
            "container_id": "MP-7002-246",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "400 L"
            }
          }
        },
        {
          "id": "mp-pc-245",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-245",
            "container_id": "MP-7002-247",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "400 L"
            }
          }
        },
        {
          "id": "mp-pc-246",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-246",
            "container_id": "MP-7002-248",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "400 L"
            }
          }
        },
        {
          "id": "mp-pc-247",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-247",
            "container_id": "MP-7002-249",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "400 L"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3Nzg2Ng==",
          "ticket_id": "20577866",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Beholder overfyldt Er der afleveret flyer: Ja Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2024-11-15T10:08:00+00:00",
          "updated_at": "2025-08-19T00:25:00.164282+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkxMTc=",
            "location": {
              "latitude": 55.515227,
              "longitude": 9.638582,
              "name": "Vigøvej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDMyOA==",
          "ticket_id": "20580328",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Batterier institution Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 14/06 2024 Besked: Rød kasse til batterier. Kontaktoplysninger: FREDERICIA KOMMUNE",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-07T12:54:00+00:00",
          "updated_at": "2025-08-19T00:25:00.308628+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkxMTc=",
            "location": {
              "latitude": 55.515227,
              "longitude": 9.638582,
              "name": "Vigøvej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDMzMA==",
          "ticket_id": "20580330",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Farligt affald institution Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 14/06 2024 Besked: Rød kasse til farligt affald. Kontaktoplysninger: FREDERICIA KOMMUNE",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-07T12:53:00+00:00",
          "updated_at": "2025-08-19T00:25:00.308740+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkxMTc=",
            "location": {
              "latitude": 55.515227,
              "longitude": 9.638582,
              "name": "Vigøvej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDMyOQ==",
          "ticket_id": "20580329",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Småt elektronik institution Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 14/06 2024 Besked: Rød kasse til småt elektronik. Kontaktoplysninger: FREDERICIA KOMMUNE",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-07T12:53:00+00:00",
          "updated_at": "2025-08-19T00:25:00.308685+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkxMTc=",
            "location": {
              "latitude": 55.515227,
              "longitude": 9.638582,
              "name": "Vigøvej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MzU1Ng==",
          "ticket_id": "20583556",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 400 l rest - Institution Uge Ny tømningsfrekvens: Hver uge Ønsket virkningsdato: 10/10-2023 Besked: Gitte Clement Meyer, tlf. 41731939. Ønsker at afmelde 1 stk. 400 liter mad og ændre til 1 stk. 400 liter rest. Kontaktoplysninger: FREDERICIA KOMMUNE",
          "status": 6,
          "priority": 2,
          "created_at": "2023-10-06T10:19:00+00:00",
          "updated_at": "2025-08-19T00:25:00.507618+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkxMTc=",
            "location": {
              "latitude": 55.515227,
              "longitude": 9.638582,
              "name": "Vigøvej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MzU1OQ==",
          "ticket_id": "20583559",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: 400 l mad - Institution Uge Vigøvej 2 1 (7000 Fredericia) ContainerNr:434194 ContainerBrik:0040000015238085 Ønsket virkningsdato: 13/10 2023 Besked: Tlf. 41731939 - institutionen. Ønsker afmelding af 1 stk. 400 liter. Kontaktoplysninger: FREDERICIA KOMMUNE",
          "status": 6,
          "priority": 2,
          "created_at": "2023-10-06T10:07:00+00:00",
          "updated_at": "2025-08-19T00:25:00.507799+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkxMTc=",
            "location": {
              "latitude": 55.515227,
              "longitude": 9.638582,
              "name": "Vigøvej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTkxNQ==",
          "ticket_id": "20585915",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Der ønskes ekstra tømning af 2 stk. 400 liter rest beholdere. Der er sendt kommunemail.",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-27T10:37:00+00:00",
          "updated_at": "2025-08-19T00:25:00.645581+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkxMTc=",
            "location": {
              "latitude": 55.515227,
              "longitude": 9.638582,
              "name": "Vigøvej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI5ODQ=",
      "location": {
        "name": "Vigøvej 1 7000 Fredericia",
        "latitude": 55.515739,
        "longitude": 9.638355
      },
      "containers": [
        {
          "id": "mp-pc-248",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-248",
            "container_id": "MP-7002-250",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NzM1NQ==",
          "ticket_id": "20587355",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2022-09-16Fraktion: 1 (Mad/Rest)Navn: Tonni Thomsen Tlf.: 60474874Email: tonni_thomsen@hotmail.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2022-09-30T17:05:00+00:00",
          "updated_at": "2025-08-19T00:25:00.788879+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI5ODQ=",
            "location": {
              "latitude": 55.515739,
              "longitude": 9.638355,
              "name": "Vigøvej 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjE1NA==",
          "ticket_id": "20596154",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-07-09Fraktion: 1 (Mad/Rest)Navn: Tonni Thomsen Tlf.: 60474874Email: tonni_thomsen@hotmail.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-23T08:40:00+00:00",
          "updated_at": "2025-08-19T00:25:01.434469+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI5ODQ=",
            "location": {
              "latitude": 55.515739,
              "longitude": 9.638355,
              "name": "Vigøvej 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQ4MjY=",
      "location": {
        "name": "Vigøvej 3 7000 Fredericia",
        "latitude": 55.51591689,
        "longitude": 9.63848348
      },
      "containers": [
        {
          "id": "mp-pc-249",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-249",
            "container_id": "MP-7002-251",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NDg3NQ==",
          "ticket_id": "20594875",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "mgl. tømning?",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-20T10:47:00+00:00",
          "updated_at": "2025-08-19T00:25:01.352951+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQ4MjY=",
            "location": {
              "latitude": 55.515916,
              "longitude": 9.638483,
              "name": "Vigøvej 3, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI5ODU=",
      "location": {
        "name": "Vigøvej 5 7000 Fredericia",
        "latitude": 55.51612,
        "longitude": 9.638669
      },
      "containers": [
        {
          "id": "mp-pc-250",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-250",
            "container_id": "MP-7002-252",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI5OTI=",
      "location": {
        "name": "Vigøvej 33 7000 Fredericia",
        "latitude": 55.515621,
        "longitude": 9.638769
      },
      "containers": [
        {
          "id": "mp-pc-251",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-251",
            "container_id": "MP-7002-253",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI5OTE=",
      "location": {
        "name": "Vigøvej 31 7000 Fredericia",
        "latitude": 55.515513,
        "longitude": 9.63909
      },
      "containers": [
        {
          "id": "mp-pc-252",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-252",
            "container_id": "MP-7002-254",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc1OTY=",
      "location": {
        "name": "Vigøvej 27 7000 Fredericia",
        "latitude": 55.515548,
        "longitude": 9.639641
      },
      "containers": [
        {
          "id": "mp-pc-253",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-253",
            "container_id": "MP-7002-255",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI5OTA=",
      "location": {
        "name": "Vigøvej 29 7000 Fredericia",
        "latitude": 55.515311,
        "longitude": 9.63942
      },
      "containers": [
        {
          "id": "mp-pc-254",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-254",
            "container_id": "MP-7002-256",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NDgxNQ==",
          "ticket_id": "20594815",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Glemt at stille frem.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-23T14:22:00+00:00",
          "updated_at": "2025-08-19T00:25:01.349909+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI5OTA=",
            "location": {
              "latitude": 55.515311,
              "longitude": 9.63942,
              "name": "Vigøvej 29, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc1OTQ=",
      "location": {
        "name": "Vigøvej 17 7000 Fredericia",
        "latitude": 55.515867,
        "longitude": 9.639197
      },
      "containers": [
        {
          "id": "mp-pc-255",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-255",
            "container_id": "MP-7002-257",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc1OTU=",
      "location": {
        "name": "Vigøvej 15 7000 Fredericia",
        "latitude": 55.516145,
        "longitude": 9.63941
      },
      "containers": [
        {
          "id": "mp-pc-256",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-256",
            "container_id": "MP-7002-258",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZTo5NjY0MTU1",
          "ticket_id": "9664155",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2023-10-24T06:00:07.807410+00:00",
          "updated_at": "2023-10-24T06:00:07.822044+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc1OTU=",
            "location": {
              "latitude": 55.516145,
              "longitude": 9.63941,
              "name": "Vigøvej 15, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20677_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI5ODc=",
      "location": {
        "name": "Vigøvej 21 7000 Fredericia",
        "latitude": 55.516021,
        "longitude": 9.63979
      },
      "containers": [
        {
          "id": "mp-pc-257",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-257",
            "container_id": "MP-7002-259",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI5ODg=",
      "location": {
        "name": "Vigøvej 23 7000 Fredericia",
        "latitude": 55.515978,
        "longitude": 9.640122
      },
      "containers": [
        {
          "id": "mp-pc-258",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-258",
            "container_id": "MP-7002-260",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MTg3NQ==",
          "ticket_id": "20591875",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Vigøvej 23 1 (7000 Fredericia) ContainerNr:414124 ContainerBrik: Beholder revnet Ønsket virkningsdato: 05/01-2022 Besked: Beholder ødelagt ved tømning d. 24/12 Kontaktoplysninger: Finn Jensen",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-04T09:50:00+00:00",
          "updated_at": "2025-08-19T00:25:01.175875+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI5ODg=",
            "location": {
              "latitude": 55.515978,
              "longitude": 9.640122,
              "name": "Vigøvej 23, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI5ODk=",
      "location": {
        "name": "Vigøvej 25 7000 Fredericia",
        "latitude": 55.515806,
        "longitude": 9.639907
      },
      "containers": [
        {
          "id": "mp-pc-259",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-259",
            "container_id": "MP-7002-261",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5ODE0OQ==",
          "ticket_id": "20598149",
          "ticket_type": "AO-Manglende tømning - grønt affald",
          "description": "Min grønne spand blev ikke tømt i går",
          "status": 6,
          "priority": 2,
          "created_at": "2021-05-21T09:12:00+00:00",
          "updated_at": "2025-08-19T00:25:01.553080+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI5ODk=",
            "location": {
              "latitude": 55.515801,
              "longitude": 9.639907,
              "name": "Vigøvej 25, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI5ODY=",
      "location": {
        "name": "Vigøvej 7 7000 Fredericia",
        "latitude": 55.516309,
        "longitude": 9.638759
      },
      "containers": [
        {
          "id": "mp-pc-260",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-260",
            "container_id": "MP-7002-262",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MDMwMA==",
          "ticket_id": "20590300",
          "ticket_type": "AO-Håndtag itu (vedhæft evt foto - kun på web)",
          "description": "For noget tid siden blev håndtag og den ene \"hængsel\" øgelagt. Efter tømning for 2 uger siden fik vi beholder uden låg tilbage. Jeg vil derfor spørge om I vil komme med en ny beholder til os så hurtig som muligt. På forhånd tak. Malgorzata Pawska",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-07T08:24:00+00:00",
          "updated_at": "2025-08-19T00:25:01.059818+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI5ODY=",
            "location": {
              "latitude": 55.516309,
              "longitude": 9.63876,
              "name": "Vigøvej 7, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDYwMDYwMA==",
          "ticket_id": "20600600",
          "ticket_type": "AO-Ændring til 180-190 liter beholder til restaffald",
          "description": "Hej, jeg vil gerne bestille en 180-190 beholder til restaffald. På forhånd tak Malgorzata Pawska",
          "status": 6,
          "priority": 2,
          "created_at": "2016-10-07T11:31:00+00:00",
          "updated_at": "2025-08-19T00:25:01.704173+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI5ODY=",
            "location": {
              "latitude": 55.516309,
              "longitude": 9.63876,
              "name": "Vigøvej 7, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDYwMDYwMQ==",
          "ticket_id": "20600601",
          "ticket_type": "AO-Ændring til 140 liter beholder til restaffald",
          "description": "Jeg vil gerne hurtigst muligt bestille 140 liter beholder til restaffald. Hvornår kan jeg modtage sådan en? På forhånd tak Malgorzata Pawska",
          "status": 6,
          "priority": 2,
          "created_at": "2016-10-06T17:29:00+00:00",
          "updated_at": "2025-08-19T00:25:01.704224+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI5ODY=",
            "location": {
              "latitude": 55.516309,
              "longitude": 9.63876,
              "name": "Vigøvej 7, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTE1NTk=",
      "location": {
        "name": "Vigøvej 11 7000 Fredericia",
        "latitude": 55.516449,
        "longitude": 9.639311
      },
      "containers": [
        {
          "id": "mp-pc-261",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-261",
            "container_id": "MP-7002-263",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5ODk3MA==",
          "ticket_id": "20598970",
          "ticket_type": "AO-Ændring til 80-90 liter beholder til restaffald",
          "description": "Skal gammel beholder hjemtages: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2020-02-26T12:49:00+00:00",
          "updated_at": "2025-08-19T00:25:01.602416+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE1NTk=",
            "location": {
              "latitude": 55.516449,
              "longitude": 9.639311,
              "name": "Vigøvej 11, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDM1NjY=",
      "location": {
        "name": "Børup Sandevej 14 7000 Fredericia",
        "latitude": 55.515018,
        "longitude": 9.636615
      },
      "containers": [
        {
          "id": "mp-pc-262",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-262",
            "container_id": "MP-7002-264",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQyMDI=",
      "location": {
        "name": "Børup Sandevej 7 7000 Fredericia",
        "latitude": 55.51535003,
        "longitude": 9.63627934
      },
      "containers": [
        {
          "id": "mp-pc-263",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-263",
            "container_id": "MP-7002-265",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MzE2Nw==",
          "ticket_id": "20593167",
          "ticket_type": "AO-Håndtag itu (vedhæft evt foto - kun på web)",
          "description": "Knækket midt på",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-28T16:43:00+00:00",
          "updated_at": "2025-08-19T00:25:01.250693+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQyMDI=",
            "location": {
              "latitude": 55.51535,
              "longitude": 9.636279,
              "name": "Børup Sandevej 7, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzE2Ng==",
          "ticket_id": "20593166",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Børup Sandevej 7 1 (7000 Fredericia) ContainerNr:415335 ContainerBrik: Håndtag itu Ønsket virkningsdato: 15/09-2021 Besked: Kontaktoplysninger: Peter Sørensen Lykkehus 29462421 Peterlykkehus@hotmail.com",
          "status": 6,
          "priority": 2,
          "created_at": "2021-09-15T14:57:00+00:00",
          "updated_at": "2025-08-19T00:25:01.250642+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQyMDI=",
            "location": {
              "latitude": 55.51535,
              "longitude": 9.636279,
              "name": "Børup Sandevej 7, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTM0Ng==",
          "ticket_id": "20595346",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "Navn: Peter LykkehusTlf.: 29462421Email: peterlykkehus@hotmail.comBesked: Hej. Vores beholder er idag blevet tømt. Desværre er håndtaget knækket. Kan vi forvente at få en ny beholder? Vh Peter og Gitte Lykkehus",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-06T14:08:00+00:00",
          "updated_at": "2025-08-19T00:25:01.382081+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQyMDI=",
            "location": {
              "latitude": 55.51535,
              "longitude": 9.636279,
              "name": "Børup Sandevej 7, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTgwOA==",
          "ticket_id": "20595808",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Navn: Peter LykkehusTlf.: 29462421Email: peterlykkehus@hotmail.comBesked: Hej vores gamle beholder med restaffald er stadig ikke tømt. Vi er selvfølgelig gået til at bruge den nye beholder fra 1. Juli. Hvad skal vi gøre ved dette? Mvh Gitte og Peter Lykkehus, Børup Sandevej 7.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-29T13:33:00+00:00",
          "updated_at": "2025-08-19T00:25:01.412015+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQyMDI=",
            "location": {
              "latitude": 55.51535,
              "longitude": 9.636279,
              "name": "Børup Sandevej 7, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDM1NjU=",
      "location": {
        "name": "Børup Sandevej 12 7000 Fredericia",
        "latitude": 55.514982,
        "longitude": 9.63623
      },
      "containers": [
        {
          "id": "mp-pc-264",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-264",
            "container_id": "MP-7002-266",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDM1NjQ=",
      "location": {
        "name": "Børup Sandevej 6 7000 Fredericia",
        "latitude": 55.515019,
        "longitude": 9.635555
      },
      "containers": [
        {
          "id": "mp-pc-265",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-265",
            "container_id": "MP-7002-267",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MzE2OA==",
          "ticket_id": "20593168",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Børup Sandevej 6 1 (7000 Fredericia) ContainerNr:404720 ContainerBrik: Håndtag itu Ønsket virkningsdato: 10/09-2021 Besked: Kontaktoplysninger: Morten Kristiansen 25408460 mrk@spacehost.dk",
          "status": 6,
          "priority": 2,
          "created_at": "2021-09-10T13:54:00+00:00",
          "updated_at": "2025-08-19T00:25:01.250744+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDM1NjQ=",
            "location": {
              "latitude": 55.51502,
              "longitude": 9.635555,
              "name": "Børup Sandevej 6, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTM0NA==",
          "ticket_id": "20595344",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Morten Kristiansen Tlf.: 25408460Email: mrk@spacehost.dkBesked: hej efter tømning i dag. har i nok været for hård ved den da der hvor i løfter den i skraldebil er ødelagt knækket midt på. hvad gør vi der, jeg håber da ikke jeg skal til og betale for en ny allerede ... da den er hel ny og intet fejlet i morges inde i kom og hentet den",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-06T16:53:00+00:00",
          "updated_at": "2025-08-19T00:25:01.381938+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDM1NjQ=",
            "location": {
              "latitude": 55.51502,
              "longitude": 9.635555,
              "name": "Børup Sandevej 6, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDUwOTA=",
      "location": {
        "name": "Børup Sandevej 8 7000 Fredericia",
        "latitude": 55.514715,
        "longitude": 9.635255
      },
      "containers": [
        {
          "id": "mp-pc-266",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-266",
            "container_id": "MP-7002-268",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDYwMDEyMw==",
          "ticket_id": "20600123",
          "ticket_type": "AO-Ændring til 80-90 liter beholder til restaffald",
          "description": "Skal gammel beholder hjemtages: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2017-11-22T10:39:00+00:00",
          "updated_at": "2025-08-19T00:25:01.673939+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDUwOTA=",
            "location": {
              "latitude": 55.514715,
              "longitude": 9.635255,
              "name": "Børup Sandevej 8, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTY5Mzk=",
      "location": {
        "name": "Børup Sandevej 3 7000 Fredericia",
        "latitude": 55.51520653,
        "longitude": 9.6357579
      },
      "containers": [
        {
          "id": "mp-pc-267",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-267",
            "container_id": "MP-7002-269",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NDQ5OA==",
          "ticket_id": "20584498",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Laila NikolajsenTlf.: 40579901Email: laila_nikolajsen@hotmail.comBesked: Spændt på hvornår vi får genbrugsposer igen??var i kontakt med kommune for 1/2 år siden hvor der blev sagt at de kom snart?mvh Nikolajsen",
          "status": 6,
          "priority": 2,
          "created_at": "2023-06-15T21:40:00+00:00",
          "updated_at": "2025-08-19T00:25:00.563351+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTY5Mzk=",
            "location": {
              "latitude": 55.515206,
              "longitude": 9.635757,
              "name": "Børup Sandevej 3, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5Mjg4Nw==",
          "ticket_id": "20592887",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-11-26Fraktion: 1 (Mad/Rest)Navn: RitaTlf.: 28829965Email: konstabelvej@live.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-11-29T18:17:00+00:00",
          "updated_at": "2025-08-19T00:25:01.234995+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTY5Mzk=",
            "location": {
              "latitude": 55.515206,
              "longitude": 9.635757,
              "name": "Børup Sandevej 3, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQyMDE=",
      "location": {
        "name": "Børup Sandevej 4 7000 Fredericia",
        "latitude": 55.51509851,
        "longitude": 9.63527489
      },
      "containers": [
        {
          "id": "mp-pc-268",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-268",
            "container_id": "MP-7002-270",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        },
        {
          "id": "mp-pc-269",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-269",
            "container_id": "MP-7002-271",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MDgyNA==",
          "ticket_id": "20590824",
          "ticket_type": "AO-Håndtag itu (vedhæft evt foto - kun på web)",
          "description": "Hej Begge vores skraldespande i sommerhuset er i stykker - begge i lågerne. har vedhæftet billede af skaderne.",
          "status": 6,
          "priority": 2,
          "created_at": "2022-02-14T11:39:00+00:00",
          "updated_at": "2025-08-19T00:25:01.095288+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQyMDE=",
            "location": {
              "latitude": 55.515098,
              "longitude": 9.635274,
              "name": "Børup Sandevej 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjYxNg==",
          "ticket_id": "20592616",
          "ticket_type": "AO-Generel besked",
          "description": "SENDES IKKE TIL MP!! Der har været lidt udfordringer med tømningen på denne adresse. Der er tømt fint i fredags, og det er ejeren af sommerhuset rigtige glade for :-) Beholderen står altid under 5 meter fra skel, men de vil meget gerne have besked, hvis der er nogle forhold som gør, at de ikke kan tømme, så de kan rette op på dette. Sommerhuset bliver lejet ud, og derfor er tømning til tiden vigtigt. Rita Ravnborg (fra borgerservice) ejer sommerhuset, hendes lokalnr. er 7241",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-15T12:08:00+00:00",
          "updated_at": "2025-08-19T00:25:01.219732+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQyMDE=",
            "location": {
              "latitude": 55.515098,
              "longitude": 9.635274,
              "name": "Børup Sandevej 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjgxOA==",
          "ticket_id": "20592818",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-11-26Fraktion: 1 (Mad/Rest)Navn: RitaTlf.: 28829965Email: konstabelvej@live.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-03T13:03:00+00:00",
          "updated_at": "2025-08-19T00:25:01.231713+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQyMDE=",
            "location": {
              "latitude": 55.515098,
              "longitude": 9.635274,
              "name": "Børup Sandevej 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY4OTY=",
      "location": {
        "name": "Børup Sandevej 1 7000 Fredericia",
        "latitude": 55.51537,
        "longitude": 9.635159
      },
      "containers": [
        {
          "id": "mp-pc-270",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-270",
            "container_id": "MP-7002-272",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NjA0MQ==",
          "ticket_id": "20586041",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "Borger kontakter os og ønsker en ekstra tømning, da hun ikke fik beholder sat ud til tiden. Helst i dag, hvis det er muligt. Har sendt kommunemail.",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-19T09:44:00+00:00",
          "updated_at": "2025-08-19T00:25:00.661341+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY4OTY=",
            "location": {
              "latitude": 55.515373,
              "longitude": 9.635159,
              "name": "Børup Sandevej 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NjAxNA==",
          "ticket_id": "20586014",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Borger kontakter os og ønsker en ekstra tømning, da hun ikke fik beholder sat ud til tiden. Helst i dag, hvis det er muligt. Har sendt kommunemail.",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-19T09:44:00+00:00",
          "updated_at": "2025-08-19T00:25:00.658539+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY4OTY=",
            "location": {
              "latitude": 55.515373,
              "longitude": 9.635159,
              "name": "Børup Sandevej 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTE2Mg==",
          "ticket_id": "20595162",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Glemte at sætte ud. Vil gerne have bestilt en ekstra tømning",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-06T10:05:00+00:00",
          "updated_at": "2025-08-19T00:25:01.370821+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY4OTY=",
            "location": {
              "latitude": 55.515373,
              "longitude": 9.635159,
              "name": "Børup Sandevej 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTczNjI=",
      "location": {
        "name": "Gisselbakken 6 7000 Fredericia",
        "latitude": 55.51658564,
        "longitude": 9.63491959
      },
      "containers": [
        {
          "id": "mp-pc-271",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-271",
            "container_id": "MP-7002-273",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NjEwMg==",
          "ticket_id": "20576102",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Fejlsorteret Er der afleveret flyer: Ja Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2025-04-11T06:36:00+00:00",
          "updated_at": "2025-08-19T00:25:00.006993+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczNjI=",
            "location": {
              "latitude": 55.516543,
              "longitude": 9.634832,
              "name": "Gisselbakken 6, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQyODI=",
      "location": {
        "name": "Tåsingevej 25 7000 Fredericia",
        "latitude": 55.51305769,
        "longitude": 9.63424294
      },
      "containers": [
        {
          "id": "mp-pc-272",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-272",
            "container_id": "MP-7002-274",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5ODE4Nw==",
          "ticket_id": "20598187",
          "ticket_type": "AO-Ændring til 80-90 liter beholder til restaffald",
          "description": "kan vi bytte vores beholder til en 80-90 liters? Skal gammel beholder hjemtages: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2021-04-28T14:53:00+00:00",
          "updated_at": "2025-08-19T00:25:01.555090+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQyODI=",
            "location": {
              "latitude": 55.513057,
              "longitude": 9.634242,
              "name": "Tåsingevej 25, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTkyMDU=",
      "location": {
        "name": "Kohavevej 2 7000 Fredericia",
        "latitude": 55.51603618,
        "longitude": 9.61969933
      },
      "containers": [
        {
          "id": "mp-pc-273",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-273",
            "container_id": "MP-7002-275",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NDk1OQ==",
          "ticket_id": "20574959",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: 2-delt 240 l beholder - Institution Uge Kohavevej 2 (7000 Fredericia) ContainerNr:432405 ContainerBrik:00400000125C5B6D Ønsket virkningsdato: 30/06-2025 Besked: Hej Lærke Omkring Kohavevej 2 ønsker vi opsige aftalen ved Fredericia kommune. Vi har allerede anden ordning og jeg er rent faktisk usikker på hvorfor vi overhovedet er kommet med i den kommunale ordning - ved du hvem som har bestilt / sørget for dette? Jeg kan se at i har betalt for dette gennem en peri",
          "status": 6,
          "priority": 2,
          "created_at": "2025-06-30T08:38:00+00:00",
          "updated_at": "2025-08-19T00:24:59.874498+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkyMDU=",
            "location": {
              "latitude": 55.516036,
              "longitude": 9.619699,
              "name": "Kohavevej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3NDk2MA==",
          "ticket_id": "20574960",
          "ticket_type": "AO-Generel besked",
          "description": "Mail sendt til jacobvesterlund@hotmail.com: Hej Jacob, Vi har i april 2025 sendt en mail vedr. affaldsløsningen ved Spejderhuset Skærbæk: Hej, Jeg skriver til jer, da I står som ejere af Kohavevej 2 , 7000 Fredericia. På adressen, er I tilmeldt med 1 stk. 2-delt 240 ltr. beholder til mad og restaffald med ugetømning. Da I anses som erhverv har Fredericia kommune kun mulighed for at afhente restaffald hos jer. Som erhverv bestemmer man selv om man ønsker den kommunale løsning til restaffald elle",
          "status": 6,
          "priority": 2,
          "created_at": "2025-06-27T08:23:00+00:00",
          "updated_at": "2025-08-19T00:24:59.874597+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkyMDU=",
            "location": {
              "latitude": 55.516036,
              "longitude": 9.619699,
              "name": "Kohavevej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3NjE5Ng==",
          "ticket_id": "20576196",
          "ticket_type": "AO-Generel besked",
          "description": "Mail sendt til info@vildengen.dk: Hej, Jeg skriver til jer, da I står som ejere af Kohavevej 2 , 7000 Fredericia. På adressen, er I tilmeldt med 1 stk. 2-delt 240 ltr. beholder til mad  og restaffald. Da I anses som erhverv har Fredericia kommune kun mulighed for at afhente restaffald hos jer. Som erhverv bestemmer man selv om man ønsker den kommunale løsning til restaffald eller om man ønsker at bruge en anden aktør. Da I skal sortere i alle fraktioner, antager vi, at I har en aftale med en an",
          "status": 6,
          "priority": 2,
          "created_at": "2025-04-07T09:41:00+00:00",
          "updated_at": "2025-08-19T00:25:00.017757+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkyMDU=",
            "location": {
              "latitude": 55.516036,
              "longitude": 9.619699,
              "name": "Kohavevej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMzg2MjY=",
      "location": {
        "name": "Tingvejen 31 7000 Fredericia",
        "latitude": 55.53333307,
        "longitude": 9.6199361
      },
      "containers": [
        {
          "id": "mp-pc-274",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-274",
            "container_id": "MP-7002-276",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-275",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-275",
            "container_id": "MP-7002-277",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-276",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-276",
            "container_id": "MP-7002-278",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-277",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-277",
            "container_id": "MP-7002-279",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-278",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-278",
            "container_id": "MP-7002-280",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTYxMzQ=",
      "location": {
        "name": "Skolevej 179 7000 Fredericia",
        "latitude": 55.51980618,
        "longitude": 9.62858914
      },
      "containers": [
        {
          "id": "mp-pc-279",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-279",
            "container_id": "MP-7002-282",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-280",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-280",
            "container_id": "MP-7002-285",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "400 L"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NzI0NA==",
          "ticket_id": "20577244",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Beholder overfyldt Er der afleveret flyer: Nej Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2025-01-03T06:20:00+00:00",
          "updated_at": "2025-08-19T00:25:00.130754+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYxMzQ=",
            "location": {
              "latitude": 55.519806,
              "longitude": 9.628589,
              "name": "Skolevej 179, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDE4NQ==",
          "ticket_id": "20580185",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: 770 l rest - Lejlighed Uge Skolevej 179 (7000 Fredericia) ContainerNr:433738 ContainerBrik:004000001523F5EE Ønsket virkningsdato: 31/12-2023 Besked: Ændret jf. aftale med Kasper fra Boligkontoret. De har kun 1 stk. på adressen. Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-11T12:38:00+00:00",
          "updated_at": "2025-08-19T00:25:00.300319+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYxMzQ=",
            "location": {
              "latitude": 55.519806,
              "longitude": 9.628589,
              "name": "Skolevej 179, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MzMwOA==",
          "ticket_id": "20583308",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 400 l mad - Lejlighed Uge Skolevej 179 (7000 Fredericia) ContainerNr:433737 ContainerBrik:0040000015238084 Beholder der ønskes i stedet: 400 l mad - Lejlighed Ny tømningsfrekvens: Hver 14 dag Gebyr: 0 kr Ønsket virkningsdato: 14/11 2023 Besked: Aftalt med Kasper, Boligkontoret. Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2023-11-07T12:53:00+00:00",
          "updated_at": "2025-08-19T00:25:00.492964+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYxMzQ=",
            "location": {
              "latitude": 55.519806,
              "longitude": 9.628589,
              "name": "Skolevej 179, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzUxNg==",
          "ticket_id": "20593516",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: D800LejUgeÅr - Lejlighed gamle Skolevej 179 (7000 Fredericia) ContainerNr:423292 ContainerBrik: Ønsket virkningsdato: 20/10-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-20T10:27:00+00:00",
          "updated_at": "2025-08-19T00:25:01.270279+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYxMzQ=",
            "location": {
              "latitude": 55.519806,
              "longitude": 9.628589,
              "name": "Skolevej 179, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzUxNQ==",
          "ticket_id": "20593515",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: D800LejUgeÅr - Lejlighed gamle Skolevej 179 (7000 Fredericia) ContainerNr:423291 ContainerBrik: Ønsket virkningsdato: 20/10-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-20T10:27:00+00:00",
          "updated_at": "2025-08-19T00:25:01.270224+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYxMzQ=",
            "location": {
              "latitude": 55.519806,
              "longitude": 9.628589,
              "name": "Skolevej 179, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc1Mjk=",
      "location": {
        "name": "Skolevej 201 7000 Fredericia",
        "latitude": 55.5196441,
        "longitude": 9.63000219
      },
      "containers": [
        {
          "id": "mp-pc-281",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-281",
            "container_id": "MP-7002-283",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-282",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-282",
            "container_id": "MP-7002-284",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "400 L"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MDE4Mw==",
          "ticket_id": "20580183",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: 770 l rest - Lejlighed Uge Skolevej 201 (7000 Fredericia) ContainerNr:435242 ContainerBrik: Ønsket virkningsdato: 31/12-2023 Besked: Ønskes afmeldt jf. Kasper fra Boligkontoret, da de kun har 1 stk. Kontaktoplysninger: Boligkontoret Fredericia",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-11T12:42:00+00:00",
          "updated_at": "2025-08-19T00:25:00.300207+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc1Mjk=",
            "location": {
              "latitude": 55.519644,
              "longitude": 9.630002,
              "name": "Skolevej 201, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjMwMw==",
          "ticket_id": "20592303",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: D800LejUgeÅr - Lejlighed gamle Skolevej 201 (7000 Fredericia) ContainerNr:425913 ContainerBrik: Ønsket virkningsdato: 01/12-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-20T10:42:00+00:00",
          "updated_at": "2025-08-19T00:25:01.202411+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc1Mjk=",
            "location": {
              "latitude": 55.519644,
              "longitude": 9.630002,
              "name": "Skolevej 201, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjMwNA==",
          "ticket_id": "20592304",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 400 l mad - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/12-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-20T10:41:00+00:00",
          "updated_at": "2025-08-19T00:25:01.202461+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc1Mjk=",
            "location": {
              "latitude": 55.519644,
              "longitude": 9.630002,
              "name": "Skolevej 201, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjMwNQ==",
          "ticket_id": "20592305",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 770 l rest - Lejlighed Uge Ny tømningsfrekvens: Hver uge Ønsket virkningsdato: 01/12-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-20T10:40:00+00:00",
          "updated_at": "2025-08-19T00:25:01.202509+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc1Mjk=",
            "location": {
              "latitude": 55.519644,
              "longitude": 9.630002,
              "name": "Skolevej 201, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjMwNw==",
          "ticket_id": "20592307",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 770 l rest - Lejlighed Uge Ny tømningsfrekvens: Hver uge Ønsket virkningsdato: 01/12-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-20T10:39:00+00:00",
          "updated_at": "2025-08-19T00:25:01.202606+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc1Mjk=",
            "location": {
              "latitude": 55.519644,
              "longitude": 9.630002,
              "name": "Skolevej 201, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjMwNg==",
          "ticket_id": "20592306",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: D800LejUgeÅr - Lejlighed gamle Skolevej 201 (7000 Fredericia) ContainerNr:425912 ContainerBrik: Ønsket virkningsdato: 01/12-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-20T10:39:00+00:00",
          "updated_at": "2025-08-19T00:25:01.202557+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc1Mjk=",
            "location": {
              "latitude": 55.519644,
              "longitude": 9.630002,
              "name": "Skolevej 201, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjMwOA==",
          "ticket_id": "20592308",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 660 l rest - Lejlighed Uge Ny tømningsfrekvens: Hver uge Ønsket virkningsdato: 01/12-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-20T10:38:00+00:00",
          "updated_at": "2025-08-19T00:25:01.202654+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc1Mjk=",
            "location": {
              "latitude": 55.519644,
              "longitude": 9.630002,
              "name": "Skolevej 201, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzUxMQ==",
          "ticket_id": "20593511",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: D800LejUgeÅr - Lejlighed gamle Ny tømningsfrekvens: Hver uge Ønsket virkningsdato: 20/10-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-20T11:35:00+00:00",
          "updated_at": "2025-08-19T00:25:01.270003+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc1Mjk=",
            "location": {
              "latitude": 55.519644,
              "longitude": 9.630002,
              "name": "Skolevej 201, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzUxMA==",
          "ticket_id": "20593510",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: D800LejUgeÅr - Lejlighed gamle Ny tømningsfrekvens: Hver uge Ønsket virkningsdato: 20/10-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-20T11:35:00+00:00",
          "updated_at": "2025-08-19T00:25:01.269949+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc1Mjk=",
            "location": {
              "latitude": 55.519644,
              "longitude": 9.630002,
              "name": "Skolevej 201, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTYwNDQ=",
      "location": {
        "name": "Skolevej 163 7000 Fredericia",
        "latitude": 55.51922869,
        "longitude": 9.62833951
      },
      "containers": [
        {
          "id": "mp-pc-283",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-283",
            "container_id": "MP-7002-286",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "660 L"
            }
          }
        },
        {
          "id": "mp-pc-284",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-284",
            "container_id": "MP-7002-287",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "400 L"
            }
          }
        },
        {
          "id": "mp-pc-285",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-285",
            "container_id": "MP-7002-288",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "400 L"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MjMwOQ==",
          "ticket_id": "20592309",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: D1000LejUgeÅr - Lejlighed gamle Skolevej 163 (7000 Fredericia) ContainerNr:425911 ContainerBrik: Ønsket virkningsdato: 01/12-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-20T10:33:00+00:00",
          "updated_at": "2025-08-19T00:25:01.202703+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYwNDQ=",
            "location": {
              "latitude": 55.519228,
              "longitude": 9.628339,
              "name": "Skolevej 163, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjMxMA==",
          "ticket_id": "20592310",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 400 l mad - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/12-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-20T10:32:00+00:00",
          "updated_at": "2025-08-19T00:25:01.202752+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYwNDQ=",
            "location": {
              "latitude": 55.519228,
              "longitude": 9.628339,
              "name": "Skolevej 163, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjMxMQ==",
          "ticket_id": "20592311",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 660 l rest - Lejlighed Uge Ny tømningsfrekvens: Hver uge Ønsket virkningsdato: 01/12-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-20T10:31:00+00:00",
          "updated_at": "2025-08-19T00:25:01.202801+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYwNDQ=",
            "location": {
              "latitude": 55.519228,
              "longitude": 9.628339,
              "name": "Skolevej 163, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjMxMg==",
          "ticket_id": "20592312",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 400 l rest - Lejlighed Uge Ny tømningsfrekvens: Hver uge Ønsket virkningsdato: 01/12-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-20T10:30:00+00:00",
          "updated_at": "2025-08-19T00:25:01.202849+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYwNDQ=",
            "location": {
              "latitude": 55.519228,
              "longitude": 9.628339,
              "name": "Skolevej 163, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzUxOA==",
          "ticket_id": "20593518",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: D800LejUgeÅr - Lejlighed gamle Skolevej 163 (7000 Fredericia) ContainerNr:423277 ContainerBrik: Beholder der ønskes i stedet: D1000LejUgeÅr - Lejlighed gamle Ny tømningsfrekvens: Hver uge Gebyr: 0 kr Ønsket virkningsdato: 20/10-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-20T10:25:00+00:00",
          "updated_at": "2025-08-19T00:25:01.270389+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYwNDQ=",
            "location": {
              "latitude": 55.519228,
              "longitude": 9.628339,
              "name": "Skolevej 163, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzUxNw==",
          "ticket_id": "20593517",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: D800LejUgeÅr - Lejlighed gamle Skolevej 163 (7000 Fredericia) ContainerNr:423276 ContainerBrik: Ønsket virkningsdato: 20/10-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-20T10:25:00+00:00",
          "updated_at": "2025-08-19T00:25:01.270334+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYwNDQ=",
            "location": {
              "latitude": 55.519228,
              "longitude": 9.628339,
              "name": "Skolevej 163, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzUyMA==",
          "ticket_id": "20593520",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Beholderen er ikke tømt i fredags. Vil i få den tømt?",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-18T11:51:00+00:00",
          "updated_at": "2025-08-19T00:25:01.270499+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYwNDQ=",
            "location": {
              "latitude": 55.519228,
              "longitude": 9.628339,
              "name": "Skolevej 163, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTU4OTA=",
      "location": {
        "name": "Skolevej 23 7000 Fredericia",
        "latitude": 55.51812207,
        "longitude": 9.6282004
      },
      "containers": [
        {
          "id": "mp-pc-286",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-286",
            "container_id": "MP-7002-289",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-287",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-287",
            "container_id": "MP-7002-290",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "1000 L"
            }
          }
        },
        {
          "id": "mp-pc-288",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-288",
            "container_id": "MP-7002-293",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "400 L"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NjEzNA==",
          "ticket_id": "20586134",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: 400 l mad - Lejlighed Skolevej 23 (7000 Fredericia) ContainerNr:435234 ContainerBrik: Ønsket virkningsdato: 31/12-2022 Besked: Jf. mail fra Kristina, Boligkontoret den 13-01-2023, skal denne ændres fra 1 x uge til 14 dages tømning. Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-16T09:00:00+00:00",
          "updated_at": "2025-08-19T00:25:00.671151+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU4OTA=",
            "location": {
              "latitude": 55.518122,
              "longitude": 9.6282,
              "name": "Skolevej 23, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NjEzMw==",
          "ticket_id": "20586133",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 400 l mad - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/01-2023 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-16T09:00:00+00:00",
          "updated_at": "2025-08-19T00:25:00.671051+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU4OTA=",
            "location": {
              "latitude": 55.518122,
              "longitude": 9.6282,
              "name": "Skolevej 23, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjMxOA==",
          "ticket_id": "20592318",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 400 l mad - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/12-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-20T10:15:00+00:00",
          "updated_at": "2025-08-19T00:25:01.203149+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU4OTA=",
            "location": {
              "latitude": 55.518122,
              "longitude": 9.6282,
              "name": "Skolevej 23, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjMyMQ==",
          "ticket_id": "20592321",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 770 l rest - Lejlighed Uge Ny tømningsfrekvens: Hver uge Ønsket virkningsdato: 01/12-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-20T10:14:00+00:00",
          "updated_at": "2025-08-19T00:25:01.203300+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU4OTA=",
            "location": {
              "latitude": 55.518122,
              "longitude": 9.6282,
              "name": "Skolevej 23, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjMyMA==",
          "ticket_id": "20592320",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: D800LejUgeÅr - Lejlighed gamle Skolevej 23 (7000 Fredericia) ContainerNr:422579 ContainerBrik: Ønsket virkningsdato: 01/12-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-20T10:14:00+00:00",
          "updated_at": "2025-08-19T00:25:01.203249+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU4OTA=",
            "location": {
              "latitude": 55.518122,
              "longitude": 9.6282,
              "name": "Skolevej 23, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjMxOQ==",
          "ticket_id": "20592319",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: D1000LejUgeÅr - Lejlighed gamle Skolevej 23 (7000 Fredericia) ContainerNr:422580 ContainerBrik: Ønsket virkningsdato: 01/12-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-20T10:14:00+00:00",
          "updated_at": "2025-08-19T00:25:01.203198+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU4OTA=",
            "location": {
              "latitude": 55.518122,
              "longitude": 9.6282,
              "name": "Skolevej 23, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjMyMg==",
          "ticket_id": "20592322",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 1000 l rest - Lejlighed Uge Ny tømningsfrekvens: Hver uge Ønsket virkningsdato: 01/12-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-20T10:13:00+00:00",
          "updated_at": "2025-08-19T00:25:01.203350+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU4OTA=",
            "location": {
              "latitude": 55.518122,
              "longitude": 9.6282,
              "name": "Skolevej 23, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjMyMw==",
          "ticket_id": "20592323",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 400 l mad - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/12-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-20T10:09:00+00:00",
          "updated_at": "2025-08-19T00:25:01.203401+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU4OTA=",
            "location": {
              "latitude": 55.518122,
              "longitude": 9.6282,
              "name": "Skolevej 23, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzUxOQ==",
          "ticket_id": "20593519",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: D1000LejUgeÅr - Lejlighed gamle Skolevej 23 (7000 Fredericia) ContainerNr:422581 ContainerBrik: Ønsket virkningsdato: 20/10-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-20T10:23:00+00:00",
          "updated_at": "2025-08-19T00:25:01.270444+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU4OTA=",
            "location": {
              "latitude": 55.518122,
              "longitude": 9.6282,
              "name": "Skolevej 23, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjE5Nw==",
          "ticket_id": "20596197",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Manglende tømning af grønne container på miljøstationer",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-22T13:43:00+00:00",
          "updated_at": "2025-08-19T00:25:01.436567+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU4OTA=",
            "location": {
              "latitude": 55.518122,
              "longitude": 9.6282,
              "name": "Skolevej 23, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTU4OTE=",
      "location": {
        "name": "Skolevej 93 7000 Fredericia",
        "latitude": 55.51863231,
        "longitude": 9.62842345
      },
      "containers": [
        {
          "id": "mp-pc-289",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-289",
            "container_id": "MP-7002-291",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-290",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-290",
            "container_id": "MP-7002-292",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "1000 L"
            }
          }
        },
        {
          "id": "mp-pc-291",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-291",
            "container_id": "MP-7002-294",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "400 L"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NjEzMg==",
          "ticket_id": "20586132",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: 400 l mad - Lejlighed Skolevej 93 1 (7000 Fredericia) ContainerNr:435235 ContainerBrik: Ønsket virkningsdato: 31/12-2022 Besked: Ifølge mail fra Kristina, Boligkontoret den 13-01-2023, ønskes denne beholder at tømmes hver 14 dages. Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-16T09:05:00+00:00",
          "updated_at": "2025-08-19T00:25:00.670943+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU4OTE=",
            "location": {
              "latitude": 55.518632,
              "longitude": 9.628423,
              "name": "Skolevej 93, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NjEzMQ==",
          "ticket_id": "20586131",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 400 l mad - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/01-2023 Besked: Ifølge mail fra Kristina, Boligkontoret den 13-01-2023, ønskes denne beholder at tømmes hver 14 dages. Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-16T09:05:00+00:00",
          "updated_at": "2025-08-19T00:25:00.670846+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU4OTE=",
            "location": {
              "latitude": 55.518632,
              "longitude": 9.628423,
              "name": "Skolevej 93, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTI2Nw==",
          "ticket_id": "20591267",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Beholderne står skur hvor der skal bruges en trekantnøgle til som er blevet udleveret herfra. Skal tømmes, da de ikke kan klare sig til næste tømning.",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-24T12:32:00+00:00",
          "updated_at": "2025-08-19T00:25:01.136971+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU4OTE=",
            "location": {
              "latitude": 55.518632,
              "longitude": 9.628423,
              "name": "Skolevej 93, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjMxNA==",
          "ticket_id": "20592314",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 1000 l rest - Lejlighed Uge Ny tømningsfrekvens: Hver uge Ønsket virkningsdato: 01/12-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-20T10:25:00+00:00",
          "updated_at": "2025-08-19T00:25:01.202948+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU4OTE=",
            "location": {
              "latitude": 55.518632,
              "longitude": 9.628423,
              "name": "Skolevej 93, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjMxMw==",
          "ticket_id": "20592313",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: D800LejUgeÅr - Lejlighed gamle Skolevej 93 1 (7000 Fredericia) ContainerNr:422589 ContainerBrik: Ønsket virkningsdato: 01/12-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-20T10:25:00+00:00",
          "updated_at": "2025-08-19T00:25:01.202898+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU4OTE=",
            "location": {
              "latitude": 55.518632,
              "longitude": 9.628423,
              "name": "Skolevej 93, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjMxNQ==",
          "ticket_id": "20592315",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 770 l rest - Lejlighed Uge Ny tømningsfrekvens: Hver uge Ønsket virkningsdato: 01/12-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-20T10:24:00+00:00",
          "updated_at": "2025-08-19T00:25:01.202999+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU4OTE=",
            "location": {
              "latitude": 55.518632,
              "longitude": 9.628423,
              "name": "Skolevej 93, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjMxNw==",
          "ticket_id": "20592317",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 400 l mad - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/12-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-20T10:23:00+00:00",
          "updated_at": "2025-08-19T00:25:01.203099+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU4OTE=",
            "location": {
              "latitude": 55.518632,
              "longitude": 9.628423,
              "name": "Skolevej 93, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjMxNg==",
          "ticket_id": "20592316",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: D1000LejUgeÅr - Lejlighed gamle Skolevej 93 1 (7000 Fredericia) ContainerNr:422590 ContainerBrik: Ønsket virkningsdato: 01/12-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 515",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-20T10:23:00+00:00",
          "updated_at": "2025-08-19T00:25:01.203049+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU4OTE=",
            "location": {
              "latitude": 55.518632,
              "longitude": 9.628423,
              "name": "Skolevej 93, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDU5NQ==",
          "ticket_id": "20594595",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Ønskes tømning af 1 stk. 800 + 1 stk. 1000 l",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-30T09:22:00+00:00",
          "updated_at": "2025-08-19T00:25:01.335999+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU4OTE=",
            "location": {
              "latitude": 55.518632,
              "longitude": 9.628423,
              "name": "Skolevej 93, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTkxMDA=",
      "location": {
        "name": "Skolevej 1 7000 Fredericia",
        "latitude": 55.51692383,
        "longitude": 9.62840747
      },
      "containers": [
        {
          "id": "mp-pc-292",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-292",
            "container_id": "MP-7002-295",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-293",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-293",
            "container_id": "MP-7002-296",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-294",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-294",
            "container_id": "MP-7002-297",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-295",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-295",
            "container_id": "MP-7002-298",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-296",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-296",
            "container_id": "MP-7002-299",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3Nzk1OQ==",
          "ticket_id": "20577959",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Vogn 7 har ladet en 770L til papir stå, da den er fejlsorteret. Papiret ligger pakket i poser. Der er sat hænger på. Jeg prøver at kontakte skolen.",
          "status": 6,
          "priority": 2,
          "created_at": "2024-11-07T09:45:00+00:00",
          "updated_at": "2025-08-19T00:25:00.168842+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkxMDA=",
            "location": {
              "latitude": 55.516923,
              "longitude": 9.628407,
              "name": "Skolevej 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3ODczMg==",
          "ticket_id": "20578732",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Vogn 7 lod i går en 240L til blød plast stå, da den er fejlsorteret. Der er sat hænger på. Jeg har skrevet til skolen servicetekniker, at der også stod møbler i vejen foran beholderne og at affaldet ikke skal pakkes i poser.",
          "status": 6,
          "priority": 2,
          "created_at": "2024-08-30T09:57:00+00:00",
          "updated_at": "2025-08-19T00:25:00.214734+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkxMDA=",
            "location": {
              "latitude": 55.516923,
              "longitude": 9.628407,
              "name": "Skolevej 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDM3NQ==",
          "ticket_id": "20580375",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Småt elektronik institution Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 14/06 2024 Besked: Rød kasse til småt elektronik. Kontaktoplysninger: FREDERICIA KOMMUNE",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-07T11:09:00+00:00",
          "updated_at": "2025-08-19T00:25:00.311385+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkxMDA=",
            "location": {
              "latitude": 55.516923,
              "longitude": 9.628407,
              "name": "Skolevej 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDM3NA==",
          "ticket_id": "20580374",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Batterier institution Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 14/06 2024 Besked: Rød kasse til batterier. Kontaktoplysninger: FREDERICIA KOMMUNE",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-07T11:09:00+00:00",
          "updated_at": "2025-08-19T00:25:00.311328+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkxMDA=",
            "location": {
              "latitude": 55.516923,
              "longitude": 9.628407,
              "name": "Skolevej 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDM3Ng==",
          "ticket_id": "20580376",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Farligt affald institution Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 14/06 2024 Besked: Rød kasse til farligt affald. Kontaktoplysninger: FREDERICIA KOMMUNE",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-07T11:08:00+00:00",
          "updated_at": "2025-08-19T00:25:00.311500+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkxMDA=",
            "location": {
              "latitude": 55.516923,
              "longitude": 9.628407,
              "name": "Skolevej 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4Mjk1Mg==",
          "ticket_id": "20582952",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Beholder overfyldt Er der afleveret flyer: Nej Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2023-12-15T06:52:00+00:00",
          "updated_at": "2025-08-19T00:25:00.465300+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkxMDA=",
            "location": {
              "latitude": 55.516923,
              "longitude": 9.628407,
              "name": "Skolevej 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4Mjk3OQ==",
          "ticket_id": "20582979",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Fejlsorteret Er der afleveret flyer: Ja Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2023-12-08T06:20:00+00:00",
          "updated_at": "2025-08-19T00:25:00.466620+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkxMDA=",
            "location": {
              "latitude": 55.516923,
              "longitude": 9.628407,
              "name": "Skolevej 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDMxMg==",
          "ticket_id": "20584312",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 770 l rest - Institution Uge Ny tømningsfrekvens: Hver uge Ønsket virkningsdato: 01/08-2023 Besked: Tilmelding i fbm. opdatering af sorteringsordninger i Folkeskolerne Kontaktoplysninger: FREDERICIA KOMMUNE",
          "status": 6,
          "priority": 2,
          "created_at": "2023-06-30T10:31:00+00:00",
          "updated_at": "2025-08-19T00:25:00.552308+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkxMDA=",
            "location": {
              "latitude": 55.516923,
              "longitude": 9.628407,
              "name": "Skolevej 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDM3Nw==",
          "ticket_id": "20584377",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 770 l rest - Institution Uge Ny tømningsfrekvens: Hver uge Ønsket virkningsdato: 01/08-2023 Besked: Tilmelding i fbm. opdatering af sorteringsordninger i Folkeskolerne Kontaktoplysninger: FREDERICIA KOMMUNE",
          "status": 6,
          "priority": 2,
          "created_at": "2023-06-27T13:28:00+00:00",
          "updated_at": "2025-08-19T00:25:00.556055+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkxMDA=",
            "location": {
              "latitude": 55.516923,
              "longitude": 9.628407,
              "name": "Skolevej 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDM3OA==",
          "ticket_id": "20584378",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 770 l rest - Institution Uge Ny tømningsfrekvens: Hver uge Ønsket virkningsdato: 01/08-2023 Besked: Tilmelding i fbm. opdatering af sorteringsordninger i Folkeskolerne. Kontaktoplysninger: FREDERICIA KOMMUNE",
          "status": 6,
          "priority": 2,
          "created_at": "2023-06-27T13:27:00+00:00",
          "updated_at": "2025-08-19T00:25:00.556113+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkxMDA=",
            "location": {
              "latitude": 55.516923,
              "longitude": 9.628407,
              "name": "Skolevej 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDM4Mg==",
          "ticket_id": "20584382",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 770 l rest - Institution Uge Ny tømningsfrekvens: Hver uge Ønsket virkningsdato: 04/08-2023 Besked: Tilmelding i fbm. opdatering af sorteringsordninger for Folkeskolerne. Kontaktoplysninger: FREDERICIA KOMMUNE",
          "status": 6,
          "priority": 2,
          "created_at": "2023-06-27T11:47:00+00:00",
          "updated_at": "2025-08-19T00:25:00.556338+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkxMDA=",
            "location": {
              "latitude": 55.516923,
              "longitude": 9.628407,
              "name": "Skolevej 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDM4Mw==",
          "ticket_id": "20584383",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 240 l mad - Institution Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 04/08-2023 Besked: Tilmelding i fbm. opdatering af sorteringsordninger for Folkeskolerne. Kontaktoplysninger: FREDERICIA KOMMUNE",
          "status": 6,
          "priority": 2,
          "created_at": "2023-06-27T11:46:00+00:00",
          "updated_at": "2025-08-19T00:25:00.556412+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkxMDA=",
            "location": {
              "latitude": 55.516923,
              "longitude": 9.628407,
              "name": "Skolevej 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMjAyMDc=",
      "location": {
        "name": "Tåsingevej 1 7000 Fredericia",
        "latitude": 55.51466625,
        "longitude": 9.63796375
      },
      "containers": [
        {
          "id": "mp-pc-297",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-297",
            "container_id": "MP-7002-300",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3ODU1MA==",
          "ticket_id": "20578550",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 18/09-2024 Besked: Lavet om fra erhverv til parcel. Kontaktoplysninger: Christophe Jean Louis Pradel",
          "status": 6,
          "priority": 2,
          "created_at": "2024-09-16T10:44:00+00:00",
          "updated_at": "2025-08-19T00:25:00.203031+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMjAyMDc=",
            "location": {
              "latitude": 55.514666,
              "longitude": 9.637963,
              "name": "Tåsingevej 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3ODU5Mw==",
          "ticket_id": "20578593",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: D140Erh14dgÅr - Erhverv Gamle Tåsingevej 1 1 (7000 Fredericia) ContainerNr:403302 ContainerBrik: Ønsket virkningsdato: 15/09-2024 Besked: Helle Ohrt Johansen (helleohrt@hotmail.dk) - Christophe Pradel oplyser, at der ikke er erhverv her på adressen længere, men alm. parcelhus. Kontaktoplysninger: Christophe Jean Louis Pradel",
          "status": 6,
          "priority": 2,
          "created_at": "2024-09-12T07:59:00+00:00",
          "updated_at": "2025-08-19T00:25:00.205527+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMjAyMDc=",
            "location": {
              "latitude": 55.514666,
              "longitude": 9.637963,
              "name": "Tåsingevej 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3ODYwOA==",
          "ticket_id": "20578608",
          "ticket_type": "AO-Generel besked",
          "description": "Mail sendt til centrum-middelfart@tandlaegen.dk: Hej Christophe Jean Louis Pradel, Jeg skriver til dig, da vi er ved at rydde op i vores beholdere hos erhverv i Fredericia Kommune. I den forbindelse kan jeg se, at I er registreret med 1 stk. 140 liter restaffald. Dette er vores gamle størrelse, som vi desværre ikke benytter mere. Vores mindste beholderstørrelse er 240 liter i dag. Jeg vil derfor høre, om I er interesseret i at få 1 stk. 240 liter til restaffald fra os eller, om I vil afmelde jer",
          "status": 6,
          "priority": 2,
          "created_at": "2024-09-11T10:36:00+00:00",
          "updated_at": "2025-08-19T00:25:00.206402+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMjAyMDc=",
            "location": {
              "latitude": 55.514666,
              "longitude": 9.637963,
              "name": "Tåsingevej 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTM1OQ==",
          "ticket_id": "20595359",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Virksomhed starter op mandag, og der er stadig ikke tømt. Skal tømmes i dag",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-06T12:37:00+00:00",
          "updated_at": "2025-08-19T00:25:01.382935+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMjAyMDc=",
            "location": {
              "latitude": 55.514666,
              "longitude": 9.637963,
              "name": "Tåsingevej 1, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI2MjM=",
      "location": {
        "name": "Birkholmvej 4 7000 Fredericia",
        "latitude": 55.514368,
        "longitude": 9.638107
      },
      "containers": [
        {
          "id": "mp-pc-298",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-298",
            "container_id": "MP-7002-301",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NTc5NQ==",
          "ticket_id": "20595795",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Aftalt med Lasse - tømmes i morgen d. 30.7.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-29T11:00:00+00:00",
          "updated_at": "2025-08-19T00:25:01.411230+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI2MjM=",
            "location": {
              "latitude": 55.514368,
              "longitude": 9.638107,
              "name": "Birkholmvej 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTk4MQ==",
          "ticket_id": "20595981",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "mgl. tømning",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-26T13:45:00+00:00",
          "updated_at": "2025-08-19T00:25:01.423542+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI2MjM=",
            "location": {
              "latitude": 55.514368,
              "longitude": 9.638107,
              "name": "Birkholmvej 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjAzNw==",
          "ticket_id": "20596037",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-07-23Fraktion: 1 (Mad/Rest)Navn: Peter PetersenTlf.: 26190314Email: pspe@icloud.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-26T09:47:00+00:00",
          "updated_at": "2025-08-19T00:25:01.426795+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI2MjM=",
            "location": {
              "latitude": 55.514368,
              "longitude": 9.638107,
              "name": "Birkholmvej 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjA5MQ==",
          "ticket_id": "20596091",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-07-23Fraktion: 1 (Mad/Rest)Navn: Peter PetersenTlf.: 26190314Email: pspe@icloud.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-24T13:22:00+00:00",
          "updated_at": "2025-08-19T00:25:01.430064+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI2MjM=",
            "location": {
              "latitude": 55.514368,
              "longitude": 9.638107,
              "name": "Birkholmvej 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjA5Mg==",
          "ticket_id": "20596092",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-07-23Fraktion: 1 (Mad/Rest)Navn: Peter PetersenTlf.: 26190314Email: pspe@icloud.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-24T12:59:00+00:00",
          "updated_at": "2025-08-19T00:25:01.430121+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI2MjM=",
            "location": {
              "latitude": 55.514368,
              "longitude": 9.638107,
              "name": "Birkholmvej 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTIyMjc=",
      "location": {
        "name": "Tåsingevej 2 7000 Fredericia",
        "latitude": 55.514884,
        "longitude": 9.637375
      },
      "containers": [
        {
          "id": "mp-pc-299",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-299",
            "container_id": "MP-7002-302",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5ODc2Nw==",
          "ticket_id": "20598767",
          "ticket_type": "AO-Ændring til 180-190 liter beholder til restaffald",
          "description": "Skal gammel beholder hjemtages: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2020-06-07T08:35:00+00:00",
          "updated_at": "2025-08-19T00:25:01.589354+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTIyMjc=",
            "location": {
              "latitude": 55.514884,
              "longitude": 9.637375,
              "name": "Tåsingevej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTYzOQ==",
          "ticket_id": "20599639",
          "ticket_type": "AO-Ændring til 240 liter beholder til restaffald",
          "description": "Skal gammel beholder hjemtages: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2018-10-16T03:07:00+00:00",
          "updated_at": "2025-08-19T00:25:01.641771+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTIyMjc=",
            "location": {
              "latitude": 55.514884,
              "longitude": 9.637375,
              "name": "Tåsingevej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTIyMjg=",
      "location": {
        "name": "Tåsingevej 3 7000 Fredericia",
        "latitude": 55.514634,
        "longitude": 9.637481
      },
      "containers": [
        {
          "id": "mp-pc-300",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-300",
            "container_id": "MP-7002-303",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDUzNzg=",
      "location": {
        "name": "Tåsingevej 5 7000 Fredericia",
        "latitude": 55.51448,
        "longitude": 9.637241
      },
      "containers": [
        {
          "id": "mp-pc-301",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-301",
            "container_id": "MP-7002-304",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTIyMzA=",
      "location": {
        "name": "Tåsingevej 6 7000 Fredericia",
        "latitude": 55.514624,
        "longitude": 9.636933
      },
      "containers": [
        {
          "id": "mp-pc-302",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-302",
            "container_id": "MP-7002-305",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MTI4Mw==",
          "ticket_id": "20591283",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Ulla HygumTlf.: 20188058Email: Tjoernely@mail.dkBesked: Hej . Jeg mangler mærkater til genbrugssække. Er det vigtigt?hvis ja, hvordan får jeg nogle flere. Mvh Ulla Hygum , Tåsingevej 6",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-23T19:07:00+00:00",
          "updated_at": "2025-08-19T00:25:01.137825+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTIyMzA=",
            "location": {
              "latitude": 55.514624,
              "longitude": 9.636933,
              "name": "Tåsingevej 6, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTAyNw==",
          "ticket_id": "20599027",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Hej Vi har ikke fået tømt vores skraldespand idag - det må være smuttet for folkene :-). Vil vi få den tømt inden næste planlagte tømning ? - den er allerede nu næsten helt fyldt. Mvh Jens Søgaard Nielsen",
          "status": 6,
          "priority": 2,
          "created_at": "2020-01-08T20:08:00+00:00",
          "updated_at": "2025-08-19T00:25:01.605661+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTIyMzA=",
            "location": {
              "latitude": 55.514624,
              "longitude": 9.636933,
              "name": "Tåsingevej 6, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTIyMzE=",
      "location": {
        "name": "Tåsingevej 7 7000 Fredericia",
        "latitude": 55.514371,
        "longitude": 9.637042
      },
      "containers": [
        {
          "id": "mp-pc-303",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-303",
            "container_id": "MP-7002-306",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc0MzQ=",
      "location": {
        "name": "Tåsingevej 8 7000 Fredericia",
        "latitude": 55.514515,
        "longitude": 9.636705
      },
      "containers": [
        {
          "id": "mp-pc-304",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-304",
            "container_id": "MP-7002-307",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc0MzU=",
      "location": {
        "name": "Tåsingevej 10 7000 Fredericia",
        "latitude": 55.514397,
        "longitude": 9.636505
      },
      "containers": [
        {
          "id": "mp-pc-305",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-305",
            "container_id": "MP-7002-308",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDUzNzk=",
      "location": {
        "name": "Tåsingevej 9 7000 Fredericia",
        "latitude": 55.514104,
        "longitude": 9.636999
      },
      "containers": [
        {
          "id": "mp-pc-306",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-306",
            "container_id": "MP-7002-309",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZTo5OTY1MjYy",
          "ticket_id": "9965262",
          "ticket_type": "Forkert emballage, sækken skal være i klar plast",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2023-12-27T07:34:01.266542+00:00",
          "updated_at": "2023-12-27T07:34:01.280073+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDUzNzk=",
            "location": {
              "latitude": 55.514104,
              "longitude": 9.636999,
              "name": "Tåsingevej 9, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20752_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzMyMg==",
          "ticket_id": "20593322",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "Navn: Claus HansenTlf.: 99554238Email: clmoh@orsted.dkBesked: Beholderen blev stærkt beskadiget ved dagens tømning, den skal udskiftes",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-29T08:15:00+00:00",
          "updated_at": "2025-08-19T00:25:01.259685+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDUzNzk=",
            "location": {
              "latitude": 55.514104,
              "longitude": 9.636999,
              "name": "Tåsingevej 9, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTMxOA==",
          "ticket_id": "20595318",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Tåsingevej 9 1 (7000 Fredericia) ContainerNr:406545 ContainerBrik: Låg itu Ønsket virkningsdato: 16/08 2021 Besked: Mangler hængsel Kontaktoplysninger: Claus Møller Hansen 99554238 clmoh@orsted.dk",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-09T13:59:00+00:00",
          "updated_at": "2025-08-19T00:25:01.380312+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDUzNzk=",
            "location": {
              "latitude": 55.514104,
              "longitude": 9.636999,
              "name": "Tåsingevej 9, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTMwNQ==",
          "ticket_id": "20595305",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "Navn: Claus HansenTlf.: 99554238Email: clmoh@orsted.dkBesked: Som jeg tidligere har oplyst mangler et hængsel på min nye spand, jeg ønsker spanden repareret eller udskiftet. Jeg forventer låget falder af og bliver i skraldebilen når spanden tømmes. Imødeser jeres svar. Mvh Claus Hansen",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-07T18:12:00+00:00",
          "updated_at": "2025-08-19T00:25:01.379537+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDUzNzk=",
            "location": {
              "latitude": 55.514104,
              "longitude": 9.636999,
              "name": "Tåsingevej 9, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjA4Nw==",
          "ticket_id": "20596087",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Claus HansenTlf.: 99554238Email: clmoh@orsted.dkBesked: Det ene hængsel på låget på min nye skraldespand mangler. Låget forsvinder sandsynligvis ned i skraldebilen næste gang spanden tømmes. Jeg ønsker spanden repareret eller udskiftet. Mvh Claus Hansen",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-24T19:33:00+00:00",
          "updated_at": "2025-08-19T00:25:01.429833+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDUzNzk=",
            "location": {
              "latitude": 55.514104,
              "longitude": 9.636999,
              "name": "Tåsingevej 9, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDUzODA=",
      "location": {
        "name": "Tåsingevej 17 7000 Fredericia",
        "latitude": 55.513653,
        "longitude": 9.635758
      },
      "containers": [
        {
          "id": "mp-pc-307",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-307",
            "container_id": "MP-7002-310",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5OTAxMA==",
          "ticket_id": "20599010",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "Jeg vil gerne bestille en ny beholder til grønt affald Mvh Caroline Ãrum",
          "status": 6,
          "priority": 2,
          "created_at": "2020-01-20T10:50:00+00:00",
          "updated_at": "2025-08-19T00:25:01.604671+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDUzODA=",
            "location": {
              "latitude": 55.513653,
              "longitude": 9.635758,
              "name": "Tåsingevej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc0Mzc=",
      "location": {
        "name": "Tåsingevej 19 7000 Fredericia",
        "latitude": 55.513493,
        "longitude": 9.635232
      },
      "containers": [
        {
          "id": "mp-pc-308",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-308",
            "container_id": "MP-7002-311",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQ3MDg=",
      "location": {
        "name": "Tåsingevej 20 7000 Fredericia",
        "latitude": 55.51367885,
        "longitude": 9.63478723
      },
      "containers": [
        {
          "id": "mp-pc-309",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-309",
            "container_id": "MP-7002-312",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3Njg4Nw==",
          "ticket_id": "20576887",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Ingen madaffald - tømt som restaffald Er der afleveret flyer: Nej Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2025-01-31T07:11:00+00:00",
          "updated_at": "2025-08-19T00:25:00.094130+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQ3MDg=",
            "location": {
              "latitude": 55.513678,
              "longitude": 9.634787,
              "name": "Tåsingevej 20, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc0Mzg=",
      "location": {
        "name": "Tåsingevej 21 7000 Fredericia",
        "latitude": 55.513325,
        "longitude": 9.634795
      },
      "containers": [
        {
          "id": "mp-pc-310",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-310",
            "container_id": "MP-7002-313",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MTU2OA==",
          "ticket_id": "20591568",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Nye beboer der troede at de fik tømt hver uge, derfor vil de gerne bestille en ekstra tømning, da de ikke kan klare sig til fredag d. 21/1. Mail sendt til MP: Hej Borgerne på Tåsigevej 21 vil gerne bestille en ekstra tømning. Der kommer også til at stå 2 sække med kode på sammen med beholderen, disse skal også tages med.",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-11T13:17:00+00:00",
          "updated_at": "2025-08-19T00:25:01.158935+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc0Mzg=",
            "location": {
              "latitude": 55.513325,
              "longitude": 9.634795,
              "name": "Tåsingevej 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjYzOA==",
          "ticket_id": "20596638",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "gl. beholder endnu ikke tømt - måske flere på gaden -",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-16T10:38:00+00:00",
          "updated_at": "2025-08-19T00:25:01.462415+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc0Mzg=",
            "location": {
              "latitude": 55.513325,
              "longitude": 9.634795,
              "name": "Tåsingevej 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTIyMzQ=",
      "location": {
        "name": "Tåsingevej 22 7000 Fredericia",
        "latitude": 55.513506,
        "longitude": 9.634343
      },
      "containers": [
        {
          "id": "mp-pc-311",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-311",
            "container_id": "MP-7002-314",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NjU1Mg==",
          "ticket_id": "20596552",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Hej Vi er lige kommet hjem fra ferie og den gamle beholder, som vi fik besked om, at vi skulle bruge indtil 1/7 er stadig ikke tømt. Det finder jeg utrolig ulækkert, at have måned-gammelt affald stående. Hvornår bliver den tømt?",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-19T10:56:00+00:00",
          "updated_at": "2025-08-19T00:25:01.456583+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTIyMzQ=",
            "location": {
              "latitude": 55.513506,
              "longitude": 9.634343,
              "name": "Tåsingevej 22, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc0MzY=",
      "location": {
        "name": "Tåsingevej 15 7000 Fredericia",
        "latitude": 55.513801,
        "longitude": 9.636205
      },
      "containers": [
        {
          "id": "mp-pc-312",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-312",
            "container_id": "MP-7002-315",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4ODcyMg==",
          "ticket_id": "20588722",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Rikke Meldgaard KirkTlf.: 28269972Email: r_meldgaard@hotmail.comBesked: Hvordan eller hvor kan man få fat i flere labels til poserne til sortering af plast, glas osv?",
          "status": 6,
          "priority": 2,
          "created_at": "2022-06-22T19:32:00+00:00",
          "updated_at": "2025-08-19T00:25:00.917990+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc0MzY=",
            "location": {
              "latitude": 55.513801,
              "longitude": 9.636205,
              "name": "Tåsingevej 15, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTMxMQ==",
          "ticket_id": "20591311",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Navn: Rikke Meldgaard KirkTlf.: 28269972Email: r_meldgaard@hotmail.comBesked: Vi er en familie på 4 med to små ble børn, som jo giver lidt ekstra poser til skraldespanden. I den forbindelse vil vi høre om det er muligt at bestille tømning af skraldespand hver uge? Med venlig hilsen Rikke Kirk",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-20T22:43:00+00:00",
          "updated_at": "2025-08-19T00:25:01.139296+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc0MzY=",
            "location": {
              "latitude": 55.513801,
              "longitude": 9.636205,
              "name": "Tåsingevej 15, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDMzMDk=",
      "location": {
        "name": "Alsvænget 1 7000 Fredericia",
        "latitude": 55.51385102,
        "longitude": 9.63528963
      },
      "containers": [
        {
          "id": "mp-pc-313",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-313",
            "container_id": "MP-7002-316",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L"
            }
          }
        },
        {
          "id": "mp-pc-314",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-314",
            "container_id": "MP-7002-317",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDMzMTA=",
      "location": {
        "name": "Alsvænget 2 7000 Fredericia",
        "latitude": 55.514241,
        "longitude": 9.634746
      },
      "containers": [
        {
          "id": "mp-pc-315",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-315",
            "container_id": "MP-7002-318",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDMzMTE=",
      "location": {
        "name": "Alsvænget 3 7000 Fredericia",
        "latitude": 55.514042,
        "longitude": 9.634867
      },
      "containers": [
        {
          "id": "mp-pc-316",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-316",
            "container_id": "MP-7002-319",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZTo5OTY1Njgw",
          "ticket_id": "9965680",
          "ticket_type": "Affaldet skal afleveres på genbrugspladsen",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2023-12-27T09:17:29.539911+00:00",
          "updated_at": "2023-12-27T09:17:29.555021+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDMzMTE=",
            "location": {
              "latitude": 55.514042,
              "longitude": 9.634867,
              "name": "Alsvænget 3, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20765_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQxNDY=",
      "location": {
        "name": "Alsvænget 4 7000 Fredericia",
        "latitude": 55.51409208,
        "longitude": 9.63421998
      },
      "containers": [
        {
          "id": "mp-pc-317",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-317",
            "container_id": "MP-7002-320",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3ODA3NA==",
          "ticket_id": "20578074",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Kirsten ØrumTlf.: 40267702Email: bedsteorum@hotmail.comBesked: Jeg skrev til jer for ca. 3 uger siden. Alsvænget 4 har stadig ikke modtaget 3 ruller med sække. Vores genbo fik; men ikke os./ vh Kirsten Ørum",
          "status": 6,
          "priority": 2,
          "created_at": "2024-10-25T13:39:00+00:00",
          "updated_at": "2025-08-19T00:25:00.175132+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQxNDY=",
            "location": {
              "latitude": 55.514092,
              "longitude": 9.634219,
              "name": "Alsvænget 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3ODE5OQ==",
          "ticket_id": "20578199",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Kirsten ØrumTlf.: 40267702Email: bedsteorum@hotmail.comBesked: Jeg kan se at Alsvænget nr. 5 har fået leveret 3 ruller genbrugssække, men Alsvænget nr. 4 har ikke modtaget nogle. Er de mon på vej?",
          "status": 6,
          "priority": 2,
          "created_at": "2024-10-10T11:48:00+00:00",
          "updated_at": "2025-08-19T00:25:00.182326+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQxNDY=",
            "location": {
              "latitude": 55.514092,
              "longitude": 9.634219,
              "name": "Alsvænget 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc5NzQ=",
      "location": {
        "name": "Alsvænget 5 7000 Fredericia",
        "latitude": 55.513852,
        "longitude": 9.634198
      },
      "containers": [
        {
          "id": "mp-pc-318",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-318",
            "container_id": "MP-7002-321",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc5NzU=",
      "location": {
        "name": "Alsvænget 6 7000 Fredericia",
        "latitude": 55.513976,
        "longitude": 9.633831
      },
      "containers": [
        {
          "id": "mp-pc-319",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-319",
            "container_id": "MP-7002-322",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5OTcyMA==",
          "ticket_id": "20599720",
          "ticket_type": "AO-Ændring til 80-90 liter beholder til restaffald",
          "description": "Skal gammel beholder hjemtages: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2018-08-13T09:15:00+00:00",
          "updated_at": "2025-08-19T00:25:01.646442+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc5NzU=",
            "location": {
              "latitude": 55.513976,
              "longitude": 9.633831,
              "name": "Alsvænget 6, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTIyMzM=",
      "location": {
        "name": "Tåsingevej 13 7000 Fredericia",
        "latitude": 55.513916,
        "longitude": 9.636372
      },
      "containers": [
        {
          "id": "mp-pc-320",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-320",
            "container_id": "MP-7002-323",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTIyMzI=",
      "location": {
        "name": "Tåsingevej 12 7000 Fredericia",
        "latitude": 55.514293,
        "longitude": 9.636266
      },
      "containers": [
        {
          "id": "mp-pc-321",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-321",
            "container_id": "MP-7002-324",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDYwMDE4MQ==",
          "ticket_id": "20600181",
          "ticket_type": "AO-Generel besked",
          "description": "jeg ønsker at opsige tømning af grønt affald",
          "status": 6,
          "priority": 2,
          "created_at": "2017-09-29T09:37:00+00:00",
          "updated_at": "2025-08-19T00:25:01.677337+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTIyMzI=",
            "location": {
              "latitude": 55.514293,
              "longitude": 9.636266,
              "name": "Tåsingevej 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDM2ODI=",
      "location": {
        "name": "Drejøvænget 1 7000 Fredericia",
        "latitude": 55.514213,
        "longitude": 9.635868
      },
      "containers": [
        {
          "id": "mp-pc-322",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-322",
            "container_id": "MP-7002-325",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDM2ODM=",
      "location": {
        "name": "Drejøvænget 2 7000 Fredericia",
        "latitude": 55.514486,
        "longitude": 9.635851
      },
      "containers": [
        {
          "id": "mp-pc-323",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-323",
            "container_id": "MP-7002-326",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU1ODk=",
      "location": {
        "name": "Birkholmvej 16 7000 Fredericia",
        "latitude": 55.513893,
        "longitude": 9.637157
      },
      "containers": [
        {
          "id": "mp-pc-324",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-324",
            "container_id": "MP-7002-327",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDg3Mzc=",
      "location": {
        "name": "Drejøvænget 4 7000 Fredericia",
        "latitude": 55.514394,
        "longitude": 9.635558
      },
      "containers": [
        {
          "id": "mp-pc-325",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-325",
            "container_id": "MP-7002-328",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY5MjY=",
      "location": {
        "name": "Drejøvænget 3 7000 Fredericia",
        "latitude": 55.514109,
        "longitude": 9.63558
      },
      "containers": [
        {
          "id": "mp-pc-326",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-326",
            "container_id": "MP-7002-329",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NDcyOA==",
          "ticket_id": "20584728",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Navn: Erik Hanse Tlf.: 26845606Email: ebhansen7000@hotmail.co.comBesked: ikke tømning drejøvænget 3",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-23T17:06:00+00:00",
          "updated_at": "2025-08-19T00:25:00.578242+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY5MjY=",
            "location": {
              "latitude": 55.514109,
              "longitude": 9.63558,
              "name": "Drejøvænget 3, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDg3Mzg=",
      "location": {
        "name": "Drejøvænget 6 7000 Fredericia",
        "latitude": 55.514242,
        "longitude": 9.635403
      },
      "containers": [
        {
          "id": "mp-pc-327",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-327",
            "container_id": "MP-7002-330",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMzg3NDA=",
      "location": {
        "name": "Børup Sandevej 26 7000 Fredericia",
        "latitude": 55.514222,
        "longitude": 9.638638
      },
      "containers": [
        {
          "id": "mp-pc-328",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-328",
            "container_id": "MP-7002-331",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTk1ODE=",
      "location": {
        "name": "Fjordvejen 40 7000 Fredericia",
        "latitude": 55.51344145,
        "longitude": 9.62945749
      },
      "containers": [
        {
          "id": "mp-pc-329",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-329",
            "container_id": "MP-7002-332",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3Nzg2OA==",
          "ticket_id": "20577868",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Fejlsorteret Er der afleveret flyer: Ja Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2024-11-15T09:47:00+00:00",
          "updated_at": "2025-08-19T00:25:00.164373+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTk1ODE=",
            "location": {
              "latitude": 55.513441,
              "longitude": 9.629457,
              "name": "Fjordvejen 40, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3ODkxNw==",
          "ticket_id": "20578917",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 770 l rest - Erhverv Uge Ny tømningsfrekvens: Hver uge Ønsket virkningsdato: 28/08-2024 Besked: Poul Erik 2175 2731, der står for stedet ringer og vi aftaler, de to 800 ltrs. skal skiftes ud med 2 x 770 ltr. Den ene 14 dg tømning og den anden ugetømning. Vi aftaler, at begge sættes det samme sted og så må han selv køre den ene hen, hvor den skal stå - Marius Pedersen er klar over, at de står to forsk. steder. De ombyttes onsdag d. 28/8. Kontaktoplysninger: Skærbæk Fiskeri",
          "status": 6,
          "priority": 2,
          "created_at": "2024-08-16T10:59:00+00:00",
          "updated_at": "2025-08-19T00:25:00.223880+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTk1ODE=",
            "location": {
              "latitude": 55.513441,
              "longitude": 9.629457,
              "name": "Fjordvejen 40, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3ODkxOA==",
          "ticket_id": "20578918",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 770 l rest - Erhverv Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 28/08-2024 Besked: Poul Erik 2175 2731, der står for stedet ringer og vi aftaler, de to 800 ltrs. skal skiftes ud med 2 x 770 ltr. Den ene 14 dg tømning og den anden ugetømning. Vi aftaler, at begge sættes det samme sted og så må han selv køre den ene hen, hvor den skal stå - Marius Pedersen er klar over, at de står to forsk. steder. De ombyttes onsdag d. 28/8. Kontaktoplysninger: Skærbæk Fiskerih",
          "status": 6,
          "priority": 2,
          "created_at": "2024-08-16T10:58:00+00:00",
          "updated_at": "2025-08-19T00:25:00.223932+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTk1ODE=",
            "location": {
              "latitude": 55.513441,
              "longitude": 9.629457,
              "name": "Fjordvejen 40, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3ODkyMA==",
          "ticket_id": "20578920",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: D800ErhUgeÅr - Erhverv Gamle Fjordvejen 40 1 (7000 Fredericia) ContainerNr:435016 ContainerBrik: Ønsket virkningsdato: 23/08 2024 Besked: Poul Erik 2175 2731, der står for stedet ringer og vi aftaler, de to 800 ltrs. skal skiftes ud med 2 x 770 ltr. Den ene 14 dg tømning og den anden ugetømning. Vi aftaler, at begge sættes det samme sted og så må han selv køre den ene hen, hvor den skal stå - Marius Pedersen er klar over, at de står to forsk. steder. De ombyttes",
          "status": 6,
          "priority": 2,
          "created_at": "2024-08-16T10:57:00+00:00",
          "updated_at": "2025-08-19T00:25:00.224036+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTk1ODE=",
            "location": {
              "latitude": 55.513441,
              "longitude": 9.629457,
              "name": "Fjordvejen 40, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3ODkxOQ==",
          "ticket_id": "20578919",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: D800Erh14dgÅr - Erhverv Gamle Fjordvejen 40 1 (7000 Fredericia) ContainerNr:435017 ContainerBrik: Ønsket virkningsdato: 28/08-2024 Besked: Poul Erik 2175 2731, der står for stedet ringer og vi aftaler, de to 800 ltrs. skal skiftes ud med 2 x 770 ltr. Den ene 14 dg tømning og den anden ugetømning. Vi aftaler, at begge sættes det samme sted og så må han selv køre den ene hen, hvor den skal stå - Marius Pedersen er klar over, at de står to forsk. steder. De ombytte",
          "status": 6,
          "priority": 2,
          "created_at": "2024-08-16T10:57:00+00:00",
          "updated_at": "2025-08-19T00:25:00.223985+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTk1ODE=",
            "location": {
              "latitude": 55.513441,
              "longitude": 9.629457,
              "name": "Fjordvejen 40, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDUwNQ==",
          "ticket_id": "20584505",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Manglende tømning - blev ikke tømt fredag i følge havnen. Der står en sæk ved siden af, der skal med. Kommer i kommunemail også.",
          "status": 6,
          "priority": 2,
          "created_at": "2023-06-14T11:04:00+00:00",
          "updated_at": "2025-08-19T00:25:00.563802+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTk1ODE=",
            "location": {
              "latitude": 55.513441,
              "longitude": 9.629457,
              "name": "Fjordvejen 40, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDUyMA==",
          "ticket_id": "20584520",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Jeg har været i kontakt med havnefogeden. De har kun fået tømt den ene beholder ifølge ham. Det er den, der er ugetømning på, som ikke er blevet tømt.",
          "status": 6,
          "priority": 2,
          "created_at": "2023-06-13T09:09:00+00:00",
          "updated_at": "2025-08-19T00:25:00.564686+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTk1ODE=",
            "location": {
              "latitude": 55.513441,
              "longitude": 9.629457,
              "name": "Fjordvejen 40, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4OTUzMQ==",
          "ticket_id": "20589531",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Bedes tømt snarest. Den ene af de to containere er ikke tømt i dag trods kvittering. Manden for bilen er jf. borgeren set kigge i begge containere - hvorefter han tømmer den næsten tomme, men lader den mere fyldte står. Der er ikke indkommet RenoTrol kommentarer.",
          "status": 6,
          "priority": 2,
          "created_at": "2022-04-22T11:45:00+00:00",
          "updated_at": "2025-08-19T00:25:00.985303+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTk1ODE=",
            "location": {
              "latitude": 55.513441,
              "longitude": 9.629457,
              "name": "Fjordvejen 40, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzMxOA==",
          "ticket_id": "20593318",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: D800ErhUge½År - Erhverv Gamle Fjordvejen 40 1 (7000 Fredericia) ContainerNr:402867 ContainerBrik: Beholder der ønskes i stedet: D800Erh14dgÅr - Erhverv Gamle Ny tømningsfrekvens: Hver 14 dag Gebyr: 0 kr Ønsket virkningsdato: 31/10-2021 Besked: Kontaktoplysninger: Skærbæk Fiskerihavn S/I",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-29T10:16:00+00:00",
          "updated_at": "2025-08-19T00:25:01.259500+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTk1ODE=",
            "location": {
              "latitude": 55.513441,
              "longitude": 9.629457,
              "name": "Fjordvejen 40, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzMyMQ==",
          "ticket_id": "20593321",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: D800ErhUge½År - Erhverv Gamle Fjordvejen 40 1 (7000 Fredericia) ContainerNr:425705 ContainerBrik: Beholder der ønskes i stedet: D800ErhUgeÅr - Erhverv Gamle Ny tømningsfrekvens: Hver uge Gebyr: 0 kr Ønsket virkningsdato: 29/10-2021 Besked: Kontaktoplysninger: Skærbæk Fiskerihavn S/I",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-29T10:13:00+00:00",
          "updated_at": "2025-08-19T00:25:01.259639+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTk1ODE=",
            "location": {
              "latitude": 55.513441,
              "longitude": 9.629457,
              "name": "Fjordvejen 40, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDQyMA==",
          "ticket_id": "20594420",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "KUN TØMT EEN BEHOLDER.. HURTIGST MULIGT.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-09-03T10:19:00+00:00",
          "updated_at": "2025-08-19T00:25:01.324963+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTk1ODE=",
            "location": {
              "latitude": 55.513441,
              "longitude": 9.629457,
              "name": "Fjordvejen 40, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDQyNw==",
          "ticket_id": "20594427",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: D800Erh14dg½ - Erhverv Gamle Fjordvejen 40 1 (7000 Fredericia) ContainerNr:402866 ContainerBrik: Beholder der ønskes i stedet: D800ErhUge½År - Erhverv Gamle Ny tømningsfrekvens: Hver uge Gebyr: 0 kr Ønsket virkningsdato: 03/09-2021 Besked: Kontaktoplysninger: Skærbæk Fiskerihavn S/I",
          "status": 6,
          "priority": 2,
          "created_at": "2021-09-03T10:15:00+00:00",
          "updated_at": "2025-08-19T00:25:01.325401+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTk1ODE=",
            "location": {
              "latitude": 55.513441,
              "longitude": 9.629457,
              "name": "Fjordvejen 40, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU1ODY=",
      "location": {
        "name": "Birkholmvej 12 7000 Fredericia",
        "latitude": 55.513639,
        "longitude": 9.637816
      },
      "containers": [
        {
          "id": "mp-pc-330",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-330",
            "container_id": "MP-7002-333",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDE4NjYxMQ==",
          "ticket_id": "10186611",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-08-28T08:24:14.579399+00:00",
          "updated_at": "2024-08-28T08:24:14.580263+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1ODY=",
            "location": {
              "latitude": 55.513639,
              "longitude": 9.637816,
              "name": "Birkholmvej 12, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20726_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDcxMg==",
          "ticket_id": "20584712",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Adgangsvej spærret Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-26T07:09:00+00:00",
          "updated_at": "2025-08-19T00:25:00.576876+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1ODY=",
            "location": {
              "latitude": 55.513639,
              "longitude": 9.637816,
              "name": "Birkholmvej 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI2MjU=",
      "location": {
        "name": "Birkholmvej 10 7000 Fredericia",
        "latitude": 55.513897,
        "longitude": 9.638292
      },
      "containers": [
        {
          "id": "mp-pc-331",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-331",
            "container_id": "MP-7002-334",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5OTE4NQ==",
          "ticket_id": "20599185",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2019-08-19T17:48:00+00:00",
          "updated_at": "2025-08-19T00:25:01.615010+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI2MjU=",
            "location": {
              "latitude": 55.513899,
              "longitude": 9.638292,
              "name": "Birkholmvej 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU1ODQ=",
      "location": {
        "name": "Birkholmvej 8 7000 Fredericia",
        "latitude": 55.513948,
        "longitude": 9.637863
      },
      "containers": [
        {
          "id": "mp-pc-332",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-332",
            "container_id": "MP-7002-335",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDA3NTk4Nw==",
          "ticket_id": "10075987",
          "ticket_type": "Forkert emballage, sækken skal være i klar plast",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-04-24T07:59:12.819818+00:00",
          "updated_at": "2024-04-24T07:59:12.820722+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1ODQ=",
            "location": {
              "latitude": 55.513948,
              "longitude": 9.637863,
              "name": "Birkholmvej 8, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20722_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDExNA==",
          "ticket_id": "20584114",
          "ticket_type": "AO-Generel besked",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2023-07-21T09:18:00+00:00",
          "updated_at": "2025-08-19T00:25:00.540584+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1ODQ=",
            "location": {
              "latitude": 55.513948,
              "longitude": 9.637863,
              "name": "Birkholmvej 8, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU1ODM=",
      "location": {
        "name": "Birkholmvej 6 7000 Fredericia",
        "latitude": 55.514171,
        "longitude": 9.637732
      },
      "containers": [
        {
          "id": "mp-pc-333",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-333",
            "container_id": "MP-7002-336",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU1ODI=",
      "location": {
        "name": "Birkholmvej 1 7000 Fredericia",
        "latitude": 55.514025,
        "longitude": 9.639196
      },
      "containers": [
        {
          "id": "mp-pc-334",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-334",
            "container_id": "MP-7002-337",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU1ODU=",
      "location": {
        "name": "Birkholmvej 11 7000 Fredericia",
        "latitude": 55.513845,
        "longitude": 9.638961
      },
      "containers": [
        {
          "id": "mp-pc-335",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-335",
            "container_id": "MP-7002-338",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQ3NTc=",
      "location": {
        "name": "Birkholmvej 3 7000 Fredericia",
        "latitude": 55.51385458,
        "longitude": 9.63964762
      },
      "containers": [
        {
          "id": "mp-pc-336",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-336",
            "container_id": "MP-7002-339",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NjYzNw==",
          "ticket_id": "20596637",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Gammel beholder ikke tømt fredag den 9/7 sammen med den ny. Skal tømmes, da den nu har stået i 3 uger",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-16T10:55:00+00:00",
          "updated_at": "2025-08-19T00:25:01.462351+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQ3NTc=",
            "location": {
              "latitude": 55.513854,
              "longitude": 9.639647,
              "name": "Birkholmvej 3, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI2MjQ=",
      "location": {
        "name": "Birkholmvej 9 7000 Fredericia",
        "latitude": 55.513631,
        "longitude": 9.639366
      },
      "containers": [
        {
          "id": "mp-pc-337",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-337",
            "container_id": "MP-7002-340",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQ3NTg=",
      "location": {
        "name": "Birkholmvej 7 7000 Fredericia",
        "latitude": 55.51353165,
        "longitude": 9.63964333
      },
      "containers": [
        {
          "id": "mp-pc-338",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-338",
            "container_id": "MP-7002-341",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NzczMw==",
          "ticket_id": "20587733",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Majbrit MolzenTlf.: 20407786Email: krebs65@hotmail.comBesked: Hej, hvis man holder fest og dermed ekstra affald! Hvad gør man ved det? Hvor kan det afleveres? Mvh Majbrit Molzen",
          "status": 6,
          "priority": 2,
          "created_at": "2022-09-02T23:09:00+00:00",
          "updated_at": "2025-08-19T00:25:00.827938+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQ3NTg=",
            "location": {
              "latitude": 55.513531,
              "longitude": 9.639643,
              "name": "Birkholmvej 7, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTI3NA==",
          "ticket_id": "20595274",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Martin MolzenTlf.: 23230357Email: martin_molzen@hotmail.comBesked: Hej, kan I forklare hvorfor der ikke må være køkkenrulle i madaffald, men at det smides ud i plasticposer i modsætning til de papirposer vi modtog for nogle år siden. Hvordan behandles madaffaldet videre når det er i plasticposer ? Mvh Martin Molzen",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-10T08:27:00+00:00",
          "updated_at": "2025-08-19T00:25:01.377648+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQ3NTg=",
            "location": {
              "latitude": 55.513531,
              "longitude": 9.639643,
              "name": "Birkholmvej 7, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5ODA2MA==",
          "ticket_id": "20598060",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Martin MolzenTlf.: 23230357Email: martin_molzen@hotmail.comBesked: Hej, den lille info seddel der blev efterladt på den grønne der blev tømt igår, siger at begge beholdere er blevet tømt for sidste gang, men vi har ingen ny beholder fået så hvad gør vi så ?",
          "status": 6,
          "priority": 2,
          "created_at": "2021-06-18T08:54:00+00:00",
          "updated_at": "2025-08-19T00:25:01.547678+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQ3NTg=",
            "location": {
              "latitude": 55.513531,
              "longitude": 9.639643,
              "name": "Birkholmvej 7, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5ODYxNQ==",
          "ticket_id": "20598615",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Vores grå spand blev ikke tømt idag 26/8-20 af en eller anden grund. Bilen var her og de tømte naboens spand, men ikke vores. Den har stået samme sted i indkørslen, nærmere end 15 m fra skel, i de 28 år vi har boet her. Ind imellem triller vi den ud i skel, men det nåede vi ikke i denne uge, men derfor skal den jo alligevel tømmes. Vi antager den bliver tømt snarest. Mvh Martin Molzen, Birkholmvej 7, Skærbæk",
          "status": 6,
          "priority": 2,
          "created_at": "2020-08-26T11:07:00+00:00",
          "updated_at": "2025-08-19T00:25:01.579969+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQ3NTg=",
            "location": {
              "latitude": 55.513531,
              "longitude": 9.639643,
              "name": "Birkholmvej 7, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY2MTE=",
      "location": {
        "name": "Fænø Kalvvej 1 7000 Fredericia",
        "latitude": 55.51431,
        "longitude": 9.639751
      },
      "containers": [
        {
          "id": "mp-pc-339",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-339",
            "container_id": "MP-7002-342",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY2NzM=",
      "location": {
        "name": "Fænø Kalvvej 2 7000 Fredericia",
        "latitude": 55.514159,
        "longitude": 9.640145
      },
      "containers": [
        {
          "id": "mp-pc-340",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-340",
            "container_id": "MP-7002-343",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MTk1OA==",
          "ticket_id": "20591958",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Navn: Vivi AaskovTlf.: 28875406Email: viviaaskov@gmail.comBesked: Vores spand er ikke tømt her til morgen. Det er vigtigt de tømmer idag pga jul.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-24T08:15:00+00:00",
          "updated_at": "2025-08-19T00:25:01.183230+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY2NzM=",
            "location": {
              "latitude": 55.514155,
              "longitude": 9.640145,
              "name": "Fænø Kalvvej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTIyNA==",
          "ticket_id": "20595224",
          "ticket_type": "AO-Generel besked",
          "description": "Flyer på beholder, at det der er for langt ift. STANDPLADS.. Borger ønsker uddybende forklaring. 2827 5406 - Vivi.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-11T09:22:00+00:00",
          "updated_at": "2025-08-19T00:25:01.374632+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY2NzM=",
            "location": {
              "latitude": 55.514155,
              "longitude": 9.640145,
              "name": "Fænø Kalvvej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTU0MA==",
          "ticket_id": "20595540",
          "ticket_type": "AO-Generel besked",
          "description": "Tilmeldt med standplads",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-03T14:35:00+00:00",
          "updated_at": "2025-08-19T00:25:01.394472+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY2NzM=",
            "location": {
              "latitude": 55.514155,
              "longitude": 9.640145,
              "name": "Fænø Kalvvej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY2NzQ=",
      "location": {
        "name": "Fænø Kalvvej 4 7000 Fredericia",
        "latitude": 55.514338,
        "longitude": 9.640397
      },
      "containers": [
        {
          "id": "mp-pc-341",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-341",
            "container_id": "MP-7002-344",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5Nzk5Mw==",
          "ticket_id": "20597993",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "Navn: Flemming KrogsgaardTlf.: 30367996Email: flemming.krogsgaard@gmail.comBesked: Min nuværende, grønne beholder har fået en skade (revne) ved tømning. Jeg vil gerne bede om en ombytning ved lejlighed.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-06-23T23:55:00+00:00",
          "updated_at": "2025-08-19T00:25:01.540546+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY2NzQ=",
            "location": {
              "latitude": 55.514338,
              "longitude": 9.640404,
              "name": "Fænø Kalvvej 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc4MDU=",
      "location": {
        "name": "Børup Sandevej 25 7000 Fredericia",
        "latitude": 55.514224,
        "longitude": 9.640899
      },
      "containers": [
        {
          "id": "mp-pc-342",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-342",
            "container_id": "MP-7002-345",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3ODA1Nw==",
          "ticket_id": "20578057",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Farligt affald Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 28/10-2024 Besked: Bestil pr. mail af Inge Lind Kontaktoplysninger: Inge Sørine Lind 41121787 Islind25@gmail.com",
          "status": 6,
          "priority": 2,
          "created_at": "2024-10-28T12:39:00+00:00",
          "updated_at": "2025-08-19T00:25:00.174209+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc4MDU=",
            "location": {
              "latitude": 55.514228,
              "longitude": 9.640899,
              "name": "Børup Sandevej 25, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTcxMjY=",
      "location": {
        "name": "Fænø Kalvvej 11 7000 Fredericia",
        "latitude": 55.51455938,
        "longitude": 9.64020762
      },
      "containers": [
        {
          "id": "mp-pc-343",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-343",
            "container_id": "MP-7002-346",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MTI0Ng==",
          "ticket_id": "20591246",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Thøger Jespersen Tlf.: 40406662Email: thj.privat@icloud.comBesked: Hvor får vi udleveret nye klistermærker til genbrugsposerne? Vh Thøger Jespersen",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-24T16:31:00+00:00",
          "updated_at": "2025-08-19T00:25:01.135932+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcxMjY=",
            "location": {
              "latitude": 55.514559,
              "longitude": 9.640207,
              "name": "Fænø Kalvvej 11, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTY0MTQ=",
      "location": {
        "name": "Fænø Kalvvej 8 7000 Fredericia",
        "latitude": 55.51485777,
        "longitude": 9.64122805
      },
      "containers": [
        {
          "id": "mp-pc-344",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-344",
            "container_id": "MP-7002-347",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQwMDY=",
      "location": {
        "name": "Fænø Kalvvej 10 7000 Fredericia",
        "latitude": 55.515075,
        "longitude": 9.64119
      },
      "containers": [
        {
          "id": "mp-pc-345",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-345",
            "container_id": "MP-7002-348",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTUwMTU=",
      "location": {
        "name": "Fænø Kalvvej 23 7000 Fredericia",
        "latitude": 55.51515069,
        "longitude": 9.64078401
      },
      "containers": [
        {
          "id": "mp-pc-346",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-346",
            "container_id": "MP-7002-349",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDUzMTU3MA==",
          "ticket_id": "10531570",
          "ticket_type": "Sækken indeholder farligt affald - brug den røde kasse",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2025-01-30T09:40:07.940446+00:00",
          "updated_at": "2025-01-30T09:40:07.941662+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUwMTU=",
            "location": {
              "latitude": 55.51515,
              "longitude": 9.640784,
              "name": "Fænø Kalvvej 23, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20712_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTM4OA==",
          "ticket_id": "20599388",
          "ticket_type": "AO-Generel besked",
          "description": "Att. Mette Lorentzen Jeg skrev forkert mht affaldsbeholderen. Det er korrekt at vi er skiftet til 80 l affaldsbeholder, men vi skal ikke have afhentet den gamle beholder. Så ingen afhentning d 1 maj Mvh Birgitte, Fænø Kalvvej 23, 7000",
          "status": 6,
          "priority": 2,
          "created_at": "2019-04-28T14:34:00+00:00",
          "updated_at": "2025-08-19T00:25:01.626645+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUwMTU=",
            "location": {
              "latitude": 55.51515,
              "longitude": 9.640784,
              "name": "Fænø Kalvvej 23, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTM5NA==",
          "ticket_id": "20599394",
          "ticket_type": "AO-Ændring til 80-90 liter beholder til restaffald",
          "description": "Vi har den tidligere 80-90 l affalds beholder, så vi skal ikke have en ny. Vi stiller den frem efter tømning i morgen Skal gammel beholder hjemtages: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2019-04-23T21:03:00+00:00",
          "updated_at": "2025-08-19T00:25:01.626963+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUwMTU=",
            "location": {
              "latitude": 55.51515,
              "longitude": 9.640784,
              "name": "Fænø Kalvvej 23, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTQ5MQ==",
          "ticket_id": "20599491",
          "ticket_type": "AO-Ændring til 140 liter beholder til restaffald",
          "description": "Skal gammel beholder hjemtages: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2019-02-08T17:50:00+00:00",
          "updated_at": "2025-08-19T00:25:01.632366+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUwMTU=",
            "location": {
              "latitude": 55.51515,
              "longitude": 9.640784,
              "name": "Fænø Kalvvej 23, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQwMDc=",
      "location": {
        "name": "Fænø Kalvvej 12 7000 Fredericia",
        "latitude": 55.515239,
        "longitude": 9.641253
      },
      "containers": [
        {
          "id": "mp-pc-347",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-347",
            "container_id": "MP-7002-350",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5OTM5OA==",
          "ticket_id": "20599398",
          "ticket_type": "AO-Generel besked",
          "description": "Hej Jeg vil høre om 2 ting: Vores beholder til restaffald, som vi nu har haft i 19 år, er revnet. kan vi få den byttet til en ny? Hvad koster det at få en beholder til restaffald? Mvh. Henrik",
          "status": 6,
          "priority": 2,
          "created_at": "2019-04-21T09:14:00+00:00",
          "updated_at": "2025-08-19T00:25:01.627173+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQwMDc=",
            "location": {
              "latitude": 55.515239,
              "longitude": 9.641253,
              "name": "Fænø Kalvvej 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY2MTQ=",
      "location": {
        "name": "Fænø Kalvvej 13 7000 Fredericia",
        "latitude": 55.514861,
        "longitude": 9.6404
      },
      "containers": [
        {
          "id": "mp-pc-348",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-348",
            "container_id": "MP-7002-351",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4OTgyNg==",
          "ticket_id": "20589826",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Fænø Kalvvej 13 1 (7000 Fredericia) ContainerNr:407781 ContainerBrik: Låg itu Ønsket virkningsdato: 08/11-2021 Besked: Hængsler Kontaktoplysninger: Helle Mosgaard Nielsen",
          "status": 6,
          "priority": 2,
          "created_at": "2021-11-08T09:20:00+00:00",
          "updated_at": "2025-08-19T00:25:01.018372+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY2MTQ=",
            "location": {
              "latitude": 55.514863,
              "longitude": 9.6404,
              "name": "Fænø Kalvvej 13, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzIzNw==",
          "ticket_id": "20593237",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Helle NielsenTlf.: 51519284Email: hellemoes@gmail.comBesked: Hej. Jeg prøver lige at skrive til jer igen, da jeg ikke har fået svar fra jer. Hængslet på vores skraldespand blev ødelagt ved første tømning. Vi vil godt bede om, at den enten repareres eller ombyttes, eller I informerer os om, hvordan vi skal forholde os. Tak. Mvh. Helle, Fænø Kalvvej 13, Fredericia",
          "status": 6,
          "priority": 2,
          "created_at": "2021-11-07T14:16:00+00:00",
          "updated_at": "2025-08-19T00:25:01.254523+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY2MTQ=",
            "location": {
              "latitude": 55.514863,
              "longitude": 9.6404,
              "name": "Fænø Kalvvej 13, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDExOQ==",
          "ticket_id": "20594119",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Helle NielsenTlf.: 51519284Email: hellemoes@gmail.comBesked: Vores skraldespands ene hængsel er blevet smadret ved tømning i fredags",
          "status": 6,
          "priority": 2,
          "created_at": "2021-09-18T19:46:00+00:00",
          "updated_at": "2025-08-19T00:25:01.306545+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY2MTQ=",
            "location": {
              "latitude": 55.514863,
              "longitude": 9.6404,
              "name": "Fænø Kalvvej 13, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY2MTU=",
      "location": {
        "name": "Fænø Kalvvej 15 7000 Fredericia",
        "latitude": 55.514985,
        "longitude": 9.640014
      },
      "containers": [
        {
          "id": "mp-pc-349",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-349",
            "container_id": "MP-7002-352",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZTo5OTk5OTY0",
          "ticket_id": "9999964",
          "ticket_type": "Affaldet skal afleveres på genbrugspladsen",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-01-30T10:32:31.405903+00:00",
          "updated_at": "2024-01-30T10:32:31.437623+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY2MTU=",
            "location": {
              "latitude": 55.514985,
              "longitude": 9.640014,
              "name": "Fænø Kalvvej 15, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20706_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY2MTc=",
      "location": {
        "name": "Fænø Kalvvej 21 7000 Fredericia",
        "latitude": 55.515247,
        "longitude": 9.640426
      },
      "containers": [
        {
          "id": "mp-pc-350",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-350",
            "container_id": "MP-7002-353",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQwMTA=",
      "location": {
        "name": "Fænø Kalvvej 19 7000 Fredericia",
        "latitude": 55.515441,
        "longitude": 9.640151
      },
      "containers": [
        {
          "id": "mp-pc-351",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-351",
            "container_id": "MP-7002-354",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDYwMDI3NA==",
          "ticket_id": "20600274",
          "ticket_type": "AO-Generel besked",
          "description": "Hej Vi har lige tilmeldt os tømning af grønt affald på vores adresse Fænø Kalvvej 19. Vi kan dog ikke finde oplysning om, hvilke ugedage grønt affald vil blive afhentet på vores adresse. Kan I oplyse hvilke ugedag grønt affald vil blive afhentet på Fænø Kalvvej 19? Mvh Morten Jensen",
          "status": 6,
          "priority": 2,
          "created_at": "2017-07-25T17:51:00+00:00",
          "updated_at": "2025-08-19T00:25:01.683730+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQwMTA=",
            "location": {
              "latitude": 55.515441,
              "longitude": 9.640151,
              "name": "Fænø Kalvvej 19, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDYwMDMwNQ==",
          "ticket_id": "20600305",
          "ticket_type": "AO-Ændring til kompostbeholder",
          "description": "Hej ønsker en beholder til grønt affald, der tømmes. Mvh. Marianne",
          "status": 6,
          "priority": 2,
          "created_at": "2017-07-04T18:47:00+00:00",
          "updated_at": "2025-08-19T00:25:01.686140+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQwMTA=",
            "location": {
              "latitude": 55.515441,
              "longitude": 9.640151,
              "name": "Fænø Kalvvej 19, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDYwMDMxMA==",
          "ticket_id": "20600310",
          "ticket_type": "AO-Ændring til kompostbeholder",
          "description": "Hej. Ãnsker kompostbeholder med tømning. Mvh. Marianne",
          "status": 6,
          "priority": 2,
          "created_at": "2017-07-02T16:11:00+00:00",
          "updated_at": "2025-08-19T00:25:01.686394+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQwMTA=",
            "location": {
              "latitude": 55.515441,
              "longitude": 9.640151,
              "name": "Fænø Kalvvej 19, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY2MTY=",
      "location": {
        "name": "Fænø Kalvvej 17 7000 Fredericia",
        "latitude": 55.515134,
        "longitude": 9.639658
      },
      "containers": [
        {
          "id": "mp-pc-352",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-352",
            "container_id": "MP-7002-355",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTY4MA==",
          "ticket_id": "20585680",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2023-02-17Fraktion: 1 (Mad/Rest)Navn: John JacobsenTlf.: 30704710Email: j_g_jacobsen@icloud.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-18T09:49:00+00:00",
          "updated_at": "2025-08-19T00:25:00.632769+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY2MTY=",
            "location": {
              "latitude": 55.515134,
              "longitude": 9.639658,
              "name": "Fænø Kalvvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTcxMw==",
          "ticket_id": "20585713",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2023-02-03Fraktion: 1 (Mad/Rest)Navn: Birgitte OslenderTlf.: 24826096Email: Birgitte.Oslender@Gmail.comBesked: Beholder ikke tømt i dag den 17/2...",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-18T00:02:00+00:00",
          "updated_at": "2025-08-19T00:25:00.634395+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY2MTY=",
            "location": {
              "latitude": 55.515134,
              "longitude": 9.639658,
              "name": "Fænø Kalvvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NzQwNA==",
          "ticket_id": "20587404",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Tømningsdato: 2022-09-22Fraktion: 2 (Genbrug)Navn: John JacobsenTlf.: 30704710Email: j_g_jacobsen@icloud.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2022-09-25T12:30:00+00:00",
          "updated_at": "2025-08-19T00:25:00.794525+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY2MTY=",
            "location": {
              "latitude": 55.515134,
              "longitude": 9.639658,
              "name": "Fænø Kalvvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzUzMg==",
          "ticket_id": "20593532",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Skal ikke sættes frem. Der er 1,5 m til spanden. Skal tømmes i dag!",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-18T09:43:00+00:00",
          "updated_at": "2025-08-19T00:25:01.271248+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY2MTY=",
            "location": {
              "latitude": 55.515134,
              "longitude": 9.639658,
              "name": "Fænø Kalvvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTAwOQ==",
          "ticket_id": "20599009",
          "ticket_type": "AO-Ændring til 180-190 liter beholder til restaffald",
          "description": "Skal gammel beholder hjemtages: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2020-01-20T22:45:00+00:00",
          "updated_at": "2025-08-19T00:25:01.604612+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY2MTY=",
            "location": {
              "latitude": 55.515134,
              "longitude": 9.639658,
              "name": "Fænø Kalvvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDcwMTk=",
      "location": {
        "name": "Fænøvej 21 7000 Fredericia",
        "latitude": 55.514995,
        "longitude": 9.642969
      },
      "containers": [
        {
          "id": "mp-pc-353",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-353",
            "container_id": "MP-7002-356",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTcxNjY=",
      "location": {
        "name": "Fænøvej 7 7000 Fredericia",
        "latitude": 55.51482776,
        "longitude": 9.64202603
      },
      "containers": [
        {
          "id": "mp-pc-354",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-354",
            "container_id": "MP-7002-357",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTY5NDM=",
      "location": {
        "name": "Fænøvej 9 7000 Fredericia",
        "latitude": 55.51509129,
        "longitude": 9.64207277
      },
      "containers": [
        {
          "id": "mp-pc-355",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-355",
            "container_id": "MP-7002-358",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NTM2MA==",
          "ticket_id": "20575360",
          "ticket_type": "AO-Generel besked",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2025-06-04T21:00:00+00:00",
          "updated_at": "2025-08-19T00:24:59.919527+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTY5NDM=",
            "location": {
              "latitude": 55.515091,
              "longitude": 9.642072,
              "name": "Fænøvej 9, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTY1MzM=",
      "location": {
        "name": "Fænøvej 11 7000 Fredericia",
        "latitude": 55.51525835,
        "longitude": 9.64213868
      },
      "containers": [
        {
          "id": "mp-pc-356",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-356",
            "container_id": "MP-7002-359",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5ODQ5Nw==",
          "ticket_id": "20598497",
          "ticket_type": "AO-Ændring til 80-90 liter beholder til restaffald",
          "description": "Hej, Vi overtager ejendommen d. 1/12-2020 og ønsker 80-90 liter til restaffald og kompostbeholder fra denne dato. Mvh Leif Rhindal Jensen Skal gammel beholder hjemtages: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2020-11-14T20:00:00+00:00",
          "updated_at": "2025-08-19T00:25:01.572747+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTY1MzM=",
            "location": {
              "latitude": 55.515258,
              "longitude": 9.642138,
              "name": "Fænøvej 11, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTY0OTY=",
      "location": {
        "name": "Fænøvej 13 7000 Fredericia",
        "latitude": 55.51561203,
        "longitude": 9.64208869
      },
      "containers": [
        {
          "id": "mp-pc-357",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-357",
            "container_id": "MP-7002-360",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NTM5Mw==",
          "ticket_id": "20595393",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Adgangsvej spærret Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-06T08:14:00+00:00",
          "updated_at": "2025-08-19T00:25:01.385795+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTY0OTY=",
            "location": {
              "latitude": 55.515612,
              "longitude": 9.642088,
              "name": "Fænøvej 13, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTY0NTU=",
      "location": {
        "name": "Fænøvej 17 7000 Fredericia",
        "latitude": 55.51568722,
        "longitude": 9.64246889
      },
      "containers": [
        {
          "id": "mp-pc-358",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-358",
            "container_id": "MP-7002-362",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQ5NjE=",
      "location": {
        "name": "Fænøvej 18 7000 Fredericia",
        "latitude": 55.51456986,
        "longitude": 9.64294241
      },
      "containers": [
        {
          "id": "mp-pc-359",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-359",
            "container_id": "MP-7002-363",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDkyMzc=",
      "location": {
        "name": "Fænøvej 23 7000 Fredericia",
        "latitude": 55.514363,
        "longitude": 9.643601
      },
      "containers": [
        {
          "id": "mp-pc-360",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-360",
            "container_id": "MP-7002-364",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDkyMzU=",
      "location": {
        "name": "Fænøvej 20 7000 Fredericia",
        "latitude": 55.513972,
        "longitude": 9.64349
      },
      "containers": [
        {
          "id": "mp-pc-361",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-361",
            "container_id": "MP-7002-365",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZTo3MjYzOTc1",
          "ticket_id": "7263975",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "Plastik og mæk i samme pose",
          "status": 1,
          "priority": 0,
          "created_at": "2023-09-21T06:19:39.943050+00:00",
          "updated_at": "2023-09-21T06:19:39.955655+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDkyMzU=",
            "location": {
              "latitude": 55.513972,
              "longitude": 9.64349,
              "name": "Fænøvej 20, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "11424_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDkyMzk=",
      "location": {
        "name": "Fænøvej 25 7000 Fredericia",
        "latitude": 55.514206,
        "longitude": 9.64394
      },
      "containers": [
        {
          "id": "mp-pc-362",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-362",
            "container_id": "MP-7002-366",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDkyMzY=",
      "location": {
        "name": "Fænøvej 22 7000 Fredericia",
        "latitude": 55.513906,
        "longitude": 9.643777
      },
      "containers": [
        {
          "id": "mp-pc-363",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-363",
            "container_id": "MP-7002-367",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDcwMTg=",
      "location": {
        "name": "Fænøvej 27 7000 Fredericia",
        "latitude": 55.514045,
        "longitude": 9.644313
      },
      "containers": [
        {
          "id": "mp-pc-364",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-364",
            "container_id": "MP-7002-368",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDkyMzg=",
      "location": {
        "name": "Fænøvej 24 7000 Fredericia",
        "latitude": 55.513823,
        "longitude": 9.64417
      },
      "containers": [
        {
          "id": "mp-pc-365",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-365",
            "container_id": "MP-7002-369",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4ODM1OQ==",
          "ticket_id": "20588359",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Fænøvej 24 1 (7000 Fredericia) ContainerNr:410383 ContainerBrik:0040000012640CEC Låg itu Ønsket virkningsdato: 19/07-2022 Besked: Kontaktoplysninger: Jonas Lindgren 40389838 jonas.lindgren@mail.dk",
          "status": 6,
          "priority": 2,
          "created_at": "2022-07-18T11:19:00+00:00",
          "updated_at": "2025-08-19T00:25:00.880749+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDkyMzg=",
            "location": {
              "latitude": 55.513823,
              "longitude": 9.64417,
              "name": "Fænøvej 24, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4ODQyMw==",
          "ticket_id": "20588423",
          "ticket_type": "AO-Generel besked",
          "description": "Skraldespand i stykker (hængslet - låget falder af). Bedes udskiftet h.m.",
          "status": 6,
          "priority": 2,
          "created_at": "2022-07-11T08:42:00+00:00",
          "updated_at": "2025-08-19T00:25:00.887409+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDkyMzg=",
            "location": {
              "latitude": 55.513823,
              "longitude": 9.64417,
              "name": "Fænøvej 24, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDYwMDU3OQ==",
          "ticket_id": "20600579",
          "ticket_type": "AO-Ændring til 140 liter beholder til grønt affald",
          "description": "Da den grønne spand først blev bestilt/leveret i september i år kan betalingen ikke være sket i 2. kvartal 2016. Jeg spørger igen: Hvad er prisen for spanden der i alt er/bliver brugt i perioden 20 sept 2016-31 dec. 2016?",
          "status": 6,
          "priority": 2,
          "created_at": "2016-11-03T14:05:00+00:00",
          "updated_at": "2025-08-19T00:25:01.703115+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDkyMzg=",
            "location": {
              "latitude": 55.513823,
              "longitude": 9.64417,
              "name": "Fænøvej 24, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDYwMDU4MQ==",
          "ticket_id": "20600581",
          "ticket_type": "AO-Ændring til 140 liter beholder til grønt affald",
          "description": "Beholderen til grønt affald bedes fjernet pr 31/12 2016 da der efter denne dag ikke mere er brug for den. Det bedes oplyst hvad prisen for beholderen for hele perioden 22/9 - 31/12 2016 er, og hvordan/hvornår beløbet bliver opkrævet. Mvh Jonas Lindgren",
          "status": 6,
          "priority": 2,
          "created_at": "2016-11-02T14:45:00+00:00",
          "updated_at": "2025-08-19T00:25:01.703213+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDkyMzg=",
            "location": {
              "latitude": 55.513823,
              "longitude": 9.64417,
              "name": "Fænøvej 24, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDYwMDYxMA==",
          "ticket_id": "20600610",
          "ticket_type": "AO-Ændring til 140 liter beholder til grønt affald",
          "description": "Venligst lever den mindste model beholder til grønt affald. Mvh Jonas Lindgren",
          "status": 6,
          "priority": 2,
          "created_at": "2016-09-22T16:02:00+00:00",
          "updated_at": "2025-08-19T00:25:01.704719+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDkyMzg=",
            "location": {
              "latitude": 55.513823,
              "longitude": 9.64417,
              "name": "Fænøvej 24, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTUwNjA=",
      "location": {
        "name": "Fænøvej 30 7000 Fredericia",
        "latitude": 55.51355233,
        "longitude": 9.64558547
      },
      "containers": [
        {
          "id": "mp-pc-366",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-366",
            "container_id": "MP-7002-370",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NjUyNA==",
          "ticket_id": "20586524",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 14/12-2022 Besked: Kontaktoplysninger: Jytte Hornbæk Madsen",
          "status": 6,
          "priority": 2,
          "created_at": "2022-12-14T14:59:00+00:00",
          "updated_at": "2025-08-19T00:25:00.708522+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUwNjA=",
            "location": {
              "latitude": 55.513552,
              "longitude": 9.645585,
              "name": "Fænøvej 30, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4Njg1NA==",
          "ticket_id": "20586854",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 2-delt 240 l beholder - Sommerhus ½ År Fænøvej 30 1 (7000 Fredericia) ContainerNr:404325 ContainerBrik:0040000012640238 Beholder der ønskes i stedet: 2-delt 240 l beholder - Sommerhus helårlig Ny tømningsfrekvens: Hver 14 dag Gebyr: 0 kr Ønsket virkningsdato: 01/01-2023 Besked: Kontaktoplysninger: Jytte Hornbæk Madsen",
          "status": 6,
          "priority": 2,
          "created_at": "2022-11-24T10:00:00+00:00",
          "updated_at": "2025-08-19T00:25:00.744376+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUwNjA=",
            "location": {
              "latitude": 55.513552,
              "longitude": 9.645585,
              "name": "Fænøvej 30, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDYyMDM=",
      "location": {
        "name": "Fænøvej 26 7000 Fredericia",
        "latitude": 55.513624,
        "longitude": 9.6451
      },
      "containers": [
        {
          "id": "mp-pc-367",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-367",
            "container_id": "MP-7002-371",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NTAyMw==",
          "ticket_id": "20575023",
          "ticket_type": "AO-Generel besked",
          "description": "Ændret fra parcel til sommer grundgebyr, da det i BBR er registeret som sommerhus. Borger er d. 24-06-25 informeret via e-Boks.",
          "status": 6,
          "priority": 2,
          "created_at": "2025-06-25T08:18:00+00:00",
          "updated_at": "2025-08-19T00:24:59.882139+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDYyMDM=",
            "location": {
              "latitude": 55.513624,
              "longitude": 9.6451,
              "name": "Fænøvej 26, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDkyNDA=",
      "location": {
        "name": "Fænøvej 29 7000 Fredericia",
        "latitude": 55.513979,
        "longitude": 9.6446
      },
      "containers": [
        {
          "id": "mp-pc-368",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-368",
            "container_id": "MP-7002-372",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDkyNDI=",
      "location": {
        "name": "Fænøvej 35 7000 Fredericia",
        "latitude": 55.513791,
        "longitude": 9.645312
      },
      "containers": [
        {
          "id": "mp-pc-369",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-369",
            "container_id": "MP-7002-373",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NjE0Nw==",
          "ticket_id": "20576147",
          "ticket_type": "AO-Generel besked",
          "description": "Har dags dato snakket med borger Inge Hansen som bor i esbjeg, Åskranten 43. tlf. 20193800 Betaler grundgebyr uden at have beholder, skal tage affald med hjem. Naboer betaler ikke gebyr",
          "status": 6,
          "priority": 2,
          "created_at": "2025-04-07T10:23:00+00:00",
          "updated_at": "2025-08-19T00:25:00.012185+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDkyNDI=",
            "location": {
              "latitude": 55.513791,
              "longitude": 9.645312,
              "name": "Fænøvej 35, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDkyNDE=",
      "location": {
        "name": "Fænøvej 33 7000 Fredericia",
        "latitude": 55.514074,
        "longitude": 9.645333
      },
      "containers": [
        {
          "id": "mp-pc-370",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-370",
            "container_id": "MP-7002-374",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY4OTk=",
      "location": {
        "name": "Børup Sandevej 59 7000 Fredericia",
        "latitude": 55.512499,
        "longitude": 9.646122
      },
      "containers": [
        {
          "id": "mp-pc-371",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-371",
            "container_id": "MP-7002-375",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDM5MTQ=",
      "location": {
        "name": "Fænøvej 8 7000 Fredericia",
        "latitude": 55.514505,
        "longitude": 9.641443
      },
      "containers": [
        {
          "id": "mp-pc-372",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-372",
            "container_id": "MP-7002-376",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZTo3MjYzOTYw",
          "ticket_id": "7263960",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "Grønne tisserør plus bleer",
          "status": 1,
          "priority": 0,
          "created_at": "2023-09-21T06:10:45.151212+00:00",
          "updated_at": "2023-09-21T06:10:45.160862+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDM5MTQ=",
            "location": {
              "latitude": 55.514505,
              "longitude": 9.641443,
              "name": "Fænøvej 8, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "11417_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQwMDg=",
      "location": {
        "name": "Fænø Kalvvej 14 7000 Fredericia",
        "latitude": 55.51553,
        "longitude": 9.641389
      },
      "containers": [
        {
          "id": "mp-pc-373",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-373",
            "container_id": "MP-7002-377",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDA3NjA4MA==",
          "ticket_id": "10076080",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-04-24T08:31:44.810262+00:00",
          "updated_at": "2024-04-24T08:31:44.811158+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQwMDg=",
            "location": {
              "latitude": 55.51553,
              "longitude": 9.641389,
              "name": "Fænø Kalvvej 14, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20705_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4OTgzMw==",
          "ticket_id": "20589833",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Fænø Kalvvej 14 1 (7000 Fredericia) ContainerNr:415134 ContainerBrik: Håndtag itu Ønsket virkningsdato: 18/10-2021 Besked: knækket Kontaktoplysninger: Bodil Friis 23110538 Hbfriis@skfr.dk",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-18T13:19:00+00:00",
          "updated_at": "2025-08-19T00:25:01.019100+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQwMDg=",
            "location": {
              "latitude": 55.51553,
              "longitude": 9.641389,
              "name": "Fænø Kalvvej 14, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzU2Mw==",
          "ticket_id": "20593563",
          "ticket_type": "AO-Håndtag itu (vedhæft evt foto - kun på web)",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-17T19:05:00+00:00",
          "updated_at": "2025-08-19T00:25:01.273402+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQwMDg=",
            "location": {
              "latitude": 55.51553,
              "longitude": 9.641389,
              "name": "Fænø Kalvvej 14, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDYwMDEzNw==",
          "ticket_id": "20600137",
          "ticket_type": "AO-Ændring til 80-90 liter beholder til restaffald",
          "description": "Skal gammel beholder hjemtages: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2017-11-13T14:23:00+00:00",
          "updated_at": "2025-08-19T00:25:01.674749+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQwMDg=",
            "location": {
              "latitude": 55.51553,
              "longitude": 9.641389,
              "name": "Fænø Kalvvej 14, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQwMDk=",
      "location": {
        "name": "Fænø Kalvvej 16 7000 Fredericia",
        "latitude": 55.515719,
        "longitude": 9.641441
      },
      "containers": [
        {
          "id": "mp-pc-374",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-374",
            "container_id": "MP-7002-378",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTUwMTQ=",
      "location": {
        "name": "Fænø Kalvvej 18 7000 Fredericia",
        "latitude": 55.51599775,
        "longitude": 9.64147892
      },
      "containers": [
        {
          "id": "mp-pc-375",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-375",
            "container_id": "MP-7002-379",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3Nzg1Mw==",
          "ticket_id": "20577853",
          "ticket_type": "AO-Håndtag itu (vedhæft evt foto - kun på web)",
          "description": "Navn: Jan OlesenTlf.: 24794877Email: jtf@olesen.mail.dkBesked: Håndtaget kan ikke lukkes på rest affalds beholder.",
          "status": 6,
          "priority": 2,
          "created_at": "2024-11-15T11:18:00+00:00",
          "updated_at": "2025-08-19T00:25:00.163657+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUwMTQ=",
            "location": {
              "latitude": 55.515997,
              "longitude": 9.641478,
              "name": "Fænø Kalvvej 18, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTUwMTk=",
      "location": {
        "name": "Fænø Kalvvej 31 7000 Fredericia",
        "latitude": 55.51604293,
        "longitude": 9.64101927
      },
      "containers": [
        {
          "id": "mp-pc-376",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-376",
            "container_id": "MP-7002-380",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTUwMTg=",
      "location": {
        "name": "Fænø Kalvvej 29 7000 Fredericia",
        "latitude": 55.51587604,
        "longitude": 9.64081606
      },
      "containers": [
        {
          "id": "mp-pc-377",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-377",
            "container_id": "MP-7002-381",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTUwMTc=",
      "location": {
        "name": "Fænø Kalvvej 27 7000 Fredericia",
        "latitude": 55.51567316,
        "longitude": 9.640503
      },
      "containers": [
        {
          "id": "mp-pc-378",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-378",
            "container_id": "MP-7002-382",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDA0OTg5Nw==",
          "ticket_id": "10049897",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-03-26T09:23:48.987548+00:00",
          "updated_at": "2024-03-26T09:23:48.988413+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUwMTc=",
            "location": {
              "latitude": 55.515673,
              "longitude": 9.640503,
              "name": "Fænø Kalvvej 27, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20714_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTUwMTY=",
      "location": {
        "name": "Fænø Kalvvej 25 7000 Fredericia",
        "latitude": 55.51552185,
        "longitude": 9.64084547
      },
      "containers": [
        {
          "id": "mp-pc-379",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-379",
            "container_id": "MP-7002-383",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQwMDU=",
      "location": {
        "name": "Fænø Kalvvej 9 7000 Fredericia",
        "latitude": 55.514643,
        "longitude": 9.639806
      },
      "containers": [
        {
          "id": "mp-pc-380",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-380",
            "container_id": "MP-7002-384",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDAyNTY0MA==",
          "ticket_id": "10025640",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-02-29T09:20:11.927721+00:00",
          "updated_at": "2024-02-29T09:20:11.936832+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQwMDU=",
            "location": {
              "latitude": 55.514643,
              "longitude": 9.639806,
              "name": "Fænø Kalvvej 9, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20700_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MjY1OA==",
          "ticket_id": "20582658",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2024-01-05Fraktion: 1 (Mad/Rest)Navn: Søren MenzerTlf.: 22274672Email: menzer94@gmail.comBesked: tidligere ejer har ikke været i boligen i et stykke tid. Vi har først fået nøgler i dag d. 8.1",
          "status": 6,
          "priority": 2,
          "created_at": "2024-01-08T13:57:00+00:00",
          "updated_at": "2025-08-19T00:25:00.448935+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQwMDU=",
            "location": {
              "latitude": 55.514643,
              "longitude": 9.639806,
              "name": "Fænø Kalvvej 9, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY2MTM=",
      "location": {
        "name": "Fænø Kalvvej 7 7000 Fredericia",
        "latitude": 55.514887,
        "longitude": 9.639428
      },
      "containers": [
        {
          "id": "mp-pc-381",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-381",
            "container_id": "MP-7002-385",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY2MTI=",
      "location": {
        "name": "Fænø Kalvvej 5 7000 Fredericia",
        "latitude": 55.514577,
        "longitude": 9.639092
      },
      "containers": [
        {
          "id": "mp-pc-382",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-382",
            "container_id": "MP-7002-386",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTYwMzY=",
      "location": {
        "name": "Fænø Kalvvej 3 7000 Fredericia",
        "latitude": 55.51446049,
        "longitude": 9.6394256
      },
      "containers": [
        {
          "id": "mp-pc-383",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-383",
            "container_id": "MP-7002-387",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDgzNzQ=",
      "location": {
        "name": "Brandsøvej 1 7000 Fredericia",
        "latitude": 55.513702,
        "longitude": 9.640598
      },
      "containers": [
        {
          "id": "mp-pc-384",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-384",
            "container_id": "MP-7002-388",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc1MjU=",
      "location": {
        "name": "Birkholmvej 17 7000 Fredericia",
        "latitude": 55.513354,
        "longitude": 9.639322
      },
      "containers": [
        {
          "id": "mp-pc-385",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-385",
            "container_id": "MP-7002-389",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3Njk0MA==",
          "ticket_id": "20576940",
          "ticket_type": "AO-Generel besked",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2025-01-24T11:23:00+00:00",
          "updated_at": "2025-08-19T00:25:00.100381+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc1MjU=",
            "location": {
              "latitude": 55.513354,
              "longitude": 9.639322,
              "name": "Birkholmvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTEyNA==",
          "ticket_id": "20599124",
          "ticket_type": "AO-Ændring til 80-90 liter beholder til restaffald",
          "description": "Hej Kan jeg få ændret min affaldsbeholder fra 180 l til 90 l. Jeg har selv en 90 liters beholder. På forhånd tak. Lene Thrane Brok Skal gammel beholder hjemtages: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2019-10-17T09:01:00+00:00",
          "updated_at": "2025-08-19T00:25:01.611457+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc1MjU=",
            "location": {
              "latitude": 55.513354,
              "longitude": 9.639322,
              "name": "Birkholmvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTQ1NQ==",
          "ticket_id": "20599455",
          "ticket_type": "AO-Ændring til 180-190 liter beholder til restaffald",
          "description": "Har brug for en større beholder i en periode, mens jeg har min søn og svigerdatter boende, mens de bygger nyt hus. Jeg skal derfor også købe en ny, større beholder. Skal gammel beholder hjemtages: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2019-03-06T07:00:00+00:00",
          "updated_at": "2025-08-19T00:25:01.630337+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc1MjU=",
            "location": {
              "latitude": 55.513354,
              "longitude": 9.639322,
              "name": "Birkholmvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY4Nzk=",
      "location": {
        "name": "Brandsøvej 17 7000 Fredericia",
        "latitude": 55.51269,
        "longitude": 9.639385
      },
      "containers": [
        {
          "id": "mp-pc-386",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-386",
            "container_id": "MP-7002-390",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MDUzMw==",
          "ticket_id": "20590533",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "mgl. tømning. Nødvendigt, at den skal tømmes på fredag",
          "status": 6,
          "priority": 2,
          "created_at": "2022-03-01T10:46:00+00:00",
          "updated_at": "2025-08-19T00:25:01.073629+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY4Nzk=",
            "location": {
              "latitude": 55.51269,
              "longitude": 9.639385,
              "name": "Brandsøvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MDU3Mg==",
          "ticket_id": "20590572",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Her er standplads? skal hentes i carporten.",
          "status": 6,
          "priority": 2,
          "created_at": "2022-02-21T10:30:00+00:00",
          "updated_at": "2025-08-19T00:25:01.075911+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY4Nzk=",
            "location": {
              "latitude": 55.51269,
              "longitude": 9.639385,
              "name": "Brandsøvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjU4OQ==",
          "ticket_id": "20596589",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "I må køre ind på gårdspladsen",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-13T12:20:00+00:00",
          "updated_at": "2025-08-19T00:25:01.459137+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY4Nzk=",
            "location": {
              "latitude": 55.51269,
              "longitude": 9.639385,
              "name": "Brandsøvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NzAxMg==",
          "ticket_id": "20597012",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-07-09Fraktion: 1 (Mad/Rest)Navn: Niels-Jørgen KovstrupTlf.: 40854125Email: nj@kovstrup.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-12T10:08:00+00:00",
          "updated_at": "2025-08-19T00:25:01.483910+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY4Nzk=",
            "location": {
              "latitude": 55.51269,
              "longitude": 9.639385,
              "name": "Brandsøvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTAzMDQ=",
      "location": {
        "name": "Klintebjerg 1 7000 Fredericia",
        "latitude": 55.512403,
        "longitude": 9.637829
      },
      "containers": [
        {
          "id": "mp-pc-387",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-387",
            "container_id": "MP-7002-391",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTAzMDk=",
      "location": {
        "name": "Klintebjerg 15 7000 Fredericia",
        "latitude": 55.512717,
        "longitude": 9.637129
      },
      "containers": [
        {
          "id": "mp-pc-388",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-388",
            "container_id": "MP-7002-392",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4Nzc4Ng==",
          "ticket_id": "20587786",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Kathrine TøfmarkTlf.: 22134743Email: kathrinemtoefting@gmail.comBesked: klistermærker. til genbrug. hvor finder jeg dem",
          "status": 6,
          "priority": 2,
          "created_at": "2022-08-29T18:25:00+00:00",
          "updated_at": "2025-08-19T00:25:00.832886+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTAzMDk=",
            "location": {
              "latitude": 55.512717,
              "longitude": 9.637129,
              "name": "Klintebjerg 15, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5ODM0Ng==",
          "ticket_id": "20598346",
          "ticket_type": "AO-Ændring til 240 liter beholder til restaffald",
          "description": "Skal gammel beholder hjemtages: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2021-01-28T14:31:00+00:00",
          "updated_at": "2025-08-19T00:25:01.564283+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTAzMDk=",
            "location": {
              "latitude": 55.512717,
              "longitude": 9.637129,
              "name": "Klintebjerg 15, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDcxNTQ=",
      "location": {
        "name": "Klintebjerg 17 7000 Fredericia",
        "latitude": 55.513011,
        "longitude": 9.636769
      },
      "containers": [
        {
          "id": "mp-pc-389",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-389",
            "container_id": "MP-7002-393",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTAzMTA=",
      "location": {
        "name": "Klintebjerg 18 7000 Fredericia",
        "latitude": 55.513363,
        "longitude": 9.636355
      },
      "containers": [
        {
          "id": "mp-pc-390",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-390",
            "container_id": "MP-7002-394",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDcxNTU=",
      "location": {
        "name": "Klintebjerg 20 7000 Fredericia",
        "latitude": 55.513225,
        "longitude": 9.635792
      },
      "containers": [
        {
          "id": "mp-pc-391",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-391",
            "container_id": "MP-7002-395",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTAzMTE=",
      "location": {
        "name": "Klintebjerg 19 7000 Fredericia",
        "latitude": 55.512957,
        "longitude": 9.636188
      },
      "containers": [
        {
          "id": "mp-pc-392",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-392",
            "container_id": "MP-7002-396",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MTMzOA==",
          "ticket_id": "20581338",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: JacobTlf.: 29888698Email: jacobpalm@hotmail.comBesked: Hej! Er det muligt at få tømning hvis skraldespanden ikke er stillet frem, f.eks. under ferie?",
          "status": 6,
          "priority": 2,
          "created_at": "2024-03-18T20:47:00+00:00",
          "updated_at": "2025-08-19T00:25:00.371117+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTAzMTE=",
            "location": {
              "latitude": 55.512957,
              "longitude": 9.636171,
              "name": "Klintebjerg 19, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4ODkwNA==",
          "ticket_id": "20588904",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: JacobTlf.: 29888698Email: jacobpalm@hotmail.comBesked: Hej, alle mine naboer har modtaget sække til genbrug, men jeg fik ingen :(",
          "status": 6,
          "priority": 2,
          "created_at": "2022-06-11T09:50:00+00:00",
          "updated_at": "2025-08-19T00:25:00.927747+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTAzMTE=",
            "location": {
              "latitude": 55.512957,
              "longitude": 9.636171,
              "name": "Klintebjerg 19, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5Nzk2OQ==",
          "ticket_id": "20597969",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: JacobTlf.: 29888698Email: jacobpalm@hotmail.comBesked: Må hundelorteposer komme i madaffald?",
          "status": 6,
          "priority": 2,
          "created_at": "2021-06-26T15:24:00+00:00",
          "updated_at": "2025-08-19T00:25:01.539155+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTAzMTE=",
            "location": {
              "latitude": 55.512957,
              "longitude": 9.636171,
              "name": "Klintebjerg 19, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTAzMTI=",
      "location": {
        "name": "Klintebjerg 22 7000 Fredericia",
        "latitude": 55.512976,
        "longitude": 9.635633
      },
      "containers": [
        {
          "id": "mp-pc-393",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-393",
            "container_id": "MP-7002-397",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MTcwOQ==",
          "ticket_id": "20591709",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Klintebjerg 22 1 (7000 Fredericia) ContainerNr:411451 ContainerBrik: Låg itu Ønsket virkningsdato: 13/01 2022 Besked: Kontaktoplysninger: Gunnar Thaarup",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-06T13:29:00+00:00",
          "updated_at": "2025-08-19T00:25:01.166561+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTAzMTI=",
            "location": {
              "latitude": 55.512976,
              "longitude": 9.635633,
              "name": "Klintebjerg 22, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQ0Mzk=",
      "location": {
        "name": "Klintebjerg 21 7000 Fredericia",
        "latitude": 55.51268736,
        "longitude": 9.63611936
      },
      "containers": [
        {
          "id": "mp-pc-394",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-394",
            "container_id": "MP-7002-398",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDcxNTY=",
      "location": {
        "name": "Klintebjerg 24 7000 Fredericia",
        "latitude": 55.512715,
        "longitude": 9.635304
      },
      "containers": [
        {
          "id": "mp-pc-395",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-395",
            "container_id": "MP-7002-399",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3Njg4NQ==",
          "ticket_id": "20576885",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Fejlsorteret Er der afleveret flyer: Ja Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2025-01-31T08:26:00+00:00",
          "updated_at": "2025-08-19T00:25:00.093930+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDcxNTY=",
            "location": {
              "latitude": 55.512715,
              "longitude": 9.635304,
              "name": "Klintebjerg 24, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4ODA4NA==",
          "ticket_id": "20588084",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Fejlsorteret Er der afleveret flyer: Ja Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2022-08-05T08:49:00+00:00",
          "updated_at": "2025-08-19T00:25:00.849777+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDcxNTY=",
            "location": {
              "latitude": 55.512715,
              "longitude": 9.635304,
              "name": "Klintebjerg 24, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTAzMTM=",
      "location": {
        "name": "Klintebjerg 23 7000 Fredericia",
        "latitude": 55.51251,
        "longitude": 9.635791
      },
      "containers": [
        {
          "id": "mp-pc-396",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-396",
            "container_id": "MP-7002-400",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDYwMDU1Mg==",
          "ticket_id": "20600552",
          "ticket_type": "AO-Ændring til 140 liter beholder til restaffald",
          "description": "I den til sendte aconto for 2017 er restaffald sat til 190 liter, det er for meget, da husstanden kun er på 2 personer. For 2017 skal restaffald være på 140 liter",
          "status": 6,
          "priority": 2,
          "created_at": "2016-12-05T19:37:00+00:00",
          "updated_at": "2025-08-19T00:25:01.701808+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTAzMTM=",
            "location": {
              "latitude": 55.51251,
              "longitude": 9.635791,
              "name": "Klintebjerg 23, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTAzMDU=",
      "location": {
        "name": "Klintebjerg 3 7000 Fredericia",
        "latitude": 55.512314,
        "longitude": 9.637473
      },
      "containers": [
        {
          "id": "mp-pc-397",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-397",
            "container_id": "MP-7002-401",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDcxNTM=",
      "location": {
        "name": "Klintebjerg 13 7000 Fredericia",
        "latitude": 55.512477,
        "longitude": 9.636942
      },
      "containers": [
        {
          "id": "mp-pc-398",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-398",
            "container_id": "MP-7002-402",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4OTk5Mw==",
          "ticket_id": "20589993",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Klintebjerg 13 1 (7000 Fredericia) ContainerNr:408321 ContainerBrik: Håndtag itu Ønsket virkningsdato: 13/08 2021 Besked: Knækket ved tømning Kontaktoplysninger: Marianne Badstue 60551748 m.badstue@gmail.com",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-06T10:20:00+00:00",
          "updated_at": "2025-08-19T00:25:01.035644+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDcxNTM=",
            "location": {
              "latitude": 55.512477,
              "longitude": 9.636942,
              "name": "Klintebjerg 13, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTAzMDg=",
      "location": {
        "name": "Klintebjerg 11 7000 Fredericia",
        "latitude": 55.512364,
        "longitude": 9.636606
      },
      "containers": [
        {
          "id": "mp-pc-399",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-399",
            "container_id": "MP-7002-403",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDYwMDEzOA==",
          "ticket_id": "20600138",
          "ticket_type": "AO-Manglende tømning - grønt affald",
          "description": "Hej Vi har fortsat ikke fået tømt den grønne spand. Mvh Christina",
          "status": 6,
          "priority": 2,
          "created_at": "2017-11-12T21:01:00+00:00",
          "updated_at": "2025-08-19T00:25:01.674807+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTAzMDg=",
            "location": {
              "latitude": 55.512364,
              "longitude": 9.636606,
              "name": "Klintebjerg 11, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDYwMDE0NA==",
          "ticket_id": "20600144",
          "ticket_type": "AO-Manglende tømning - grønt affald",
          "description": "Vores grønne affaldsbeholder er ikke blevet tømt i torsdags.",
          "status": 6,
          "priority": 2,
          "created_at": "2017-11-06T21:02:00+00:00",
          "updated_at": "2025-08-19T00:25:01.675183+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTAzMDg=",
            "location": {
              "latitude": 55.512364,
              "longitude": 9.636606,
              "name": "Klintebjerg 11, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDYwMDIwNQ==",
          "ticket_id": "20600205",
          "ticket_type": "AO-Ændring til 140 liter beholder til grønt affald",
          "description": "Jeg vil gerne bestille en beholder til grønt affald. Der har os bekendt ikke tidligere været en på adressen Skal gammel beholder hjemtages: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2017-09-12T08:46:00+00:00",
          "updated_at": "2025-08-19T00:25:01.678894+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTAzMDg=",
            "location": {
              "latitude": 55.512364,
              "longitude": 9.636606,
              "name": "Klintebjerg 11, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTAzMDY=",
      "location": {
        "name": "Klintebjerg 5 7000 Fredericia",
        "latitude": 55.512142,
        "longitude": 9.637131
      },
      "containers": [
        {
          "id": "mp-pc-400",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-400",
            "container_id": "MP-7002-404",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDcxNTI=",
      "location": {
        "name": "Klintebjerg 9 7000 Fredericia",
        "latitude": 55.512077,
        "longitude": 9.636527
      },
      "containers": [
        {
          "id": "mp-pc-401",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-401",
            "container_id": "MP-7002-405",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTAzMDc=",
      "location": {
        "name": "Klintebjerg 7 7000 Fredericia",
        "latitude": 55.511854,
        "longitude": 9.636986
      },
      "containers": [
        {
          "id": "mp-pc-402",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-402",
            "container_id": "MP-7002-406",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTUwNjE=",
      "location": {
        "name": "Børup Sandevej 46 7000 Fredericia",
        "latitude": 55.5129737,
        "longitude": 9.64278891
      },
      "containers": [
        {
          "id": "mp-pc-403",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-403",
            "container_id": "MP-7002-407",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3OTQ1OQ==",
          "ticket_id": "20579459",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 25/07 2024 Besked: Kontaktoplysninger: Flemming Kolkjær Sørensen",
          "status": 6,
          "priority": 2,
          "created_at": "2024-07-18T14:04:00+00:00",
          "updated_at": "2025-08-19T00:25:00.254989+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUwNjE=",
            "location": {
              "latitude": 55.512973,
              "longitude": 9.642788,
              "name": "Børup Sandevej 46, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY4OTg=",
      "location": {
        "name": "Børup Sandevej 43 7000 Fredericia",
        "latitude": 55.51323,
        "longitude": 9.643772
      },
      "containers": [
        {
          "id": "mp-pc-404",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-404",
            "container_id": "MP-7002-408",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDg1MDc=",
      "location": {
        "name": "Børup Sandevej 50 7000 Fredericia",
        "latitude": 55.512428,
        "longitude": 9.643808
      },
      "containers": [
        {
          "id": "mp-pc-405",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-405",
            "container_id": "MP-7002-409",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDM1Njc=",
      "location": {
        "name": "Børup Sandevej 52 7000 Fredericia",
        "latitude": 55.51212,
        "longitude": 9.644581
      },
      "containers": [
        {
          "id": "mp-pc-406",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-406",
            "container_id": "MP-7002-410",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY5MDE=",
      "location": {
        "name": "Børup Sandevej 55 7000 Fredericia",
        "latitude": 55.512379,
        "longitude": 9.645285
      },
      "containers": [
        {
          "id": "mp-pc-407",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-407",
            "container_id": "MP-7002-411",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3Njk2Ng==",
          "ticket_id": "20576966",
          "ticket_type": "AO-Generel besked",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2025-01-23T10:14:00+00:00",
          "updated_at": "2025-08-19T00:25:00.103075+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY5MDE=",
            "location": {
              "latitude": 55.512379,
              "longitude": 9.645285,
              "name": "Børup Sandevej 55, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3Njk3NA==",
          "ticket_id": "20576974",
          "ticket_type": "AO-Generel besked",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2025-01-22T16:24:00+00:00",
          "updated_at": "2025-08-19T00:25:00.103928+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY5MDE=",
            "location": {
              "latitude": 55.512379,
              "longitude": 9.645285,
              "name": "Børup Sandevej 55, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDg1MDg=",
      "location": {
        "name": "Børup Sandevej 54 7000 Fredericia",
        "latitude": 55.511925,
        "longitude": 9.644452
      },
      "containers": [
        {
          "id": "mp-pc-408",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-408",
            "container_id": "MP-7002-412",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MzU0Ng==",
          "ticket_id": "20593546",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Log viser tømt - beholder er IKKE tømt. Tømmes snarest, tak.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-18T14:12:00+00:00",
          "updated_at": "2025-08-19T00:25:01.272030+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MDg=",
            "location": {
              "latitude": 55.511925,
              "longitude": 9.644452,
              "name": "Børup Sandevej 54, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzU5Nw==",
          "ticket_id": "20593597",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Naboerne har fået tømt!",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-15T10:09:00+00:00",
          "updated_at": "2025-08-19T00:25:01.275029+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MDg=",
            "location": {
              "latitude": 55.511925,
              "longitude": 9.644452,
              "name": "Børup Sandevej 54, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDM1Njg=",
      "location": {
        "name": "Børup Sandevej 56 7000 Fredericia",
        "latitude": 55.511897,
        "longitude": 9.644133
      },
      "containers": [
        {
          "id": "mp-pc-409",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-409",
            "container_id": "MP-7002-413",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQyMDM=",
      "location": {
        "name": "Børup Sandevej 62 7000 Fredericia",
        "latitude": 55.51190597,
        "longitude": 9.64258956
      },
      "containers": [
        {
          "id": "mp-pc-410",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-410",
            "container_id": "MP-7002-414",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5ODMwNA==",
          "ticket_id": "20598304",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Vi har ikke fået tømt affald, som vi skulle have tømt i går. Vh Susanne Larsen",
          "status": 6,
          "priority": 2,
          "created_at": "2021-02-18T08:03:00+00:00",
          "updated_at": "2025-08-19T00:25:01.561758+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQyMDM=",
            "location": {
              "latitude": 55.511905,
              "longitude": 9.642589,
              "name": "Børup Sandevej 62, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5ODM2NQ==",
          "ticket_id": "20598365",
          "ticket_type": "AO-Generel besked",
          "description": "Manglende afhentning af Genbrugssække (plast, pap, glas mm) den 21. januar 2021. Lastbilen var nede ved Børup Sande, men der blev ikke afhentet noget hos os.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-01-21T09:49:00+00:00",
          "updated_at": "2025-08-19T00:25:01.565723+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQyMDM=",
            "location": {
              "latitude": 55.511905,
              "longitude": 9.642589,
              "name": "Børup Sandevej 62, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQyMDQ=",
      "location": {
        "name": "Børup Sandevej 66 7000 Fredericia",
        "latitude": 55.51141006,
        "longitude": 9.64390292
      },
      "containers": [
        {
          "id": "mp-pc-411",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-411",
            "container_id": "MP-7002-415",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NDE4OQ==",
          "ticket_id": "20594189",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Vi har ikke fået tømt vores spand 2 gange nu - seneste tømning skulle have været i fredags (3/9). mvh Jørgen Lindegaard",
          "status": 6,
          "priority": 2,
          "created_at": "2021-09-05T11:06:00+00:00",
          "updated_at": "2025-08-19T00:25:01.310557+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQyMDQ=",
            "location": {
              "latitude": 55.51141,
              "longitude": 9.643902,
              "name": "Børup Sandevej 66, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjMxMw==",
          "ticket_id": "20596313",
          "ticket_type": "AO-Generel besked",
          "description": "Gl. beholder ej afhentet. Lovet afh. ved ekstra opsamling efter uge 30.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-21T09:16:00+00:00",
          "updated_at": "2025-08-19T00:25:01.442225+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQyMDQ=",
            "location": {
              "latitude": 55.51141,
              "longitude": 9.643902,
              "name": "Børup Sandevej 66, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NzEzMg==",
          "ticket_id": "20597132",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Ekstra sæk medtaget Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-09T07:40:00+00:00",
          "updated_at": "2025-08-19T00:25:01.490535+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQyMDQ=",
            "location": {
              "latitude": 55.51141,
              "longitude": 9.643902,
              "name": "Børup Sandevej 66, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDg1MDk=",
      "location": {
        "name": "Børup Sandevej 58 7000 Fredericia",
        "latitude": 55.512283,
        "longitude": 9.64311
      },
      "containers": [
        {
          "id": "mp-pc-412",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-412",
            "container_id": "MP-7002-416",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI2Mjg=",
      "location": {
        "name": "Birkholmvej 23 7000 Fredericia",
        "latitude": 55.513417,
        "longitude": 9.638297
      },
      "containers": [
        {
          "id": "mp-pc-413",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-413",
            "container_id": "MP-7002-417",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDYwMDM4Mw==",
          "ticket_id": "20600383",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "Ãnsker at købe en ny Kompostbeholder, da den gamle er ved at være træt.",
          "status": 6,
          "priority": 2,
          "created_at": "2017-05-09T16:52:00+00:00",
          "updated_at": "2025-08-19T00:25:01.689881+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI2Mjg=",
            "location": {
              "latitude": 55.513417,
              "longitude": 9.638297,
              "name": "Birkholmvej 23, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDYwMDM4NA==",
          "ticket_id": "20600384",
          "ticket_type": "AO-Ændring til 80-90 liter beholder til restaffald",
          "description": "Har en 140 l restbeholder, ønsker at skifte til en 80-90 liter.",
          "status": 6,
          "priority": 2,
          "created_at": "2017-05-09T16:49:00+00:00",
          "updated_at": "2025-08-19T00:25:01.689929+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI2Mjg=",
            "location": {
              "latitude": 55.513417,
              "longitude": 9.638297,
              "name": "Birkholmvej 23, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU1ODc=",
      "location": {
        "name": "Birkholmvej 13 7000 Fredericia",
        "latitude": 55.513573,
        "longitude": 9.638615
      },
      "containers": [
        {
          "id": "mp-pc-414",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-414",
            "container_id": "MP-7002-418",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU1OTE=",
      "location": {
        "name": "Birkholmvej 21 7000 Fredericia",
        "latitude": 55.513275,
        "longitude": 9.638641
      },
      "containers": [
        {
          "id": "mp-pc-415",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-415",
            "container_id": "MP-7002-419",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3OTAyNA==",
          "ticket_id": "20579024",
          "ticket_type": "AO-Generel besked",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2024-08-05T17:57:00+00:00",
          "updated_at": "2025-08-19T00:25:00.230677+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1OTE=",
            "location": {
              "latitude": 55.513275,
              "longitude": 9.638641,
              "name": "Birkholmvej 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NjI1OA==",
          "ticket_id": "20586258",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: 2-delt 240 l beholder - Parcel Birkholmvej 21 1 (7000 Fredericia) ContainerNr:406754 ContainerBrik:0040000012640278 Ønsket virkningsdato: 10/01 2023 Besked: Kontaktoplysninger: Steffen Busk Jespersen",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-03T12:28:00+00:00",
          "updated_at": "2025-08-19T00:25:00.684961+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1OTE=",
            "location": {
              "latitude": 55.513275,
              "longitude": 9.638641,
              "name": "Birkholmvej 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjI3Mg==",
          "ticket_id": "20596272",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "2 gamle rest og 1 grøn beholder ej tømt fredag den 9.7. Tømmes hurtigst muligt. Overskydende affald står i sække ved siden af og tages med.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-21T10:20:00+00:00",
          "updated_at": "2025-08-19T00:25:01.440171+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1OTE=",
            "location": {
              "latitude": 55.513275,
              "longitude": 9.638641,
              "name": "Birkholmvej 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI2MjY=",
      "location": {
        "name": "Birkholmvej 15 7000 Fredericia",
        "latitude": 55.513476,
        "longitude": 9.639064
      },
      "containers": [
        {
          "id": "mp-pc-416",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-416",
            "container_id": "MP-7002-420",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU1OTA=",
      "location": {
        "name": "Birkholmvej 19 7000 Fredericia",
        "latitude": 55.513092,
        "longitude": 9.639035
      },
      "containers": [
        {
          "id": "mp-pc-417",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-417",
            "container_id": "MP-7002-421",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MTkxMg==",
          "ticket_id": "20581912",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2024-01-19Fraktion: 1 (Mad/Rest)Navn: Jens Bach Hansen Tlf.: 51642602Email: jenslh83@gmail.comBesked: Beholder stod ved indkørsel. Nabo nr 15s beholder stod ved os, men vores nr 19 stod urørt",
          "status": 6,
          "priority": 2,
          "created_at": "2024-02-02T07:37:00+00:00",
          "updated_at": "2025-08-19T00:25:00.407626+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1OTA=",
            "location": {
              "latitude": 55.513092,
              "longitude": 9.639035,
              "name": "Birkholmvej 19, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDYwMDIxOQ==",
          "ticket_id": "20600219",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "Hej Vi vil gerne købe en kompostbeholder til grønt affald, så vi selv kan kompostere. Hvor skal vi hente/købe den? Vi vil også gerne skifte til en større beholder til restaffald, men ved ikke hvor stor vores nuværende beholder er, da vi ikke selv har tilmeldt beholderen. Kan I hvad der er tilmeldt på adressen? Eller kan man se et sted på beholderen hvor stor den er? Mvh Tina Jørgensen",
          "status": 6,
          "priority": 2,
          "created_at": "2017-08-31T19:21:00+00:00",
          "updated_at": "2025-08-19T00:25:01.679736+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1OTA=",
            "location": {
              "latitude": 55.513092,
              "longitude": 9.639035,
              "name": "Birkholmvej 19, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDYwMDI0MA==",
          "ticket_id": "20600240",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "Hej Den kompostbeholder som man kan købe via affaldonline til haven, er det af mærket humus eller hvilket mærke er det? Mvh Tina Jørgensen",
          "status": 6,
          "priority": 2,
          "created_at": "2017-08-14T18:50:00+00:00",
          "updated_at": "2025-08-19T00:25:01.680949+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1OTA=",
            "location": {
              "latitude": 55.513092,
              "longitude": 9.639035,
              "name": "Birkholmvej 19, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDYwMDI0NA==",
          "ticket_id": "20600244",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "Hej Hvilken slags kompostbeholder er det man kan købe via affaldonline? - Hvad hedder den? På forhånd tak for hjælpen. Mvh Tina Bach Jørgensen",
          "status": 6,
          "priority": 2,
          "created_at": "2017-08-14T14:16:00+00:00",
          "updated_at": "2025-08-19T00:25:01.681200+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1OTA=",
            "location": {
              "latitude": 55.513092,
              "longitude": 9.639035,
              "name": "Birkholmvej 19, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU1OTI=",
      "location": {
        "name": "Birkholmvej 22 7000 Fredericia",
        "latitude": 55.513376,
        "longitude": 9.637368
      },
      "containers": [
        {
          "id": "mp-pc-418",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-418",
            "container_id": "MP-7002-422",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NDcwOA==",
          "ticket_id": "20584708",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Adgangsvej spærret Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-26T07:09:00+00:00",
          "updated_at": "2025-08-19T00:25:00.576313+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1OTI=",
            "location": {
              "latitude": 55.513376,
              "longitude": 9.637368,
              "name": "Birkholmvej 22, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU1ODg=",
      "location": {
        "name": "Birkholmvej 14 7000 Fredericia",
        "latitude": 55.513684,
        "longitude": 9.637467
      },
      "containers": [
        {
          "id": "mp-pc-419",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-419",
            "container_id": "MP-7002-423",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NDcxMQ==",
          "ticket_id": "20584711",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Adgangsvej spærret Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-26T07:09:00+00:00",
          "updated_at": "2025-08-19T00:25:00.576761+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1ODg=",
            "location": {
              "latitude": 55.513684,
              "longitude": 9.637467,
              "name": "Birkholmvej 14, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NzU3MA==",
          "ticket_id": "20587570",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Navn: Anne Sophie MikkelsenTlf.: 61467677Email: as_mik@msn.comBesked: Vi har for første gang nogensinde glemt, at sætte vores skraldespand ud til skel, så den er ikke blevet tømt. Jeg har fuld forståelse for, at I har nogle regler, men det undre mig, at jeres medarbejdere af princip ikke vil gå de 20 meter hen og hente vores skraldespand. En pædagog kunne da ik drømme om, at sætte et barn uden for lågen, hvis forældrene kommer 5 min efter lukketid. Det er ærgerligt, at I ikke har den mindste smu",
          "status": 6,
          "priority": 2,
          "created_at": "2022-09-16T11:39:00+00:00",
          "updated_at": "2025-08-19T00:25:00.811878+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1ODg=",
            "location": {
              "latitude": 55.513684,
              "longitude": 9.637467,
              "name": "Birkholmvej 14, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc1MjY=",
      "location": {
        "name": "Birkholmvej 20 7000 Fredericia",
        "latitude": 55.513483,
        "longitude": 9.637028
      },
      "containers": [
        {
          "id": "mp-pc-420",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-420",
            "container_id": "MP-7002-424",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NDcwOQ==",
          "ticket_id": "20584709",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Adgangsvej spærret Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-26T07:09:00+00:00",
          "updated_at": "2025-08-19T00:25:00.576515+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc1MjY=",
            "location": {
              "latitude": 55.513483,
              "longitude": 9.637028,
              "name": "Birkholmvej 20, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTI2Mjc=",
      "location": {
        "name": "Birkholmvej 18 7000 Fredericia",
        "latitude": 55.513632,
        "longitude": 9.636895
      },
      "containers": [
        {
          "id": "mp-pc-421",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-421",
            "container_id": "MP-7002-425",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDUzMTQzOA==",
          "ticket_id": "10531438",
          "ticket_type": "Affaldet skal sorteres som restaffald",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2025-01-30T09:05:56.326927+00:00",
          "updated_at": "2025-01-30T09:05:56.328235+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI2Mjc=",
            "location": {
              "latitude": 55.513632,
              "longitude": 9.636895,
              "name": "Birkholmvej 18, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20732_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MTk0NQ==",
          "ticket_id": "20581945",
          "ticket_type": "AO-Generel besked",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2024-01-31T00:19:00+00:00",
          "updated_at": "2025-08-19T00:25:00.409189+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI2Mjc=",
            "location": {
              "latitude": 55.513632,
              "longitude": 9.636895,
              "name": "Birkholmvej 18, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDcxMA==",
          "ticket_id": "20584710",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Adgangsvej spærret Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-26T07:09:00+00:00",
          "updated_at": "2025-08-19T00:25:00.576645+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTI2Mjc=",
            "location": {
              "latitude": 55.513632,
              "longitude": 9.636895,
              "name": "Birkholmvej 18, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU1OTM=",
      "location": {
        "name": "Birkholmvej 25 7000 Fredericia",
        "latitude": 55.513224,
        "longitude": 9.637914
      },
      "containers": [
        {
          "id": "mp-pc-422",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-422",
            "container_id": "MP-7002-426",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MzY2OA==",
          "ticket_id": "20583668",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Finn KaadTlf.: 40428881Email: finnkaadjensen@gmail.comBesked: Hvornår er det adviseret at  glas og metaldåser skal skilles i 2 sække? . Vh. Finn Kaad.",
          "status": 6,
          "priority": 2,
          "created_at": "2023-09-25T10:29:00+00:00",
          "updated_at": "2025-08-19T00:25:00.514248+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1OTM=",
            "location": {
              "latitude": 55.513224,
              "longitude": 9.637914,
              "name": "Birkholmvej 25, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU1OTY=",
      "location": {
        "name": "Birkholmvej 35 7000 Fredericia",
        "latitude": 55.512999,
        "longitude": 9.637713
      },
      "containers": [
        {
          "id": "mp-pc-423",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-423",
            "container_id": "MP-7002-427",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDAyNTU5Mg==",
          "ticket_id": "10025592",
          "ticket_type": "Affaldet skal afleveres på genbrugspladsen",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-02-29T09:04:23.486393+00:00",
          "updated_at": "2024-02-29T09:04:23.495155+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1OTY=",
            "location": {
              "latitude": 55.512999,
              "longitude": 9.637713,
              "name": "Birkholmvej 35, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20743_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZTo5OTk5OTQz",
          "ticket_id": "9999943",
          "ticket_type": "Gavepapir- og bånd er restaffald",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-01-30T10:23:19.573056+00:00",
          "updated_at": "2024-01-30T10:23:19.588700+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1OTY=",
            "location": {
              "latitude": 55.512999,
              "longitude": 9.637713,
              "name": "Birkholmvej 35, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20743_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU1OTQ=",
      "location": {
        "name": "Birkholmvej 27 7000 Fredericia",
        "latitude": 55.513096,
        "longitude": 9.638367
      },
      "containers": [
        {
          "id": "mp-pc-424",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-424",
            "container_id": "MP-7002-428",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MzU5NA==",
          "ticket_id": "20593594",
          "ticket_type": "AO-Generel besked",
          "description": "Beholder ikke stillet hvor den bliver taget. Låge til haven er påkørt og skrammet, samt den er ikke lukket, så hund kan løbe ud..!! Vil I venligst sørge for at informere turen om dette og ændre det, tak.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-15T10:41:00+00:00",
          "updated_at": "2025-08-19T00:25:01.274891+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDU1OTQ=",
            "location": {
              "latitude": 55.513096,
              "longitude": 9.638367,
              "name": "Birkholmvej 27, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc1Mjg=",
      "location": {
        "name": "Birkholmvej 33 7000 Fredericia",
        "latitude": 55.512847,
        "longitude": 9.638015
      },
      "containers": [
        {
          "id": "mp-pc-425",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-425",
            "container_id": "MP-7002-429",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDU1OTU=",
      "location": {
        "name": "Birkholmvej 29 7000 Fredericia",
        "latitude": 55.512859,
        "longitude": 9.63861
      },
      "containers": [
        {
          "id": "mp-pc-426",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-426",
            "container_id": "MP-7002-430",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc1Mjc=",
      "location": {
        "name": "Birkholmvej 31 7000 Fredericia",
        "latitude": 55.512719,
        "longitude": 9.638357
      },
      "containers": [
        {
          "id": "mp-pc-427",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-427",
            "container_id": "MP-7002-431",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZTo5NjY0NzY3",
          "ticket_id": "9664767",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2023-10-24T08:11:06.329791+00:00",
          "updated_at": "2023-10-24T08:11:06.339267+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc1Mjc=",
            "location": {
              "latitude": 55.512719,
              "longitude": 9.638357,
              "name": "Birkholmvej 31, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "20741_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTczMjU=",
      "location": {
        "name": "Agersøvænget 2 7000 Fredericia",
        "latitude": 55.52044369,
        "longitude": 9.64459605
      },
      "containers": [
        {
          "id": "mp-pc-428",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-428",
            "container_id": "MP-7002-432",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NDg0NQ==",
          "ticket_id": "20584845",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Carsten PedersenTlf.: 40324100Email: ctp@atbiler.dkBesked: Får vi ikke genbrugssække længere? Vi har ikke fået de sidste par måneder.",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-07T18:59:00+00:00",
          "updated_at": "2025-08-19T00:25:00.584007+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczMjU=",
            "location": {
              "latitude": 55.520443,
              "longitude": 9.644596,
              "name": "Agersøvænget 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTczOTA=",
      "location": {
        "name": "Agersøvænget 28 7000 Fredericia",
        "latitude": 55.520401,
        "longitude": 9.64385
      },
      "containers": [
        {
          "id": "mp-pc-429",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-429",
            "container_id": "MP-7002-433",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTczMjI=",
      "location": {
        "name": "Agersøvænget 4 7000 Fredericia",
        "latitude": 55.52066112,
        "longitude": 9.64460656
      },
      "containers": [
        {
          "id": "mp-pc-430",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-430",
            "container_id": "MP-7002-434",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5OTI3NA==",
          "ticket_id": "20599274",
          "ticket_type": "AO-Bestilling af sommertømning  (15/6 - 15/8)",
          "description": "Hej Fredericia Kommune Vi er for nyligt flyttet til Fredericia Kommune, og i den forbindelse har vi misforstået konceptet bag sommertømning. Vi har tilmeldt os sommertømning, men det var kun fordi vi troede at elles vil der ikke blive tømt affald om sommeren. Det var så en forkert antagelse fra vores side af. Vi er meget tilfredse med 14 dages tømning året rundt, og har ikke behov for ugentlig sommertømning, vi ønsker derfor at afmelde sommertømnings ordningen.",
          "status": 6,
          "priority": 2,
          "created_at": "2019-07-01T11:43:00+00:00",
          "updated_at": "2025-08-19T00:25:01.620546+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczMjI=",
            "location": {
              "latitude": 55.520661,
              "longitude": 9.644606,
              "name": "Agersøvænget 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTMwOQ==",
          "ticket_id": "20599309",
          "ticket_type": "AO-Ændring til 240 liter beholder til restaffald",
          "description": "Hej Fredericia Affald Vi har desværre fundet ud af at vi har brug for større affald beholder, fordi vi har her i Maj måned fået et barn mere i familien. Dermed ønsker vi at bytte vores 140 liter beholder til 240 liter mvh Ingolfur Thor Gudmundsson Skal gammel beholder hjemtages: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2019-06-08T08:24:00+00:00",
          "updated_at": "2025-08-19T00:25:01.622701+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczMjI=",
            "location": {
              "latitude": 55.520661,
              "longitude": 9.644606,
              "name": "Agersøvænget 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTczMzA=",
      "location": {
        "name": "Agersøvænget 8 7000 Fredericia",
        "latitude": 55.52090528,
        "longitude": 9.64406383
      },
      "containers": [
        {
          "id": "mp-pc-431",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-431",
            "container_id": "MP-7002-435",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTczMDE=",
      "location": {
        "name": "Agersøvænget 12 7000 Fredericia",
        "latitude": 55.52068699,
        "longitude": 9.64329309
      },
      "containers": [
        {
          "id": "mp-pc-432",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-432",
            "container_id": "MP-7002-436",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDE5MjQyNQ==",
          "ticket_id": "10192425",
          "ticket_type": "Ekstra tømning - Rest",
          "description": "",
          "status": 2,
          "priority": 2,
          "created_at": "2024-09-03T07:09:18.672087+00:00",
          "updated_at": "2024-09-03T07:09:18.695862+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": {
            "name": null
          },
          "assignee": {
            "name": null,
            "phone_number": "+4560481851"
          },
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczMDE=",
            "location": {
              "latitude": 55.520637,
              "longitude": 9.643364,
              "name": "Agersøvænget 12, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "417483",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "name": "2-delt 240 L"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToxMDE5MjQyNA==",
          "ticket_id": "10192424",
          "ticket_type": "Manglende tømning - Genbrug",
          "description": "",
          "status": 2,
          "priority": 2,
          "created_at": "2024-09-03T07:08:54.964822+00:00",
          "updated_at": "2024-09-03T07:08:54.987835+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": {
            "name": null
          },
          "assignee": {
            "name": null,
            "phone_number": "+4560481851"
          },
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczMDE=",
            "location": {
              "latitude": 55.520637,
              "longitude": 9.643364,
              "name": "Agersøvænget 12, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "417483",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "name": "2-delt 240 L"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToxMDE5MjQyMw==",
          "ticket_id": "10192423",
          "ticket_type": "Manglende tømning - Rest",
          "description": "test",
          "status": 2,
          "priority": 2,
          "created_at": "2024-09-03T07:07:39.971321+00:00",
          "updated_at": "2024-09-03T07:07:39.991665+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": {
            "name": null
          },
          "assignee": {
            "name": null,
            "phone_number": "+4560481851"
          },
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczMDE=",
            "location": {
              "latitude": 55.520637,
              "longitude": 9.643364,
              "name": "Agersøvænget 12, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "417483",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "name": "2-delt 240 L"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc1NjQ=",
      "location": {
        "name": "Agersøvænget 10 7000 Fredericia",
        "latitude": 55.52078022,
        "longitude": 9.64363446
      },
      "containers": [
        {
          "id": "mp-pc-433",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-433",
            "container_id": "MP-7002-437",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3OTU2MA==",
          "ticket_id": "20579560",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 23/07 2024 Besked: Kontaktoplysninger: Christina Hjarsbech Larsen",
          "status": 6,
          "priority": 2,
          "created_at": "2024-07-16T08:19:00+00:00",
          "updated_at": "2025-08-19T00:25:00.261103+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc1NjQ=",
            "location": {
              "latitude": 55.52078,
              "longitude": 9.643634,
              "name": "Agersøvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzUzOA==",
          "ticket_id": "20593538",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 19/10-2021 Besked: Kontaktoplysninger: Egon H U Nielsen",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-19T11:36:00+00:00",
          "updated_at": "2025-08-19T00:25:01.271585+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc1NjQ=",
            "location": {
              "latitude": 55.52078,
              "longitude": 9.643634,
              "name": "Agersøvænget 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTcyNzE=",
      "location": {
        "name": "Agersøvænget 14 7000 Fredericia",
        "latitude": 55.52051907,
        "longitude": 9.64295307
      },
      "containers": [
        {
          "id": "mp-pc-434",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-434",
            "container_id": "MP-7002-438",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTcyNzI=",
      "location": {
        "name": "Agersøvænget 16 7000 Fredericia",
        "latitude": 55.52040803,
        "longitude": 9.64251802
      },
      "containers": [
        {
          "id": "mp-pc-435",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-435",
            "container_id": "MP-7002-439",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5OTY3OA==",
          "ticket_id": "20599678",
          "ticket_type": "AO-Ændring til kompostbeholder",
          "description": "Hej, Vi ønsker at få fjernet vores beholder til Grønt affald. Hvordan gør vi det nemmest. mvh Agersøvænget 16",
          "status": 6,
          "priority": 2,
          "created_at": "2018-09-09T19:12:00+00:00",
          "updated_at": "2025-08-19T00:25:01.644002+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcyNzI=",
            "location": {
              "latitude": 55.520336,
              "longitude": 9.642504,
              "name": "Agersøvænget 16, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTY3OQ==",
          "ticket_id": "20599679",
          "ticket_type": "AO-Ændring til 240 liter beholder til restaffald",
          "description": "Hej, Vi ønsker at ændre restaffald beholder. Skal gammel beholder hjemtages: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2018-09-09T19:11:00+00:00",
          "updated_at": "2025-08-19T00:25:01.644058+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTcyNzI=",
            "location": {
              "latitude": 55.520336,
              "longitude": 9.642504,
              "name": "Agersøvænget 16, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTczNjU=",
      "location": {
        "name": "Agersøvænget 24 7000 Fredericia",
        "latitude": 55.52025863,
        "longitude": 9.64300712
      },
      "containers": [
        {
          "id": "mp-pc-436",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-436",
            "container_id": "MP-7002-440",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MzMwNA==",
          "ticket_id": "20593304",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Agersøvænget 24 (7000 Fredericia) ContainerNr:417540 ContainerBrik: Håndtag itu Ønsket virkningsdato: 01/11-2021 Besked: Kontaktoplysninger: Søren Ellegaard",
          "status": 6,
          "priority": 2,
          "created_at": "2021-11-01T11:08:00+00:00",
          "updated_at": "2025-08-19T00:25:01.258803+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczNjU=",
            "location": {
              "latitude": 55.520193,
              "longitude": 9.643142,
              "name": "Agersøvænget 24, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTAyNQ==",
          "ticket_id": "20591025",
          "ticket_type": "AO-Håndtag itu (vedhæft evt foto - kun på web)",
          "description": "Navn: Søren EllegaardTlf.: 20612196Email: ellegaard1987@gmail.comBesked: Håndtag itu efter dagens tømning",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-29T14:36:00+00:00",
          "updated_at": "2025-08-19T00:25:01.117117+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTczNjU=",
            "location": {
              "latitude": 55.520193,
              "longitude": 9.643142,
              "name": "Agersøvænget 24, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc1Mzg=",
      "location": {
        "name": "Agersøvænget 18 7000 Fredericia",
        "latitude": 55.52028462,
        "longitude": 9.64215079
      },
      "containers": [
        {
          "id": "mp-pc-437",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-437",
            "container_id": "MP-7002-441",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NzA2OQ==",
          "ticket_id": "20587069",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "Hej. Kan man bestille en ekstra affaldsbeholder?",
          "status": 6,
          "priority": 2,
          "created_at": "2022-11-08T15:03:00+00:00",
          "updated_at": "2025-08-19T00:25:00.757793+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc1Mzg=",
            "location": {
              "latitude": 55.520284,
              "longitude": 9.64215,
              "name": "Agersøvænget 18, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDgwNw==",
          "ticket_id": "20594807",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 31/08 2021 Besked: Kontaktoplysninger: Nikolaj Nygaard Buhl 60240135 Nikolaj.buhl@live.dk",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-24T07:51:00+00:00",
          "updated_at": "2025-08-19T00:25:01.349426+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc1Mzg=",
            "location": {
              "latitude": 55.520284,
              "longitude": 9.64215,
              "name": "Agersøvænget 18, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDgwOA==",
          "ticket_id": "20594808",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 31/08 2021 Besked: Kontaktoplysninger: Nikolaj Nygaard Buhl 60240135 Nikolaj.buhl@live.dk",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-24T07:50:00+00:00",
          "updated_at": "2025-08-19T00:25:01.349489+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc1Mzg=",
            "location": {
              "latitude": 55.520284,
              "longitude": 9.64215,
              "name": "Agersøvænget 18, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc1MTg=",
      "location": {
        "name": "Agersøvænget 20 7000 Fredericia",
        "latitude": 55.52010725,
        "longitude": 9.64252951
      },
      "containers": [
        {
          "id": "mp-pc-438",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-438",
            "container_id": "MP-7002-442",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MTY5Ng==",
          "ticket_id": "20581696",
          "ticket_type": "AO-Generel besked",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2024-02-15T19:52:00+00:00",
          "updated_at": "2025-08-19T00:25:00.391571+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc1MTg=",
            "location": {
              "latitude": 55.520107,
              "longitude": 9.642529,
              "name": "Agersøvænget 20, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc1MzY=",
      "location": {
        "name": "Agersøvænget 22 7000 Fredericia",
        "latitude": 55.51992261,
        "longitude": 9.6427609
      },
      "containers": [
        {
          "id": "mp-pc-439",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-439",
            "container_id": "MP-7002-443",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NTMwNg==",
          "ticket_id": "20595306",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 16/08 2021 Besked: Kontaktoplysninger: Malene Hansen",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-09T14:25:00+00:00",
          "updated_at": "2025-08-19T00:25:01.379617+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc1MzY=",
            "location": {
              "latitude": 55.519922,
              "longitude": 9.64276,
              "name": "Agersøvænget 22, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NzY4Mg==",
          "ticket_id": "20597682",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "Navn: Malene HansenTlf.: 20317160Email: malone-5@hotmail.comBesked: Vi er flyttet ind på Agersøvænget 22 (Skærbæk) og i den forbindelse bestilt en beholder. Modtaget beholder er ikke to-delt efter den nye renovatør. Hvornår modtager vi denne? Vh Malene",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-04T20:32:00+00:00",
          "updated_at": "2025-08-19T00:25:01.523184+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc1MzY=",
            "location": {
              "latitude": 55.519922,
              "longitude": 9.64276,
              "name": "Agersøvænget 22, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc1MTk=",
      "location": {
        "name": "Agersøvænget 9 7000 Fredericia",
        "latitude": 55.519682,
        "longitude": 9.643348
      },
      "containers": [
        {
          "id": "mp-pc-440",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-440",
            "container_id": "MP-7002-444",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc1MjI=",
      "location": {
        "name": "Agersøvænget 7 7000 Fredericia",
        "latitude": 55.5198486,
        "longitude": 9.64367289
      },
      "containers": [
        {
          "id": "mp-pc-441",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-441",
            "container_id": "MP-7002-445",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MjY2Ng==",
          "ticket_id": "20592666",
          "ticket_type": "AO-Generel besked",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-09T13:41:00+00:00",
          "updated_at": "2025-08-19T00:25:01.222435+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc1MjI=",
            "location": {
              "latitude": 55.519848,
              "longitude": 9.643672,
              "name": "Agersøvænget 7, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc3MjU=",
      "location": {
        "name": "Omøvænget 8 7000 Fredericia",
        "latitude": 55.52043531,
        "longitude": 9.64619314
      },
      "containers": [
        {
          "id": "mp-pc-442",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-442",
            "container_id": "MP-7002-446",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4Mjk3MA==",
          "ticket_id": "20582970",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Ekstra tømning bestilt af ejer. Kommer i kommunemail.",
          "status": 6,
          "priority": 2,
          "created_at": "2023-12-12T07:49:00+00:00",
          "updated_at": "2025-08-19T00:25:00.466162+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MjU=",
            "location": {
              "latitude": 55.520435,
              "longitude": 9.646193,
              "name": "Omøvænget 8, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4Mjk5OA==",
          "ticket_id": "20582998",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2023-12-08Fraktion: 1 (Mad/Rest)Navn: Rasmus Tlf.: 42142209Email: Rasmus.Hartmann.madsen@gmail.comBesked: Vi er lige flyttet ind og har haft brolæggere igang i indførelsen - jeg tror derfor i har overset skraldespanden. Men 3 fødselsdage og en nu fyldt beholder bliver i nød til og komme og tømme den hurtigst muligt.",
          "status": 6,
          "priority": 2,
          "created_at": "2023-12-09T11:17:00+00:00",
          "updated_at": "2025-08-19T00:25:00.467620+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MjU=",
            "location": {
              "latitude": 55.520435,
              "longitude": 9.646193,
              "name": "Omøvænget 8, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MzIwNg==",
          "ticket_id": "20583206",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 17/11-2023 Besked: Kontaktoplysninger: Rasmus Hartmann Hald",
          "status": 6,
          "priority": 2,
          "created_at": "2023-11-17T11:11:00+00:00",
          "updated_at": "2025-08-19T00:25:00.487057+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MjU=",
            "location": {
              "latitude": 55.520435,
              "longitude": 9.646193,
              "name": "Omøvænget 8, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MzQyMA==",
          "ticket_id": "20583420",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 21/11-2023 Besked: Kontaktoplysninger: Rasmus Hartmann Hald",
          "status": 6,
          "priority": 2,
          "created_at": "2023-10-24T08:59:00+00:00",
          "updated_at": "2025-08-19T00:25:00.499431+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MjU=",
            "location": {
              "latitude": 55.520435,
              "longitude": 9.646193,
              "name": "Omøvænget 8, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MzQyMQ==",
          "ticket_id": "20583421",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 21/11-2023 Besked: Bestilt af borger, Rasmus Hartmann Hald. Indflytning den 21-11-2023. Kontaktoplysninger: Rasmus Hartmann Hald",
          "status": 6,
          "priority": 2,
          "created_at": "2023-10-24T08:58:00+00:00",
          "updated_at": "2025-08-19T00:25:00.499491+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc3MjU=",
            "location": {
              "latitude": 55.520435,
              "longitude": 9.646193,
              "name": "Omøvænget 8, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc2NDg=",
      "location": {
        "name": "Omøvænget 13 7000 Fredericia",
        "latitude": 55.521685,
        "longitude": 9.647637
      },
      "containers": [
        {
          "id": "mp-pc-443",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-443",
            "container_id": "MP-7002-448",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3OTczNA==",
          "ticket_id": "20579734",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 17/07 2024 Besked: Kontaktoplysninger: Steffen Arntoft Paulsen",
          "status": 6,
          "priority": 2,
          "created_at": "2024-07-10T14:32:00+00:00",
          "updated_at": "2025-08-19T00:25:00.270446+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2NDg=",
            "location": {
              "latitude": 55.521685,
              "longitude": 9.647637,
              "name": "Omøvænget 13, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4ODg0NQ==",
          "ticket_id": "20588845",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Manglende tømning her var sat frem dagen i forvejen.",
          "status": 6,
          "priority": 2,
          "created_at": "2022-06-14T10:17:00+00:00",
          "updated_at": "2025-08-19T00:25:00.924338+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2NDg=",
            "location": {
              "latitude": 55.521685,
              "longitude": 9.647637,
              "name": "Omøvænget 13, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4ODkwNQ==",
          "ticket_id": "20588905",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Beholderen er ikke tømt. Den stod helt ude ved vejen",
          "status": 6,
          "priority": 2,
          "created_at": "2022-06-10T12:34:00+00:00",
          "updated_at": "2025-08-19T00:25:00.927800+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2NDg=",
            "location": {
              "latitude": 55.521685,
              "longitude": 9.647637,
              "name": "Omøvænget 13, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4OTA3MA==",
          "ticket_id": "20589070",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Der blev ikke tømt her i fredags - måske fordi de endnu ikke har modtaget en beholder, da deter en ny parcel. Nødvendigt at der hentes sække i dag.",
          "status": 6,
          "priority": 2,
          "created_at": "2022-05-31T10:00:00+00:00",
          "updated_at": "2025-08-19T00:25:00.942805+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2NDg=",
            "location": {
              "latitude": 55.521685,
              "longitude": 9.647637,
              "name": "Omøvænget 13, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4OTA3Nw==",
          "ticket_id": "20589077",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Ekstra tømning uden beregning. Der er sendt mail til kommune@mariuspedersen.dk. Deres beholder er ikke kommet, så det er sække, de har stående efter aftale.",
          "status": 6,
          "priority": 2,
          "created_at": "2022-05-30T11:07:00+00:00",
          "updated_at": "2025-08-19T00:25:00.943541+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2NDg=",
            "location": {
              "latitude": 55.521685,
              "longitude": 9.647637,
              "name": "Omøvænget 13, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4OTA3OA==",
          "ticket_id": "20589078",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Navn: Anika Paulsen Tlf.: 29619211Email: Anika.arntoft@gmail.comBesked: Hej, vi skulle ha leveret skraldespand den 19/5 men grundet flere fejl fra jer har vi endnu ikke modtaget skraldespand. Jeg aftalte derfor med din kollega at vi blot skulle bruge affaldssække og sætte dem frem. De blev IKKE taget med i fredags, da der var tømning af mad/rest. Vil i sørge for at dette bliver afhentet. Mvh Anika",
          "status": 6,
          "priority": 2,
          "created_at": "2022-05-30T07:21:00+00:00",
          "updated_at": "2025-08-19T00:25:00.943639+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2NDg=",
            "location": {
              "latitude": 55.521685,
              "longitude": 9.647637,
              "name": "Omøvænget 13, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4OTIxOQ==",
          "ticket_id": "20589219",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 18/05-2022 Besked: Kontaktoplysninger: Steffen Arntoft Paulsen",
          "status": 6,
          "priority": 2,
          "created_at": "2022-05-17T13:30:00+00:00",
          "updated_at": "2025-08-19T00:25:00.958184+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2NDg=",
            "location": {
              "latitude": 55.521685,
              "longitude": 9.647637,
              "name": "Omøvænget 13, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc2NDk=",
      "location": {
        "name": "Omøvænget 24 7000 Fredericia",
        "latitude": 55.52101798,
        "longitude": 9.6480587
      },
      "containers": [
        {
          "id": "mp-pc-444",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-444",
            "container_id": "MP-7002-449",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NDg3NA==",
          "ticket_id": "20584874",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: EmilTlf.: 28889868Email: Emil@orumbertelsen.dkBesked: Hej, jeg undre mig over hvor ofte man får nye genbrugsposer? Vi har ikke fået siden sidste år, august-september mener jeg. Så vi har nærmest ikke flere tilbage? Mvh. Emil",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-01T19:38:00+00:00",
          "updated_at": "2025-08-19T00:25:00.585469+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2NDk=",
            "location": {
              "latitude": 55.521017,
              "longitude": 9.648058,
              "name": "Omøvænget 24, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4Nzk1Mw==",
          "ticket_id": "20587953",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Hej, Så ventede vi troligt 2 yderligere måneder, eftersom vi blev snydt af en tømmekalender der ikke passede og derfor ikke fik hentet i juni. Men efter at have stillet ud til genbrug hele dagen i går, kunne jeg skuffende hente det ind i går aftes, det var ikke blevet afhentet. Så nu håber jeg sandelig at det kan blive hentet en anden dag? Mvh. Emil",
          "status": 6,
          "priority": 2,
          "created_at": "2022-08-17T07:27:00+00:00",
          "updated_at": "2025-08-19T00:25:00.841149+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2NDk=",
            "location": {
              "latitude": 55.521017,
              "longitude": 9.648058,
              "name": "Omøvænget 24, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4ODUwOQ==",
          "ticket_id": "20588509",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Hej, Vi skulle have afhentet genbrug d 28 juni. Men det blev aldrig afhentet. Tænker du måske er fordi vejen er ny. Men det burde ikke være en undskyldning. Lad mig høre hvornår vi kan forvente de kommer i stedet? Mvh. Emil",
          "status": 6,
          "priority": 2,
          "created_at": "2022-07-05T08:55:00+00:00",
          "updated_at": "2025-08-19T00:25:00.896808+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2NDk=",
            "location": {
              "latitude": 55.521017,
              "longitude": 9.648058,
              "name": "Omøvænget 24, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4ODkxMA==",
          "ticket_id": "20588910",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 20/06 2022 Besked: Kontaktoplysninger: Tine Fischer Jørgensen",
          "status": 6,
          "priority": 2,
          "created_at": "2022-06-13T08:24:00+00:00",
          "updated_at": "2025-08-19T00:25:00.928068+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2NDk=",
            "location": {
              "latitude": 55.521017,
              "longitude": 9.648058,
              "name": "Omøvænget 24, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4ODk4MQ==",
          "ticket_id": "20588981",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 14/06 2022 Besked: Kontaktoplysninger: Tine Fischer Jørgensen",
          "status": 6,
          "priority": 2,
          "created_at": "2022-06-07T10:15:00+00:00",
          "updated_at": "2025-08-19T00:25:00.933555+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2NDk=",
            "location": {
              "latitude": 55.521017,
              "longitude": 9.648058,
              "name": "Omøvænget 24, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc2OTY=",
      "location": {
        "name": "Omøvænget 32 7000 Fredericia",
        "latitude": 55.52230402,
        "longitude": 9.64823285
      },
      "containers": [
        {
          "id": "mp-pc-445",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-445",
            "container_id": "MP-7002-450",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4ODIxMA==",
          "ticket_id": "20588210",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 03/08 2022 Besked: Kontaktoplysninger: Lasse Østengaard",
          "status": 6,
          "priority": 2,
          "created_at": "2022-07-27T08:05:00+00:00",
          "updated_at": "2025-08-19T00:25:00.862765+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2OTY=",
            "location": {
              "latitude": 55.522304,
              "longitude": 9.648232,
              "name": "Omøvænget 32, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4ODIxMQ==",
          "ticket_id": "20588211",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 03/08 2022 Besked: Kontaktoplysninger: Lasse Østengaard",
          "status": 6,
          "priority": 2,
          "created_at": "2022-07-27T08:04:00+00:00",
          "updated_at": "2025-08-19T00:25:00.862868+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2OTY=",
            "location": {
              "latitude": 55.522304,
              "longitude": 9.648232,
              "name": "Omøvænget 32, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTc2NDU=",
      "location": {
        "name": "Omøvænget 38 7000 Fredericia",
        "latitude": 55.52186238,
        "longitude": 9.64681969
      },
      "containers": [
        {
          "id": "mp-pc-446",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-446",
            "container_id": "MP-7002-452",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4OTQxOA==",
          "ticket_id": "20589418",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 10/05 2022 Besked: Kontaktoplysninger: Henriette Skov",
          "status": 6,
          "priority": 2,
          "created_at": "2022-05-03T09:04:00+00:00",
          "updated_at": "2025-08-19T00:25:00.973219+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2NDU=",
            "location": {
              "latitude": 55.52182,
              "longitude": 9.646983,
              "name": "Omøvænget 38, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4OTQxOQ==",
          "ticket_id": "20589419",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 10/05 2022 Besked: Kontaktoplysninger: Henriette Skov",
          "status": 6,
          "priority": 2,
          "created_at": "2022-05-03T09:03:00+00:00",
          "updated_at": "2025-08-19T00:25:00.973361+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTc2NDU=",
            "location": {
              "latitude": 55.52182,
              "longitude": 9.646983,
              "name": "Omøvænget 38, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDQwMzQ=",
      "location": {
        "name": "Hagenørvej 68 7000 Fredericia",
        "latitude": 55.517674,
        "longitude": 9.655973
      },
      "containers": [
        {
          "id": "mp-pc-447",
          "num_open_tickets": 1,
          "container": {
            "id": "mp-c-447",
            "container_id": "MP-7004-0",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NTIyNA==",
          "ticket_id": "20575224",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "AT-tilsyn ønskes Er der afleveret flyer: Nej Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2025-06-06T06:33:00+00:00",
          "updated_at": "2025-08-19T00:24:59.904051+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQwMzQ=",
            "location": {
              "latitude": 55.517674,
              "longitude": 9.655973,
              "name": "Hagenørvej 68, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToxMDQyMTEzMQ==",
          "ticket_id": "10421131",
          "ticket_type": "Defekt beholder - Hjul",
          "description": "Test",
          "status": 2,
          "priority": 0,
          "created_at": "2024-10-11T07:21:13.394770+00:00",
          "updated_at": "2024-10-11T07:21:13.395485+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQwMzQ=",
            "location": {
              "latitude": 55.517674,
              "longitude": 9.655973,
              "name": "Hagenørvej 68 7000 Fredericia"
            }
          },
          "container": {
            "container_id": "MP-7004-0",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "name": "240 L 2-delt"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTk1Nw==",
          "ticket_id": "20595957",
          "ticket_type": "AO-Generel besked",
          "description": "mgl. tømning af gl. beholdere",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-27T09:34:00+00:00",
          "updated_at": "2025-08-19T00:25:01.422124+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQwMzQ=",
            "location": {
              "latitude": 55.517674,
              "longitude": 9.655973,
              "name": "Hagenørvej 68, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTk1OA==",
          "ticket_id": "20595958",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "mgl. tømning",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-27T09:31:00+00:00",
          "updated_at": "2025-08-19T00:25:01.422180+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQwMzQ=",
            "location": {
              "latitude": 55.517674,
              "longitude": 9.655973,
              "name": "Hagenørvej 68, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDcwNTg=",
      "location": {
        "name": "Hagenørvej 60 7000 Fredericia",
        "latitude": 55.517974,
        "longitude": 9.652292
      },
      "containers": [
        {
          "id": "mp-pc-448",
          "num_open_tickets": 1,
          "container": {
            "id": "mp-c-448",
            "container_id": "MP-7004-1",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDQyMTIzMw==",
          "ticket_id": "10421233",
          "ticket_type": "Adgangsvej spærret",
          "description": "Test lasse ",
          "status": 1,
          "priority": 0,
          "created_at": "2024-10-11T07:59:19.547315+00:00",
          "updated_at": "2024-10-11T07:59:19.548596+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDcwNTg=",
            "location": {
              "latitude": 55.517974,
              "longitude": 9.652292,
              "name": "Hagenørvej 60 7000 Fredericia"
            }
          },
          "container": {
            "container_id": "MP-7004-1",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "name": "240 L 2-delt"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDk0ODU=",
      "location": {
        "name": "Hagenørvej 58 7000 Fredericia",
        "latitude": 55.51886,
        "longitude": 9.651787
      },
      "containers": [
        {
          "id": "mp-pc-449",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-449",
            "container_id": "MP-7004-2",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NTIzNw==",
          "ticket_id": "20595237",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-08-06Fraktion: 1 (Mad/Rest)Navn: Jens Peter LindTlf.: 40282749Email: lind-bruun@profiber.dkBesked: Hvornår får vi tømt skraldespand??? Får vi ikke svar på spørgsmål her????",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-10T19:56:00+00:00",
          "updated_at": "2025-08-19T00:25:01.375398+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk0ODU=",
            "location": {
              "latitude": 55.51886,
              "longitude": 9.651787,
              "name": "Hagenørvej 58, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTI3OA==",
          "ticket_id": "20595278",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Navn: Jens Peter LindTlf.: 40282749Email: lind-bruun@profiber.dkBesked: Blev tømt i mandags. Følger den ikke almindelige tømningsuger eller skal der skrives ind hver gang?!?!?!",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-07T14:48:00+00:00",
          "updated_at": "2025-08-19T00:25:01.377906+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk0ODU=",
            "location": {
              "latitude": 55.51886,
              "longitude": 9.651787,
              "name": "Hagenørvej 58, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTkzOQ==",
          "ticket_id": "20595939",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "mgl. tømning",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-27T12:23:00+00:00",
          "updated_at": "2025-08-19T00:25:01.421033+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk0ODU=",
            "location": {
              "latitude": 55.51886,
              "longitude": 9.651787,
              "name": "Hagenørvej 58, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjAxNg==",
          "ticket_id": "20596016",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Navn: Jens Peter LindTlf.: 40282749Email: lind-bruun@profiber.dkBesked: Hvad sker der, når man melder, at skraldespanden ikke er tømt.???",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-26T14:53:00+00:00",
          "updated_at": "2025-08-19T00:25:01.425577+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk0ODU=",
            "location": {
              "latitude": 55.51886,
              "longitude": 9.651787,
              "name": "Hagenørvej 58, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjAyOQ==",
          "ticket_id": "20596029",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-07-23Fraktion: 1 (Mad/Rest)Navn: Jens Peter LindTlf.: 40282749Email: lind-bruun@profiber.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-26T11:55:00+00:00",
          "updated_at": "2025-08-19T00:25:01.426330+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk0ODU=",
            "location": {
              "latitude": 55.51886,
              "longitude": 9.651787,
              "name": "Hagenørvej 58, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjA3OA==",
          "ticket_id": "20596078",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-07-23Fraktion: 1 (Mad/Rest)Navn: Jens Peter LindTlf.: 40282749Email: lind-bruun@profiber.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-25T21:52:00+00:00",
          "updated_at": "2025-08-19T00:25:01.429299+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk0ODU=",
            "location": {
              "latitude": 55.51886,
              "longitude": 9.651787,
              "name": "Hagenørvej 58, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDk0ODY=",
      "location": {
        "name": "Hagenørvej 59 7000 Fredericia",
        "latitude": 55.518396,
        "longitude": 9.652528
      },
      "containers": [
        {
          "id": "mp-pc-450",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-450",
            "container_id": "MP-7004-3",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDk0ODc=",
      "location": {
        "name": "Hagenørvej 69 7000 Fredericia",
        "latitude": 55.517872,
        "longitude": 9.655987
      },
      "containers": [
        {
          "id": "mp-pc-451",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-451",
            "container_id": "MP-7004-4",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NTIyMw==",
          "ticket_id": "20575223",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "AT-tilsyn ønskes Er der afleveret flyer: Nej Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2025-06-06T06:33:00+00:00",
          "updated_at": "2025-08-19T00:24:59.903951+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk0ODc=",
            "location": {
              "latitude": 55.517872,
              "longitude": 9.655987,
              "name": "Hagenørvej 69, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDQyMg==",
          "ticket_id": "20594422",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Hej Renovationsbilen er netop kørt afsted fra Hagenørvej. Jeg stillede vores beholder op til vejen, mens bilen var ved nr. 73 længere nede for at tømme beholderne der. Desværre så føreren ikke vores beholder på tilbagevejen..!!!? Kan den mon blive tømt snarest? Venlig hilsen Karin Abildgaard Hagenørvej 69",
          "status": 6,
          "priority": 2,
          "created_at": "2021-09-03T10:52:00+00:00",
          "updated_at": "2025-08-19T00:25:01.325085+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk0ODc=",
            "location": {
              "latitude": 55.517872,
              "longitude": 9.655987,
              "name": "Hagenørvej 69, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTY2Ng==",
          "ticket_id": "20595666",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Hvornår får vi tømt på Hagenørvej? Tømning ikke foretaget i juli og beholder er overfyldt. Får vi refunderet betaling får juli måned?",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-02T10:13:00+00:00",
          "updated_at": "2025-08-19T00:25:01.403550+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk0ODc=",
            "location": {
              "latitude": 55.517872,
              "longitude": 9.655987,
              "name": "Hagenørvej 69, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTY4OA==",
          "ticket_id": "20595688",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Ifølge nyeste kalender skulle vores beholder blive tømt den 23. juli 2021. Det er imidlertid ikke sket. Er der fejl i jeres tømmekalender? Hvornår kan vi forvente næste tømning? Venlig hilsen Karin Abildgaard",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-30T13:26:00+00:00",
          "updated_at": "2025-08-19T00:25:01.404806+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk0ODc=",
            "location": {
              "latitude": 55.517872,
              "longitude": 9.655987,
              "name": "Hagenørvej 69, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQzMzM=",
      "location": {
        "name": "Hagenørvej 71 7000 Fredericia",
        "latitude": 55.51788828,
        "longitude": 9.65749655
      },
      "containers": [
        {
          "id": "mp-pc-452",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-452",
            "container_id": "MP-7004-5",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NTIyMg==",
          "ticket_id": "20575222",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "AT-tilsyn ønskes Er der afleveret flyer: Nej Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2025-06-06T06:33:00+00:00",
          "updated_at": "2025-08-19T00:24:59.903853+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQzMzM=",
            "location": {
              "latitude": 55.517888,
              "longitude": 9.657496,
              "name": "Hagenørvej 71, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3NjI1NA==",
          "ticket_id": "20576254",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2025-03-28Fraktion: 1 (Mad/Rest)Navn: Søren ØstergaardTlf.: 30367311Email: hagenoergaarden@gmail.comBesked: Hagenørvej 73 har heller ikke fået tomt",
          "status": 6,
          "priority": 2,
          "created_at": "2025-03-29T15:22:00+00:00",
          "updated_at": "2025-08-19T00:25:00.024365+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQzMzM=",
            "location": {
              "latitude": 55.517888,
              "longitude": 9.657496,
              "name": "Hagenørvej 71, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4Mzg5NA==",
          "ticket_id": "20583894",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "AT-tilsyn ønskes Er der afleveret flyer: Nej Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2023-08-18T06:08:00+00:00",
          "updated_at": "2025-08-19T00:25:00.528292+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQzMzM=",
            "location": {
              "latitude": 55.517888,
              "longitude": 9.657496,
              "name": "Hagenørvej 71, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTI4MA==",
          "ticket_id": "20595280",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-08-06Fraktion: 1 (Mad/Rest)Navn: Søren ØstergaardTlf.: 30367311Email: hagenoergaarden@gmail.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-09T14:21:00+00:00",
          "updated_at": "2025-08-19T00:25:01.378026+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQzMzM=",
            "location": {
              "latitude": 55.517888,
              "longitude": 9.657496,
              "name": "Hagenørvej 71, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTMzNA==",
          "ticket_id": "20595334",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Navn: Søren ØstergaardTlf.: 30367311Email: hagenoergaarden@gmail.comBesked: Hej, har ikke fået tømt med skraldespand den 6/8 på Hagenørvej 71. Den er ikke fuld med lugter noget så grusomt. Mvh Søren Østergaard",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-07T21:13:00+00:00",
          "updated_at": "2025-08-19T00:25:01.381228+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQzMzM=",
            "location": {
              "latitude": 55.517888,
              "longitude": 9.657496,
              "name": "Hagenørvej 71, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQ5OTg=",
      "location": {
        "name": "Hagenørvej 73 7000 Fredericia",
        "latitude": 55.51820416,
        "longitude": 9.65769203
      },
      "containers": [
        {
          "id": "mp-pc-453",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-453",
            "container_id": "MP-7004-6",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NTA0OQ==",
          "ticket_id": "20575049",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Navn: Inge Birgitte Siegumfeldt Tlf.: 23251644Email: siegum@hum.ku.dkBesked: I tømte ikke min beholder i fredags. Den stod ellers klar med håndtaget udad som altid på hjørnet af huset ved køkkendøren",
          "status": 6,
          "priority": 2,
          "created_at": "2025-06-21T16:21:00+00:00",
          "updated_at": "2025-08-19T00:24:59.884893+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQ5OTg=",
            "location": {
              "latitude": 55.518204,
              "longitude": 9.657692,
              "name": "Hagenørvej 73, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3NTIyMQ==",
          "ticket_id": "20575221",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "AT-tilsyn ønskes Er der afleveret flyer: Nej Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2025-06-06T06:33:00+00:00",
          "updated_at": "2025-08-19T00:24:59.903750+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQ5OTg=",
            "location": {
              "latitude": 55.518204,
              "longitude": 9.657692,
              "name": "Hagenørvej 73, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTA1Ng==",
          "ticket_id": "20599056",
          "ticket_type": "AO-Generel besked",
          "description": "Hvordan får jeg tømt plastikaffald?",
          "status": 6,
          "priority": 2,
          "created_at": "2019-12-16T09:38:00+00:00",
          "updated_at": "2025-08-19T00:25:01.607503+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQ5OTg=",
            "location": {
              "latitude": 55.518204,
              "longitude": 9.657692,
              "name": "Hagenørvej 73, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTIxMQ==",
          "ticket_id": "20599211",
          "ticket_type": "AO-Generel besked",
          "description": "Er der afhentning af andet sorteret affald som plastic, pap, metal, papir osv?",
          "status": 6,
          "priority": 2,
          "created_at": "2019-08-06T14:34:00+00:00",
          "updated_at": "2025-08-19T00:25:01.616764+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTQ5OTg=",
            "location": {
              "latitude": 55.518204,
              "longitude": 9.657692,
              "name": "Hagenørvej 73, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTUwNDg=",
      "location": {
        "name": "Hagenørvej 61 7000 Fredericia",
        "latitude": 55.51811836,
        "longitude": 9.65266479
      },
      "containers": [
        {
          "id": "mp-pc-454",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-454",
            "container_id": "MP-7004-7",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NDkwMA==",
          "ticket_id": "20574900",
          "ticket_type": "AO-Generel besked",
          "description": "Tina ringer, tlf. 24210041 og har fået regning for sidste halve år af 25 for renovation. Hus solgt pr. 04-01-25. Aftalt at hun ikke betaler. Sendt i ejendomsbidrag.",
          "status": 6,
          "priority": 2,
          "created_at": "2025-07-02T10:53:00+00:00",
          "updated_at": "2025-08-19T00:24:59.868315+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUwNDg=",
            "location": {
              "latitude": 55.518118,
              "longitude": 9.652664,
              "name": "Hagenørvej 61, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTUwNzY=",
      "location": {
        "name": "Hagenørvej 66 7000 Fredericia",
        "latitude": 55.51778299,
        "longitude": 9.65553029
      },
      "containers": [
        {
          "id": "mp-pc-455",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-455",
            "container_id": "MP-7004-8",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NTIyNg==",
          "ticket_id": "20575226",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "AT-tilsyn ønskes Er der afleveret flyer: Nej Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2025-06-06T06:33:00+00:00",
          "updated_at": "2025-08-19T00:24:59.904250+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUwNzY=",
            "location": {
              "latitude": 55.517782,
              "longitude": 9.65553,
              "name": "Hagenørvej 66, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3OTUxMA==",
          "ticket_id": "20579510",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 23/07 2024 Besked: Kontaktoplysninger: Finn Buhl 22914850 Toplak@toplak.dk",
          "status": 6,
          "priority": 2,
          "created_at": "2024-07-16T14:48:00+00:00",
          "updated_at": "2025-08-19T00:25:00.258250+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUwNzY=",
            "location": {
              "latitude": 55.517782,
              "longitude": 9.65553,
              "name": "Hagenørvej 66, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MzgyOA==",
          "ticket_id": "20583828",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "AT-tilsyn ønskes Er der afleveret flyer: Nej Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2023-09-01T06:00:00+00:00",
          "updated_at": "2025-08-19T00:25:00.523742+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUwNzY=",
            "location": {
              "latitude": 55.517782,
              "longitude": 9.65553,
              "name": "Hagenørvej 66, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4OTE0OA==",
          "ticket_id": "20589148",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Manglende tømning trods tømmelog",
          "status": 6,
          "priority": 2,
          "created_at": "2022-05-18T11:56:00+00:00",
          "updated_at": "2025-08-19T00:25:00.951731+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUwNzY=",
            "location": {
              "latitude": 55.517782,
              "longitude": 9.65553,
              "name": "Hagenørvej 66, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5ODU5Ng==",
          "ticket_id": "20598596",
          "ticket_type": "AO-Ændring til 140 liter beholder til grønt affald",
          "description": "Skal gammel beholder hjemtages: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2020-09-06T11:22:00+00:00",
          "updated_at": "2025-08-19T00:25:01.578812+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUwNzY=",
            "location": {
              "latitude": 55.517782,
              "longitude": 9.65553,
              "name": "Hagenørvej 66, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTUxOTU=",
      "location": {
        "name": "Hagenørvej 62 7000 Fredericia",
        "latitude": 55.51721632,
        "longitude": 9.65628915
      },
      "containers": [
        {
          "id": "mp-pc-456",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-456",
            "container_id": "MP-7004-9",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3OTUxMQ==",
          "ticket_id": "20579511",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Genbrug Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 23/07 2024 Besked: Kontaktoplysninger: Clara Hygum Youden Suhr",
          "status": 6,
          "priority": 2,
          "created_at": "2024-07-16T14:48:00+00:00",
          "updated_at": "2025-08-19T00:25:00.258307+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUxOTU=",
            "location": {
              "latitude": 55.517216,
              "longitude": 9.656289,
              "name": "Hagenørvej 62, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MTY1OA==",
          "ticket_id": "20581658",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Per Zoffmann AndersenTlf.: 29469913Email: perzoffmann@gmail.comBesked: Hej jeg har slette min tidligere adresser, Jens Thuesens Vej 21 og Gavnøvænget 32, men jeg bliver ved med at få notifikationer om genbrug og restaffald på de 2 adresser har i mulighed for ar slette beskederne? Beskederne bliver sendt til 29469913 mvh Per",
          "status": 6,
          "priority": 2,
          "created_at": "2024-02-19T16:10:00+00:00",
          "updated_at": "2025-08-19T00:25:00.389780+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUxOTU=",
            "location": {
              "latitude": 55.517216,
              "longitude": 9.656289,
              "name": "Hagenørvej 62, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5Mzk4MQ==",
          "ticket_id": "20593981",
          "ticket_type": "AO-Generel besked",
          "description": "Ejeren stiller beholder op / frem til postkasse ovenfor stikvej, så bilen ikke skal køre ned. Stiller kun frem ved behov.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-09-20T12:47:00+00:00",
          "updated_at": "2025-08-19T00:25:01.297748+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUxOTU=",
            "location": {
              "latitude": 55.517216,
              "longitude": 9.656289,
              "name": "Hagenørvej 62, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTA4Mg==",
          "ticket_id": "20595082",
          "ticket_type": "AO-Generel besked",
          "description": "Nr. 62+64 skal kun tømmes, når de er stillet op til vejen - altså ingen grund til at køre ned til ejd.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-13T13:15:00+00:00",
          "updated_at": "2025-08-19T00:25:01.365527+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUxOTU=",
            "location": {
              "latitude": 55.517216,
              "longitude": 9.656289,
              "name": "Hagenørvej 62, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTY4NA==",
          "ticket_id": "20595684",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-07-23Fraktion: 1 (Mad/Rest)Navn: Lene SuhrTlf.: 99557083Email: lensu@orsted.dkBesked: Beholder ikke tømt siden 9/7",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-30T16:25:00+00:00",
          "updated_at": "2025-08-19T00:25:01.404557+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUxOTU=",
            "location": {
              "latitude": 55.517216,
              "longitude": 9.656289,
              "name": "Hagenørvej 62, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDg1MTU=",
      "location": {
        "name": "Børup Skovvej 37 7000 Fredericia",
        "latitude": 55.521892,
        "longitude": 9.655871
      },
      "containers": [
        {
          "id": "mp-pc-457",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-457",
            "container_id": "MP-7004-10",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NjU4Nw==",
          "ticket_id": "20576587",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2025-02-14Fraktion: 1 (Mad/Rest)Navn: Lene SuhrTlf.: 99557083Email: lensu@orsted.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2025-02-28T09:58:00+00:00",
          "updated_at": "2025-08-19T00:25:00.060691+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTU=",
            "location": {
              "latitude": 55.521892,
              "longitude": 9.655871,
              "name": "Børup Skovvej 37, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4ODAyMA==",
          "ticket_id": "20588020",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2022-07-22Fraktion: 1 (Mad/Rest)Navn: Lene SuhrTlf.: 99557083Email: lensu@orsted.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2022-08-05T14:13:00+00:00",
          "updated_at": "2025-08-19T00:25:00.844749+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTU=",
            "location": {
              "latitude": 55.521892,
              "longitude": 9.655871,
              "name": "Børup Skovvej 37, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTkxOQ==",
          "ticket_id": "20591919",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-12-24Fraktion: 1 (Mad/Rest)Navn: Lene SuhrTlf.: 99557083Email: lensu@orsted.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-30T08:20:00+00:00",
          "updated_at": "2025-08-19T00:25:01.178310+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTU=",
            "location": {
              "latitude": 55.521892,
              "longitude": 9.655871,
              "name": "Børup Skovvej 37, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTk0Mg==",
          "ticket_id": "20591942",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-12-24Fraktion: 1 (Mad/Rest)Navn: Lene SuhrTlf.: 99557083Email: lensu@orsted.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-27T15:03:00+00:00",
          "updated_at": "2025-08-19T00:25:01.181707+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTU=",
            "location": {
              "latitude": 55.521892,
              "longitude": 9.655871,
              "name": "Børup Skovvej 37, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDM0Mw==",
          "ticket_id": "20594343",
          "ticket_type": "AO-Generel besked",
          "description": "Jvf. Kenneth afklares adgangsforhold 2021.09.08",
          "status": 6,
          "priority": 2,
          "created_at": "2021-09-07T16:57:00+00:00",
          "updated_at": "2025-08-19T00:25:01.320139+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTU=",
            "location": {
              "latitude": 55.521892,
              "longitude": 9.655871,
              "name": "Børup Skovvej 37, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDM2OA==",
          "ticket_id": "20594368",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Beholder IKKE tømt 3.9. De skal køre ned af vores grusvej - det er tidligere aftalt med dem. Beholderen var stillet frem på det aftalte sted. Til info er grusvejen 300 m lang. Skraldebilen kan sagtens vende i vores gårdsplads. Det har de gjort tidligere - både det gamle og det nye firma. Beholderen kan vente med at blive tømt til næste gang. Med venlig hilsen Lene Suhr",
          "status": 6,
          "priority": 2,
          "created_at": "2021-09-06T13:18:00+00:00",
          "updated_at": "2025-08-19T00:25:01.321814+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTU=",
            "location": {
              "latitude": 55.521892,
              "longitude": 9.655871,
              "name": "Børup Skovvej 37, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDM3NA==",
          "ticket_id": "20594374",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Beholder ikke tømt den 3/9",
          "status": 6,
          "priority": 2,
          "created_at": "2021-09-06T08:23:00+00:00",
          "updated_at": "2025-08-19T00:25:01.322188+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTU=",
            "location": {
              "latitude": 55.521892,
              "longitude": 9.655871,
              "name": "Børup Skovvej 37, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDEzMQ==",
          "ticket_id": "20594131",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "AT-tilsyn ønskes Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2021-09-03T10:27:00+00:00",
          "updated_at": "2025-08-19T00:25:01.307217+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTU=",
            "location": {
              "latitude": 55.521892,
              "longitude": 9.655871,
              "name": "Børup Skovvej 37, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTA4Mw==",
          "ticket_id": "20595083",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-08-06Fraktion: 1 (Mad/Rest)Navn: Lene SuhrTlf.: 99557083Email: lensu@orsted.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-11T12:21:00+00:00",
          "updated_at": "2025-08-19T00:25:01.365623+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTU=",
            "location": {
              "latitude": 55.521892,
              "longitude": 9.655871,
              "name": "Børup Skovvej 37, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTI2Mg==",
          "ticket_id": "20595262",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-07-23Fraktion: 1 (Mad/Rest)Navn: Lene SuhrTlf.: 99557083Email: lensu@orsted.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-06T13:53:00+00:00",
          "updated_at": "2025-08-19T00:25:01.376901+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTU=",
            "location": {
              "latitude": 55.521892,
              "longitude": 9.655871,
              "name": "Børup Skovvej 37, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTIwMQ==",
          "ticket_id": "20595201",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "AT-tilsyn ønskes Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-06T10:23:00+00:00",
          "updated_at": "2025-08-19T00:25:01.373238+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTU=",
            "location": {
              "latitude": 55.521892,
              "longitude": 9.655871,
              "name": "Børup Skovvej 37, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjA0Ng==",
          "ticket_id": "20596046",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-07-23Fraktion: 1 (Mad/Rest)Navn: Lene SuhrTlf.: 99557083Email: lensu@orsted.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-26T09:09:00+00:00",
          "updated_at": "2025-08-19T00:25:01.427355+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTU=",
            "location": {
              "latitude": 55.521892,
              "longitude": 9.655871,
              "name": "Børup Skovvej 37, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjA5Mw==",
          "ticket_id": "20596093",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Navn: Lene SuhrTlf.: 99557083Email: lensu@orsted.dkBesked: Hagenørvej 62 er heller ikke tømt",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-24T12:10:00+00:00",
          "updated_at": "2025-08-19T00:25:01.430177+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTU=",
            "location": {
              "latitude": 55.521892,
              "longitude": 9.655871,
              "name": "Børup Skovvej 37, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5Njg3Mg==",
          "ticket_id": "20596872",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "mgl. tømning",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-13T14:45:00+00:00",
          "updated_at": "2025-08-19T00:25:01.475647+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTU=",
            "location": {
              "latitude": 55.521892,
              "longitude": 9.655871,
              "name": "Børup Skovvej 37, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NzA5Mg==",
          "ticket_id": "20597092",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Grusvej - der KAN vendes på gårdsplads. Fournaise tømte tidl. i stor bil. Beholder står ved skel, men kan ikke ses fra vejen.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-09T11:39:00+00:00",
          "updated_at": "2025-08-19T00:25:01.488113+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTU=",
            "location": {
              "latitude": 55.521892,
              "longitude": 9.655871,
              "name": "Børup Skovvej 37, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTk2OA==",
          "ticket_id": "20599968",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "Den nuværende affaldsbeholder på 140 l er flækket i hele den ene side. Jeg vil derfor gerne have en ny affaldsbeholder på 140 l. Med venlig hilsen Henrik Suhr",
          "status": 6,
          "priority": 2,
          "created_at": "2018-03-29T09:53:00+00:00",
          "updated_at": "2025-08-19T00:25:01.664408+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTU=",
            "location": {
              "latitude": 55.521892,
              "longitude": 9.655871,
              "name": "Børup Skovvej 37, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMzg2MzA=",
      "location": {
        "name": "Huslodsvej 49 7000 Fredericia",
        "latitude": 55.574806,
        "longitude": 9.762561
      },
      "containers": [
        {
          "id": "mp-pc-458",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-458",
            "container_id": "MP-7004-11",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "660 L"
            }
          }
        },
        {
          "id": "mp-pc-459",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-459",
            "container_id": "MP-7004-12",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "660 L"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDM1NzE=",
      "location": {
        "name": "Børup Skovvej 50 7000 Fredericia",
        "latitude": 55.519558,
        "longitude": 9.6513
      },
      "containers": [
        {
          "id": "mp-pc-460",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-460",
            "container_id": "MP-7004-17",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NDA0Mw==",
          "ticket_id": "20584043",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2023-08-04Fraktion: 1 (Mad/Rest)Navn: Sönke HardersTlf.: 71942155Email: s_harders@outlook.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-08-05T22:50:00+00:00",
          "updated_at": "2025-08-19T00:25:00.536416+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDM1NzE=",
            "location": {
              "latitude": 55.519558,
              "longitude": 9.6513,
              "name": "Børup Skovvej 50, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5ODQ1NQ==",
          "ticket_id": "20598455",
          "ticket_type": "AO-Manglende tømning - grønt affald",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2020-12-11T13:57:00+00:00",
          "updated_at": "2025-08-19T00:25:01.570539+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDM1NzE=",
            "location": {
              "latitude": 55.519558,
              "longitude": 9.6513,
              "name": "Børup Skovvej 50, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5ODQ3Mw==",
          "ticket_id": "20598473",
          "ticket_type": "AO-Generel besked",
          "description": "Hej, jeg har ingen brug for grøntaffald. Det er for stor til mig. Jeg vil kompostere selv. Hvor kan jeg frameld tømning? Tak SÃ¶nke Harders",
          "status": 6,
          "priority": 2,
          "created_at": "2020-11-30T16:43:00+00:00",
          "updated_at": "2025-08-19T00:25:01.571484+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDM1NzE=",
            "location": {
              "latitude": 55.519558,
              "longitude": 9.6513,
              "name": "Børup Skovvej 50, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDcwNTc=",
      "location": {
        "name": "Hagenørvej 40 7000 Fredericia",
        "latitude": 55.516973,
        "longitude": 9.649441
      },
      "containers": [
        {
          "id": "mp-pc-461",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-461",
            "container_id": "MP-7004-18",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MDQ2MA==",
          "ticket_id": "20590460",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2022-02-18Fraktion: 1 (Mad/Rest)Navn: Martin SuhrTlf.: 21652358Email: suhr@profibermail.dkBesked: Hagenørvej 21a/b også kaldet Omøvænget 5 og 7 er nu på 4 uge ikke tømt. Det er utroligt skuffende. Jeg har kontaktet jer på Appen og to gange telefonisk. Resultat: en masse snak, ingen handling. Ring gerne til 21652358 for yderlige information /Martin Suhr",
          "status": 6,
          "priority": 2,
          "created_at": "2022-03-04T14:29:00+00:00",
          "updated_at": "2025-08-19T00:25:01.068854+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDcwNTc=",
            "location": {
              "latitude": 55.516973,
              "longitude": 9.649441,
              "name": "Hagenørvej 40, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MDcwOA==",
          "ticket_id": "20590708",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2022-02-04Fraktion: 1 (Mad/Rest)Navn: Martin SuhrTlf.: 21652358Email: suhr@profibermail.dkBesked: Hagenørvej 21A/B er ophørt med at eksistere og erstattet af Omøvænget 5 og 7. Disse renovationsbeholdere er ikke tømt i dag. Kontakt Martin Suhr på 21652358 for yderligere oplysninger. Vh Martin",
          "status": 6,
          "priority": 2,
          "created_at": "2022-02-18T16:40:00+00:00",
          "updated_at": "2025-08-19T00:25:01.083963+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDcwNTc=",
            "location": {
              "latitude": 55.516973,
              "longitude": 9.649441,
              "name": "Hagenørvej 40, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzQ1NQ==",
          "ticket_id": "20593455",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Hverken nr. 40 eller 40B har fået tømt 15.10... Vil I tømme, tak.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-22T07:53:00+00:00",
          "updated_at": "2025-08-19T00:25:01.267020+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDcwNTc=",
            "location": {
              "latitude": 55.516973,
              "longitude": 9.649441,
              "name": "Hagenørvej 40, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzU3Ng==",
          "ticket_id": "20593576",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-10-15Fraktion: 1 (Mad/Rest)Navn: Martin SuhrTlf.: 21652358Email: suhr@profibermail.dkBesked: Beholder heller ikke tømt på nummer 40b",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-16T08:47:00+00:00",
          "updated_at": "2025-08-19T00:25:01.274021+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDcwNTc=",
            "location": {
              "latitude": 55.516973,
              "longitude": 9.649441,
              "name": "Hagenørvej 40, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjA5Ng==",
          "ticket_id": "20596096",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-07-23Fraktion: 1 (Mad/Rest)Navn: Martin SuhrTlf.: 21652358Email: suhr@profibermail.dkBesked: Det samme gælder Nummer 40b",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-24T08:22:00+00:00",
          "updated_at": "2025-08-19T00:25:01.430347+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDcwNTc=",
            "location": {
              "latitude": 55.516973,
              "longitude": 9.649441,
              "name": "Hagenørvej 40, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDg1MTA=",
      "location": {
        "name": "Børup Skovvej 10 7000 Fredericia",
        "latitude": 55.528135,
        "longitude": 9.644421
      },
      "containers": [
        {
          "id": "mp-pc-462",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-462",
            "container_id": "MP-7004-19",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NzY5MA==",
          "ticket_id": "20577690",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Tømningsdato: 2024-10-24Fraktion: 2 (Genbrug)Navn: DiannaTlf.: 61244389Email: dhoegh@yahoo.dkBesked: Det har stået siden i går aftes og er ikke blevet hentet",
          "status": 6,
          "priority": 2,
          "created_at": "2024-11-26T15:39:00+00:00",
          "updated_at": "2025-08-19T00:25:00.154184+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTA=",
            "location": {
              "latitude": 55.528135,
              "longitude": 9.644438,
              "name": "Børup Skovvej 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjEwNg==",
          "ticket_id": "20596106",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-23T16:59:00+00:00",
          "updated_at": "2025-08-19T00:25:01.430914+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTA=",
            "location": {
              "latitude": 55.528135,
              "longitude": 9.644438,
              "name": "Børup Skovvej 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjAxMA==",
          "ticket_id": "20596010",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-07-09Fraktion: 1 (Mad/Rest)Navn: Dianna HøghTlf.: 53861656Email: dhoegh@yahoo.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-23T16:59:00+00:00",
          "updated_at": "2025-08-19T00:25:01.425210+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTA=",
            "location": {
              "latitude": 55.528135,
              "longitude": 9.644438,
              "name": "Børup Skovvej 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTAyNA==",
          "ticket_id": "20599024",
          "ticket_type": "AO-Ændring til 140 liter beholder til restaffald",
          "description": "Skal gammel beholder hjemtages: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2020-01-08T16:17:00+00:00",
          "updated_at": "2025-08-19T00:25:01.605490+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTA=",
            "location": {
              "latitude": 55.528135,
              "longitude": 9.644438,
              "name": "Børup Skovvej 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5OTA3OA==",
          "ticket_id": "20599078",
          "ticket_type": "AO-Ændring til 140 liter beholder til restaffald",
          "description": "Skal gammel beholder hjemtages: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2019-12-01T13:58:00+00:00",
          "updated_at": "2025-08-19T00:25:01.608757+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTA=",
            "location": {
              "latitude": 55.528135,
              "longitude": 9.644438,
              "name": "Børup Skovvej 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDYwMDA2NQ==",
          "ticket_id": "20600065",
          "ticket_type": "AO-Generel besked",
          "description": "Hej. Min udlejer har fjernet min beholder til dagligt affald, så jeg vil gerne høre, hvad jeg stiller op. Han henviser til, at der står en beholder, men det er den lave type, som ikke er godkendt af Arbejdstilsynet, hvorfor den ikke blir tømt. Med venlig hilsen Tommy Karlsson",
          "status": 6,
          "priority": 2,
          "created_at": "2018-01-02T12:47:00+00:00",
          "updated_at": "2025-08-19T00:25:01.670494+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTA=",
            "location": {
              "latitude": 55.528135,
              "longitude": 9.644438,
              "name": "Børup Skovvej 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDg1MTI=",
      "location": {
        "name": "Børup Skovvej 22 7000 Fredericia",
        "latitude": 55.522185,
        "longitude": 9.651455
      },
      "containers": [
        {
          "id": "mp-pc-463",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-463",
            "container_id": "MP-7004-20",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MDA5OA==",
          "ticket_id": "20590098",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2022-03-18Fraktion: 1 (Mad/Rest)Navn: Ulla Salmonsen Bjarne PoulsenTlf.: 20898269Email: u.salmonsen@outlook.dkBesked: Tak beholder tømt????",
          "status": 6,
          "priority": 2,
          "created_at": "2022-03-22T12:16:00+00:00",
          "updated_at": "2025-08-19T00:25:01.046736+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTI=",
            "location": {
              "latitude": 55.522185,
              "longitude": 9.651455,
              "name": "Børup Skovvej 22, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MDEwMA==",
          "ticket_id": "20590100",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2022-03-18Fraktion: 1 (Mad/Rest)Navn: Ulla Salmonsen Bjarne PoulsenTlf.: 20898269Email: u.salmonsen@outlook.dkBesked: Beholder stadig ikke tømt?????",
          "status": 6,
          "priority": 2,
          "created_at": "2022-03-22T11:09:00+00:00",
          "updated_at": "2025-08-19T00:25:01.046935+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTI=",
            "location": {
              "latitude": 55.522185,
              "longitude": 9.651455,
              "name": "Børup Skovvej 22, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MDE0NQ==",
          "ticket_id": "20590145",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2022-03-18Fraktion: 1 (Mad/Rest)Navn: Ulla Salmonsen Bjarne PoulsenTlf.: 20898269Email: u.salmonsen@outlook.dkBesked: Beholder er placeret samme sted som altid 1 m fra skel men de kørte forbi uden at tømme?",
          "status": 6,
          "priority": 2,
          "created_at": "2022-03-19T13:09:00+00:00",
          "updated_at": "2025-08-19T00:25:01.051352+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTI=",
            "location": {
              "latitude": 55.522185,
              "longitude": 9.651455,
              "name": "Børup Skovvej 22, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjEwNw==",
          "ticket_id": "20596107",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Skrald er kørt til skel d.d. Der er ikke tømt",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-23T16:35:00+00:00",
          "updated_at": "2025-08-19T00:25:01.430970+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTI=",
            "location": {
              "latitude": 55.522185,
              "longitude": 9.651455,
              "name": "Børup Skovvej 22, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDM1Njk=",
      "location": {
        "name": "Børup Skovvej 25 7000 Fredericia",
        "latitude": 55.525168,
        "longitude": 9.652394
      },
      "containers": [
        {
          "id": "mp-pc-464",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-464",
            "container_id": "MP-7004-21",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MDg0OA==",
          "ticket_id": "20580848",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: LineTlf.: 22624510Email: linel86@hotmail.comBesked: Hej da vi er de heldige på jeres rute som får tømt affald som en af de første, betyder dette også at jeres kæmpe larmende lastbil kommer forbi vores hus omkring kl 6.00 hver 2.fredag og som vækker hele huset. Havde det været håndværkere, såsom tømrer eller andet, ville det være normal pli at starte kl 7.00, derfor min forespørgsel om I ku vente med at tømme til senere, for at respektere folks søvn.",
          "status": 6,
          "priority": 2,
          "created_at": "2024-05-10T07:39:00+00:00",
          "updated_at": "2025-08-19T00:25:00.340421+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDM1Njk=",
            "location": {
              "latitude": 55.525168,
              "longitude": 9.652394,
              "name": "Børup Skovvej 25, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5Mjg2MA==",
          "ticket_id": "20592860",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Børup Skovvej 25 1 (7000 Fredericia) ContainerNr:404725 ContainerBrik: Låg itu Ønsket virkningsdato: 08/12-2021 Besked: Kontaktoplysninger: Anders Løvbjerg 99557856 anderskok.privat@gmail.com",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-02T13:18:00+00:00",
          "updated_at": "2025-08-19T00:25:01.233734+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDM1Njk=",
            "location": {
              "latitude": 55.525168,
              "longitude": 9.652394,
              "name": "Børup Skovvej 25, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjkyNg==",
          "ticket_id": "20592926",
          "ticket_type": "AO-Håndtag itu (vedhæft evt foto - kun på web)",
          "description": "Navn: LineTlf.: 22624510Email: linel86@hotmil.comBesked: Låget på vores skraldespand er knækket efter tømning i går fredag",
          "status": 6,
          "priority": 2,
          "created_at": "2021-11-27T12:19:00+00:00",
          "updated_at": "2025-08-19T00:25:01.236995+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDM1Njk=",
            "location": {
              "latitude": 55.525168,
              "longitude": 9.652394,
              "name": "Børup Skovvej 25, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzEyNw==",
          "ticket_id": "20593127",
          "ticket_type": "AO-Generel besked",
          "description": "Besked fra borger: Kunne være mega lækkert at vores skraldespand bliver stillet ind på plads efter tømning når nu i ønsker at vi skal stille den ud til jer. Så går det vel begge veje så den ikke står ude på vejen men inde i siden. Eller hvad? Jeg har taget billeder af dette!",
          "status": 6,
          "priority": 2,
          "created_at": "2021-11-15T09:00:00+00:00",
          "updated_at": "2025-08-19T00:25:01.248725+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDM1Njk=",
            "location": {
              "latitude": 55.525168,
              "longitude": 9.652394,
              "name": "Børup Skovvej 25, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzEzMA==",
          "ticket_id": "20593130",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: LineTlf.: 22624510Email: linel86@hotmil.comBesked: Kunne være mega lækkert at vores skraldespand bliver stillet ind på plads efter tømning når nu i ønsker at vi skal stille den ud til jer. Så går det vel begge veje så den ikke står ude på vejen men inde i siden. Eller hvad? Jeg har taget billeder af dette!",
          "status": 6,
          "priority": 2,
          "created_at": "2021-11-12T15:43:00+00:00",
          "updated_at": "2025-08-19T00:25:01.248871+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDM1Njk=",
            "location": {
              "latitude": 55.525168,
              "longitude": 9.652394,
              "name": "Børup Skovvej 25, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NTg5Nw==",
          "ticket_id": "20595897",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: LineTlf.: 22624510Email: linel86@hotmil.comBesked: Når nu der er så strikse regler om skraldespand skal stå ved skel, håndtaget skal vende ud af mod vejen, mv, så ku det være mega rart at dette også gælder den anden vej rundt. Vores skraldespand sættes i indkørslen til vores garage, 10-15 meter fra hvor de har taget den ved vores fordør. Den må gerne sættes samme sted som den tages når nu de er så glæde for regler!!!",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-28T11:33:00+00:00",
          "updated_at": "2025-08-19T00:25:01.418304+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDM1Njk=",
            "location": {
              "latitude": 55.525168,
              "longitude": 9.652394,
              "name": "Børup Skovvej 25, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjAzOQ==",
          "ticket_id": "20596039",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "mgl. tømning på adressen og muligvis hele vejen",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-26T09:42:00+00:00",
          "updated_at": "2025-08-19T00:25:01.426913+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDM1Njk=",
            "location": {
              "latitude": 55.525168,
              "longitude": 9.652394,
              "name": "Børup Skovvej 25, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjEwMw==",
          "ticket_id": "20596103",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-07-09Fraktion: 1 (Mad/Rest)Navn: LineTlf.: 22624510Email: linel86@hotmail.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-23T18:05:00+00:00",
          "updated_at": "2025-08-19T00:25:01.430745+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDM1Njk=",
            "location": {
              "latitude": 55.525168,
              "longitude": 9.652394,
              "name": "Børup Skovvej 25, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY5MDI=",
      "location": {
        "name": "Børup Skovvej 33 7000 Fredericia",
        "latitude": 55.522062,
        "longitude": 9.651816
      },
      "containers": [
        {
          "id": "mp-pc-465",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-465",
            "container_id": "MP-7004-22",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NjEwMg==",
          "ticket_id": "20596102",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdag 23.07.21...beholder ikke tømt.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-23T20:05:00+00:00",
          "updated_at": "2025-08-19T00:25:01.430688+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY5MDI=",
            "location": {
              "latitude": 55.522062,
              "longitude": 9.651814,
              "name": "Børup Skovvej 33, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDM1NzA=",
      "location": {
        "name": "Børup Skovvej 49 7000 Fredericia",
        "latitude": 55.520966,
        "longitude": 9.651507
      },
      "containers": [
        {
          "id": "mp-pc-466",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-466",
            "container_id": "MP-7004-23",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NjAwOA==",
          "ticket_id": "20596008",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Hanne BaxterTlf.: 21385702Email: hbaxter@mail.dkBesked: Hvor er min skraldespand? Den er hentet men ikke kommet tilbage",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-26T17:11:00+00:00",
          "updated_at": "2025-08-19T00:25:01.425096+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDM1NzA=",
            "location": {
              "latitude": 55.520966,
              "longitude": 9.651507,
              "name": "Børup Skovvej 49, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjAyMw==",
          "ticket_id": "20596023",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-07-23Fraktion: 1 (Mad/Rest)Navn: Hanne BaxterTlf.: 21385702Email: hbaxter@mail.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-26T13:27:00+00:00",
          "updated_at": "2025-08-19T00:25:01.425983+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDM1NzA=",
            "location": {
              "latitude": 55.520966,
              "longitude": 9.651507,
              "name": "Børup Skovvej 49, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjAzMA==",
          "ticket_id": "20596030",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Navn: Hanne BaxterTlf.: 21385702Email: hbaxter@mail.dkBesked: Ingen på Børup Skovvej fik tømt 23/7 og nu står næste tømning til august, det kan vel ikke passe?",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-26T11:19:00+00:00",
          "updated_at": "2025-08-19T00:25:01.426387+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDM1NzA=",
            "location": {
              "latitude": 55.520966,
              "longitude": 9.651507,
              "name": "Børup Skovvej 49, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY5MDM=",
      "location": {
        "name": "Børup Skovvej 51 7000 Fredericia",
        "latitude": 55.520639,
        "longitude": 9.651545
      },
      "containers": [
        {
          "id": "mp-pc-467",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-467",
            "container_id": "MP-7004-24",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NDAzNg==",
          "ticket_id": "20584036",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2023-08-04Fraktion: 1 (Mad/Rest)Navn: Randi Sylvester Hvid Tlf.: 21472391Email: randisylvester@gmail.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2023-08-07T13:21:00+00:00",
          "updated_at": "2025-08-19T00:25:00.536013+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY5MDM=",
            "location": {
              "latitude": 55.520639,
              "longitude": 9.651545,
              "name": "Børup Skovvej 51, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjAwNw==",
          "ticket_id": "20596007",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Vi har ikke fået tømt vores affaldsbeholder. Hvornår får vi det gjort? Skulle have været i fredags.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-26T15:17:00+00:00",
          "updated_at": "2025-08-19T00:25:01.425040+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY5MDM=",
            "location": {
              "latitude": 55.520639,
              "longitude": 9.651545,
              "name": "Børup Skovvej 51, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDg1MTQ=",
      "location": {
        "name": "Børup Skovvej 24 7000 Fredericia",
        "latitude": 55.523123,
        "longitude": 9.651601
      },
      "containers": [
        {
          "id": "mp-pc-468",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-468",
            "container_id": "MP-7004-26",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NTI1OA==",
          "ticket_id": "20595258",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-08-06Fraktion: 1 (Mad/Rest)Navn: Merete LyhneTlf.: 23748365Email: bentor@privat.dkBesked: Beholderen er som sidste tømmedag ikke tømt",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-09T19:07:00+00:00",
          "updated_at": "2025-08-19T00:25:01.376658+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTQ=",
            "location": {
              "latitude": 55.523123,
              "longitude": 9.651601,
              "name": "Børup Skovvej 24, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NjA5MA==",
          "ticket_id": "20596090",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-07-23Fraktion: 1 (Mad/Rest)Navn: Merete LyhneTlf.: 23748365Email: bentor@privat.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-24T13:26:00+00:00",
          "updated_at": "2025-08-19T00:25:01.430008+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDg1MTQ=",
            "location": {
              "latitude": 55.523123,
              "longitude": 9.651601,
              "name": "Børup Skovvej 24, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTA3ODM=",
      "location": {
        "name": "Mærskkildevej 3 7000 Fredericia",
        "latitude": 55.559812,
        "longitude": 9.604543
      },
      "containers": [
        {
          "id": "mp-pc-469",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-469",
            "container_id": "MP-7004-27",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3ODYyOA==",
          "ticket_id": "20578628",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2024-09-06Fraktion: 1 (Mad/Rest)Navn: Hanne NielsenTlf.: 60715424Email: hfb.hanne@live.dkBesked: Hvad der gik galt kan jeg ikke svare på, men vores beholder blev sat ned torsdag den 5/9 kl 18:00.",
          "status": 6,
          "priority": 2,
          "created_at": "2024-09-07T11:51:00+00:00",
          "updated_at": "2025-08-19T00:25:00.207581+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTA3ODM=",
            "location": {
              "latitude": 55.559812,
              "longitude": 9.604543,
              "name": "Mærskkildevej 3, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZTo3MjY0MzIz",
          "ticket_id": "7264323",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2023-09-21T08:13:19.794162+00:00",
          "updated_at": "2023-09-21T08:13:19.810801+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTA3ODM=",
            "location": {
              "latitude": 55.559812,
              "longitude": 9.604543,
              "name": "Mærskkildevej 3, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "21992_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NzQzOA==",
          "ticket_id": "20587438",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2022-09-23Fraktion: 1 (Mad/Rest)Navn: Hanne NielsenTlf.: 60715424Email: hfb.hanne@live.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2022-09-24T10:35:00+00:00",
          "updated_at": "2025-08-19T00:25:00.798145+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTA3ODM=",
            "location": {
              "latitude": 55.559812,
              "longitude": 9.604543,
              "name": "Mærskkildevej 3, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTA3ODQ=",
      "location": {
        "name": "Mærskkildevej 26 7000 Fredericia",
        "latitude": 55.561953,
        "longitude": 9.614642
      },
      "containers": [
        {
          "id": "mp-pc-470",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-470",
            "container_id": "MP-7004-28",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NzI2NA==",
          "ticket_id": "20587264",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Borger gør opmærksom på, at de ikke har fået tømt i en måneds tid nu. De har beholderen stående fremme hele tiden, da det vist er en stor grund. Jeg har oplyst om, at der gerne skulle være tømt to gange i september og den 30. var den ikke stillet frem. Vil I undersøge og tømme hurtigst muligt? Giv gerne besked, hvis der er problemer på adressen. Gerne et billede, hvis den ikke står fremme.",
          "status": 6,
          "priority": 2,
          "created_at": "2022-10-10T14:56:00+00:00",
          "updated_at": "2025-08-19T00:25:00.775990+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTA3ODQ=",
            "location": {
              "latitude": 55.561953,
              "longitude": 9.614642,
              "name": "Mærskkildevej 26, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTY4NjU=",
      "location": {
        "name": "Nyvangen 4 7000 Fredericia",
        "latitude": 55.55893588,
        "longitude": 9.58811352
      },
      "containers": [
        {
          "id": "mp-pc-471",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-471",
            "container_id": "MP-7004-29",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTA5Mzg=",
      "location": {
        "name": "Nyvangen 15 7000 Fredericia",
        "latitude": 55.560049,
        "longitude": 9.585947
      },
      "containers": [
        {
          "id": "mp-pc-472",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-472",
            "container_id": "MP-7004-30",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTA5NDA=",
      "location": {
        "name": "Nyvangen 25 7000 Fredericia",
        "latitude": 55.564375,
        "longitude": 9.585708
      },
      "containers": [
        {
          "id": "mp-pc-473",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-473",
            "container_id": "MP-7004-31",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3ODUwNQ==",
          "ticket_id": "20578505",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Der er ikke tømt genbrugsaffald som ellers planlagt d. 17. Sækkene er sat ud rettidig, står i skel, ingen knude, ikke overfyldte. Kan I være behjælpelig med tømning og forklaring på hvorfor dette ikke blev gjort d. 17.? Har vi gjort noget forkert?",
          "status": 6,
          "priority": 2,
          "created_at": "2024-09-19T07:08:00+00:00",
          "updated_at": "2025-08-19T00:25:00.200389+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTA5NDA=",
            "location": {
              "latitude": 55.564375,
              "longitude": 9.585708,
              "name": "Nyvangen 25, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3ODUxOA==",
          "ticket_id": "20578518",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2024-09-17T14:46:00+00:00",
          "updated_at": "2025-08-19T00:25:00.201178+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTA5NDA=",
            "location": {
              "latitude": 55.564375,
              "longitude": 9.585708,
              "name": "Nyvangen 25, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTA5Mzk=",
      "location": {
        "name": "Nyvangen 33 7000 Fredericia",
        "latitude": 55.568612,
        "longitude": 9.585985
      },
      "containers": [
        {
          "id": "mp-pc-474",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-474",
            "container_id": "MP-7004-32",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDkzMjM=",
      "location": {
        "name": "Gl. Ribevej 99 7000 Fredericia",
        "latitude": 55.569754,
        "longitude": 9.587423
      },
      "containers": [
        {
          "id": "mp-pc-475",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-475",
            "container_id": "MP-7004-33",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDkzMjI=",
      "location": {
        "name": "Gl. Ribevej 98 7000 Fredericia",
        "latitude": 55.569955,
        "longitude": 9.586718
      },
      "containers": [
        {
          "id": "mp-pc-476",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-476",
            "container_id": "MP-7004-34",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MzQxMw==",
          "ticket_id": "20583413",
          "ticket_type": "AO-Generel besked",
          "description": "Der er ordinær tømning fredag - står helt ude ved vejen - er i fare for trafik og vælter ofte i blæst - er derfor flyttet 30 cm tilbage op ad en mur. Vigtigt, at der tømmes. Det er glippet et par gange. Evt. ekstra sæk skal tages med.",
          "status": 6,
          "priority": 2,
          "created_at": "2023-10-24T13:38:00+00:00",
          "updated_at": "2025-08-19T00:25:00.498987+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDkzMjI=",
            "location": {
              "latitude": 55.569955,
              "longitude": 9.58672,
              "name": "Gl. Ribevej 98, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDkzMjE=",
      "location": {
        "name": "Gl. Ribevej 95 7000 Fredericia",
        "latitude": 55.569207,
        "longitude": 9.592193
      },
      "containers": [
        {
          "id": "mp-pc-477",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-477",
            "container_id": "MP-7004-35",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NzEzOA==",
          "ticket_id": "20587138",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: 2-delt 240 l beholder - Parcel Gl. Ribevej 95 1 (7000 Fredericia) ContainerNr:410465 ContainerBrik:004000001264082C Beholder revnet Ønsket virkningsdato: 03/11 2022 Besked: Kontaktoplysninger: Karen-Margrethe Dupont",
          "status": 6,
          "priority": 2,
          "created_at": "2022-10-28T10:36:00+00:00",
          "updated_at": "2025-08-19T00:25:00.761546+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDkzMjE=",
            "location": {
              "latitude": 55.569207,
              "longitude": 9.592193,
              "name": "Gl. Ribevej 95, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDkzMjA=",
      "location": {
        "name": "Gl. Ribevej 92 7000 Fredericia",
        "latitude": 55.569218,
        "longitude": 9.594853
      },
      "containers": [
        {
          "id": "mp-pc-478",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-478",
            "container_id": "MP-7004-36",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NjY1OA==",
          "ticket_id": "20586658",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Louise Skou Laxy Tlf.: 61766729Email: louiseskoulaxy@gmail.comBesked: Hvordan får man slettet sit nummer, når man er flyttet og ikke vil have SMS om tømning på den gamle adresse mere",
          "status": 6,
          "priority": 2,
          "created_at": "2022-12-09T08:30:00+00:00",
          "updated_at": "2025-08-19T00:25:00.723687+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDkzMjA=",
            "location": {
              "latitude": 55.569218,
              "longitude": 9.594853,
              "name": "Gl. Ribevej 92, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDkzMTk=",
      "location": {
        "name": "Gl. Ribevej 91 7000 Fredericia",
        "latitude": 55.569007,
        "longitude": 9.594828
      },
      "containers": [
        {
          "id": "mp-pc-479",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-479",
            "container_id": "MP-7004-37",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NDcwMw==",
          "ticket_id": "20594703",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: DmytroTlf.: 50188759Email: shaptala1000@gmail.comBesked: Jeg har brug for nye papirmarkører til skraldespand.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-25T18:28:00+00:00",
          "updated_at": "2025-08-19T00:25:01.342691+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDkzMTk=",
            "location": {
              "latitude": 55.569007,
              "longitude": 9.594804,
              "name": "Gl. Ribevej 91, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDkzMTg=",
      "location": {
        "name": "Gl. Ribevej 89 7000 Fredericia",
        "latitude": 55.568673,
        "longitude": 9.598181
      },
      "containers": [
        {
          "id": "mp-pc-480",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-480",
            "container_id": "MP-7004-38",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDkzMTY=",
      "location": {
        "name": "Gl. Ribevej 81 7000 Fredericia",
        "latitude": 55.568383,
        "longitude": 9.600881
      },
      "containers": [
        {
          "id": "mp-pc-481",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-481",
            "container_id": "MP-7004-39",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NDE5OA==",
          "ticket_id": "20584198",
          "ticket_type": "AO-Generel besked",
          "description": "Borger indskærper, at beholder skal sættes på plads og ikke sættes på vejen.",
          "status": 6,
          "priority": 2,
          "created_at": "2023-07-07T11:34:00+00:00",
          "updated_at": "2025-08-19T00:25:00.545402+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDkzMTY=",
            "location": {
              "latitude": 55.568383,
              "longitude": 9.600881,
              "name": "Gl. Ribevej 81, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDkzMTc=",
      "location": {
        "name": "Gl. Ribevej 86 7000 Fredericia",
        "latitude": 55.568305,
        "longitude": 9.603549
      },
      "containers": [
        {
          "id": "mp-pc-482",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-482",
            "container_id": "MP-7004-40",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MDY4OQ==",
          "ticket_id": "20580689",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Farligt affald Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 30/05 2024 Besked: Udleveret d. 6/7-23 Kontaktoplysninger: Carsten Søndermølle Sørensen",
          "status": 6,
          "priority": 2,
          "created_at": "2024-05-23T09:36:00+00:00",
          "updated_at": "2025-08-19T00:25:00.330142+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDkzMTc=",
            "location": {
              "latitude": 55.568305,
              "longitude": 9.603549,
              "name": "Gl. Ribevej 86, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MDA4NA==",
          "ticket_id": "20590084",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Manglende tømning. Har fået ny spand pga brand.",
          "status": 6,
          "priority": 2,
          "created_at": "2022-03-23T11:54:00+00:00",
          "updated_at": "2025-08-19T00:25:01.045285+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDkzMTc=",
            "location": {
              "latitude": 55.568305,
              "longitude": 9.603549,
              "name": "Gl. Ribevej 86, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MDUzMA==",
          "ticket_id": "20590530",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Ønsket virkningsdato: 08/03 2022 Besked: Kontaktoplysninger: Carsten Søndermølle Sørensen",
          "status": 6,
          "priority": 2,
          "created_at": "2022-03-01T14:01:00+00:00",
          "updated_at": "2025-08-19T00:25:01.073441+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDkzMTc=",
            "location": {
              "latitude": 55.568305,
              "longitude": 9.603549,
              "name": "Gl. Ribevej 86, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDM5NDU=",
      "location": {
        "name": "Gl. Ribevej 76 7000 Fredericia",
        "latitude": 55.567642,
        "longitude": 9.610521
      },
      "containers": [
        {
          "id": "mp-pc-483",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-483",
            "container_id": "MP-7004-41",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDEyMzAxNw==",
          "ticket_id": "10123017",
          "ticket_type": "Indeholder småt elektronik - læg i frysepose (sækkeordning) eller brug kassen (miljøstation)",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-06-17T05:26:23.689939+00:00",
          "updated_at": "2024-06-17T05:26:23.690786+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDM5NDU=",
            "location": {
              "latitude": 55.56764,
              "longitude": 9.610521,
              "name": "Gl. Ribevej 76, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "18600_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZTo4MDc2NTIy",
          "ticket_id": "8076522",
          "ticket_type": "Sækken indeholder farligt affald - brug den røde kasse",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2023-10-16T11:39:32.935330+00:00",
          "updated_at": "2023-10-16T11:39:32.944991+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDM5NDU=",
            "location": {
              "latitude": 55.56764,
              "longitude": 9.610521,
              "name": "Gl. Ribevej 76, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "18600_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDkzMTU=",
      "location": {
        "name": "Gl. Ribevej 74 7000 Fredericia",
        "latitude": 55.567607,
        "longitude": 9.611285
      },
      "containers": [
        {
          "id": "mp-pc-484",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-484",
            "container_id": "MP-7004-42",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NzAwNg==",
          "ticket_id": "20597006",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Skulle have været tømt 9.7.. Er ikke fyldt, så kunden kan vente til næste tømmedag. Vær obs på, at der tømmes den 28.7.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-12T11:35:00+00:00",
          "updated_at": "2025-08-19T00:25:01.483630+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDkzMTU=",
            "location": {
              "latitude": 55.567607,
              "longitude": 9.611285,
              "name": "Gl. Ribevej 74, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDkzMTQ=",
      "location": {
        "name": "Gl. Ribevej 72 7000 Fredericia",
        "latitude": 55.567534,
        "longitude": 9.612101
      },
      "containers": [
        {
          "id": "mp-pc-485",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-485",
            "container_id": "MP-7004-43",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDkzMTM=",
      "location": {
        "name": "Gl. Ribevej 70 7000 Fredericia",
        "latitude": 55.567286,
        "longitude": 9.614421
      },
      "containers": [
        {
          "id": "mp-pc-486",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-486",
            "container_id": "MP-7004-44",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NDQ5Mw==",
          "ticket_id": "20594493",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-08-20Fraktion: 1 (Mad/Rest)Navn: Nicklas ElkjærTlf.: 26111294Email: nicklas2210@hotmail.comBesked: 2. gang i træk",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-21T21:42:00+00:00",
          "updated_at": "2025-08-19T00:25:01.329347+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDkzMTM=",
            "location": {
              "latitude": 55.567286,
              "longitude": 9.614421,
              "name": "Gl. Ribevej 70, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTcwMDI=",
      "location": {
        "name": "Gl. Ribevej 105 7000 Fredericia",
        "latitude": 55.56828823,
        "longitude": 9.57718983
      },
      "containers": [
        {
          "id": "mp-pc-487",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-487",
            "container_id": "MP-7004-46",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDkzMjY=",
      "location": {
        "name": "Gl. Ribevej 106 7000 Fredericia",
        "latitude": 55.568636,
        "longitude": 9.575715
      },
      "containers": [
        {
          "id": "mp-pc-488",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-488",
            "container_id": "MP-7004-47",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDM5NDY=",
      "location": {
        "name": "Gl. Ribevej 110 7000 Fredericia",
        "latitude": 55.567844,
        "longitude": 9.570424
      },
      "containers": [
        {
          "id": "mp-pc-489",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-489",
            "container_id": "MP-7004-48",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDkzMjU=",
      "location": {
        "name": "Gl. Ribevej 103 7000 Fredericia",
        "latitude": 55.568556,
        "longitude": 9.580654
      },
      "containers": [
        {
          "id": "mp-pc-490",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-490",
            "container_id": "MP-7004-49",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZTo4MDc2NDk0",
          "ticket_id": "8076494",
          "ticket_type": "Affaldet skal afleveres på genbrugspladsen",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2023-10-16T11:27:23.131200+00:00",
          "updated_at": "2023-10-16T11:27:23.145555+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDkzMjU=",
            "location": {
              "latitude": 55.568556,
              "longitude": 9.580654,
              "name": "Gl. Ribevej 103, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "18627_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDkzMjQ=",
      "location": {
        "name": "Gl. Ribevej 101 7000 Fredericia",
        "latitude": 55.568349,
        "longitude": 9.583988
      },
      "containers": [
        {
          "id": "mp-pc-491",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-491",
            "container_id": "MP-7004-50",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMTQzNjgz",
          "ticket_id": "1143683",
          "ticket_type": "Beholder overfyldt",
          "description": "",
          "status": 1,
          "priority": 1,
          "created_at": "2023-01-18T12:43:33.912790+00:00",
          "updated_at": "2023-01-18T12:43:33.926671+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": {
            "name": null
          },
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDkzMjQ=",
            "location": {
              "latitude": 55.568349,
              "longitude": 9.583988,
              "name": "Gl. Ribevej 101, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "18626_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDk5MDY=",
      "location": {
        "name": "Højrupvej 125 7000 Fredericia",
        "latitude": 55.566125,
        "longitude": 9.60255
      },
      "containers": [
        {
          "id": "mp-pc-492",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-492",
            "container_id": "MP-7004-51",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDk5MDQ=",
      "location": {
        "name": "Højrupvej 115 7000 Fredericia",
        "latitude": 55.564498,
        "longitude": 9.60084
      },
      "containers": [
        {
          "id": "mp-pc-493",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-493",
            "container_id": "MP-7004-52",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDAxNzA2NA==",
          "ticket_id": "10017064",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-02-20T09:04:30.220503+00:00",
          "updated_at": "2024-02-20T09:04:30.247525+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk5MDQ=",
            "location": {
              "latitude": 55.564498,
              "longitude": 9.60084,
              "name": "Højrupvej 115, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "21972_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDk5MDU=",
      "location": {
        "name": "Højrupvej 117 7000 Fredericia",
        "latitude": 55.565046,
        "longitude": 9.599957
      },
      "containers": [
        {
          "id": "mp-pc-494",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-494",
            "container_id": "MP-7004-53",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NTA0Ng==",
          "ticket_id": "20575046",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Der er ikke tømt, selvom logget. Den er logget langt derfra. Vil I tømme hurtigst muligt?",
          "status": 6,
          "priority": 2,
          "created_at": "2025-06-23T14:27:00+00:00",
          "updated_at": "2025-08-19T00:24:59.884567+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk5MDU=",
            "location": {
              "latitude": 55.565046,
              "longitude": 9.599957,
              "name": "Højrupvej 117, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDk4ODU=",
      "location": {
        "name": "Højrupvej 119 7000 Fredericia",
        "latitude": 55.564635,
        "longitude": 9.602958
      },
      "containers": [
        {
          "id": "mp-pc-495",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-495",
            "container_id": "MP-7004-54",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTE4NDU=",
      "location": {
        "name": "Sdr. Vilstrupvej 2 7000 Fredericia",
        "latitude": 55.5562082,
        "longitude": 9.6017121
      },
      "containers": [
        {
          "id": "mp-pc-496",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-496",
            "container_id": "MP-7004-56",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L"
            }
          }
        },
        {
          "id": "mp-pc-497",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-497",
            "container_id": "MP-7004-57",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NTIzNw==",
          "ticket_id": "20585237",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 240 l rest - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 27/03 2023 Besked: Kontaktoplysninger: Kristian Hansen 24474306 Krillel_3@hotmail.com",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-20T11:01:00+00:00",
          "updated_at": "2025-08-19T00:25:00.605429+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE4NDU=",
            "location": {
              "latitude": 55.556208,
              "longitude": 9.601712,
              "name": "Sdr. Vilstrupvej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTIzOA==",
          "ticket_id": "20585238",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: 2-delt 240 l beholder - Parcel Sdr. Vilstrupvej 2 1 (7000 Fredericia) ContainerNr:412983 ContainerBrik:004000001264022B Ønsket virkningsdato: 27/03 2023 Besked: Kontaktoplysninger: Kristian Hansen 24474306 Krillel_3@hotmail.com",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-20T11:00:00+00:00",
          "updated_at": "2025-08-19T00:25:00.605486+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE4NDU=",
            "location": {
              "latitude": 55.556208,
              "longitude": 9.601712,
              "name": "Sdr. Vilstrupvej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTIzOQ==",
          "ticket_id": "20585239",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 27/03 2023 Besked: Kontaktoplysninger: Kristian Hansen 24474306 Krillel_3@hotmail.com",
          "status": 6,
          "priority": 2,
          "created_at": "2023-03-20T10:59:00+00:00",
          "updated_at": "2025-08-19T00:25:00.605542+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE4NDU=",
            "location": {
              "latitude": 55.556208,
              "longitude": 9.601712,
              "name": "Sdr. Vilstrupvej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTE4NDY=",
      "location": {
        "name": "Sdr. Vilstrupvej 4 7000 Fredericia",
        "latitude": 55.556545,
        "longitude": 9.600069
      },
      "containers": [
        {
          "id": "mp-pc-498",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-498",
            "container_id": "MP-7004-58",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NDU4NA==",
          "ticket_id": "20594584",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Anne Sophie BasseTlf.: 21425343Email: asb@staldbasse.dkBesked: Hej. Før vi fik nye beholdere, havde vi købt en ekstra stor beholder og betalte for det. Så mit spørgsmål er om vi ikke burde have en størrer beholder denne gang også. Med venlig hilsen Anne Sophie Basse",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-29T09:07:00+00:00",
          "updated_at": "2025-08-19T00:25:01.335050+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE4NDY=",
            "location": {
              "latitude": 55.556545,
              "longitude": 9.600069,
              "name": "Sdr. Vilstrupvej 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTE4NDg=",
      "location": {
        "name": "Sdr. Vilstrupvej 15 7000 Fredericia",
        "latitude": 55.556566,
        "longitude": 9.5917
      },
      "containers": [
        {
          "id": "mp-pc-499",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-499",
            "container_id": "MP-7004-59",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MDEwNw==",
          "ticket_id": "20580107",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Hej Jeg har ikke fået tømt min affalds beholder fredag d 7 juni, som kalenderen siger. Er der ændringer i kalenderen ? Eller er der andre årsager ? Mvh",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-12T11:46:00+00:00",
          "updated_at": "2025-08-19T00:25:00.295869+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE4NDg=",
            "location": {
              "latitude": 55.556566,
              "longitude": 9.5917,
              "name": "Sdr. Vilstrupvej 15, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTE4NTc=",
      "location": {
        "name": "Sdr. Vilstrupvej 40 7000 Fredericia",
        "latitude": 55.555059,
        "longitude": 9.581551
      },
      "containers": [
        {
          "id": "mp-pc-500",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-500",
            "container_id": "MP-7004-60",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5Njg5NQ==",
          "ticket_id": "20596895",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "mgl. tømning",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-13T12:06:00+00:00",
          "updated_at": "2025-08-19T00:25:01.476937+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE4NTc=",
            "location": {
              "latitude": 55.555059,
              "longitude": 9.581551,
              "name": "Sdr. Vilstrupvej 40, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NzA3Mw==",
          "ticket_id": "20597073",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Vores skraldespand er ikke blevet tømt i dag som annonceret",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-09T20:01:00+00:00",
          "updated_at": "2025-08-19T00:25:01.487048+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE4NTc=",
            "location": {
              "latitude": 55.555059,
              "longitude": 9.581551,
              "name": "Sdr. Vilstrupvej 40, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDk0NTM=",
      "location": {
        "name": "Sdr. Vilstrupvej 186 7000 Fredericia",
        "latitude": 55.534775,
        "longitude": 9.57547
      },
      "containers": [
        {
          "id": "mp-pc-501",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-501",
            "container_id": "MP-7004-61",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDk0NTQ=",
      "location": {
        "name": "Sdr. Vilstrupvej 183 7000 Fredericia",
        "latitude": 55.53611428,
        "longitude": 9.57655214
      },
      "containers": [
        {
          "id": "mp-pc-502",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-502",
            "container_id": "MP-7004-62",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3OTEzNA==",
          "ticket_id": "20579134",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Borger har ifølge tømmeloggen ikke fået tømt siden den 21. juni? Vil I undersøge og tømme? Han har nemlig rykket for tømning.",
          "status": 6,
          "priority": 2,
          "created_at": "2024-07-29T12:53:00+00:00",
          "updated_at": "2025-08-19T00:25:00.237055+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk0NTQ=",
            "location": {
              "latitude": 55.536114,
              "longitude": 9.576552,
              "name": "Sdr. Vilstrupvej 183, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3OTE2Mg==",
          "ticket_id": "20579162",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: 2-delt 240 l beholder - Parcel Sdr. Vilstrupvej 183 (7000 Fredericia) ContainerNr:410598 ContainerBrik:00400000125C56FA Ønsket virkningsdato: 01/07-2024 Besked: Beholder er fejltilmeldt. Borger har skrevet på samme adresse, men den sag er havnet et andet sted. Kontaktoplysninger: Erling Bang Nielsen",
          "status": 6,
          "priority": 2,
          "created_at": "2024-07-29T12:52:00+00:00",
          "updated_at": "2025-08-19T00:25:00.238660+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk0NTQ=",
            "location": {
              "latitude": 55.536114,
              "longitude": 9.576552,
              "name": "Sdr. Vilstrupvej 183, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3OTE2NQ==",
          "ticket_id": "20579165",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/07-2024 Besked: Borger rykker for tømning, men af en ukendt årsag, er der ikke registreret en beholder på adressen. Den tilmeldes d.d. til tømning fredag i ulige uger. Kontaktoplysninger: Erling Bang Nielsen",
          "status": 6,
          "priority": 2,
          "created_at": "2024-07-29T10:45:00+00:00",
          "updated_at": "2025-08-19T00:25:00.238833+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk0NTQ=",
            "location": {
              "latitude": 55.536114,
              "longitude": 9.576552,
              "name": "Sdr. Vilstrupvej 183, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTE4NTQ=",
      "location": {
        "name": "Sdr. Vilstrupvej 33 7000 Fredericia",
        "latitude": 55.553919,
        "longitude": 9.58349
      },
      "containers": [
        {
          "id": "mp-pc-503",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-503",
            "container_id": "MP-7004-63",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTE4NTY=",
      "location": {
        "name": "Sdr. Vilstrupvej 37 7000 Fredericia",
        "latitude": 55.552977,
        "longitude": 9.583684
      },
      "containers": [
        {
          "id": "mp-pc-504",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-504",
            "container_id": "MP-7004-64",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTE4NTU=",
      "location": {
        "name": "Sdr. Vilstrupvej 34 7000 Fredericia",
        "latitude": 55.555304,
        "longitude": 9.583631
      },
      "containers": [
        {
          "id": "mp-pc-505",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-505",
            "container_id": "MP-7004-65",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTE4NTE=",
      "location": {
        "name": "Sdr. Vilstrupvej 26 7000 Fredericia",
        "latitude": 55.555511,
        "longitude": 9.584517
      },
      "containers": [
        {
          "id": "mp-pc-506",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-506",
            "container_id": "MP-7004-66",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTE4NTM=",
      "location": {
        "name": "Sdr. Vilstrupvej 30 7000 Fredericia",
        "latitude": 55.558041,
        "longitude": 9.582632
      },
      "containers": [
        {
          "id": "mp-pc-507",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-507",
            "container_id": "MP-7004-67",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTE4NTI=",
      "location": {
        "name": "Sdr. Vilstrupvej 27 7000 Fredericia",
        "latitude": 55.555206,
        "longitude": 9.585686
      },
      "containers": [
        {
          "id": "mp-pc-508",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-508",
            "container_id": "MP-7004-68",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDYwMDYwNg==",
          "ticket_id": "20600606",
          "ticket_type": "AO-Ændring til 180-190 liter beholder til restaffald",
          "description": "Hej Jeg ønsker at få en større beholder til restaffald, er det noget I leverer eller hvordan??? Med venlig hilsen Ulrik Andersen",
          "status": 6,
          "priority": 2,
          "created_at": "2016-09-26T19:34:00+00:00",
          "updated_at": "2025-08-19T00:25:01.704480+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE4NTI=",
            "location": {
              "latitude": 55.555206,
              "longitude": 9.585686,
              "name": "Sdr. Vilstrupvej 27, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTE4NDk=",
      "location": {
        "name": "Sdr. Vilstrupvej 21 7000 Fredericia",
        "latitude": 55.556407,
        "longitude": 9.589168
      },
      "containers": [
        {
          "id": "mp-pc-509",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-509",
            "container_id": "MP-7004-69",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTE4NTA=",
      "location": {
        "name": "Sdr. Vilstrupvej 22 7000 Fredericia",
        "latitude": 55.556462,
        "longitude": 9.588084
      },
      "containers": [
        {
          "id": "mp-pc-510",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-510",
            "container_id": "MP-7004-70",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDA0MjQxMw==",
          "ticket_id": "10042413",
          "ticket_type": "Affaldet skal sorteres som restaffald",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-03-19T09:03:01.144315+00:00",
          "updated_at": "2024-03-19T09:03:01.145069+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE4NTA=",
            "location": {
              "latitude": 55.556462,
              "longitude": 9.588084,
              "name": "Sdr. Vilstrupvej 22, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "21938_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTE4NDc=",
      "location": {
        "name": "Sdr. Vilstrupvej 5 7000 Fredericia",
        "latitude": 55.555641,
        "longitude": 9.601186
      },
      "containers": [
        {
          "id": "mp-pc-511",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-511",
            "container_id": "MP-7004-71",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTE4OTI=",
      "location": {
        "name": "Taulov Engvej 8 7000 Fredericia",
        "latitude": 55.547766,
        "longitude": 9.608875
      },
      "containers": [
        {
          "id": "mp-pc-512",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-512",
            "container_id": "MP-7004-72",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4NDUxNA==",
          "ticket_id": "20584514",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Lasse NissenTlf.: 30128755Email: Lassehemdorffnissen@gmail.comBesked: Vi undre os over at vi ikke har fået sække til genbrug, de sidste 18 måneder.",
          "status": 6,
          "priority": 2,
          "created_at": "2023-06-13T22:10:00+00:00",
          "updated_at": "2025-08-19T00:25:00.564340+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE4OTI=",
            "location": {
              "latitude": 55.547766,
              "longitude": 9.608875,
              "name": "Taulov Engvej 8, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDYwMDY2OQ==",
          "ticket_id": "20600669",
          "ticket_type": "AO-Generel besked",
          "description": "Har overtaget ejendommen og der mangler tømning af både restaffald og grønt affald!",
          "status": 6,
          "priority": 2,
          "created_at": "2016-07-19T23:30:00+00:00",
          "updated_at": "2025-08-19T00:25:01.708236+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE4OTI=",
            "location": {
              "latitude": 55.547766,
              "longitude": 9.608875,
              "name": "Taulov Engvej 8, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc0MTI=",
      "location": {
        "name": "Møllersmindevej 31 7000 Fredericia",
        "latitude": 55.550761,
        "longitude": 9.625456
      },
      "containers": [
        {
          "id": "mp-pc-513",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-513",
            "container_id": "MP-7004-73",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDY1MTQ=",
      "location": {
        "name": "Møllersmindevej 35 7000 Fredericia",
        "latitude": 55.551772,
        "longitude": 9.627973
      },
      "containers": [
        {
          "id": "mp-pc-514",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-514",
            "container_id": "MP-7004-74",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZTo0MTQ4MDE0MA==",
          "ticket_id": "41480140",
          "ticket_type": "Affaldet skal sorteres som restaffald",
          "description": "",
          "status": 2,
          "priority": 0,
          "created_at": "2025-10-16T11:28:07.009308+00:00",
          "updated_at": "2025-10-16T11:28:07.010557+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY1MTQ=",
            "location": {
              "latitude": 55.551772,
              "longitude": 9.627973,
              "name": "Møllersmindevej 35, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "21926_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZTo0MTQ4MDEzOQ==",
          "ticket_id": "41480139",
          "ticket_type": "Affaldet skal sorteres som restaffald",
          "description": "",
          "status": 2,
          "priority": 0,
          "created_at": "2025-10-16T11:27:07.868839+00:00",
          "updated_at": "2025-10-16T11:27:07.870070+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY1MTQ=",
            "location": {
              "latitude": 55.551772,
              "longitude": 9.627973,
              "name": "Møllersmindevej 35, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "21926_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToxMDEwMDk5Mg==",
          "ticket_id": "10100992",
          "ticket_type": "Affaldet skal afleveres på genbrugspladsen",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-05-22T11:35:42.575456+00:00",
          "updated_at": "2024-05-22T11:35:42.576306+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY1MTQ=",
            "location": {
              "latitude": 55.551772,
              "longitude": 9.627973,
              "name": "Møllersmindevej 35, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "21926_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToxMDA3MTQ1NQ==",
          "ticket_id": "10071455",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-04-18T11:36:30.240051+00:00",
          "updated_at": "2024-04-18T11:36:30.240804+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY1MTQ=",
            "location": {
              "latitude": 55.551772,
              "longitude": 9.627973,
              "name": "Møllersmindevej 35, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "21926_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToxMDA0MjkxMA==",
          "ticket_id": "10042910",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-03-19T12:28:47.736319+00:00",
          "updated_at": "2024-03-19T12:28:47.737268+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY1MTQ=",
            "location": {
              "latitude": 55.551772,
              "longitude": 9.627973,
              "name": "Møllersmindevej 35, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "21926_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToxMDAxNzUxMA==",
          "ticket_id": "10017510",
          "ticket_type": "Affaldet skal afleveres på genbrugspladsen",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-02-20T12:50:18.004507+00:00",
          "updated_at": "2024-02-20T12:50:18.030767+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY1MTQ=",
            "location": {
              "latitude": 55.551772,
              "longitude": 9.627973,
              "name": "Møllersmindevej 35, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "21926_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5ODk1MA==",
          "ticket_id": "20598950",
          "ticket_type": "AO-Generel besked",
          "description": "Hej der er smidt affald på Højen på Møllersmindevej noget er køkkenaffald. Da der er ret meget har vi ikke plads i vores affaldsspande. noget i vil og kan hjælpe med eller hvem skal jeg henvende mig til i kommunen Med venlig hilsen Helle Greiner 60196343",
          "status": 6,
          "priority": 2,
          "created_at": "2020-03-15T14:14:00+00:00",
          "updated_at": "2025-08-19T00:25:01.601258+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDY1MTQ=",
            "location": {
              "latitude": 55.551772,
              "longitude": 9.627973,
              "name": "Møllersmindevej 35, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc0MTM=",
      "location": {
        "name": "Taulov Skovvej 39 7000 Fredericia",
        "latitude": 55.556278,
        "longitude": 9.625248
      },
      "containers": [
        {
          "id": "mp-pc-515",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-515",
            "container_id": "MP-7004-75",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NzczNQ==",
          "ticket_id": "20577735",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Manglende snerydning Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2024-11-22T09:01:00+00:00",
          "updated_at": "2025-08-19T00:25:00.156538+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc0MTM=",
            "location": {
              "latitude": 55.556278,
              "longitude": 9.625248,
              "name": "Taulov Skovvej 39, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3ODM4Ng==",
          "ticket_id": "20578386",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Adgangsvej spærret Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2024-09-27T08:26:00+00:00",
          "updated_at": "2025-08-19T00:25:00.193275+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc0MTM=",
            "location": {
              "latitude": 55.556278,
              "longitude": 9.625248,
              "name": "Taulov Skovvej 39, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDMzNg==",
          "ticket_id": "20580336",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "AT-tilsyn ønskes Er der afleveret flyer: Nej Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-07T09:45:00+00:00",
          "updated_at": "2025-08-19T00:25:00.309080+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc0MTM=",
            "location": {
              "latitude": 55.556278,
              "longitude": 9.625248,
              "name": "Taulov Skovvej 39, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MTE3Nw==",
          "ticket_id": "20581177",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Adgangsvej spærret Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2024-03-29T08:40:00+00:00",
          "updated_at": "2025-08-19T00:25:00.361138+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDc0MTM=",
            "location": {
              "latitude": 55.556278,
              "longitude": 9.625248,
              "name": "Taulov Skovvej 39, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTE5MDc=",
      "location": {
        "name": "Taulov Skovvej 41 7000 Fredericia",
        "latitude": 55.556627,
        "longitude": 9.626521
      },
      "containers": [
        {
          "id": "mp-pc-516",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-516",
            "container_id": "MP-7004-76",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NzY2OQ==",
          "ticket_id": "20577669",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2024-11-22Fraktion: 1 (Mad/Rest)Navn: Morten NielsenTlf.: 20710134Email: mortenn2009@live.dkBesked: Hvad er grunden til vi ikke har fået tømt skraldespand endnu?",
          "status": 6,
          "priority": 2,
          "created_at": "2024-11-26T23:20:00+00:00",
          "updated_at": "2025-08-19T00:25:00.153110+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE5MDc=",
            "location": {
              "latitude": 55.556627,
              "longitude": 9.626521,
              "name": "Taulov Skovvej 41, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3NzcyNw==",
          "ticket_id": "20577727",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2024-11-22Fraktion: 1 (Mad/Rest)Navn: Morten NielsenTlf.: 20710134Email: mortenn2009@live.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2024-11-23T13:18:00+00:00",
          "updated_at": "2025-08-19T00:25:00.156124+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE5MDc=",
            "location": {
              "latitude": 55.556627,
              "longitude": 9.626521,
              "name": "Taulov Skovvej 41, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3NzcyMg==",
          "ticket_id": "20577722",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2024-11-08Fraktion: 1 (Mad/Rest)Navn: Morten NielsenTlf.: 20710134Email: mortenn2009@live.dkBesked: Idag 22/11",
          "status": 6,
          "priority": 2,
          "created_at": "2024-11-22T23:51:00+00:00",
          "updated_at": "2025-08-19T00:25:00.155866+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE5MDc=",
            "location": {
              "latitude": 55.556627,
              "longitude": 9.626521,
              "name": "Taulov Skovvej 41, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3NzczNA==",
          "ticket_id": "20577734",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Manglende snerydning Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2024-11-22T09:01:00+00:00",
          "updated_at": "2025-08-19T00:25:00.156485+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE5MDc=",
            "location": {
              "latitude": 55.556627,
              "longitude": 9.626521,
              "name": "Taulov Skovvej 41, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3ODM3NQ==",
          "ticket_id": "20578375",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2024-09-13Fraktion: 1 (Mad/Rest)Navn: Morten NielsenTlf.: 20710134Email: mortenn2009@live.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2024-09-27T13:01:00+00:00",
          "updated_at": "2025-08-19T00:25:00.192537+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE5MDc=",
            "location": {
              "latitude": 55.556627,
              "longitude": 9.626521,
              "name": "Taulov Skovvej 41, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3ODM4NQ==",
          "ticket_id": "20578385",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Adgangsvej spærret Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2024-09-27T08:26:00+00:00",
          "updated_at": "2025-08-19T00:25:00.193217+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE5MDc=",
            "location": {
              "latitude": 55.556627,
              "longitude": 9.626521,
              "name": "Taulov Skovvej 41, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3ODkwNg==",
          "ticket_id": "20578906",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2024-08-16Fraktion: 1 (Mad/Rest)Navn: Morten NielsenTlf.: 20710134Email: mortenn2009@live.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2024-08-19T18:41:00+00:00",
          "updated_at": "2025-08-19T00:25:00.223296+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE5MDc=",
            "location": {
              "latitude": 55.556627,
              "longitude": 9.626521,
              "name": "Taulov Skovvej 41, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3ODg3Mg==",
          "ticket_id": "20578872",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2024-08-16Fraktion: 1 (Mad/Rest)Navn: Morten NielsenTlf.: 20710134Email: mortenn2009@live.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2024-08-19T18:41:00+00:00",
          "updated_at": "2025-08-19T00:25:00.221543+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE5MDc=",
            "location": {
              "latitude": 55.556627,
              "longitude": 9.626521,
              "name": "Taulov Skovvej 41, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDMzNQ==",
          "ticket_id": "20580335",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "AT-tilsyn ønskes Er der afleveret flyer: Nej Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-07T09:45:00+00:00",
          "updated_at": "2025-08-19T00:25:00.309022+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE5MDc=",
            "location": {
              "latitude": 55.556627,
              "longitude": 9.626521,
              "name": "Taulov Skovvej 41, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTk0MA==",
          "ticket_id": "20591940",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-12-24Fraktion: 1 (Mad/Rest)Navn: Morten NielsenTlf.: 20710134Email: mortenn2009@live.dkBesked: Mine naboer har heller ikke fået tømt. Hvor længe skal vi vente?",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-27T20:55:00+00:00",
          "updated_at": "2025-08-19T00:25:01.181535+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE5MDc=",
            "location": {
              "latitude": 55.556627,
              "longitude": 9.626521,
              "name": "Taulov Skovvej 41, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDUyNTE=",
      "location": {
        "name": "Taulov Skovvej 33 7000 Fredericia",
        "latitude": 55.555909,
        "longitude": 9.623645
      },
      "containers": [
        {
          "id": "mp-pc-517",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-517",
            "container_id": "MP-7004-77",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NzczNg==",
          "ticket_id": "20577736",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Manglende snerydning Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2024-11-22T09:01:00+00:00",
          "updated_at": "2025-08-19T00:25:00.156590+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDUyNTE=",
            "location": {
              "latitude": 55.555909,
              "longitude": 9.623645,
              "name": "Taulov Skovvej 33, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3ODM4Nw==",
          "ticket_id": "20578387",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Adgangsvej spærret Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2024-09-27T08:26:00+00:00",
          "updated_at": "2025-08-19T00:25:00.193335+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDUyNTE=",
            "location": {
              "latitude": 55.555909,
              "longitude": 9.623645,
              "name": "Taulov Skovvej 33, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTE5MDY=",
      "location": {
        "name": "Taulov Skovvej 31 7000 Fredericia",
        "latitude": 55.555782,
        "longitude": 9.622879
      },
      "containers": [
        {
          "id": "mp-pc-518",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-518",
            "container_id": "MP-7004-78",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NzczNw==",
          "ticket_id": "20577737",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Manglende snerydning Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2024-11-22T09:01:00+00:00",
          "updated_at": "2025-08-19T00:25:00.156642+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE5MDY=",
            "location": {
              "latitude": 55.555782,
              "longitude": 9.622879,
              "name": "Taulov Skovvej 31, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3ODM4OA==",
          "ticket_id": "20578388",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Adgangsvej spærret Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2024-09-27T08:26:00+00:00",
          "updated_at": "2025-08-19T00:25:00.193405+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE5MDY=",
            "location": {
              "latitude": 55.555782,
              "longitude": 9.622879,
              "name": "Taulov Skovvej 31, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTE5MDU=",
      "location": {
        "name": "Taulov Skovvej 17 7000 Fredericia",
        "latitude": 55.553098,
        "longitude": 9.626114
      },
      "containers": [
        {
          "id": "mp-pc-519",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-519",
            "container_id": "MP-7004-79",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MDMzNA==",
          "ticket_id": "20580334",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "AT-tilsyn ønskes Er der afleveret flyer: Nej Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-07T09:45:00+00:00",
          "updated_at": "2025-08-19T00:25:00.308966+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE5MDU=",
            "location": {
              "latitude": 55.553098,
              "longitude": 9.626114,
              "name": "Taulov Skovvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDc0MTQ=",
      "location": {
        "name": "Taulov Skovvej 43 7000 Fredericia",
        "latitude": 55.556776,
        "longitude": 9.62713
      },
      "containers": [
        {
          "id": "mp-pc-520",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-520",
            "container_id": "MP-7004-80",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDQ2OTg=",
      "location": {
        "name": "Mogens Lebechs Vej 7 7000 Fredericia",
        "latitude": 55.556759,
        "longitude": 9.629982
      },
      "containers": [
        {
          "id": "mp-pc-521",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-521",
            "container_id": "MP-7004-81",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDQ2OTk=",
      "location": {
        "name": "Mogens Lebechs Vej 15 7000 Fredericia",
        "latitude": 55.557162,
        "longitude": 9.623776
      },
      "containers": [
        {
          "id": "mp-pc-522",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-522",
            "container_id": "MP-7004-82",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTA3NDc=",
      "location": {
        "name": "Mogens Lebechs Vej 19 7000 Fredericia",
        "latitude": 55.557158,
        "longitude": 9.621916
      },
      "containers": [
        {
          "id": "mp-pc-523",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-523",
            "container_id": "MP-7004-83",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5Nzc2NQ==",
          "ticket_id": "20597765",
          "ticket_type": "AO-Generel besked",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-02T10:23:00+00:00",
          "updated_at": "2025-08-19T00:25:01.528131+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTA3NDc=",
            "location": {
              "latitude": 55.557158,
              "longitude": 9.621916,
              "name": "Mogens Lebechs Vej 19, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTA3NDg=",
      "location": {
        "name": "Mogens Lebechs Vej 23 7000 Fredericia",
        "latitude": 55.557348,
        "longitude": 9.621277
      },
      "containers": [
        {
          "id": "mp-pc-524",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-524",
            "container_id": "MP-7004-84",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTE4ODY=",
      "location": {
        "name": "Møllersmindevej 24 7000 Fredericia",
        "latitude": 55.550721,
        "longitude": 9.626502
      },
      "containers": [
        {
          "id": "mp-pc-525",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-525",
            "container_id": "MP-7004-85",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZTo0MTQ4MDE0OA==",
          "ticket_id": "41480148",
          "ticket_type": "Gavepapir- og bånd er restaffald",
          "description": "",
          "status": 2,
          "priority": 0,
          "created_at": "2025-10-16T11:32:32.719503+00:00",
          "updated_at": "2025-10-16T11:32:32.720736+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE4ODY=",
            "location": {
              "latitude": 55.550721,
              "longitude": 9.626502,
              "name": "Møllersmindevej 24, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "21924_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZTo0MTQ4MDE0Nw==",
          "ticket_id": "41480147",
          "ticket_type": "Gavepapir- og bånd er restaffald",
          "description": "",
          "status": 2,
          "priority": 0,
          "created_at": "2025-10-16T11:31:36.948170+00:00",
          "updated_at": "2025-10-16T11:31:36.949379+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTE4ODY=",
            "location": {
              "latitude": 55.550721,
              "longitude": 9.626502,
              "name": "Møllersmindevej 24, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "21924_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDcwNTQ=",
      "location": {
        "name": "Sdr. Vilstrupvej 209 7000 Fredericia",
        "latitude": 55.531077,
        "longitude": 9.57728
      },
      "containers": [
        {
          "id": "mp-pc-526",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-526",
            "container_id": "MP-7004-92",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NDEyMw==",
          "ticket_id": "20594123",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Vores skraldespand til restaffald er ikke blevet tømt, skulle være tømt i dag. Bilen holdt der ca 10 ser. Ingen var ude af bilen, derefter kørte de igen uden at tømme den. Spanden var ikke overfyldt, stod ved vejen og vendte rigtig.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-09-17T15:48:00+00:00",
          "updated_at": "2025-08-19T00:25:01.306759+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDcwNTQ=",
            "location": {
              "latitude": 55.531077,
              "longitude": 9.57728,
              "name": "Sdr. Vilstrupvej 209, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDk0NTI=",
      "location": {
        "name": "Sdr. Vilstrupvej 207 7000 Fredericia",
        "latitude": 55.531708,
        "longitude": 9.577456
      },
      "containers": [
        {
          "id": "mp-pc-527",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-527",
            "container_id": "MP-7004-93",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NjczOA==",
          "ticket_id": "20596738",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "mg. tømning",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-15T12:50:00+00:00",
          "updated_at": "2025-08-19T00:25:01.468370+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk0NTI=",
            "location": {
              "latitude": 55.531708,
              "longitude": 9.577456,
              "name": "Sdr. Vilstrupvej 207, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDcwNTU=",
      "location": {
        "name": "Sdr. Vilstrupvej 201 7000 Fredericia",
        "latitude": 55.53341,
        "longitude": 9.576701
      },
      "containers": [
        {
          "id": "mp-pc-528",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-528",
            "container_id": "MP-7004-94",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MDc3OA==",
          "ticket_id": "20580778",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Tlf. 25893782. Borger ringer, at I ikke har tømt i fredags. Beholder står fast samme sted og ønsker hurtigst muligt tømning.",
          "status": 6,
          "priority": 2,
          "created_at": "2024-05-17T12:22:00+00:00",
          "updated_at": "2025-08-19T00:25:00.335278+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDcwNTU=",
            "location": {
              "latitude": 55.53341,
              "longitude": 9.576701,
              "name": "Sdr. Vilstrupvej 201, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjcxNA==",
          "ticket_id": "20592714",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Beholder ER stillet frem ved vejen og bedes tømt snarest.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-10T10:40:00+00:00",
          "updated_at": "2025-08-19T00:25:01.225210+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDcwNTU=",
            "location": {
              "latitude": 55.53341,
              "longitude": 9.576701,
              "name": "Sdr. Vilstrupvej 201, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5Mjk5OQ==",
          "ticket_id": "20592999",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Manglende tømning",
          "status": 6,
          "priority": 2,
          "created_at": "2021-11-22T13:24:00+00:00",
          "updated_at": "2025-08-19T00:25:01.241260+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDcwNTU=",
            "location": {
              "latitude": 55.53341,
              "longitude": 9.576701,
              "name": "Sdr. Vilstrupvej 201, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDcwNTM=",
      "location": {
        "name": "Sdr. Vilstrupvej 211 7000 Fredericia",
        "latitude": 55.530835,
        "longitude": 9.577287
      },
      "containers": [
        {
          "id": "mp-pc-529",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-529",
            "container_id": "MP-7004-95",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NjA1OQ==",
          "ticket_id": "20576059",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Farligt affald Parcel Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 15/04-2025 Besked: Kontaktoplysninger: Morten Venzel Nielsen",
          "status": 6,
          "priority": 2,
          "created_at": "2025-04-15T13:41:00+00:00",
          "updated_at": "2025-08-19T00:25:00.002341+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDcwNTM=",
            "location": {
              "latitude": 55.530835,
              "longitude": 9.577274,
              "name": "Sdr. Vilstrupvej 211, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
      "location": {
        "name": "Lundingsvej 17 7000 Fredericia",
        "latitude": 55.57216698,
        "longitude": 9.77096775
      },
      "containers": [
        {
          "id": "mp-pc-530",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-530",
            "container_id": "MP-7004-99",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-531",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-531",
            "container_id": "MP-7004-100",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-532",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-532",
            "container_id": "MP-7004-101",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-533",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-533",
            "container_id": "MP-7004-102",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-534",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-534",
            "container_id": "MP-7004-103",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-535",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-535",
            "container_id": "MP-7004-104",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-536",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-536",
            "container_id": "MP-7004-105",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-537",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-537",
            "container_id": "MP-7004-106",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-538",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-538",
            "container_id": "MP-7004-107",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-539",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-539",
            "container_id": "MP-7004-108",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NzI3OQ==",
          "ticket_id": "20577279",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Beholdere blev ikke tømt d. 30-12, som de skulle (i stedet for 31-12) Vil I tømme hurtigst muligt? De har ordinær tømmedag i morgen, men de er meget presset, så de skal tømmes i dag.",
          "status": 6,
          "priority": 2,
          "created_at": "2025-01-02T09:05:00+00:00",
          "updated_at": "2025-08-19T00:25:00.132609+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3NzYwMw==",
          "ticket_id": "20577603",
          "ticket_type": "AO-Generel besked",
          "description": "Mail sendt til Torben Bøge Mikkelsen (torben.mikkelsen@fredericia.dk); Ivalo Knudsen Schmidt (mariane.schmidt@fredericia.dk): Hej med jer, Jeg skriver til jer, da tømning af jeres restaffald ændres ifm. julen 2024. Det gælder adressen: Lundingsvej 17  7000 Fredericia Der er tømning af restaffald 2 x ugentligt og da jeres den ene tømning lander på d. 24/12 og d. 31/12, rykker vi disse dage til: Mandag d. 23/12 og mandag d. 30/12. Venligst bekræft modtagelsen af denne besked.",
          "status": 6,
          "priority": 2,
          "created_at": "2024-12-04T13:36:00+00:00",
          "updated_at": "2025-08-19T00:25:00.149701+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3ODg5Mw==",
          "ticket_id": "20578893",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Vogn 6 lod i går en 400L blød plast og en 240L til mad- og drikkekartoner stå, da begge var fejlsorteret. De har sat hængere på.",
          "status": 6,
          "priority": 2,
          "created_at": "2024-08-20T12:38:00+00:00",
          "updated_at": "2025-08-19T00:25:00.222609+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3OTMwMQ==",
          "ticket_id": "20579301",
          "ticket_type": "AO-Generel besked",
          "description": "Vogn 6 melder om 1 stk. 240 liter MDK fyldt med madaffald.",
          "status": 6,
          "priority": 2,
          "created_at": "2024-07-22T12:10:00+00:00",
          "updated_at": "2025-08-19T00:25:00.246139+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDE2NA==",
          "ticket_id": "20580164",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Småt elektronik Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 18/06 2024 Besked: Rød kasse til småt elektronik. Kontaktoplysninger: Ejerforeningen 45-05 Hybyhus",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-11T13:01:00+00:00",
          "updated_at": "2025-08-19T00:25:00.299105+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDE2Mw==",
          "ticket_id": "20580163",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Batterier Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 18/06 2024 Besked: Rød kasse til batterier. Kontaktoplysninger: Ejerforeningen 45-05 Hybyhus",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-11T13:01:00+00:00",
          "updated_at": "2025-08-19T00:25:00.299049+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDE2Ng==",
          "ticket_id": "20580166",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Farligt affald Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 18/06 2024 Besked: Rød kasse til farligt affald. Kontaktoplysninger: Ejerforeningen 45-05 Hybyhus",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-11T13:00:00+00:00",
          "updated_at": "2025-08-19T00:25:00.299257+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDg4OA==",
          "ticket_id": "20580888",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Jeg har lige haft besøg af viceværten, der oplyser, at de ikke fik tømt i går. Han har taget billeder i morges, at der ikke var tømt. Ifølge ham, har han været i kontakt med jer, hvor han fik oplyst, at I troede mere på jeres chauffører end ham. Han har taget billeder af det, så det tænker jeg passer :) I har meldt tømning ind i loggen på 3 beholdere for en halv time siden, men der er 10 restbeholdere og 4 madbeholdere. Vil I oplyse, hvad der er gået galt og få tømt alt i dag?",
          "status": 6,
          "priority": 2,
          "created_at": "2024-05-08T12:11:00+00:00",
          "updated_at": "2025-08-19T00:25:00.342715+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MTA5MQ==",
          "ticket_id": "20581091",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 770 l rest - Lejlighed 2 x Uge Ny tømningsfrekvens: 2 x uge Ønsket virkningsdato: 24/04 2024 Besked: Tilmeldes efter udrulning af miljøstationer til plejehjem. De har fået afmeldt deres 16 m3 til restaffald, der er blevet tømt af Fournaise og så skal de tilmeldes med 10 stk. 770 liter rest 2 x ugetømning. Kontaktoplysninger: Ejerforeningen 45-05 Hybyhus",
          "status": 6,
          "priority": 2,
          "created_at": "2024-04-17T13:54:00+00:00",
          "updated_at": "2025-08-19T00:25:00.355817+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MTA5MA==",
          "ticket_id": "20581090",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 770 l rest - Lejlighed 2 x Uge Ny tømningsfrekvens: 2 x uge Ønsket virkningsdato: 24/04 2024 Besked: Tilmeldes efter udrulning af miljøstationer til plejehjem. De har fået afmeldt deres 16 m3 til restaffald, der er blevet tømt af Fournaise og så skal de tilmeldes med 10 stk. 770 liter rest 2 x ugetømning. Kontaktoplysninger: Ejerforeningen 45-05 Hybyhus",
          "status": 6,
          "priority": 2,
          "created_at": "2024-04-17T13:54:00+00:00",
          "updated_at": "2025-08-19T00:25:00.355760+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MTA4OQ==",
          "ticket_id": "20581089",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 770 l rest - Lejlighed 2 x Uge Ny tømningsfrekvens: 2 x uge Ønsket virkningsdato: 24/04 2024 Besked: Tilmeldes efter udrulning af miljøstationer til plejehjem. De har fået afmeldt deres 16 m3 til restaffald, der er blevet tømt af Fournaise og så skal de tilmeldes med 10 stk. 770 liter rest 2 x ugetømning. Kontaktoplysninger: Ejerforeningen 45-05 Hybyhus",
          "status": 6,
          "priority": 2,
          "created_at": "2024-04-17T13:54:00+00:00",
          "updated_at": "2025-08-19T00:25:00.355701+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MTA4OA==",
          "ticket_id": "20581088",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 770 l rest - Lejlighed 2 x Uge Ny tømningsfrekvens: 2 x uge Ønsket virkningsdato: 24/04 2024 Besked: Tilmeldes efter udrulning af miljøstationer til plejehjem. De har fået afmeldt deres 16 m3 til restaffald, der er blevet tømt af Fournaise og så skal de tilmeldes med 10 stk. 770 liter rest 2 x ugetømning. Kontaktoplysninger: Ejerforeningen 45-05 Hybyhus",
          "status": 6,
          "priority": 2,
          "created_at": "2024-04-17T13:54:00+00:00",
          "updated_at": "2025-08-19T00:25:00.355644+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MTA5NQ==",
          "ticket_id": "20581095",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 770 l rest - Lejlighed 2 x Uge Ny tømningsfrekvens: 2 x uge Ønsket virkningsdato: 24/04 2024 Besked: Tilmeldes efter udrulning af miljøstationer til plejehjem. De har fået afmeldt deres 16 m3 til restaffald, der er blevet tømt af Fournaise og så skal de tilmeldes med 10 stk. 770 liter rest 2 x ugetømning. Kontaktoplysninger: Ejerforeningen 45-05 Hybyhus",
          "status": 6,
          "priority": 2,
          "created_at": "2024-04-17T13:53:00+00:00",
          "updated_at": "2025-08-19T00:25:00.356070+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MTA5NA==",
          "ticket_id": "20581094",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 770 l rest - Lejlighed 2 x Uge Ny tømningsfrekvens: 2 x uge Ønsket virkningsdato: 24/04 2024 Besked: Tilmeldes efter udrulning af miljøstationer til plejehjem. De har fået afmeldt deres 16 m3 til restaffald, der er blevet tømt af Fournaise og så skal de tilmeldes med 10 stk. 770 liter rest 2 x ugetømning. Kontaktoplysninger: Ejerforeningen 45-05 Hybyhus",
          "status": 6,
          "priority": 2,
          "created_at": "2024-04-17T13:53:00+00:00",
          "updated_at": "2025-08-19T00:25:00.356006+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MTA5Mw==",
          "ticket_id": "20581093",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 770 l rest - Lejlighed 2 x Uge Ny tømningsfrekvens: 2 x uge Ønsket virkningsdato: 24/04 2024 Besked: Tilmeldes efter udrulning af miljøstationer til plejehjem. De har fået afmeldt deres 16 m3 til restaffald, der er blevet tømt af Fournaise og så skal de tilmeldes med 10 stk. 770 liter rest 2 x ugetømning. Kontaktoplysninger: Ejerforeningen 45-05 Hybyhus",
          "status": 6,
          "priority": 2,
          "created_at": "2024-04-17T13:53:00+00:00",
          "updated_at": "2025-08-19T00:25:00.355932+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MTA5Mg==",
          "ticket_id": "20581092",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 770 l rest - Lejlighed 2 x Uge Ny tømningsfrekvens: 2 x uge Ønsket virkningsdato: 24/04 2024 Besked: Tilmeldes efter udrulning af miljøstationer til plejehjem. De har fået afmeldt deres 16 m3 til restaffald, der er blevet tømt af Fournaise og så skal de tilmeldes med 10 stk. 770 liter rest 2 x ugetømning. Kontaktoplysninger: Ejerforeningen 45-05 Hybyhus",
          "status": 6,
          "priority": 2,
          "created_at": "2024-04-17T13:53:00+00:00",
          "updated_at": "2025-08-19T00:25:00.355875+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MTA5Nw==",
          "ticket_id": "20581097",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 770 l rest - Lejlighed 2 x Uge Ny tømningsfrekvens: 2 x uge Ønsket virkningsdato: 24/04 2024 Besked: Tilmeldes efter udrulning af miljøstationer til plejehjem. De har fået afmeldt deres 16 m3 til restaffald, der er blevet tømt af Fournaise og så skal de tilmeldes med 10 stk. 770 liter rest 2 x ugetømning. Kontaktoplysninger: Ejerforeningen 45-05 Hybyhus",
          "status": 6,
          "priority": 2,
          "created_at": "2024-04-17T13:52:00+00:00",
          "updated_at": "2025-08-19T00:25:00.356187+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MTA5Ng==",
          "ticket_id": "20581096",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 770 l rest - Lejlighed 2 x Uge Ny tømningsfrekvens: 2 x uge Ønsket virkningsdato: 24/04 2024 Besked: Tilmeldes efter udrulning af miljøstationer til plejehjem. De har fået afmeldt deres 16 m3 til restaffald, der er blevet tømt af Fournaise og så skal de tilmeldes med 10 stk. 770 liter rest 2 x ugetømning. Kontaktoplysninger: Ejerforeningen 45-05 Hybyhus",
          "status": 6,
          "priority": 2,
          "created_at": "2024-04-17T13:52:00+00:00",
          "updated_at": "2025-08-19T00:25:00.356128+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MTA5OQ==",
          "ticket_id": "20581099",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 400 l mad - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 24/04 2024 Besked: Tilmeldes efter udrulning af miljøstationer til plejehjem. De har ønsket at tilføje 2 ekstra mad beholdere. Kontaktoplysninger: Ejerforeningen 45-05 Hybyhus",
          "status": 6,
          "priority": 2,
          "created_at": "2024-04-17T13:49:00+00:00",
          "updated_at": "2025-08-19T00:25:00.356306+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MTA5OA==",
          "ticket_id": "20581098",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 400 l mad - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 24/04 2024 Besked: Tilmeldes efter udrulning af miljøstationer til plejehjem. De har ønsket at tilføje 2 ekstra mad beholdere. Kontaktoplysninger: Ejerforeningen 45-05 Hybyhus",
          "status": 6,
          "priority": 2,
          "created_at": "2024-04-17T13:49:00+00:00",
          "updated_at": "2025-08-19T00:25:00.356247+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MTA0Nw==",
          "ticket_id": "20581047",
          "ticket_type": "AO-Generel besked",
          "description": "Jeg skal tilmelde 10 stk. 770 liter rest med 2 x ugetømning. Hvilke dage vil I tømme dem? Er mad fortsat tirsdag i lige uger?",
          "status": 6,
          "priority": 2,
          "created_at": "2024-04-17T13:48:00+00:00",
          "updated_at": "2025-08-19T00:25:00.353217+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MjU0Mw==",
          "ticket_id": "20582543",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Manglende snerydning Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2024-01-09T07:30:00+00:00",
          "updated_at": "2025-08-19T00:25:00.442656+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MzA3NA==",
          "ticket_id": "20583074",
          "ticket_type": "AO-Generel besked",
          "description": "Besked fra vogn 6: 1 stk. 800 liter til pap/papir fejlsorteret og ikke tømt. Billeder vedhæftet.",
          "status": 6,
          "priority": 2,
          "created_at": "2023-12-04T12:34:00+00:00",
          "updated_at": "2025-08-19T00:25:00.471768+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTY4Mg==",
          "ticket_id": "20585682",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 400 l mad - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 28/02-2023 Besked: Ekstra beholder / kapacitet efter opfordring fra MP. Eksisterende 400 ltr mad meget tung. Aftalt med Ib Hansen, 21755951 Kontaktoplysninger: Ejerforeningen 45-05 Hybyhus",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-21T12:14:00+00:00",
          "updated_at": "2025-08-19T00:25:00.632867+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTY4NQ==",
          "ticket_id": "20585685",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 400 l mad - Lejlighed Ny tømningsfrekvens: Ønsket virkningsdato: 28/02 2023 Besked: Ekstra beholder / kapacitet efter opfordring fra MP. Eksisterende 400 ltr mad meget tung. Aftalt med Ib Hansen, 21755951 Kontaktoplysninger: Ejerforeningen 45-05 Hybyhus",
          "status": 6,
          "priority": 2,
          "created_at": "2023-02-21T12:12:00+00:00",
          "updated_at": "2025-08-19T00:25:00.633010+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTMzOA==",
          "ticket_id": "20591338",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Der er ikke tømt madbeholder. Den er helt fuld ?",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-13T15:35:00+00:00",
          "updated_at": "2025-08-19T00:25:01.140762+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTY4Nw==",
          "ticket_id": "20591687",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 400 l mad - Lejlighed Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/01-2022 Besked: Kontaktoplysninger: Ejerforeningen 45-05 Hybyhus",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-07T11:19:00+00:00",
          "updated_at": "2025-08-19T00:25:01.165372+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzYzNTg=",
            "location": {
              "latitude": 55.572166,
              "longitude": 9.770967,
              "name": "Lundingsvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTU0OTE=",
      "location": {
        "name": "Huslodsvej 79 7000 Fredericia",
        "latitude": 55.5745517,
        "longitude": 9.76615746
      },
      "containers": [
        {
          "id": "mp-pc-540",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-540",
            "container_id": "MP-7004-109",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "660 L"
            }
          }
        },
        {
          "id": "mp-pc-541",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-541",
            "container_id": "MP-7004-110",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "660 L"
            }
          }
        },
        {
          "id": "mp-pc-542",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-542",
            "container_id": "MP-7004-111",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "660 L"
            }
          }
        },
        {
          "id": "mp-pc-543",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-543",
            "container_id": "MP-7004-112",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "660 L"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NDg3OA==",
          "ticket_id": "20574878",
          "ticket_type": "AO-Generel besked",
          "description": "Besked fra Marius Pedersen: Hej Kristina Vil du notere følgende: 432119  ikke tømt, se venligst billeder P.S. Turen kunne ikke oprette den på RenoTrol, derfor sender jeg den på email 😊 Venlig hilsen / Best regards Galina Erichsen Kørselsassistent Marius Pedersen A/S Kørsel/Kundeservice Esbjerg Dagrenovation Måde Industrivej 23-25 6705 Esbjerg Ø",
          "status": 6,
          "priority": 2,
          "created_at": "2025-07-04T08:28:00+00:00",
          "updated_at": "2025-08-19T00:24:59.865962+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU0OTE=",
            "location": {
              "latitude": 55.574551,
              "longitude": 9.766157,
              "name": "Huslodsvej 79, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3NDkyMQ==",
          "ticket_id": "20574921",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Hej Vil I oprette afvigelse ( vores afløser har ikke mulighed for at gøre det) Huslodsvej 79, container 432119 Ikke tømt Overfyldt Billeder er vedlagt Galina",
          "status": 6,
          "priority": 2,
          "created_at": "2025-07-01T10:53:00+00:00",
          "updated_at": "2025-08-19T00:24:59.870468+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU0OTE=",
            "location": {
              "latitude": 55.574551,
              "longitude": 9.766157,
              "name": "Huslodsvej 79, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3NTQxMg==",
          "ticket_id": "20575412",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "1 stk. 660 ltr (cont.nr. 432122) ikke tømt - overfyldt og fejlsorteret",
          "status": 6,
          "priority": 2,
          "created_at": "2025-06-03T09:31:00+00:00",
          "updated_at": "2025-08-19T00:24:59.925767+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU0OTE=",
            "location": {
              "latitude": 55.574551,
              "longitude": 9.766157,
              "name": "Huslodsvej 79, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MjAzNA==",
          "ticket_id": "20582034",
          "ticket_type": "AO-Generel besked",
          "description": "Mail fra Louise til Boligkontoret: Vores chauffører har ladet en 600L glas stå i affaldsløsningen på Huslodsvej 77, da den er fejlsorteret. I skal derfor rette henvendelse til vores kundeservice på affald.genbrug@fredericia.dk eller tlf. 7210 6367 for at få den tømt som restaffald.",
          "status": 6,
          "priority": 2,
          "created_at": "2024-01-22T11:09:00+00:00",
          "updated_at": "2025-08-19T00:25:00.413896+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU0OTE=",
            "location": {
              "latitude": 55.574551,
              "longitude": 9.766157,
              "name": "Huslodsvej 79, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MjIzNg==",
          "ticket_id": "20582236",
          "ticket_type": "AO-Generel besked",
          "description": "Vogn 6 har meldt en 600L til glas/plast ind, som fejlsorteret på Huslodsvej 77.",
          "status": 6,
          "priority": 2,
          "created_at": "2024-01-15T12:58:00+00:00",
          "updated_at": "2025-08-19T00:25:00.424485+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU0OTE=",
            "location": {
              "latitude": 55.574551,
              "longitude": 9.766157,
              "name": "Huslodsvej 79, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NjIyMA==",
          "ticket_id": "20586220",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 400 l mad - Lejlighed 2 x Uge Huslodsvej 77 (7000 Fredericia) ContainerNr:432118 ContainerBrik: Beholder der ønskes i stedet: 400 l mad - Lejlighed Uge Ny tømningsfrekvens: Hver uge Gebyr: 0 kr Ønsket virkningsdato: 01/01-2023 Besked: Ændres jf. mail fra Kristina fra Boligkontoret den 13. december. 2 stk. ændres fra 2 x uge til 1 x uge. Kontaktoplysninger: Boligkontoret Fredericia afd. 304",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-05T13:57:00+00:00",
          "updated_at": "2025-08-19T00:25:00.680419+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU0OTE=",
            "location": {
              "latitude": 55.574551,
              "longitude": 9.766157,
              "name": "Huslodsvej 79, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NjIyMQ==",
          "ticket_id": "20586221",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 400 l mad - Lejlighed 2 x Uge Huslodsvej 79 (7000 Fredericia) ContainerNr:432117 ContainerBrik: Beholder der ønskes i stedet: 400 l mad - Lejlighed Uge Ny tømningsfrekvens: Hver uge Gebyr: 0 kr Ønsket virkningsdato: 01/01-2023 Besked: Ændres jf. mail fra Kristina fra Boligkontoret den 13. december. 2 stk. ændres fra 2 x uge til 1 x uge. Kontaktoplysninger: Boligkontoret Fredericia afd. 304",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-05T13:56:00+00:00",
          "updated_at": "2025-08-19T00:25:00.681093+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU0OTE=",
            "location": {
              "latitude": 55.574551,
              "longitude": 9.766157,
              "name": "Huslodsvej 79, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4ODc5NQ==",
          "ticket_id": "20588795",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Beholderene til rest er ikke tømt- Der er tømt i nr. 95 Vigtig de bliver tømt i dag.",
          "status": 6,
          "priority": 2,
          "created_at": "2022-06-17T11:34:00+00:00",
          "updated_at": "2025-08-19T00:25:00.921828+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU0OTE=",
            "location": {
              "latitude": 55.574551,
              "longitude": 9.766157,
              "name": "Huslodsvej 79, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MDc4Nw==",
          "ticket_id": "20590787",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Beholder ikke tømt i går som de skulle",
          "status": 6,
          "priority": 2,
          "created_at": "2022-02-16T11:46:00+00:00",
          "updated_at": "2025-08-19T00:25:01.091443+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU0OTE=",
            "location": {
              "latitude": 55.574551,
              "longitude": 9.766157,
              "name": "Huslodsvej 79, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzY2MQ==",
          "ticket_id": "20593661",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "2 x 1000 l er ikke tømt her",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-12T13:53:00+00:00",
          "updated_at": "2025-08-19T00:25:01.278505+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU0OTE=",
            "location": {
              "latitude": 55.574551,
              "longitude": 9.766157,
              "name": "Huslodsvej 79, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzkxMA==",
          "ticket_id": "20593910",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Beholderen er ikke tømt!",
          "status": 6,
          "priority": 2,
          "created_at": "2021-09-28T14:23:00+00:00",
          "updated_at": "2025-08-19T00:25:01.293722+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU0OTE=",
            "location": {
              "latitude": 55.574551,
              "longitude": 9.766157,
              "name": "Huslodsvej 79, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDg4MQ==",
          "ticket_id": "20594881",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Ekstra tømning af 2 stk 1000 L på Huslodsvej 77, med indkørsel fra Treldevej",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-20T09:28:00+00:00",
          "updated_at": "2025-08-19T00:25:01.353235+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU0OTE=",
            "location": {
              "latitude": 55.574551,
              "longitude": 9.766157,
              "name": "Huslodsvej 79, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NzI0Nw==",
          "ticket_id": "20597247",
          "ticket_type": "AO-Bestilling af ekstra tømning",
          "description": "Ekstra tømning uden beregning grundet ændret tømmedag. Ekstra sække og eller ekstra affaldsbeholdere skal også tømmes med.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-07T12:16:00+00:00",
          "updated_at": "2025-08-19T00:25:01.497274+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU0OTE=",
            "location": {
              "latitude": 55.574551,
              "longitude": 9.766157,
              "name": "Huslodsvej 79, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMzkwMzc=",
      "location": {
        "name": "Frantz Hansens Allé 12 7000 Fredericia",
        "latitude": 55.57568465,
        "longitude": 9.74411233
      },
      "containers": [
        {
          "id": "mp-pc-544",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-544",
            "container_id": "MP-7004-113",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-545",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-545",
            "container_id": "MP-7004-114",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-546",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-546",
            "container_id": "MP-7004-115",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NzE3OQ==",
          "ticket_id": "20577179",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Skadedyr konstateret på adressen Er der afleveret flyer: Nej Er beholder tømt: Ja",
          "status": 6,
          "priority": 2,
          "created_at": "2025-01-07T08:04:00+00:00",
          "updated_at": "2025-08-19T00:25:00.124931+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMzc=",
            "location": {
              "latitude": 55.575684,
              "longitude": 9.744112,
              "name": "Frantz Hansens Allé 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3NzYxNw==",
          "ticket_id": "20577617",
          "ticket_type": "AO-Generel besked",
          "description": "Mail sendt til \"servicecenter@boligfa.dk\": Hej, Grundet jul og nytår, ændres tømmedag fra tirsdag d. 24/12 til mandag d. 23/12 samt fra tirsdag d. 31/12 til mandag d. 30/12 på følgende adresser: Egumvej 21 Frantz Hansens Allé 12 Indre Ringvej 53 Viaduktvej 11 Venligst bekræft modtagelsen af denne besked.",
          "status": 6,
          "priority": 2,
          "created_at": "2024-12-04T10:32:00+00:00",
          "updated_at": "2025-08-19T00:25:00.150566+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMzc=",
            "location": {
              "latitude": 55.575684,
              "longitude": 9.744112,
              "name": "Frantz Hansens Allé 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3OTQ0OQ==",
          "ticket_id": "20579449",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: Genbrug Lejlighed Frantz Hansens Allé 12 1 (7000 Fredericia) ContainerNr:361935 ContainerBrik: Ønsket virkningsdato: 25/07 2024 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 203",
          "status": 6,
          "priority": 2,
          "created_at": "2024-07-18T14:47:00+00:00",
          "updated_at": "2025-08-19T00:25:00.254417+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMzc=",
            "location": {
              "latitude": 55.575684,
              "longitude": 9.744112,
              "name": "Frantz Hansens Allé 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDQ4Mw==",
          "ticket_id": "20580483",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Batterier Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 10/06 2024 Besked: Rød kasse til batterier. Kontaktoplysninger: Boligkontoret Fredericia afd. 203",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-03T15:25:00+00:00",
          "updated_at": "2025-08-19T00:25:00.317804+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMzc=",
            "location": {
              "latitude": 55.575684,
              "longitude": 9.744112,
              "name": "Frantz Hansens Allé 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDQ4NA==",
          "ticket_id": "20580484",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Batterier Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 10/06 2024 Besked: Rød kasse til batterier. Kontaktoplysninger: Boligkontoret Fredericia afd. 203",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-03T15:24:00+00:00",
          "updated_at": "2025-08-19T00:25:00.317859+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMzc=",
            "location": {
              "latitude": 55.575684,
              "longitude": 9.744112,
              "name": "Frantz Hansens Allé 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDQ4Ng==",
          "ticket_id": "20580486",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Batterier Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 10/06 2024 Besked: Rød kasse til batterier. Kontaktoplysninger: Boligkontoret Fredericia afd. 203",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-03T15:16:00+00:00",
          "updated_at": "2025-08-19T00:25:00.317973+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMzc=",
            "location": {
              "latitude": 55.575684,
              "longitude": 9.744112,
              "name": "Frantz Hansens Allé 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDQ4NQ==",
          "ticket_id": "20580485",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Batterier Lejlighed Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 10/06 2024 Besked: Rød kasse til batterier. Kontaktoplysninger: Boligkontoret Fredericia afd. 203",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-03T15:16:00+00:00",
          "updated_at": "2025-08-19T00:25:00.317916+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMzc=",
            "location": {
              "latitude": 55.575684,
              "longitude": 9.744112,
              "name": "Frantz Hansens Allé 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDkxOA==",
          "ticket_id": "20580918",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Vogn 6 har i dag ladet en 1000L tik pap/papir + en 1000L til plast stå, da begge beholdere var overfyldte. Jeg har skrevet til Boligkontoret og henvist til, at de skal bestille en ekstratømning.",
          "status": 6,
          "priority": 2,
          "created_at": "2024-05-03T10:04:00+00:00",
          "updated_at": "2025-08-19T00:25:00.344534+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMzc=",
            "location": {
              "latitude": 55.575684,
              "longitude": 9.744112,
              "name": "Frantz Hansens Allé 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NjExNA==",
          "ticket_id": "20586114",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 400 l mad - Lejlighed 2 x Uge Frantz Hansens Allé 12 1 (7000 Fredericia) ContainerNr:435626 ContainerBrik: Beholder der ønskes i stedet: 400 l mad - Lejlighed Uge Ny tømningsfrekvens: Hver uge Gebyr: 0 kr Ønsket virkningsdato: 01/01-2023 Besked: Jf. mail fra Kristina den 16-01-2023. Kontaktoplysninger: Boligkontoret Fredericia afd. 203",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-16T14:01:00+00:00",
          "updated_at": "2025-08-19T00:25:00.669009+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMzc=",
            "location": {
              "latitude": 55.575684,
              "longitude": 9.744112,
              "name": "Frantz Hansens Allé 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTM0Nw==",
          "ticket_id": "20591347",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 770 l rest - Lejlighed Uge Frantz Hansens Allé 12 1 (7000 Fredericia) ContainerNr:431532 ContainerBrik:004000001524FB70 Beholder der ønskes i stedet: 770 l rest - Lejlighed 2 x Uge Ny tømningsfrekvens: 2 x uge Gebyr: 0 kr Ønsket virkningsdato: 20/01-2022 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 203",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-20T10:02:00+00:00",
          "updated_at": "2025-08-19T00:25:01.141253+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMzc=",
            "location": {
              "latitude": 55.575684,
              "longitude": 9.744112,
              "name": "Frantz Hansens Allé 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTM0OQ==",
          "ticket_id": "20591349",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 770 l rest - Lejlighed Uge Frantz Hansens Allé 12 1 (7000 Fredericia) ContainerNr:431531 ContainerBrik:0040000015246859 Beholder der ønskes i stedet: 770 l rest - Lejlighed 2 x Uge Ny tømningsfrekvens: 2 x uge Gebyr: 0 kr Ønsket virkningsdato: 20/01-2022 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 203",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-20T10:01:00+00:00",
          "updated_at": "2025-08-19T00:25:01.141359+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMzc=",
            "location": {
              "latitude": 55.575684,
              "longitude": 9.744112,
              "name": "Frantz Hansens Allé 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTM0OA==",
          "ticket_id": "20591348",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 770 l rest - Lejlighed Uge Frantz Hansens Allé 12 1 (7000 Fredericia) ContainerNr:431533 ContainerBrik:004000001523F623 Beholder der ønskes i stedet: 770 l rest - Lejlighed 2 x Uge Ny tømningsfrekvens: 2 x uge Gebyr: 0 kr Ønsket virkningsdato: 20/01-2022 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 203",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-20T10:01:00+00:00",
          "updated_at": "2025-08-19T00:25:01.141306+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMzc=",
            "location": {
              "latitude": 55.575684,
              "longitude": 9.744112,
              "name": "Frantz Hansens Allé 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTM1MA==",
          "ticket_id": "20591350",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 400 l mad - Lejlighed Uge Frantz Hansens Allé 12 1 (7000 Fredericia) ContainerNr:431530 ContainerBrik:0040000012673283 Beholder der ønskes i stedet: 400 l mad - Lejlighed 2 x Uge Ny tømningsfrekvens: 2 x uge Gebyr: 0 kr Ønsket virkningsdato: 20/01-2022 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 203",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-20T10:00:00+00:00",
          "updated_at": "2025-08-19T00:25:01.141413+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMzc=",
            "location": {
              "latitude": 55.575684,
              "longitude": 9.744112,
              "name": "Frantz Hansens Allé 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjE0MQ==",
          "ticket_id": "20592141",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: 770 l rest - Lejlighed Uge Frantz Hansens Allé 12 1 (7000 Fredericia) ContainerNr:431534 ContainerBrik:0040000015246836 Ønsket virkningsdato: 01/12-2021 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 203",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-21T08:40:00+00:00",
          "updated_at": "2025-08-19T00:25:01.192455+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMzc=",
            "location": {
              "latitude": 55.575684,
              "longitude": 9.744112,
              "name": "Frantz Hansens Allé 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NzU2NA==",
          "ticket_id": "20597564",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Beholder overfyldt Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-06T06:14:00+00:00",
          "updated_at": "2025-08-19T00:25:01.517302+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMzc=",
            "location": {
              "latitude": 55.575684,
              "longitude": 9.744112,
              "name": "Frantz Hansens Allé 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTUzNTY=",
      "location": {
        "name": "Egumvej 21 7000 Fredericia",
        "latitude": 55.57692663,
        "longitude": 9.74497679
      },
      "containers": [
        {
          "id": "mp-pc-547",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-547",
            "container_id": "MP-7004-116",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-548",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-548",
            "container_id": "MP-7004-117",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-549",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-549",
            "container_id": "MP-7004-118",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-550",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-550",
            "container_id": "MP-7004-119",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NjI2Ng==",
          "ticket_id": "20576266",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2025-03-25Fraktion: 1 (Mad/Rest)Navn: Thomas MøllerTlf.: 69172079Email: tmh@boligfa.dkBesked: Miljøstationen er ud for Egumvej 35",
          "status": 6,
          "priority": 2,
          "created_at": "2025-03-28T09:46:00+00:00",
          "updated_at": "2025-08-19T00:25:00.025745+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUzNTY=",
            "location": {
              "latitude": 55.576926,
              "longitude": 9.744976,
              "name": "Egumvej 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3NjI2Mg==",
          "ticket_id": "20576262",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2025-03-25Fraktion: 1 (Mad/Rest)Navn: Thomas MøllerTlf.: 69172079Email: tmh@boligfa.dkBesked: Miljøstationen er ud for Egumvej 35",
          "status": 6,
          "priority": 2,
          "created_at": "2025-03-28T09:46:00+00:00",
          "updated_at": "2025-08-19T00:25:00.025256+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUzNTY=",
            "location": {
              "latitude": 55.576926,
              "longitude": 9.744976,
              "name": "Egumvej 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3NzYxOA==",
          "ticket_id": "20577618",
          "ticket_type": "AO-Generel besked",
          "description": "Mail sendt til \"servicecenter@boligfa.dk\": Hej, Grundet jul og nytår, ændres tømmedag fra tirsdag d. 24/12 til mandag d. 23/12 samt fra tirsdag d. 31/12 til mandag d. 30/12 på følgende adresser: Egumvej 21 Frantz Hansens Allé 12 Indre Ringvej 53 Viaduktvej 11 Venligst bekræft modtagelsen af denne besked.",
          "status": 6,
          "priority": 2,
          "created_at": "2024-12-04T10:31:00+00:00",
          "updated_at": "2025-08-19T00:25:00.150613+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUzNTY=",
            "location": {
              "latitude": 55.576926,
              "longitude": 9.744976,
              "name": "Egumvej 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MzMyNA==",
          "ticket_id": "20583324",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 400 l mad - Lejlighed 2 x Uge Egumvej 21 1 (7000 Fredericia) ContainerNr:435621 ContainerBrik: Beholder der ønskes i stedet: 400 l mad - Lejlighed Uge Ny tømningsfrekvens: Hver uge Gebyr: 0 kr Ønsket virkningsdato: 14/11 2023 Besked: Modtaget mail fra Kasper, Boligkontoret. Ønsker ugetømning i stedet for 2 x uge tømning. Kontaktoplysninger: Boligkontoret Fredericia afd. 207",
          "status": 6,
          "priority": 2,
          "created_at": "2023-11-07T09:12:00+00:00",
          "updated_at": "2025-08-19T00:25:00.493837+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUzNTY=",
            "location": {
              "latitude": 55.576926,
              "longitude": 9.744976,
              "name": "Egumvej 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDI2OQ==",
          "ticket_id": "20584269",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Adgangsvej spærret Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2023-07-04T08:16:00+00:00",
          "updated_at": "2025-08-19T00:25:00.549687+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUzNTY=",
            "location": {
              "latitude": 55.576926,
              "longitude": 9.744976,
              "name": "Egumvej 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTM1MQ==",
          "ticket_id": "20591351",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 770 l rest - Lejlighed Uge Egumvej 21 1 (7000 Fredericia) ContainerNr:431376 ContainerBrik:004000001523F5F5 Beholder der ønskes i stedet: 770 l rest - Lejlighed 2 x Uge Ny tømningsfrekvens: 2 x uge Gebyr: 0 kr Ønsket virkningsdato: 20/01-2022 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 207",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-20T09:54:00+00:00",
          "updated_at": "2025-08-19T00:25:01.141467+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUzNTY=",
            "location": {
              "latitude": 55.576926,
              "longitude": 9.744976,
              "name": "Egumvej 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTM1Ng==",
          "ticket_id": "20591356",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 770 l rest - Lejlighed Uge Egumvej 21 1 (7000 Fredericia) ContainerNr:431378 ContainerBrik:004000001523F5D3 Beholder der ønskes i stedet: 770 l rest - Lejlighed 2 x Uge Ny tømningsfrekvens: 2 x uge Gebyr: 0 kr Ønsket virkningsdato: 20/01-2022 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 207",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-20T09:53:00+00:00",
          "updated_at": "2025-08-19T00:25:01.141758+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUzNTY=",
            "location": {
              "latitude": 55.576926,
              "longitude": 9.744976,
              "name": "Egumvej 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTM1Mw==",
          "ticket_id": "20591353",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 770 l rest - Lejlighed Uge Egumvej 21 1 (7000 Fredericia) ContainerNr:431377 ContainerBrik:004000001523F639 Beholder der ønskes i stedet: 770 l rest - Lejlighed 2 x Uge Ny tømningsfrekvens: 2 x uge Gebyr: 0 kr Ønsket virkningsdato: 20/01-2022 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 207",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-20T09:53:00+00:00",
          "updated_at": "2025-08-19T00:25:01.141576+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUzNTY=",
            "location": {
              "latitude": 55.576926,
              "longitude": 9.744976,
              "name": "Egumvej 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTM1Nw==",
          "ticket_id": "20591357",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 770 l rest - Lejlighed Uge Egumvej 21 1 (7000 Fredericia) ContainerNr:431375 ContainerBrik:004000001523F5E7 Beholder der ønskes i stedet: 770 l rest - Lejlighed 2 x Uge Ny tømningsfrekvens: 2 x uge Gebyr: 0 kr Ønsket virkningsdato: 20/01-2022 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 207",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-20T09:52:00+00:00",
          "updated_at": "2025-08-19T00:25:01.141814+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUzNTY=",
            "location": {
              "latitude": 55.576926,
              "longitude": 9.744976,
              "name": "Egumvej 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTM1OA==",
          "ticket_id": "20591358",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 400 l mad - Lejlighed Uge Egumvej 21 1 (7000 Fredericia) ContainerNr:431374 ContainerBrik:0040000012673048 Beholder der ønskes i stedet: 400 l mad - Lejlighed 2 x Uge Ny tømningsfrekvens: 2 x uge Gebyr: 0 kr Ønsket virkningsdato: 20/01-2022 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 207",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-20T09:51:00+00:00",
          "updated_at": "2025-08-19T00:25:01.141870+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUzNTY=",
            "location": {
              "latitude": 55.576926,
              "longitude": 9.744976,
              "name": "Egumvej 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTg4Mw==",
          "ticket_id": "20591883",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "mgl. tømning",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-03T14:18:00+00:00",
          "updated_at": "2025-08-19T00:25:01.176321+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUzNTY=",
            "location": {
              "latitude": 55.576926,
              "longitude": 9.744976,
              "name": "Egumvej 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTkzNw==",
          "ticket_id": "20591937",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Beholder overfyldt Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-28T08:53:00+00:00",
          "updated_at": "2025-08-19T00:25:01.180910+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUzNTY=",
            "location": {
              "latitude": 55.576926,
              "longitude": 9.744976,
              "name": "Egumvej 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NzU2Ng==",
          "ticket_id": "20597566",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Beholder overfyldt Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-06T06:07:00+00:00",
          "updated_at": "2025-08-19T00:25:01.517397+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTUzNTY=",
            "location": {
              "latitude": 55.576926,
              "longitude": 9.744976,
              "name": "Egumvej 21, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTU0OTk=",
      "location": {
        "name": "Indre Ringvej 53 7000 Fredericia",
        "latitude": 55.57488161,
        "longitude": 9.74477376
      },
      "containers": [
        {
          "id": "mp-pc-551",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-551",
            "container_id": "MP-7004-120",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-552",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-552",
            "container_id": "MP-7004-121",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-553",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-553",
            "container_id": "MP-7004-122",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        },
        {
          "id": "mp-pc-554",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-554",
            "container_id": "MP-7004-123",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "770 L"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NzYxOQ==",
          "ticket_id": "20577619",
          "ticket_type": "AO-Generel besked",
          "description": "Mail sendt til \"servicecenter@boligfa.dk\": Hej, Grundet jul og nytår, ændres tømmedag fra tirsdag d. 24/12 til mandag d. 23/12 samt fra tirsdag d. 31/12 til mandag d. 30/12 på følgende adresser: Egumvej 21 Frantz Hansens Allé 12 Indre Ringvej 53 Viaduktvej 11 Venligst bekræft modtagelsen af denne besked.",
          "status": 6,
          "priority": 2,
          "created_at": "2024-12-04T10:31:00+00:00",
          "updated_at": "2025-08-19T00:25:00.150661+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU0OTk=",
            "location": {
              "latitude": 55.574881,
              "longitude": 9.744773,
              "name": "Indre Ringvej 53, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MzMzNA==",
          "ticket_id": "20583334",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 400 l mad - Lejlighed 2 x Uge Indre Ringvej 53 1 (7000 Fredericia) ContainerNr:435630 ContainerBrik: Beholder der ønskes i stedet: 400 l rest - Lejlighed Uge Ny tømningsfrekvens: Hver uge Gebyr: 0 kr Ønsket virkningsdato: 14/11-2023 Besked: Ifølge mail fra Kasper, Boligkontoret, ønsker de kun tømning 1 x uge i stedet for 2 x uge. Kontaktoplysninger: Boligkontoret Fredericia afd. 209",
          "status": 6,
          "priority": 2,
          "created_at": "2023-11-06T14:13:00+00:00",
          "updated_at": "2025-08-19T00:25:00.494412+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU0OTk=",
            "location": {
              "latitude": 55.574881,
              "longitude": 9.744773,
              "name": "Indre Ringvej 53, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDYzMw==",
          "ticket_id": "20584633",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2023-05-30Fraktion: 1 (Mad/Rest)Navn: Thomas MøllerTlf.: 69172079Email: tmh@boligfa.dkBesked: Er ved miljøstation bagved Frantz Hansens Alle 6.",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-31T10:13:00+00:00",
          "updated_at": "2025-08-19T00:25:00.571455+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU0OTk=",
            "location": {
              "latitude": 55.574881,
              "longitude": 9.744773,
              "name": "Indre Ringvej 53, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTM0Mw==",
          "ticket_id": "20591343",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 770 l rest - Lejlighed Uge Indre Ringvej 53 1 (7000 Fredericia) ContainerNr:432193 ContainerBrik:004000001524FB9F Beholder der ønskes i stedet: 770 l rest - Lejlighed 2 x Uge Ny tømningsfrekvens: 2 x uge Gebyr: 0 kr Ønsket virkningsdato: 20/01-2022 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 209",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-20T10:05:00+00:00",
          "updated_at": "2025-08-19T00:25:01.141033+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU0OTk=",
            "location": {
              "latitude": 55.574881,
              "longitude": 9.744773,
              "name": "Indre Ringvej 53, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTM0Mg==",
          "ticket_id": "20591342",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 770 l rest - Lejlighed Uge Indre Ringvej 53 1 (7000 Fredericia) ContainerNr:432194 ContainerBrik:004000001524FB4F Beholder der ønskes i stedet: 770 l rest - Lejlighed 2 x Uge Ny tømningsfrekvens: 2 x uge Gebyr: 0 kr Ønsket virkningsdato: 20/01-2022 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 209",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-20T10:05:00+00:00",
          "updated_at": "2025-08-19T00:25:01.140978+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU0OTk=",
            "location": {
              "latitude": 55.574881,
              "longitude": 9.744773,
              "name": "Indre Ringvej 53, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTM0NQ==",
          "ticket_id": "20591345",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 770 l rest - Lejlighed Uge Indre Ringvej 53 1 (7000 Fredericia) ContainerNr:432191 ContainerBrik:004000001523F61E Beholder der ønskes i stedet: 770 l rest - Lejlighed 2 x Uge Ny tømningsfrekvens: 2 x uge Gebyr: 0 kr Ønsket virkningsdato: 20/01-2022 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 209",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-20T10:04:00+00:00",
          "updated_at": "2025-08-19T00:25:01.141143+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU0OTk=",
            "location": {
              "latitude": 55.574881,
              "longitude": 9.744773,
              "name": "Indre Ringvej 53, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTM0NA==",
          "ticket_id": "20591344",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 770 l rest - Lejlighed Uge Indre Ringvej 53 1 (7000 Fredericia) ContainerNr:432192 ContainerBrik:004000001524FBAF Beholder der ønskes i stedet: 770 l rest - Lejlighed 2 x Uge Ny tømningsfrekvens: 2 x uge Gebyr: 0 kr Ønsket virkningsdato: 20/01-2022 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 209",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-20T10:04:00+00:00",
          "updated_at": "2025-08-19T00:25:01.141087+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU0OTk=",
            "location": {
              "latitude": 55.574881,
              "longitude": 9.744773,
              "name": "Indre Ringvej 53, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTM0Ng==",
          "ticket_id": "20591346",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: 400 l mad - Lejlighed Uge Indre Ringvej 53 1 (7000 Fredericia) ContainerNr:432190 ContainerBrik:0040000012672FF2 Beholder der ønskes i stedet: 400 l mad - Lejlighed 2 x Uge Ny tømningsfrekvens: 2 x uge Gebyr: 0 kr Ønsket virkningsdato: 20/01-2022 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 209",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-20T10:03:00+00:00",
          "updated_at": "2025-08-19T00:25:01.141197+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTU0OTk=",
            "location": {
              "latitude": 55.574881,
              "longitude": 9.744773,
              "name": "Indre Ringvej 53, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMzkwMTQ=",
      "location": {
        "name": "Højrupvej 153 7000 Fredericia",
        "latitude": 55.57912743,
        "longitude": 9.59607043
      },
      "containers": [
        {
          "id": "mp-pc-555",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-555",
            "container_id": "MP-7004-124",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L"
            }
          }
        },
        {
          "id": "mp-pc-556",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-556",
            "container_id": "MP-7004-125",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "400 L"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MDI1NA==",
          "ticket_id": "20580254",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Batterier institution Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 18/06 2024 Besked: Rød kasse til batterier. Kontaktoplysninger: Hanne Jørgensen 28702914 hannepopsen@gmail.com",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-11T09:41:00+00:00",
          "updated_at": "2025-08-19T00:25:00.304401+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMTQ=",
            "location": {
              "latitude": 55.579127,
              "longitude": 9.59607,
              "name": "Højrupvej 153, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDI1NQ==",
          "ticket_id": "20580255",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Småt elektronik institution Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 18/06 2024 Besked: Rød kasse til småt elektronik. Kontaktoplysninger: Hanne Jørgensen 28702914 hannepopsen@gmail.com",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-11T09:40:00+00:00",
          "updated_at": "2025-08-19T00:25:00.304458+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMTQ=",
            "location": {
              "latitude": 55.579127,
              "longitude": 9.59607,
              "name": "Højrupvej 153, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDI5NA==",
          "ticket_id": "20580294",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: Farligt affald institution Ny tømningsfrekvens: Genbrug Ønsket virkningsdato: 17/06 2024 Besked: Rød kasse til farligt affald. Kontaktoplysninger: Hanne Jørgensen 28702914 hannepopsen@gmail.com",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-10T14:45:00+00:00",
          "updated_at": "2025-08-19T00:25:00.306691+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMTQ=",
            "location": {
              "latitude": 55.579127,
              "longitude": 9.59607,
              "name": "Højrupvej 153, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDkxNw==",
          "ticket_id": "20580917",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Defekt låg Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2024-05-03T10:16:00+00:00",
          "updated_at": "2025-08-19T00:25:00.344475+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMTQ=",
            "location": {
              "latitude": 55.579127,
              "longitude": 9.59607,
              "name": "Højrupvej 153, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MjM2OQ==",
          "ticket_id": "20582369",
          "ticket_type": "AO-Generel besked",
          "description": "Jeg bor i nr 157 men den findes ikke på jeres side hvor man skal vælge hus nummer",
          "status": 6,
          "priority": 2,
          "created_at": "2024-01-10T04:03:00+00:00",
          "updated_at": "2025-08-19T00:25:00.432993+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMTQ=",
            "location": {
              "latitude": 55.579127,
              "longitude": 9.59607,
              "name": "Højrupvej 153, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MzU1Nw==",
          "ticket_id": "20583557",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 400 l rest - Institution Uge Ny tømningsfrekvens: Hver uge Ønsket virkningsdato: 10/10-2023 Besked: Gitte Clement Meyer, tlf. 41731939. Ønsker 1 stk. 400 liter til rest i stedet for 660 liter. Kontaktoplysninger: FREDERICIA KOMMUNE",
          "status": 6,
          "priority": 2,
          "created_at": "2023-10-06T10:17:00+00:00",
          "updated_at": "2025-08-19T00:25:00.507675+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMTQ=",
            "location": {
              "latitude": 55.579127,
              "longitude": 9.59607,
              "name": "Højrupvej 153, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MzU1OA==",
          "ticket_id": "20583558",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: 660 l rest - Institution Uge Højrupvej 153 1 (7000 Fredericia) ContainerNr:436019 ContainerBrik: Ønsket virkningsdato: 10/10-2023 Besked: Afmelding aftalt med Gitte Clement Meyer, tlf. 41731939. Ønsker 1 stk. 400 liter til rest i stedet. Kontaktoplysninger: FREDERICIA KOMMUNE",
          "status": 6,
          "priority": 2,
          "created_at": "2023-10-06T10:16:00+00:00",
          "updated_at": "2025-08-19T00:25:00.507733+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMTQ=",
            "location": {
              "latitude": 55.579127,
              "longitude": 9.59607,
              "name": "Højrupvej 153, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4OTUwOA==",
          "ticket_id": "20589508",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 660 l rest - Institution Uge Ny tømningsfrekvens: Hver uge Ønsket virkningsdato: 03/05 2022 Besked: Kontaktoplysninger: FREDERICIA KOMMUNE",
          "status": 6,
          "priority": 2,
          "created_at": "2022-04-26T10:10:00+00:00",
          "updated_at": "2025-08-19T00:25:00.983020+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMTQ=",
            "location": {
              "latitude": 55.579127,
              "longitude": 9.59607,
              "name": "Højrupvej 153, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4OTUwOQ==",
          "ticket_id": "20589509",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 240 l mad - Institution Uge Ny tømningsfrekvens: Hver uge Ønsket virkningsdato: 03/05 2022 Besked: Kontaktoplysninger: FREDERICIA KOMMUNE",
          "status": 6,
          "priority": 2,
          "created_at": "2022-04-26T10:08:00+00:00",
          "updated_at": "2025-08-19T00:25:00.983127+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMTQ=",
            "location": {
              "latitude": 55.579127,
              "longitude": 9.59607,
              "name": "Højrupvej 153, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4OTUxMQ==",
          "ticket_id": "20589511",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: 400 l mad - Institution Uge Højrupvej 153 1 (7000 Fredericia) ContainerNr:432173 ContainerBrik:0040000015237FEE Ønsket virkningsdato: 03/05 2022 Besked: Kontaktoplysninger: FREDERICIA KOMMUNE",
          "status": 6,
          "priority": 2,
          "created_at": "2022-04-26T10:07:00+00:00",
          "updated_at": "2025-08-19T00:25:00.983328+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMTQ=",
            "location": {
              "latitude": 55.579127,
              "longitude": 9.59607,
              "name": "Højrupvej 153, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4OTUxMA==",
          "ticket_id": "20589510",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: 400 l rest - Institution Uge Højrupvej 153 1 (7000 Fredericia) ContainerNr:432174 ContainerBrik:0040000012A3B5C0 Ønsket virkningsdato: 03/05 2022 Besked: Kontaktoplysninger: FREDERICIA KOMMUNE",
          "status": 6,
          "priority": 2,
          "created_at": "2022-04-26T10:07:00+00:00",
          "updated_at": "2025-08-19T00:25:00.983231+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzkwMTQ=",
            "location": {
              "latitude": 55.579127,
              "longitude": 9.59607,
              "name": "Højrupvej 153, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDk2Mzc=",
      "location": {
        "name": "Herslevvej 54 7000 Fredericia",
        "latitude": 55.580389,
        "longitude": 9.610487
      },
      "containers": [
        {
          "id": "mp-pc-557",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-557",
            "container_id": "MP-7004-127",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDk2Mzk=",
      "location": {
        "name": "Herslevvej 58 7000 Fredericia",
        "latitude": 55.580439,
        "longitude": 9.607345
      },
      "containers": [
        {
          "id": "mp-pc-558",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-558",
            "container_id": "MP-7004-128",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDk2NDA=",
      "location": {
        "name": "Herslevvej 62 7000 Fredericia",
        "latitude": 55.580501,
        "longitude": 9.604674
      },
      "containers": [
        {
          "id": "mp-pc-559",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-559",
            "container_id": "MP-7004-129",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDk2NDE=",
      "location": {
        "name": "Herslevvej 66 7000 Fredericia",
        "latitude": 55.580529,
        "longitude": 9.602281
      },
      "containers": [
        {
          "id": "mp-pc-560",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-560",
            "container_id": "MP-7004-130",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NTY3NQ==",
          "ticket_id": "20595675",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Dorthe ThorbjørkTlf.: 28834753Email: famthor@mail.dkBesked: Synes den nye ordning med sorterings spand er ulækker , det stinker og er fuld af dyr. Kan heller ikke se meningen med alle de plastposer ( ihvertfald dobbelt så mange ) som vi normalt brugte. Det må kunne gøres bedere , tror det ville være en god ide at tage op til genovervejelse .",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-01T21:27:00+00:00",
          "updated_at": "2025-08-19T00:25:01.404059+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk2NDE=",
            "location": {
              "latitude": 55.580529,
              "longitude": 9.602281,
              "name": "Herslevvej 66, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQzNTI=",
      "location": {
        "name": "Herslevvej 70 7000 Fredericia",
        "latitude": 55.580567,
        "longitude": 9.599446
      },
      "containers": [
        {
          "id": "mp-pc-561",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-561",
            "container_id": "MP-7004-131",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTM2NTQ=",
      "location": {
        "name": "Højrupvej 146 7000 Fredericia",
        "latitude": 55.578237,
        "longitude": 9.597154
      },
      "containers": [
        {
          "id": "mp-pc-562",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-562",
            "container_id": "MP-7004-132",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTY3Nzg=",
      "location": {
        "name": "Højrupvej 144 7000 Fredericia",
        "latitude": 55.57781183,
        "longitude": 9.59734339
      },
      "containers": [
        {
          "id": "mp-pc-563",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-563",
            "container_id": "MP-7004-133",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5ODc1OQ==",
          "ticket_id": "20598759",
          "ticket_type": "AO-Bestilling af ny/ekstra beholder",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2020-06-10T13:25:00+00:00",
          "updated_at": "2025-08-19T00:25:01.588782+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTY3Nzg=",
            "location": {
              "latitude": 55.577811,
              "longitude": 9.597343,
              "name": "Højrupvej 144, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDk5MDc=",
      "location": {
        "name": "Højrupvej 126 7000 Fredericia",
        "latitude": 55.571232,
        "longitude": 9.602566
      },
      "containers": [
        {
          "id": "mp-pc-564",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-564",
            "container_id": "MP-7004-134",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NDg2NA==",
          "ticket_id": "20574864",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Ingen tømning i fredags !!",
          "status": 6,
          "priority": 2,
          "created_at": "2025-07-06T22:52:00+00:00",
          "updated_at": "2025-08-19T00:24:59.864566+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk5MDc=",
            "location": {
              "latitude": 55.571232,
              "longitude": 9.602566,
              "name": "Højrupvej 126, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3NjI1MQ==",
          "ticket_id": "20576251",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Der er ikke tømt affald i dag , trods den var kørt frem. Sidste tømning måtte vi også standse skralde bil , da den kørte forbi",
          "status": 6,
          "priority": 2,
          "created_at": "2025-03-28T16:39:00+00:00",
          "updated_at": "2025-08-19T00:25:00.024001+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk5MDc=",
            "location": {
              "latitude": 55.571232,
              "longitude": 9.602566,
              "name": "Højrupvej 126, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzUwOA==",
          "ticket_id": "20593508",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Billede af hvorfra skraldespanden er blevet tømt , siden 1.7.21.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-20T08:53:00+00:00",
          "updated_at": "2025-08-19T00:25:01.269841+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk5MDc=",
            "location": {
              "latitude": 55.571232,
              "longitude": 9.602566,
              "name": "Højrupvej 126, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzUyMw==",
          "ticket_id": "20593523",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Det passer ikke!!! Jeg satte skraldespanden frem d.15.10. Kl 7.00 -der hvor den er blevet tømt , siden det nye system trådte i kraft !! De har simpelthen ikke været her - jeg arbejder hjemme hver fredag. Rikke Buus",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-19T17:49:00+00:00",
          "updated_at": "2025-08-19T00:25:01.270666+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk5MDc=",
            "location": {
              "latitude": 55.571232,
              "longitude": 9.602566,
              "name": "Højrupvej 126, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzU1Nw==",
          "ticket_id": "20593557",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2021-10-18T19:26:00+00:00",
          "updated_at": "2025-08-19T00:25:01.272667+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk5MDc=",
            "location": {
              "latitude": 55.571232,
              "longitude": 9.602566,
              "name": "Højrupvej 126, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5Njc3Mg==",
          "ticket_id": "20596772",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Skulle have været tømt den 9.7. Tømmes UB",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-15T09:13:00+00:00",
          "updated_at": "2025-08-19T00:25:01.470102+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk5MDc=",
            "location": {
              "latitude": 55.571232,
              "longitude": 9.602566,
              "name": "Højrupvej 126, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDk2Mzg=",
      "location": {
        "name": "Herslevvej 57 7000 Fredericia",
        "latitude": 55.579921,
        "longitude": 9.607351
      },
      "containers": [
        {
          "id": "mp-pc-565",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-565",
            "container_id": "MP-7004-136",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MTM2OQ==",
          "ticket_id": "20581369",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2024-03-01Fraktion: 1 (Mad/Rest)Navn: Heidi MathiesenTlf.: 27598815Email: hnbm@hotmail.dkBesked: Den var 100% kørt ud til vejen, for der stod den da jeg kom hjem fra arbejde til midnat torsdag",
          "status": 6,
          "priority": 2,
          "created_at": "2024-03-15T11:08:00+00:00",
          "updated_at": "2025-08-19T00:25:00.372965+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk2Mzg=",
            "location": {
              "latitude": 55.579921,
              "longitude": 9.607351,
              "name": "Herslevvej 57, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDk2MzU=",
      "location": {
        "name": "Herslevvej 51 7000 Fredericia",
        "latitude": 55.577717,
        "longitude": 9.608989
      },
      "containers": [
        {
          "id": "mp-pc-566",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-566",
            "container_id": "MP-7004-137",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NjI1MA==",
          "ticket_id": "20576250",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2025-03-28Fraktion: 1 (Mad/Rest)Navn: SineTlf.: 53842416Email: sinesnell@hotmail.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2025-03-29T18:53:00+00:00",
          "updated_at": "2025-08-19T00:25:00.023904+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk2MzU=",
            "location": {
              "latitude": 55.577717,
              "longitude": 9.608989,
              "name": "Herslevvej 51, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3NjI2MQ==",
          "ticket_id": "20576261",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2025-03-28Fraktion: 1 (Mad/Rest)Navn: SineTlf.: 53842416Email: sinesnell@hotmail.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2025-03-29T18:51:00+00:00",
          "updated_at": "2025-08-19T00:25:00.025152+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk2MzU=",
            "location": {
              "latitude": 55.577717,
              "longitude": 9.608989,
              "name": "Herslevvej 51, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3ODA4MA==",
          "ticket_id": "20578080",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: SineTlf.: 53842416Email: sinesnell@hotmail.dkBesked: Hejsa kan se de andre naboer på Herslevvej har fået affald sække men det har vi ikke os der bor på Herslevvej 51 - 53 og 55. Kan vi forvente at det kommer de nærmeste dage? Hilsen Sine Snell",
          "status": 6,
          "priority": 2,
          "created_at": "2024-10-24T16:18:00+00:00",
          "updated_at": "2025-08-19T00:25:00.175477+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk2MzU=",
            "location": {
              "latitude": 55.577717,
              "longitude": 9.608989,
              "name": "Herslevvej 51, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4OTI2MA==",
          "ticket_id": "20589260",
          "ticket_type": "AO-Beholder ikke sat på plads",
          "description": "Navn: SineTlf.: 53842416Email: sinesnell@hotmail.dkBesked: Jeg forstår ikke hvorfor vi SKAL vende skraldespanden med håndtaget ud. Når de så efterfølgende kan smide den hvor det passer dem. Nu var jeg ved at køre vores skraldespand ned da de har sat den lige rundt om hjørnet. Det var ikke der de tog den. Vi har gjort så det er let tilgængelig for skraldemændene at komme til vores skraldespand. Ude ved grusvejen. Men synes det er dårligt de bare henkaster den hvor det passer dem når den er tømt. ",
          "status": 6,
          "priority": 2,
          "created_at": "2022-05-13T15:39:00+00:00",
          "updated_at": "2025-08-19T00:25:00.960194+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk2MzU=",
            "location": {
              "latitude": 55.577717,
              "longitude": 9.608989,
              "name": "Herslevvej 51, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTM3MA==",
          "ticket_id": "20591370",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Tømningsdato: 2022-01-18Fraktion: 2 (Genbrug)Navn: SineTlf.: 53842416Email: sinesnell@hotmail.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-19T11:28:00+00:00",
          "updated_at": "2025-08-19T00:25:01.142532+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk2MzU=",
            "location": {
              "latitude": 55.577717,
              "longitude": 9.608989,
              "name": "Herslevvej 51, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDEyNQ==",
          "ticket_id": "20594125",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Tømningsdato: 2021-09-16Fraktion: 2 (Genbrug)Navn: SineTlf.: 53842416Email: sinesnell@hotmail.dkBesked: Vores genbrug er ikke afhentet d 16/9 hvornår vil dette blive hentet???",
          "status": 6,
          "priority": 2,
          "created_at": "2021-09-17T13:32:00+00:00",
          "updated_at": "2025-08-19T00:25:01.306867+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk2MzU=",
            "location": {
              "latitude": 55.577717,
              "longitude": 9.608989,
              "name": "Herslevvej 51, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDEzMw==",
          "ticket_id": "20594133",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Tømningsdato: 2021-08-17Fraktion: 2 (Genbrug)Navn: SineTlf.: 53842416Email: sinesnell@hotmail.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-09-16T15:14:00+00:00",
          "updated_at": "2025-08-19T00:25:01.307336+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk2MzU=",
            "location": {
              "latitude": 55.577717,
              "longitude": 9.608989,
              "name": "Herslevvej 51, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NzA2Mw==",
          "ticket_id": "20597063",
          "ticket_type": "AO-Generel besked",
          "description": "Borger (Sine) synes, at chauffør kører for stærkt på grusvejen til fare for børnene. Har fået tilsendt video filmet af borgeren, som er videresendt til Kenneth. Kenneth kontakter borgeren.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-07-09T12:57:00+00:00",
          "updated_at": "2025-08-19T00:25:01.486487+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk2MzU=",
            "location": {
              "latitude": 55.577717,
              "longitude": 9.608989,
              "name": "Herslevvej 51, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDQxMTc=",
      "location": {
        "name": "Herslevvej 55 7000 Fredericia",
        "latitude": 55.577537,
        "longitude": 9.605878
      },
      "containers": [
        {
          "id": "mp-pc-567",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-567",
            "container_id": "MP-7004-138",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NjI0Nw==",
          "ticket_id": "20576247",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2025-03-28Fraktion: 1 (Mad/Rest)Navn: Stinne AndersenTlf.: 20618476Email: stinne.andersen@outlook.dkBesked: Beholder er ikke tømt, står i skel.",
          "status": 6,
          "priority": 2,
          "created_at": "2025-03-31T16:43:00+00:00",
          "updated_at": "2025-08-19T00:25:00.023610+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQxMTc=",
            "location": {
              "latitude": 55.577537,
              "longitude": 9.605878,
              "name": "Herslevvej 55, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToxMDQzNTk4Nw==",
          "ticket_id": "10435987",
          "ticket_type": "Defekt beholder - Låg i stykker",
          "description": "",
          "status": 5,
          "priority": 2,
          "created_at": "2024-10-24T15:08:21.499790+00:00",
          "updated_at": "2024-10-24T15:08:21.522111+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": {
            "name": null
          },
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQxMTc=",
            "location": {
              "latitude": 55.577537,
              "longitude": 9.605878,
              "name": "Herslevvej 55, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "new_6311325097936524",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToxMDQzNTk4Ng==",
          "ticket_id": "10435986",
          "ticket_type": "Defekt beholder - Krop",
          "description": "",
          "status": 5,
          "priority": 2,
          "created_at": "2024-10-24T15:06:34.221482+00:00",
          "updated_at": "2024-10-24T15:06:34.260576+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": {
            "name": null
          },
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQxMTc=",
            "location": {
              "latitude": 55.577537,
              "longitude": 9.605878,
              "name": "Herslevvej 55, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "new_6311325097936524",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4Njk5MQ==",
          "ticket_id": "20586991",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Tømningsdato: 2022-11-16Fraktion: 2 (Genbrug)Navn: Stinne AndersenTlf.: 20618476Email: stinne.rasmussen@hotmail.comBesked: De har ikke hentet vores sæt med metal affald på trods af at den lå samme sted som normalt.",
          "status": 6,
          "priority": 2,
          "created_at": "2022-11-17T07:08:00+00:00",
          "updated_at": "2025-08-19T00:25:00.753850+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQxMTc=",
            "location": {
              "latitude": 55.577537,
              "longitude": 9.605878,
              "name": "Herslevvej 55, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MDcwNA==",
          "ticket_id": "20590704",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Stinne AndersenTlf.: 20618476Email: stinne.rasmussen@hotmail.comBesked: Hvordan får jeg ekstra sække til genbrug?",
          "status": 6,
          "priority": 2,
          "created_at": "2022-02-16T17:32:00+00:00",
          "updated_at": "2025-08-19T00:25:01.083734+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQxMTc=",
            "location": {
              "latitude": 55.577537,
              "longitude": 9.605878,
              "name": "Herslevvej 55, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MDg1OQ==",
          "ticket_id": "20590859",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Stinne AndersenTlf.: 20618476Email: stinne.rasmussen@hotmail.comBesked: Hej, hvis man gerne vil have nogle ekstra genbrugssække, er det så nogen i har med på bilen og kan smide af eller hvor skal man hente dem henne? Mvh Stinne",
          "status": 6,
          "priority": 2,
          "created_at": "2022-02-13T15:12:00+00:00",
          "updated_at": "2025-08-19T00:25:01.099429+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQxMTc=",
            "location": {
              "latitude": 55.577537,
              "longitude": 9.605878,
              "name": "Herslevvej 55, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTM3MQ==",
          "ticket_id": "20591371",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Tømningsdato: 2022-01-18Fraktion: 2 (Genbrug)Navn: Stinne AndersenTlf.: 20618476Email: stinne.rasmussen@hotmail.comBesked: Der er endnu en gang ikke afhentet genbrug på vores adresse, det er 3 ud af 6 gange! Det er simpelthen bare ikke godt nok!",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-19T07:17:00+00:00",
          "updated_at": "2025-08-19T00:25:01.142586+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQxMTc=",
            "location": {
              "latitude": 55.577537,
              "longitude": 9.605878,
              "name": "Herslevvej 55, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDEyNg==",
          "ticket_id": "20594126",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Tømningsdato: 2021-09-16Fraktion: 2 (Genbrug)Navn: Stinne AndersenTlf.: 20618476Email: stinne.rasmussen@hotmail.comBesked: Vi har igen ikke fået hentet genbrug, det er anden gang ud af to mulige.",
          "status": 6,
          "priority": 2,
          "created_at": "2021-09-17T07:37:00+00:00",
          "updated_at": "2025-08-19T00:25:01.306922+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQxMTc=",
            "location": {
              "latitude": 55.577537,
              "longitude": 9.605878,
              "name": "Herslevvej 55, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDk2OQ==",
          "ticket_id": "20594969",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Tømningsdato: 2021-08-17Fraktion: 2 (Genbrug)Navn: Stinne AndersenTlf.: 20618476Email: stinne.rasmussen@hotmail.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-18T07:48:00+00:00",
          "updated_at": "2025-08-19T00:25:01.358105+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQxMTc=",
            "location": {
              "latitude": 55.577537,
              "longitude": 9.605878,
              "name": "Herslevvej 55, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTkyNDU=",
      "location": {
        "name": "Herslev Kirkevej 4 7000 Fredericia",
        "latitude": 55.58037808,
        "longitude": 9.59456782
      },
      "containers": [
        {
          "id": "mp-pc-568",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-568",
            "container_id": "MP-7004-139",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "400 L"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NDg2Mg==",
          "ticket_id": "20574862",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Container ikke tømt i fredags ! Vi har udlejning igen onsdag - så meget vigtig den tømmes inden!!!",
          "status": 6,
          "priority": 2,
          "created_at": "2025-07-06T22:52:00+00:00",
          "updated_at": "2025-08-19T00:24:59.864383+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkyNDU=",
            "location": {
              "latitude": 55.580378,
              "longitude": 9.594567,
              "name": "Herslev Kirkevej 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDQyMg==",
          "ticket_id": "20580422",
          "ticket_type": "AO-Ændring af beholder",
          "description": "Følgende beholder ønskes udskiftet: D400ErhUgeÅr - Erhverv Gamle Herslev Kirkevej 4 (7000 Fredericia) ContainerNr:402219 ContainerBrik: Beholder der ønskes i stedet: 400 l rest - Erhverv Uge Ny tømningsfrekvens: Hver uge Gebyr: 0 kr Ønsket virkningsdato: 13/06 2024 Besked: Ændres fra gammel til ny beholder. Kontaktoplysninger: Rikke Buus 29437290 Rikke.buus@fredericia.dk",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-06T08:15:00+00:00",
          "updated_at": "2025-08-19T00:25:00.314313+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkyNDU=",
            "location": {
              "latitude": 55.580378,
              "longitude": 9.594567,
              "name": "Herslev Kirkevej 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDQyMw==",
          "ticket_id": "20580423",
          "ticket_type": "AO-Defekt beholder",
          "description": "Der ønskes reparation af beholder: D400ErhUgeÅr - Erhverv Gamle Herslev Kirkevej 4 (7000 Fredericia) ContainerNr:402219 ContainerBrik: Låg itu Ønsket virkningsdato: 12/06-2024 Besked: Hængsel v/ låg knækket. Kontaktoplysninger: Rikke Buus 29437290 Rikke.buus@fredericia.dk",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-06T08:12:00+00:00",
          "updated_at": "2025-08-19T00:25:00.314368+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkyNDU=",
            "location": {
              "latitude": 55.580378,
              "longitude": 9.594567,
              "name": "Herslev Kirkevej 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MDQyMA==",
          "ticket_id": "20580420",
          "ticket_type": "AO-Håndtag itu (vedhæft evt foto - kun på web)",
          "description": "Hængsel knækket under dagens tømning",
          "status": 6,
          "priority": 2,
          "created_at": "2024-06-05T12:25:00+00:00",
          "updated_at": "2025-08-19T00:25:00.314203+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkyNDU=",
            "location": {
              "latitude": 55.580378,
              "longitude": 9.594567,
              "name": "Herslev Kirkevej 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4OTczNg==",
          "ticket_id": "20589736",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Vi fik en mail forrige onsdag,at forsamlingshusets container var blevet tømt- og fremover ville blive tømt fredage. Første tømning ville være d. 1.4.- det skete så ikke!!! Det kan simpelthen ikke være rigtig, at de ikke kan finde ud af at tømme den - sådan et sted er drevet af frivillige kræfter, og vi bruger vores fritid på at tjekke om den er tømt... Så skal det simpelthen fungere!! Vi betaler for tømning hver uge. Det er ,jeg ved ikke hvilken gang - vi har udlejning hvor skraldespanden ikke e",
          "status": 6,
          "priority": 2,
          "created_at": "2022-04-02T20:39:00+00:00",
          "updated_at": "2025-08-19T00:25:01.009039+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkyNDU=",
            "location": {
              "latitude": 55.580378,
              "longitude": 9.594567,
              "name": "Herslev Kirkevej 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MDYyOA==",
          "ticket_id": "20590628",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Containeren er stadig ikke tømt!,! Den skal normalt tømmes i morgen onsdag og der regner jeg med de tager de sække med som ligger ved siden af .Så vi har en Tom container til udlejning i weekenden??",
          "status": 6,
          "priority": 2,
          "created_at": "2022-02-22T18:00:00+00:00",
          "updated_at": "2025-08-19T00:25:01.079158+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkyNDU=",
            "location": {
              "latitude": 55.580378,
              "longitude": 9.594567,
              "name": "Herslev Kirkevej 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MDc0NQ==",
          "ticket_id": "20590745",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "SKAL TÃMMES I DAG!! Forsamlingshusets container er ikke tømt i onsdags, og der er stor fest der i weekenden - så den skal tømmes i dag! Fremad rettet er der udlejet hver uge , så det er vigtigt at den tømmes hver onsdag - som vi forøvrigt betaler for i dyre domme....",
          "status": 6,
          "priority": 2,
          "created_at": "2022-02-18T05:47:00+00:00",
          "updated_at": "2025-08-19T00:25:01.087261+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkyNDU=",
            "location": {
              "latitude": 55.580378,
              "longitude": 9.594567,
              "name": "Herslev Kirkevej 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MzE5NQ==",
          "ticket_id": "20593195",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Endnu engang må vi konstatere at beholderen ved Herslev Forsamlingshus ikke er tømt !! Den skulle være tømt d3.11. Vi har udlejning hver weekend og den er derfor fuld hver uge. Nu stiller vi en ekstra container op - så skraldet fra denne weekend ikke skal stå og trække rotter til !",
          "status": 6,
          "priority": 2,
          "created_at": "2021-11-05T16:18:00+00:00",
          "updated_at": "2025-08-19T00:25:01.252172+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkyNDU=",
            "location": {
              "latitude": 55.580378,
              "longitude": 9.594567,
              "name": "Herslev Kirkevej 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDU4MA==",
          "ticket_id": "20594580",
          "ticket_type": "AO-Manglende tømning - restaffald",
          "description": "Ikke tømt",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-30T11:08:00+00:00",
          "updated_at": "2025-08-19T00:25:01.334785+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTkyNDU=",
            "location": {
              "latitude": 55.580378,
              "longitude": 9.594567,
              "name": "Herslev Kirkevej 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDYxNTY=",
      "location": {
        "name": "Åbrinken 2 7000 Fredericia",
        "latitude": 55.585097,
        "longitude": 9.587091
      },
      "containers": [
        {
          "id": "mp-pc-569",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-569",
            "container_id": "MP-7004-140",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDYxNTc=",
      "location": {
        "name": "Åbrinken 4 7000 Fredericia",
        "latitude": 55.585139,
        "longitude": 9.587245
      },
      "containers": [
        {
          "id": "mp-pc-570",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-570",
            "container_id": "MP-7004-141",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5NDM0Nw==",
          "ticket_id": "20594347",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Connie MaintzTlf.: 42307719Email: connie.maintz@hotmail.vomBesked: Hej jeg vil gerne bare vide hvorfor der ikke er klistermærker til flamingo , og hvor gør vi af det, vi bor ude i Herslev vi har ikke bil og har ikke mulighed for selv at køre ind med det på genbrugs stationen, jeg undrer mig bare over at vi ikke længere kan komme af med flamingo. V.h.connie maintz",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-20T10:33:00+00:00",
          "updated_at": "2025-08-19T00:25:01.320435+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDYxNTc=",
            "location": {
              "latitude": 55.585139,
              "longitude": 9.587245,
              "name": "Åbrinken 4, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDYxNTk=",
      "location": {
        "name": "Åbrinken 8 7000 Fredericia",
        "latitude": 55.58529,
        "longitude": 9.587205
      },
      "containers": [
        {
          "id": "mp-pc-571",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-571",
            "container_id": "MP-7004-142",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDYxNTg=",
      "location": {
        "name": "Åbrinken 6 7000 Fredericia",
        "latitude": 55.585275,
        "longitude": 9.587057
      },
      "containers": [
        {
          "id": "mp-pc-572",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-572",
            "container_id": "MP-7004-143",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDYxNjA=",
      "location": {
        "name": "Åbrinken 10 7000 Fredericia",
        "latitude": 55.585443,
        "longitude": 9.586905
      },
      "containers": [
        {
          "id": "mp-pc-573",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-573",
            "container_id": "MP-7004-144",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZTo4MDc2MDAy",
          "ticket_id": "8076002",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2023-10-16T07:49:45.354996+00:00",
          "updated_at": "2023-10-16T07:49:45.370145+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDYxNjA=",
            "location": {
              "latitude": 55.585443,
              "longitude": 9.586905,
              "name": "Åbrinken 10, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "18535_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZTo3MjU5MDM2",
          "ticket_id": "7259036",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2023-09-14T11:19:12.098757+00:00",
          "updated_at": "2023-09-14T11:19:12.111155+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDYxNjA=",
            "location": {
              "latitude": 55.585443,
              "longitude": 9.586905,
              "name": "Åbrinken 10, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "18535_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDEyOA==",
          "ticket_id": "20594128",
          "ticket_type": "AO-Generel besked",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2021-09-16T20:13:00+00:00",
          "updated_at": "2025-08-19T00:25:01.307032+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDYxNjA=",
            "location": {
              "latitude": 55.585443,
              "longitude": 9.586905,
              "name": "Åbrinken 10, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDYxNjE=",
      "location": {
        "name": "Åbrinken 12 7000 Fredericia",
        "latitude": 55.585534,
        "longitude": 9.58683
      },
      "containers": [
        {
          "id": "mp-pc-574",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-574",
            "container_id": "MP-7004-145",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5ODI3MA==",
          "ticket_id": "20598270",
          "ticket_type": "AO-Generel besked",
          "description": "Da jeg i maj får en kompostbeholder, på Ã brinken 12, ønsker jeg ikke længere at have og betale for en affaldsbeholder til grønt affald, fra 1. juni 2021. Med venlig hilsen Jens Christian Gammelby Jensen",
          "status": 6,
          "priority": 2,
          "created_at": "2021-03-06T05:43:00+00:00",
          "updated_at": "2025-08-19T00:25:01.559771+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDYxNjE=",
            "location": {
              "latitude": 55.585534,
              "longitude": 9.58683,
              "name": "Åbrinken 12, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDYxNjM=",
      "location": {
        "name": "Åbrinken 16 7000 Fredericia",
        "latitude": 55.585499,
        "longitude": 9.586566
      },
      "containers": [
        {
          "id": "mp-pc-575",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-575",
            "container_id": "MP-7004-146",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDYxNjI=",
      "location": {
        "name": "Åbrinken 14 7000 Fredericia",
        "latitude": 55.585415,
        "longitude": 9.586595
      },
      "containers": [
        {
          "id": "mp-pc-576",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-576",
            "container_id": "MP-7004-147",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToxMDA5NjM3OQ==",
          "ticket_id": "10096379",
          "ticket_type": "Affaldet skal afleveres på genbrugspladsen",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2024-05-16T08:11:48.384233+00:00",
          "updated_at": "2024-05-16T08:11:48.385187+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDYxNjI=",
            "location": {
              "latitude": 55.585415,
              "longitude": 9.586595,
              "name": "Åbrinken 14, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "18537_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDYwMDY5OA==",
          "ticket_id": "20600698",
          "ticket_type": "AO-Ændring til 180-190 liter beholder til restaffald",
          "description": "",
          "status": 6,
          "priority": 2,
          "created_at": "2016-06-28T20:29:00+00:00",
          "updated_at": "2025-08-19T00:25:01.709929+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDYxNjI=",
            "location": {
              "latitude": 55.585415,
              "longitude": 9.586595,
              "name": "Åbrinken 14, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDYxNjQ=",
      "location": {
        "name": "Åbrinken 18 7000 Fredericia",
        "latitude": 55.585308,
        "longitude": 9.586267
      },
      "containers": [
        {
          "id": "mp-pc-577",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-577",
            "container_id": "MP-7004-148",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NDg1OQ==",
          "ticket_id": "20574859",
          "ticket_type": "AO-Generel besked",
          "description": "Borger ringer og er sur over at den ikke er tømt. Truer med at ringe til borgmester, da beholder ikke er tømt mellem kl 9 og 10.",
          "status": 6,
          "priority": 2,
          "created_at": "2025-07-04T11:35:00+00:00",
          "updated_at": "2025-08-19T00:24:59.864108+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDYxNjQ=",
            "location": {
              "latitude": 55.585308,
              "longitude": 9.586267,
              "name": "Åbrinken 18, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MTEwOA==",
          "ticket_id": "20581108",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: 240 l rest - Parcel Åbrinken 18 1 (7000 Fredericia) ContainerNr:437044 ContainerBrik:0040000012672D38 Ønsket virkningsdato: 31/12-2023 Besked: Jf. aftale med Kasper fra Boligkontoret, skal beholder afmeldes og ikke betales for i 2024. Kontaktoplysninger: Boligkontoret Fredericia afd. 504",
          "status": 6,
          "priority": 2,
          "created_at": "2024-04-16T10:38:00+00:00",
          "updated_at": "2025-08-19T00:25:00.357025+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDYxNjQ=",
            "location": {
              "latitude": 55.585308,
              "longitude": 9.586267,
              "name": "Åbrinken 18, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTkwMQ==",
          "ticket_id": "20585901",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 240 l rest - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 06/02 2023 Besked: Kontaktoplysninger: Boligkontoret Fredericia afd. 504",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-30T11:24:00+00:00",
          "updated_at": "2025-08-19T00:25:00.644810+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDYxNjQ=",
            "location": {
              "latitude": 55.585308,
              "longitude": 9.586267,
              "name": "Åbrinken 18, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NjM5NA==",
          "ticket_id": "20586394",
          "ticket_type": "AO-Generel besked",
          "description": "Her står ekstra sæk ved næste tømning. Har haft problemer med at erhverve sækkemærke - så ub",
          "status": 6,
          "priority": 2,
          "created_at": "2022-12-20T11:34:00+00:00",
          "updated_at": "2025-08-19T00:25:00.699697+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDYxNjQ=",
            "location": {
              "latitude": 55.585308,
              "longitude": 9.586267,
              "name": "Åbrinken 18, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDYxNjU=",
      "location": {
        "name": "Åbrinken 20 7000 Fredericia",
        "latitude": 55.585397,
        "longitude": 9.586237
      },
      "containers": [
        {
          "id": "mp-pc-578",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-578",
            "container_id": "MP-7004-149",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MDgzOQ==",
          "ticket_id": "20580839",
          "ticket_type": "AO-Generel besked",
          "description": "Mail til Boligkontoret: Hej Jeg har fået en forespørgsel fra plejen på vegne af lejer i Åbrinken 20. Hun har problemer med at få kørt sin beholder frem, så hun vil gerne have afstandstillæg. Det koster 162 kr. om året og så henter skraldemændene beholderen, hvor den står. Jeg vil dog ikke tilmelde noget, før jeg har bekræftelse fra jer, da det jo er jer, der modtager opkrævninger fra os. Vil I vende tilbage med, om vi må oprette dette? Evt. tage fat på lejer også.",
          "status": 6,
          "priority": 2,
          "created_at": "2024-05-06T12:54:00+00:00",
          "updated_at": "2025-08-19T00:25:00.339966+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDYxNjU=",
            "location": {
              "latitude": 55.585397,
              "longitude": 9.586237,
              "name": "Åbrinken 20, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTYzODA=",
      "location": {
        "name": "Mølleåvej 2 7000 Fredericia",
        "latitude": 55.58566875,
        "longitude": 9.58854081
      },
      "containers": [
        {
          "id": "mp-pc-579",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-579",
            "container_id": "MP-7004-150",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NzcyMQ==",
          "ticket_id": "20577721",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2024-11-22Fraktion: 1 (Mad/Rest)Navn: AnikaTlf.: 61287190Email: a-hjorth@hotmail.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2024-11-24T14:25:00+00:00",
          "updated_at": "2025-08-19T00:25:00.155815+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYzODA=",
            "location": {
              "latitude": 55.585668,
              "longitude": 9.58854,
              "name": "Mølleåvej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU3NzczOQ==",
          "ticket_id": "20577739",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Manglende snerydning Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2024-11-22T07:42:00+00:00",
          "updated_at": "2025-08-19T00:25:00.156746+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYzODA=",
            "location": {
              "latitude": 55.585668,
              "longitude": 9.58854,
              "name": "Mølleåvej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MjA1NA==",
          "ticket_id": "20582054",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Tømningsdato: 2024-01-17Fraktion: 2 (Genbrug)Navn: AnikaTlf.: 61287190Email: a-hjorth@hotmail.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2024-01-18T20:13:00+00:00",
          "updated_at": "2025-08-19T00:25:00.414848+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYzODA=",
            "location": {
              "latitude": 55.585668,
              "longitude": 9.58854,
              "name": "Mølleåvej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MjExNg==",
          "ticket_id": "20582116",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Vogn 3 kunne 17. jan. 2024 ikke komme ned og tømme grundet sne og is på vejen.",
          "status": 6,
          "priority": 2,
          "created_at": "2024-01-17T13:20:00+00:00",
          "updated_at": "2025-08-19T00:25:00.417952+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYzODA=",
            "location": {
              "latitude": 55.585668,
              "longitude": 9.58854,
              "name": "Mølleåvej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MjY2Ng==",
          "ticket_id": "20582666",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2024-01-05Fraktion: 1 (Mad/Rest)Navn: AnikaTlf.: 61287190Email: a-hjorth@hotmail.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2024-01-06T13:48:00+00:00",
          "updated_at": "2025-08-19T00:25:00.449381+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYzODA=",
            "location": {
              "latitude": 55.585668,
              "longitude": 9.58854,
              "name": "Mølleåvej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MjcyMQ==",
          "ticket_id": "20582721",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Manglende snerydning Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2024-01-05T08:14:00+00:00",
          "updated_at": "2025-08-19T00:25:00.452170+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYzODA=",
            "location": {
              "latitude": 55.585668,
              "longitude": 9.58854,
              "name": "Mølleåvej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NDY5Nw==",
          "ticket_id": "20584697",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Navn: AnikaTlf.: 61287190Email: a-hjorth@hotmail.comBesked: Skraldespand ikke tømt 26.05.2023",
          "status": 6,
          "priority": 2,
          "created_at": "2023-05-26T14:17:00+00:00",
          "updated_at": "2025-08-19T00:25:00.575129+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYzODA=",
            "location": {
              "latitude": 55.585668,
              "longitude": 9.58854,
              "name": "Mølleåvej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTg2OA==",
          "ticket_id": "20591868",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-12-24Fraktion: 1 (Mad/Rest)Navn: AnikaTlf.: 61287190Email: a-hjorth@hotmail.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-03T19:23:00+00:00",
          "updated_at": "2025-08-19T00:25:01.175452+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYzODA=",
            "location": {
              "latitude": 55.585668,
              "longitude": 9.58854,
              "name": "Mølleåvej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTkyNQ==",
          "ticket_id": "20591925",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-12-24Fraktion: 1 (Mad/Rest)Navn: AnikaTlf.: 61287190Email: a-hjorth@hotmail.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-29T13:57:00+00:00",
          "updated_at": "2025-08-19T00:25:01.178635+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYzODA=",
            "location": {
              "latitude": 55.585668,
              "longitude": 9.58854,
              "name": "Mølleåvej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTk1Mg==",
          "ticket_id": "20591952",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2021-12-24Fraktion: 1 (Mad/Rest)Navn: AnikaTlf.: 61287190Email: a-hjorth@hotmail.comBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-25T11:22:00+00:00",
          "updated_at": "2025-08-19T00:25:01.182708+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYzODA=",
            "location": {
              "latitude": 55.585668,
              "longitude": 9.58854,
              "name": "Mølleåvej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MjU1OA==",
          "ticket_id": "20592558",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: AnikaTlf.: 61287190Email: a-hjorth@hotmail.comBesked: Vi mangler klistermærker - hvornår bliver de omdelt igen ?",
          "status": 6,
          "priority": 2,
          "created_at": "2021-12-08T12:53:00+00:00",
          "updated_at": "2025-08-19T00:25:01.216819+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTYzODA=",
            "location": {
              "latitude": 55.585668,
              "longitude": 9.58854,
              "name": "Mølleåvej 2, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDQ3MDk=",
      "location": {
        "name": "Mølleåvej 17 7000 Fredericia",
        "latitude": 55.586707,
        "longitude": 9.587518
      },
      "containers": [
        {
          "id": "mp-pc-580",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-580",
            "container_id": "MP-7004-151",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NzczOA==",
          "ticket_id": "20577738",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Manglende snerydning Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2024-11-22T07:42:00+00:00",
          "updated_at": "2025-08-19T00:25:00.156694+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQ3MDk=",
            "location": {
              "latitude": 55.586707,
              "longitude": 9.587518,
              "name": "Mølleåvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MjExNA==",
          "ticket_id": "20582114",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Vogn 3 kunne 17. jan. 2024 ikke komme ned og tømme grundet sne og is på vejen.",
          "status": 6,
          "priority": 2,
          "created_at": "2024-01-17T13:20:00+00:00",
          "updated_at": "2025-08-19T00:25:00.417850+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQ3MDk=",
            "location": {
              "latitude": 55.586707,
              "longitude": 9.587518,
              "name": "Mølleåvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MzAyMA==",
          "ticket_id": "20583020",
          "ticket_type": "AO-Besked fra renovatør",
          "description": "Manglende snerydning Er der afleveret flyer: Nej Er beholder tømt: Nej",
          "status": 6,
          "priority": 2,
          "created_at": "2023-12-08T07:50:00+00:00",
          "updated_at": "2025-08-19T00:25:00.468733+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQ3MDk=",
            "location": {
              "latitude": 55.586707,
              "longitude": 9.587518,
              "name": "Mølleåvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4MzAxNQ==",
          "ticket_id": "20583015",
          "ticket_type": "AO-Generel besked",
          "description": "Navn: Sandra ArvidsonTlf.: 40551098Email: sandra@arvidson.dkBesked: Hej. Vi vil opfordre til, at skraldebilen ikke kører ned til os på Mølleåvej 17 i morgen. Det kan være meget svært at komme op igen for store køretøjer, da der ikke er ryddet for sne. Vi kan sagtens undvære en tømning. Mvh Sandra Arvidson",
          "status": 6,
          "priority": 2,
          "created_at": "2023-12-07T17:59:00+00:00",
          "updated_at": "2025-08-19T00:25:00.468478+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQ3MDk=",
            "location": {
              "latitude": 55.586707,
              "longitude": 9.587518,
              "name": "Mølleåvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MDgwOA==",
          "ticket_id": "20590808",
          "ticket_type": "AO-Manglende tømning - genbrug",
          "description": "Tømningsdato: 2022-02-14Fraktion: 2 (Genbrug)Navn: Sandra ArvidsonTlf.: 40551098Email: sandra@arvidson.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2022-02-15T14:29:00+00:00",
          "updated_at": "2025-08-19T00:25:01.093640+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQ3MDk=",
            "location": {
              "latitude": 55.586707,
              "longitude": 9.587518,
              "name": "Mølleåvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTg2Nw==",
          "ticket_id": "20591867",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Har ikke fået tømt den 24/12. Har snakket med Lasse fra MP. Der bliver tømt i morgen d. 5/1",
          "status": 6,
          "priority": 2,
          "created_at": "2022-01-04T10:45:00+00:00",
          "updated_at": "2025-08-19T00:25:01.175398+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDQ3MDk=",
            "location": {
              "latitude": 55.586707,
              "longitude": 9.587518,
              "name": "Mølleåvej 17, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDk2MDk=",
      "location": {
        "name": "Herslev Fælledvej 16 7000 Fredericia",
        "latitude": 55.581064,
        "longitude": 9.576743
      },
      "containers": [
        {
          "id": "mp-pc-581",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-581",
            "container_id": "MP-7004-152",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NTUyNw==",
          "ticket_id": "20575527",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2025-05-23Fraktion: 1 (Mad/Rest)Navn: Jakob JensenTlf.: 26655034Email: pegeo@live.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2025-05-24T14:07:00+00:00",
          "updated_at": "2025-08-19T00:24:59.942442+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk2MDk=",
            "location": {
              "latitude": 55.581064,
              "longitude": 9.576743,
              "name": "Herslev Fælledvej 16, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTAzMA==",
          "ticket_id": "20591030",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2022-02-04Fraktion: 1 (Mad/Rest)Navn: Jakob JensenTlf.: 26655034Email: pegeo@live.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2022-02-05T10:45:00+00:00",
          "updated_at": "2025-08-19T00:25:01.117618+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk2MDk=",
            "location": {
              "latitude": 55.581064,
              "longitude": 9.576743,
              "name": "Herslev Fælledvej 16, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5MTAyOQ==",
          "ticket_id": "20591029",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2022-02-04Fraktion: 1 (Mad/Rest)Navn: Jakob JensenTlf.: 26655034Email: pegeo@live.dkBesked:",
          "status": 6,
          "priority": 2,
          "created_at": "2022-02-05T10:44:00+00:00",
          "updated_at": "2025-08-19T00:25:01.117521+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk2MDk=",
            "location": {
              "latitude": 55.581064,
              "longitude": 9.576743,
              "name": "Herslev Fælledvej 16, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDk2MTA=",
      "location": {
        "name": "Herslev Fælledvej 20 7000 Fredericia",
        "latitude": 55.578909,
        "longitude": 9.574159
      },
      "containers": [
        {
          "id": "mp-pc-582",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-582",
            "container_id": "MP-7004-153",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTQzNDg=",
      "location": {
        "name": "Herslev Fælledvej 26 7000 Fredericia",
        "latitude": 55.57794308,
        "longitude": 9.57404457
      },
      "containers": [
        {
          "id": "mp-pc-583",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-583",
            "container_id": "MP-7004-154",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDk2MTI=",
      "location": {
        "name": "Herslev Fælledvej 38 7000 Fredericia",
        "latitude": 55.576423,
        "longitude": 9.570799
      },
      "containers": [
        {
          "id": "mp-pc-584",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-584",
            "container_id": "MP-7004-155",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZTo3MjMxNTIx",
          "ticket_id": "7231521",
          "ticket_type": "Affaldet er ikke sorteret korrekt",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2023-08-15T12:02:29.116143+00:00",
          "updated_at": "2023-08-15T12:02:29.131736+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk2MTI=",
            "location": {
              "latitude": 55.576423,
              "longitude": 9.570799,
              "name": "Herslev Fælledvej 38, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "18563_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDk2MTE=",
      "location": {
        "name": "Herslev Fælledvej 32 7000 Fredericia",
        "latitude": 55.576205,
        "longitude": 9.573904
      },
      "containers": [
        {
          "id": "mp-pc-585",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-585",
            "container_id": "MP-7004-156",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU5MzAwNw==",
          "ticket_id": "20593007",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Hej. Min affaldsbeholder bliver ikke tømt efter vi har fået de nye 2delte. Siden vi har skiftet over til den nye sortering, har jeg kun fået tømt beholderen 1 gang, skønt den står hvor den altid har gjort. Ca 2m fra vejen, med fri ryddet adgang og fast køre underlag. Vi har nu flere sække med restaffald stående, som lokker mus, rotter osv til, dem vil vi gerne ha de tager med ved næste tømning, vi skal nok stille dem ud til vejen sammen med beholderen, til næste tømning om ca en uge. Hvis vi gør",
          "status": 6,
          "priority": 2,
          "created_at": "2021-11-19T17:02:00+00:00",
          "updated_at": "2025-08-19T00:25:01.241697+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk2MTE=",
            "location": {
              "latitude": 55.576205,
              "longitude": 9.573904,
              "name": "Herslev Fælledvej 32, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDk2MTM=",
      "location": {
        "name": "Herslev Fælledvej 56 7000 Fredericia",
        "latitude": 55.575575,
        "longitude": 9.572778
      },
      "containers": [
        {
          "id": "mp-pc-586",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-586",
            "container_id": "MP-7004-157",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": []
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMDk2MTY=",
      "location": {
        "name": "Herslev Fælledvej 66 7000 Fredericia",
        "latitude": 55.57407,
        "longitude": 9.569834
      },
      "containers": [
        {
          "id": "mp-pc-587",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-587",
            "container_id": "MP-7004-158",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4MTIxOA==",
          "ticket_id": "20581218",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Tømningsdato: 2024-03-29Fraktion: 1 (Mad/Rest)Navn: Carina PedersenTlf.: 81618925Email: cborup1986@gmail.comBesked: kan se der var flere der ikke var blevet tømt også er der noget grund til det",
          "status": 6,
          "priority": 2,
          "created_at": "2024-03-30T11:00:00+00:00",
          "updated_at": "2025-08-19T00:25:00.363704+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk2MTY=",
            "location": {
              "latitude": 55.57407,
              "longitude": 9.569834,
              "name": "Herslev Fælledvej 66, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZTo3MjU4NzQz",
          "ticket_id": "7258743",
          "ticket_type": "Sækken indeholder farligt affald - brug den røde kasse",
          "description": "",
          "status": 1,
          "priority": 0,
          "created_at": "2023-09-14T08:53:34.363186+00:00",
          "updated_at": "2023-09-14T08:53:34.377985+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk2MTY=",
            "location": {
              "latitude": 55.57407,
              "longitude": 9.569834,
              "name": "Herslev Fælledvej 66, 7000, Fredericia, Danmark"
            }
          },
          "container": {
            "container_id": "18565_883",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6MjA4NA==",
              "name": "Genbrug",
              "color": null
            },
            "container_type": {
              "name": "Poser"
            },
            "pickup_setting": null
          },
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTkyOA==",
          "ticket_id": "20585928",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Hej Henrik Beholderen står udenfor havelågen og der har den stået siden jeg er flyttet ind den 1 januar 2023",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-26T09:15:00+00:00",
          "updated_at": "2025-08-19T00:25:00.648716+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk2MTY=",
            "location": {
              "latitude": 55.57407,
              "longitude": 9.569834,
              "name": "Herslev Fælledvej 66, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4NTkzNg==",
          "ticket_id": "20585936",
          "ticket_type": "AO-Beholder ikke tømt",
          "description": "Jeg ved ikke hvorfor beholderen ikke er tømt og der ligger ikke besked i min postkasse om evt årsag",
          "status": 6,
          "priority": 2,
          "created_at": "2023-01-25T22:41:00+00:00",
          "updated_at": "2025-08-19T00:25:00.649959+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMDk2MTY=",
            "location": {
              "latitude": 55.57407,
              "longitude": 9.569834,
              "name": "Herslev Fælledvej 66, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMzg3MzQ=",
      "location": {
        "name": "Herslev Fælledvej 65 7000 Fredericia",
        "latitude": 55.57277565,
        "longitude": 9.56887982
      },
      "containers": [
        {
          "id": "mp-pc-588",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-588",
            "container_id": "MP-7004-159",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU4OTgzOA==",
          "ticket_id": "20589838",
          "ticket_type": "AO-Ny beholder",
          "description": "Der ønskes ny beholder: 2-delt 240 l beholder - Parcel Ny tømningsfrekvens: Hver 14 dag Ønsket virkningsdato: 01/04-2022 Besked: Erstatter brændt beholder Kontaktoplysninger: Klaus-Peter Million",
          "status": 6,
          "priority": 2,
          "created_at": "2022-03-30T14:40:00+00:00",
          "updated_at": "2025-08-19T00:25:01.019603+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzg3MzQ=",
            "location": {
              "latitude": 55.572775,
              "longitude": 9.568879,
              "name": "Herslev Fælledvej 65, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4OTgzOQ==",
          "ticket_id": "20589839",
          "ticket_type": "AO-Afmelding af beholder",
          "description": "Følgende beholder ønskes afmeldt: 2-delt 240 l beholder - Parcel Herslev Fælledvej 65 1 (7000 Fredericia) ContainerNr:410757 ContainerBrik: Ønsket virkningsdato: 01/04-2022 Besked: Beholderen er forsvundet i en brand. Kontaktoplysninger: Klaus-Peter Million",
          "status": 6,
          "priority": 2,
          "created_at": "2022-03-30T14:39:00+00:00",
          "updated_at": "2025-08-19T00:25:01.019700+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzg3MzQ=",
            "location": {
              "latitude": 55.572775,
              "longitude": 9.568879,
              "name": "Herslev Fælledvej 65, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4OTg0MA==",
          "ticket_id": "20589840",
          "ticket_type": "AO-Generel besked",
          "description": "Boligen er totalt nedbrændt 12. marts. Den oprindelige beholder er forsvundet - leverer en ny snarest muligt.",
          "status": 6,
          "priority": 2,
          "created_at": "2022-03-30T14:37:00+00:00",
          "updated_at": "2025-08-19T00:25:01.019807+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMzg3MzQ=",
            "location": {
              "latitude": 55.572775,
              "longitude": 9.568879,
              "name": "Herslev Fælledvej 65, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    },
    {
      "id": "UHJvcGVydHlUeXBlOjExMTA3ODU=",
      "location": {
        "name": "Mærskkildevej 30 7000 Fredericia",
        "latitude": 55.563283,
        "longitude": 9.612755
      },
      "containers": [
        {
          "id": "mp-pc-589",
          "num_open_tickets": 0,
          "container": {
            "id": "mp-c-589",
            "container_id": "MP-7004-160",
            "waste_fraction": {
              "id": "V2FzdGVGcmFjdGlvblR5cGU6Mjc2OQ==",
              "name": "Mad/Rest",
              "color": null
            },
            "container_type": {
              "id": "",
              "name": "240 L 2-delt"
            }
          }
        }
      ],
      "tickets": [
        {
          "id": "VGlja2V0VHlwZToyMDU3NzcxNg==",
          "ticket_id": "20577716",
          "ticket_type": "AO-Generel besked",
          "description": "Der er lavet aftale med Marius Pedersen, at når det er snevejr og glatte veje, så kører nr. 26 og nr. 30 beholderne op til den fælleshovedvej. Nr. 26 og nr. 30 ligger på en privatfællesvej.",
          "status": 6,
          "priority": 2,
          "created_at": "2024-11-22T09:26:00+00:00",
          "updated_at": "2025-08-19T00:25:00.155550+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTA3ODU=",
            "location": {
              "latitude": 55.563283,
              "longitude": 9.612755,
              "name": "Mærskkildevej 30, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4ODI1Mg==",
          "ticket_id": "20588252",
          "ticket_type": "AO-Ønsker tilsyn",
          "description": "Se ligeledes under generel besked",
          "status": 6,
          "priority": 2,
          "created_at": "2022-07-22T12:40:00+00:00",
          "updated_at": "2025-08-19T00:25:00.867456+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTA3ODU=",
            "location": {
              "latitude": 55.563283,
              "longitude": 9.612755,
              "name": "Mærskkildevej 30, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU4ODI1Mw==",
          "ticket_id": "20588253",
          "ticket_type": "AO-Generel besked",
          "description": "Ønske om fornyet AT-tilsyn på adressen.",
          "status": 6,
          "priority": 2,
          "created_at": "2022-07-22T12:11:00+00:00",
          "updated_at": "2025-08-19T00:25:00.867556+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTA3ODU=",
            "location": {
              "latitude": 55.563283,
              "longitude": 9.612755,
              "name": "Mærskkildevej 30, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        },
        {
          "id": "VGlja2V0VHlwZToyMDU5NDYzNg==",
          "ticket_id": "20594636",
          "ticket_type": "AO-Ønsker tilsyn",
          "description": "beboer har klaget over opkørt grusvej",
          "status": 6,
          "priority": 2,
          "created_at": "2021-08-27T12:38:00+00:00",
          "updated_at": "2025-08-19T00:25:01.338643+00:00",
          "resolved_at": null,
          "preferred_date": null,
          "contact_name": null,
          "user": null,
          "assignee": null,
          "property": {
            "id": "UHJvcGVydHlUeXBlOjExMTA3ODU=",
            "location": {
              "latitude": 55.563283,
              "longitude": 9.612755,
              "name": "Mærskkildevej 30, 7000, Fredericia, Danmark"
            }
          },
          "container": null,
          "attachments": []
        }
      ]
    }
  ]
}
